(function() {
  'use strict';

  angular
    .module('fmuslimPosClient', ['ngAnimate', 'ngSanitize', 'ngMessages', 'ui.router', 'ui.bootstrap', 'toastr', 'ui.select', 'angular-loading-bar', 'ng-locale-number', 'file-model', 'angular-jwt', 'angular-storage', 'ngdexie', 'nvd3', 'Api.DuplicateRequestsFilter.Decorator', 'angular-q-extras']);

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainStockHistoryController', MainStockHistoryController);

  /** @ngInject */
  function MainStockHistoryController($log, APIHandling, moment, _, $scope, Papa, saveAs, toastr, $uibModal) {

    var vm = this;
    vm.stockList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.inProcess = false;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page : 1,
      per_page :10,
      by_sku : null,
      tgl_min : null,
      tgl_max : null,
      tgl_opt : 4, /* Di antara tgl_min dan tgl_max */
      mode : '0'
    };

    vm.exportCSVStockChanges = function () {

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;
      filter.penjualan = filter.penjualan === true ? 1 : 0;
      filter.inventori = filter.inventori == true ? 1 : 0;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }
      filter.per_page = 100;

      var products = [];
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var getData = function (page, callback) {

        filter.page = page;

        APIHandling.get('stok/list', filter).then(function (response) {

            products = products.concat(response.data.data);

            if (response.data.data.length === filter.per_page) {
              getData(page + 1, callback);
            } else {
               callback(products);
            }
        }, function (error) {
          $log.error(error);
          vm.inProcess = false;
          angular.element('.loading-animation').hide();
          $scope.main.message = '';
          toastr.error('Terjadi kesalahan saat download riwayat stok', 'Gagal');
        });
      };

      getData(1, function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            waktu : item.tgl,
            id: item.produk_id,
            sku : item.sku,
            nama : item.nama,
            size: item.size,
            warna: item.warna,
            harga_beli: (item.harga_beli * 1),
            tambah_stok : (item.jumlah_in * 1),
            kurang_stok : (item.jumlah_out * 1),
            jumlah_akhir: (item.jumlah_akhir * 1),
            keterangan : item.ket
          });
        });

        var csv = Papa.unparse(result, {
            worker: false,
            skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
        var filename = 'stock_history_';

        if ((vm.filter.tgl_min !== null) && (vm.filter.tgl_max !== null)) {
          filename = filename + vm.filter.tgl_min + '_to_' + vm.filter.tgl_max;
        } else {
          filename = filename + 'all_time';
        }

        if (vm.filter.penjualan) {
          filename = filename + '_transaction';
        }

        if (vm.filter.inventori) {
          filename = filename + '_inventory';
        }

        saveAs(blob, filename + "_.csv");

      });

    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      APIHandling.get('stok/list', filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.stockList = response.data.data;
        vm.shownPage = filter.page;
      });
    };

    vm.editHistory = function (item) {
      if (((item.sisa_stok * 1) === ((item.jumlah_in * 1) - (item.jumlah_out * 1)))) {
        var modalInstance = $uibModal.open({
          animation: true,
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'app/components/modals/editStock/editStockDialog.html',
          controller: 'EditStockDialogController as vm',
          resolve: {
            data: function () {
              return {
                item: item
              };
            }
          }
        });

        modalInstance.result.then(function () {
          $log.info('Ok');
          vm.initView(vm.filter.page);
        }, function () {
            $log.info('Cancel');
        });
      }
    };

    vm.showTranscation = function (id) {
      $log.debug('Jalan');
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/DetailTransaksi/DetailTransaksiDialog.html',
        controller: 'DetailTransaksiDialogController as vm',
        resolve: {
          data: function () {
            return id;
          }
        }
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page))  {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainStockOpnameController', MainStockOpnameController);

  /** @ngInject */
  function MainStockOpnameController($log, APIHandling, moment, _, $scope, Papa, saveAs, toastr, $filter) {

    var vm = this;
    vm.stockList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.inProcess = false;
    vm.shownPage = 1;

    vm.filter = {
      page : 1,
      per_page :10,
      by_sku : null
    };

    vm.exportCSVStockChanges = function () {

      var filter = _.cloneDeep(vm.filter);

      filter.per_page = 100;

      var products = [];
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var getData = function (page, callback) {

        filter.page = page;

        APIHandling.get('stok/opname', filter).then(function (response) {

            products = products.concat(response.data.data);

            if (response.data.data.length === filter.per_page) {
              getData(page + 1, callback);
            } else {
               callback(products);
            }
        }, function (error) {
          $log.error(error);
          vm.inProcess = false;
          angular.element('.loading-animation').hide();
          $scope.main.message = '';
          toastr.error('Terjadi kesalahan saat download data stok opname', 'Gagal');
        });
      };

      getData(1, function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            id : item.id,
            sku : item.sku,
            nama : item.nama,
            keterangan : item.ket,
            weight: (item.weight * 1),
            size: item.size,
            warna: item.color,
            harga : (item.harga * 1),
            harga_beli_stok: (item.harga_beli * 1),
            sisa : (item.sisa * 1)
          });
        });

        var csv = Papa.unparse(result, {
            worker: false,
            skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
        var filename = 'stock_opname_' + moment().format('YYYY-MM-DD') + '_.csv';

        saveAs(blob, filename);

      });

    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      // filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      // filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;
      // filter.penjualan = filter.penjualan === true ? 1 : 0;
      // filter.inventori = filter.inventori == true ? 1 : 0;

      // if (!filter.tgl_max) {
      //   filter.tgl_opt = 3;
      // }

      APIHandling.get('stok/opname', filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.stockList = $filter('fm-detail')(response.data.data);
        vm.shownPage = filter.page;
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page))  {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainStockChangeController', MainStockChangeController);

  /** @ngInject */
  function MainStockChangeController(
    $log,
    _,
    toastr,
    APIHandling,
    store,
    $q,
    $uibModal,
    moment,
    draft
  ) {
    var vm = this;
    vm.product = [];
    vm.stockDraft = [];
    vm.inProcess = false;
    vm.loadDraft = false;
    vm.draftUser = true;

    vm.user = APIHandling.getCurrentUser();

    vm.getProducts = function(search) {
      if (search.length >= 3) {
        APIHandling.get('produk/list', {
          search: search,
          only_with_sku: 1,
        }).then(function(response) {
          vm.productList = response.data.data;
        });
      }
    };

    vm.checkHargaBeliValid = function() {
      var result = true;

      _.each(vm.product, function(n) {
        if (n.harga_beli === 0) {
          result = false;
        }
      });

      return result;
    };

    vm.saveStock = function() {
      function processSave() {
        vm.inProcess = true;
        angular.element('.loading-animation').show();

        var payload = {
          data: vm.product,
        };

        APIHandling.post('stok/save', payload, true)
          .then(
            function() {
              toastr.success('Data stok berhasil disimpan', 'Simpan Sukses');

              if (vm.loadDraft) {
                draft
                  .process({
                    id: vm.loadDraft.id,
                    draft: vm.product,
                  })
                  .then(function() {
                    /* Kosongkan list produk */
                    vm.product = [];

                    /* Simpan data yang sudah dikosongkan di localstorage */
                    store.set('stock', vm.product);
                    vm.loadDraft = false;
                    store.set('loadDraft', vm.loadDraft);
                    vm.initView();
                  });

                // _.remove(vm.stockDraft, function(n) {
                //   return n.id == vm.loadDraft;
                // });

                // vm.loadDraft = false;
                // store.set('stockDraft', vm.stockDraft);
                // store.set('loadDraft', vm.loadDraft);
              } else {
                /* Kosongkan list produk */
                vm.product = [];

                /* Simpan data yang sudah dikosongkan di localstorage */
                store.set('stock', vm.product);
              }
            },
            function(error) {
              $log.log(error);
              if (error.status === 400) {
                toastr.error('Terdapat data yang salah', 'Gagal');
              } else {
                toastr.error(
                  'Terjadi kesalahan saat menyimpan data stok',
                  'Gagal menyimpan data stok'
                );
              }
            }
          )
          .finally(function() {
            vm.inProcess = false;
            angular.element('.loading-animation').hide();
          });
      }

      if (vm.checkHargaBeliValid()) {
        processSave();
      } else {
        $uibModal
          .open({
            animation: true,
            templateUrl:
              'app/components/modals/changeStockDialog/changeStockDialog.html',
            controller: 'ChangeStockDialogController as vm',
          })
          .result.then(function() {
            processSave();
          });
      }
    };

    vm.changeStock = function(item) {
      if (item.is_input) {
        item.akhir = item.awal * 1 + item.jumlah_in * 1;

        store.set('stock', vm.product);
      } else {
        var akhir = item.awal * 1 - item.jumlah_out * 1;

        if (akhir >= 0) {
          item.akhir = akhir;

          store.set('stock', vm.product);
        } else {
          item.jumlah_out = item.jumlah_out - 1;
          toastr.error(
            'Tidak bisa mengurangi stok lebih dari jumlah stok awal',
            'Tidak bisa mengurangi stok'
          );
        }
      }
    };

    vm.addProduct = function(sku) {
      var getDataProduk = APIHandling.get('produk/list', {
        by_sku: sku,
        only_with_sku: 1,
      });
      var getHargaBeli = APIHandling.get('stok/list', {
        by_sku: sku,
        only_with_sku: 1,
        per_page: 1,
        mode: 1,
        order_by: 'by_tgl',
        sorting: 'desc',
      });

      $q.all([getDataProduk, getHargaBeli])
        .then(
          function(response) {
            /* Cek apakah ada produk dengan kode SKU yang dimasukkan  */
            var l = response[0].data.data.length;

            /* Jika tidak ada, beri pesan error */
            if (l === 0) {
              toastr.error(
                'Tidak ada produk dengan kode SKU: ' + sku,
                'Produk tidak ada'
              );
            } else if (response[0].data.data.length > 1) {
              toastr.error(
                'Ada lebih dari 1 produk dengan SKU: ' +
                  sku +
                  '.<br><br>Terjadi kesalahan data. <strong>Segera Hubungi Administrator!!</strong>',
                'Kesalahan Data'
              );
            } else if (l === 1 && response[0].data.data[0].status === 'nw') {
              toastr.error(
                'Produk dengan Woo ID: ' +
                  response[0].data.data[0].woo_id +
                  ' dan SKU: ' +
                  sku +
                  ' hanya ada di sistem POS, dan tidak ada di Website.<br><br>Terjadi kesalahan data. <strong>Segera hubungi Administrator</strong>',
                'Kesalahan Data'
              );
            } else if (l === 1 && response[0].data.data[0].status === 'ok') {
              var item = response[0].data.data[0];
              /* Jika ada, maka cek apa sudah ada di daftar atau belum */
              var tmp = _.find(vm.product, function(o) {
                return o.sku === item.sku;
              });

              item.harga_beli = response[1].data.data[0]
                ? response[1].data.data[0].harga_beli
                : 0;

              /* Jika belum ada di daftar, maka masukkan dan tambahkan qty + 1 */
              if (_.isUndefined(tmp)) {
                var newProduct = {
                  produk_id: item.id,
                  sku: item.sku,
                  nama: item.nama + ' ' + item.ket,
                  harga_beli: item.harga_beli,
                  awal: item.jumlah,
                  jumlah_in: 1,
                  jumlah_out: 0,
                  akhir: item.jumlah * 1 + 1,
                  ket: '',
                  is_input: true,
                };

                vm.product.unshift(newProduct);

                store.set('stock', vm.product);
              } else {
                /* Jika sudah ada, maka cukup tambahkan qty + 1 */
                if (tmp.is_input) {
                  tmp.jumlah_in = tmp.jumlah_in * 1 + 1;
                } else {
                  tmp.jumlah_out = tmp.jumlah_out * 1 + 1;
                }

                vm.changeStock(tmp);
              }
            }
          },
          function(error) {
            $log.error(error);
            toastr.error(
              'Terjadi kesalahan saat mengambil data produk',
              'Gagal'
            );
          }
        )
        .finally(function() {
          /*  Reset isi input untuk pengisian berikutnya */
          vm.sku = null;
          vm.selectedProduct = null;
        });
    };

    vm.addViaSKU = function(event) {
      /* Jika tombol enter ditekan  */
      /* Pastikan sku ada isinya sebelum diproses */
      if (event.which === 13 && vm.sku) {
        vm.addProduct(vm.sku);
      }
    };

    vm.addViaSelect = function() {
      vm.addProduct(vm.selectedProduct.sku);
    };

    vm.removeStock = function(index) {
      vm.product.splice(index, 1);

      /* Simpan data yang sudah dihapus di localstorage */
      store.set('stock', vm.product);
    };

    vm.initView = function() {
      $log.info('Init view');
      /* Inisialisasi list product diambil dari data stock yang belum disimpan */
      /* Jika belum pernah ada data, maka beri array kosong */
      vm.product = store.get('stock') || [];
      vm.loadDraft = store.get('loadDraft') || false;

      draft.list('STOCK').then(
        function(response) {
          vm.stockDraft = response.data || [];

          if (vm.loadDraft) {
            vm.loadDraft = _.find(vm.stockDraft, function(n) {
              return n.id === vm.loadDraft.id;
            });
            store.set('loadDraft', vm.loadDraft);
            vm.product = vm.loadDraft.draft;
            store.set('stock', vm.product);

            var user = APIHandling.getCurrentUser();

            if (user.uname === vm.loadDraft.created_by) {
              vm.draftUser = true;
            } else {
              vm.draftUser = false;
            }
          }
        },
        function(error) {
          vm.stockDraft = [];
          $log.error(error);
        }
      );
    };

    vm.changeInOut = function(item) {
      item.jumlah_in = 0;
      item.jumlah_out = 0;
      item.akhir = item.awal;
      item.is_input = !item.is_input;

      if (!item.is_input) {
        APIHandling.get('stok/opname', {
          page: 1,
          per_page: 10,
          by_sku: item.sku,
        }).then(
          function(response) {
            // vm.stockOpname = response.data.data;

            if (!item.info) {
              item.info = {
                original: _.cloneDeep(item),
              };
            }

            item.info.opname = _.cloneDeep(response.data.data);
          },
          function(error) {
            $log.error(error);
            toastr.error(
              'Terjadi kesalahan saat mengambil data harga produk',
              'Gagal'
            );
          }
        );
      } else {
        $log.error('jalan');
        var tmp = _.cloneDeep(item.info.original);
        item.awal = tmp.awal;
        item.harga_beli = tmp.harga_beli;
        item.akhir = tmp.akhir;
        vm.changeStock(item);
      }
    };

    vm.cancelStock = function() {
      /* Kosongkan list produk */
      vm.product = [];
      vm.loadDraft = false;

      /* Simpan data yang sudah dikosongkan di localstorage */
      store.set('stock', vm.product);
      store.set('loadDraft', vm.loadDraft);
      vm.draftUser = true;
    };

    vm.changeAwal = function(item) {
      if (item.harga_beli) {
        var data = _.find(item.info.opname, function(o) {
          return o.harga_beli * 1 === item.harga_beli * 1;
        });
        item.awal = data.sisa;
      } else {
        item.awal = item.info.original.awal;
      }

      vm.changeStock(item);
    };

    vm.saveDraft = function() {
      if (!vm.loadDraft) {
        draft
          .create({
            type: 'STOCK',
            draft: vm.product,
          })
          .then(
            function(response) {
              $log.log(response);
              toastr.success('Draft berhasil disimpan', 'Sukses');

              vm.loadDraft = false;
              vm.product = [];

              store.set('stock', vm.product);
              store.set('loadDraft', vm.loadDraft);
              vm.initView();
            },
            function(error) {
              $log.error(error);
              toastr.error('Gagal menyimpan draft', 'Gagal');
            }
          );
      } else {
        draft
          .update({
            id: vm.loadDraft.id,
            draft: vm.product,
          })
          .then(
            function(response) {
              $log.info(response);
              toastr.success('Draft berhasil disimpan', 'Sukses');

              vm.loadDraft = false;
              vm.product = [];

              store.set('stock', vm.product);
              store.set('loadDraft', vm.loadDraft);
            },
            function(error) {
              $log.error(error);
              toastr.error('Gagal menyimpan draft', 'Gagal');
            }
          );
      }
    };

    vm.useDraft = function(selectedDraft) {
      var confirmed = false;

      if (vm.product.length > 0) {
        confirmed = confirm(
          'Data belum disimpan.\nJika kamu load draft, maka data yg belum disimpan akan hilang. Yakin load draft ?'
        );
      }

      if (confirmed || vm.product.length === 0) {
        vm.loadDraft = selectedDraft;
        store.set('loadDraft', vm.loadDraft);
        vm.product = selectedDraft.draft;
        store.set('stock', vm.product);

        if (vm.user.uname === vm.loadDraft.created_by) {
          vm.draftUser = true;
        } else {
          vm.draftUser = false;
        }
      }
    };

    vm.removeDraft = function(index) {
      draft.delete(vm.stockDraft[index]).then(
        function() {
          vm.stockDraft.splice(index, 1);
          toastr.success('Berhasil hapus draft', 'Sukses');
        },
        function() {
          toastr.error('Gagal hapus draft', 'Gagal');
        }
      );
    };

    vm.initView();
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainProductListController', MainProductListController);

  /** @ngInject */
  function MainProductListController($log, APIHandling, $filter, $scope, toastr, _, Papa, saveAs) {

    var vm = this;

    vm.productList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.filter = {
      by_sku : null,
      search : null,
      only_with_sku: 1,
      per_page : 10,
      woo_only: 0,
      only_with_stok: '0'
    };

    vm.exportCSV = function () {

      var filter = _.cloneDeep(vm.filter);

      filter.per_page = 100;
      var products = [];
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var getData = function (page, callback) {

        filter.page = page;

        APIHandling.get('produk/list', filter).then(function (response) {

            products = products.concat(response.data.data);

            if (response.data.data.length === filter.per_page) {
                getData(page + 1, callback);
            } else {
                callback(products);
            }
        }, function (error) {
          $log.error(error);
          angular.element('.loading-animation').hide();
          $scope.main.message = '';
          vm.inProcess = false;
          toastr.error('Terjadi kesalahan saat download data produk', 'Gagal');
        });
      };

      getData(1, function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            id : item.id,
            sku : item.sku,
            nama : item.nama,
            keterangan : item.ket,
            weight: (item.weight * 1),
            size: item.size,
            warna: item.color,
            jumlah : (item.jumlah * 1),
            harga : (item.harga * 1),
            tambah_stok : 0,
            kurang_stok : 0,
            harga_beli_stok: 0,
            keterangan_stok : ''
          });
        });

        var csv = Papa.unparse(result, {
            worker: false,
            skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], {type: "text/plain;charset=utf-8"});
        saveAs(blob, "produk.csv");

      });

    };

    vm.initView = function (page) {

      vm.filter.page = page;

      /* Pastikan search ada isinya atay null, kalau tidak, akan memperoleh hasil query yang salah */
      vm.filter.search = vm.filter.search || null;

      var filter = _.cloneDeep(vm.filter);

      APIHandling.get('produk/list', filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        /* Filter data detail produk, ubah yang sebelumnya cuma data teks, menjadi object */
        vm.productList = $filter ('fm-detail') (response.data.data);
        vm.shownPage = filter.page;

      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page))  {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller("MainBulkUpdateController", MainBulkUpdateController);

  /** @ngInject */
  function MainBulkUpdateController($log, APIHandling, $q, _, XLSX, toastr) {
    var vm = this;

    vm.inProcess = false;
    vm.products = [];

    var uploadFile = angular.element("#uploadedFile");

    uploadFile.on("change", function (e) {
      vm.products = [];

      var file = e.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        vm.inProcess = true;
        angular.element(".loading-animation").show();

        var data = e.target.result;
        var workbook = XLSX.read(data, { type: "binary" });

        /**
         * Dapatkan worksheet. Ambil dari sheet kedua
         */
        var ws = workbook.Sheets[workbook.SheetNames[0]];

        var allPromises = [];
        var abjad = [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];

        var skuCol = "B";
        var qtyCol = "C";
        var priceCol = "D";

        _.each(abjad, function (n) {
          if (ws[n + 1]) {
            if (ws[n + 1].v === "Barcode") {
              skuCol = n;
            }

            if (ws[n + 1].v === "Qty") {
              qtyCol = n;
            }

            if (ws[n + 1].v === "Harga Akhir") {
              priceCol = n;
            }
          }
        });

        $log.info('SKU Col: ' + skuCol);
        $log.info('QTY Col: ' + qtyCol);
        $log.info('Price Col: ' + priceCol);

        /**
         *  Posisi [SKU, STOK, HARGA_BELI]:
         *  Contoh:
         *
         *  Sesuaikan dengan posisi yg ada di file excel
         */
        var dataPosition = [[skuCol, qtyCol, priceCol]];

        $log.log(workbook);

        //** Area kerjanya */
        /**
         * Data mulai dari baris ke-2
         */
        var minRow = 2;

        // /** ws['!ref'] berisi data range worksheed. Contoh isinya: A1:CD984 */
        // /** Ambil data baris terakhir dari hasil tsb. Gunakan regex untuk ambil data barisnya. */
        var maxRow = ws["!ref"].split(":")[1].match(/\d+$/)[0] * 1;
        $log.info("Total baris dibaca: " + maxRow);
        var i;

        var dataProduct = [];
        var dataOnServer = [];
        var list_sku = [];

        for (i = minRow; i <= maxRow; i++) {
          $log.info('Baca data baris: ' + i);

          _.each(dataPosition, function (n) {
            var sku = ws[n[0] + i] ? ws[n[0] + i].v : null;
            if (sku && sku !== "Barcode") {
              var stok = ws[n[1] + i] ? ws[n[1] + i].v : null;

              /**
               * Hilangkan tanda pemisah ribuan, untuk amankan data harga
               */
              var harga = ws[n[2] + i] ? parseInt(ws[n[2] + i].w.replace(/\D/g, '')) : null;
              $log.log('SKU: ' + sku + ' stok: ' + stok + ' harga ' + harga);

              dataProduct.push({
                sku: sku.trim(),
                qty: stok,
                price: harga,
              });

              list_sku.push(sku);
            }
          });
        }

        if (list_sku.length > 0) {
          var skuChunk = _.chunk(list_sku, 100);

          // $log.info(skuChunk);

          _.each(skuChunk, function (list) {
            var filter = {
              list_sku: list,
              per_page: 100,
            };

            var tmp = APIHandling.get("produk/list", filter);

            allPromises.push(tmp);
          });
        }

        $q.all(allPromises).then(function (result) {

          _.each(result, function (dataRow) {
            dataOnServer = dataOnServer.concat(dataRow.data.data);
          });

          // $log.info(dataOnServer);
          // $log.info(dataProduct);

          _.each(dataProduct, function (product) {
            // $log.info('Proses produk');
            // $log.info(product);

            var tmp = _.find(dataOnServer, function (n) {
              return n.sku == product.sku;
            });

            if (tmp) {
              vm.products.push({
                produk_id: tmp.id,
                sku: tmp.sku,
                nama: tmp.nama,
                info: tmp.ket,
                stok_awal: tmp.jumlah,
                jumlah_in: product.qty,
                jumlah_out: 0,
                harga_beli: product.price,
                ket: "Update massal via file Excel",
              });
            }
          });

          vm.inProcess = false;

          $log.info(vm.products);
          angular.element(".loading-animation").hide();
        });
      };

      reader.readAsBinaryString(file);
    });

    vm.reset = function () {
      vm.products = [];
      uploadFile.val(null);
    };

    vm.update = function () {
      vm.inProcess = true;
      APIHandling.post("stok/save", { data: vm.products }, true).then(
        function (result) {
          $log.info(result);
          vm.reset();
          vm.inProcess = false;
          toastr.success("Data stok berhasil disimpan", "Simpan Sukses");
        },
        function (error) {
          $log.log(error);
          vm.inProcess = false;
          if (error.status === 400) {
            toastr.error("Terdapat data yang salah", "Gagal");
          } else {
            toastr.error(
              "Terjadi kesalahan saat menyimpan data stok",
              "Gagal menyimpan data stok"
            );
          }
        }
      );
    };

    vm.initView = function () {};

    vm.initView();
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportTransactionOresellController', MainReportTransactionOresellController);

  /** @ngInject */
  function MainReportTransactionOresellController($log, moment, APIHandling, $filter, $timeout, $q, $uibModal, _) {

    var vm = this;
    vm.today = new Date();
    vm.report = {
      transaction_count: 0,
      transaction_value: 0
    };

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.source = {
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today
    };

    vm.filter = {
      page: 1,
      per_page: 500,
      scope: 0,
      area: 0,
      tgl_min: null,
      tgl_max: null,
      order_by: 'by_trans_value',
      sorting: 'desc',
      dropship: 2
    };

    vm.order = {
      transaction_count: false,
      transaction_value: false,
      field: 'transaction_value'
    };


    vm.initView = function (page) {

      vm.report = {
        transaction_count: 0,
        transaction_value: 0
      };
      vm.filter.page = page;
      vm.filter.tgl_min = moment(vm.source.tgl_min).format('YYYY-MM-DD');
      vm.filter.tgl_max = moment(vm.source.tgl_max).format('YYYY-MM-DD');

      APIHandling.get('order/report-transaction', vm.filter).then(function (response) {

        _.each(response.data, function (n) {
          n.transaction_value = n.transaction_value * 1;
          vm.report.transaction_count = vm.report.transaction_count + (n.transaction_count * 1);
          vm.report.transaction_value = vm.report.transaction_value + n.transaction_value;
          n.lain_lain = angular.fromJson(n.lain_lain);
        });

        vm.report.data = response.data;

        // vm.reportAsli = _.cloneDeep(response.data.data);
      });

    };

    vm.timeTemplate = {
      value: '2',
      change: function (template) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source.tgl_max = vm.today;
            break;
          case '2':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source.tgl_max = vm.today;
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = new Date(vm.today.getFullYear(), vm.today.getMonth(), 0);
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '5':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source.tgl_min = new Date(year, 0, 1);
            vm.source.tgl_max = new Date(year, 11, 31);
            break;
          default:
            break;
        }

        if (template !== '6') {
          vm.initView();
        }
      }
    };

    vm.changeOrder = function (field) {
      vm.order[field] = !vm.order[field];
      vm.report.data = $filter('orderBy')(vm.report.data, field, vm.order[field]);
    };

    vm.switchField = function () {

      if (vm.order.field === 'transaction_value') {
        vm.order.field = 'transaction_count';
      } else {
        vm.order.field = 'transaction_value';
      }

      vm.report.data = $filter('orderBy')(vm.report.data, vm.order.field, true);
    };

    vm.detailTransaction = function (item) {
      $uibModal.open({
        animation: true,
        size: 'md',
        // backdrop: 'static',
        templateUrl: 'app/components/modals/listTransaksi/listTransaksi.html',
        controller: 'ListTransaksiController as vm',
        resolve: {
          data: function () {
            return {
              customer: item,
              filter: vm.filter,
              dropship: 2
            };
          }
        }
      });
    };

    vm.refreshData = function () {
      vm.initView();
    };

    vm.initView(1);
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportTransactionDropshipController', MainReportTransactionDropshipController);

  /** @ngInject */
  function MainReportTransactionDropshipController($log, moment, APIHandling, $filter, $timeout, $q, $uibModal, _) {

    var vm = this;
    vm.today = new Date();
    vm.report = {
      transaction_count: 0,
      transaction_value: 0
    };

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.source = {
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today
    };

    vm.filter = {
      page: 1,
      per_page: 500,
      scope: 0,
      area: 0,
      tgl_min: null,
      tgl_max: null,
      order_by: 'by_trans_value',
      sorting: 'desc',
      dropship: 1
    };

    vm.order = {
      transaction_count: false,
      transaction_value: false,
      field: 'transaction_value'
    };


    vm.initView = function (page) {

      vm.report = {
        transaction_count: 0,
        transaction_value: 0
      };
      vm.filter.page = page;
      vm.filter.tgl_min = moment(vm.source.tgl_min).format('YYYY-MM-DD');
      vm.filter.tgl_max = moment(vm.source.tgl_max).format('YYYY-MM-DD');

      APIHandling.get('order/report-transaction', vm.filter).then(function (response) {

        _.each(response.data, function (n) {
          n.transaction_value = n.transaction_value * 1;
          vm.report.transaction_count = vm.report.transaction_count + (n.transaction_count * 1);
          vm.report.transaction_value = vm.report.transaction_value + n.transaction_value;
          n.lain_lain = angular.fromJson(n.lain_lain);
        });

        vm.report.data = response.data;

        // vm.reportAsli = _.cloneDeep(response.data.data);
      });

    };

    vm.timeTemplate = {
      value: '2',
      change: function (template) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source.tgl_max = vm.today;
            break;
          case '2':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source.tgl_max = vm.today;
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = new Date(vm.today.getFullYear(), vm.today.getMonth(), 0);
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '5':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source.tgl_min = new Date(year, 0, 1);
            vm.source.tgl_max = new Date(year, 11, 31);
            break;
          default:
            break;
        }

        if (template !== '6') {
          vm.initView();
        }
      }
    };

    vm.changeOrder = function (field) {
      vm.order[field] = !vm.order[field];
      vm.report.data = $filter('orderBy')(vm.report.data, field, vm.order[field]);
    };

    vm.switchField = function () {

      if (vm.order.field === 'transaction_value') {
        vm.order.field = 'transaction_count';
      } else {
        vm.order.field = 'transaction_value';
      }

      vm.report.data = $filter('orderBy')(vm.report.data, vm.order.field, true);
    };

    vm.detailTransaction = function (item) {
      $uibModal.open({
        animation: true,
        size: 'md',
        // backdrop: 'static',
        templateUrl: 'app/components/modals/listTransaksi/listTransaksi.html',
        controller: 'ListTransaksiController as vm',
        resolve: {
          data: function () {
            return {
              customer: item,
              filter: vm.filter,
              dropship: 1
            };
          }
        }
      });
    };

    vm.refreshData = function () {
      vm.initView();
    };

    vm.initView(1);
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportTransactionController', MainReportTransactionController);

  /** @ngInject */
  function MainReportTransactionController($log, moment, APIHandling, $filter, $timeout, $q, $uibModal, _) {

    var vm = this;
    vm.today = new Date();
    vm.report = {
      transaction_count: 0,
      transaction_value: 0
    };

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.source = {
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today
    };

    vm.filter = {
      page : 1,
      per_page :500,
      scope : 0,
      area: 0,
      tgl_min : null,
      tgl_max : null,
      order_by: 'by_trans_value',
      sorting: 'desc',
      only_crm: '1'
    };

    vm.order = {
      transaction_count: false,
      transaction_value: false,
      field: 'transaction_value'
    };


    vm.initView = function (page) {

      vm.report = {
        transaction_count: 0,
        transaction_value: 0
      };
      vm.filter.page = page;
      vm.filter.tgl_min = moment(vm.source.tgl_min).format('YYYY-MM-DD');
      vm.filter.tgl_max = moment(vm.source.tgl_max).format('YYYY-MM-DD');

      APIHandling.get('order/report-transaction', vm.filter).then(function (response) {

        _.each(response.data, function (n) {
          n.transaction_value = n.transaction_value * 1;
          vm.report.transaction_count = vm.report.transaction_count + (n.transaction_count * 1);
          vm.report.transaction_value = vm.report.transaction_value + n.transaction_value;

          if ((n.cust_id * 1) === 0) {
            n.pembeli = 'TRANSAKSI NON-CRM';
          }
        });

        vm.report.data = response.data;

        // vm.reportAsli = _.cloneDeep(response.data.data);
      });

    };

    vm.timeTemplate = {
      value: '2',
      change: function (template) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source.tgl_max = vm.today;
            break;
          case '2':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source.tgl_max = vm.today;
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = new Date(vm.today.getFullYear(), vm.today.getMonth(), 0);
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '5':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source.tgl_min = new Date(year, 0, 1);
            vm.source.tgl_max = new Date(year, 11, 31);
            break;
          default:
            break;
        }

        if (template !== '6') {
          vm.initView();
        }
      }
    };

    vm.changeOrder = function (field) {
      vm.order[field] = !vm.order[field];
      vm.report.data = $filter('orderBy')(vm.report.data, field, vm.order[field]);
    };

    vm.switchField = function () {

      if (vm.order.field === 'transaction_value') {
        vm.order.field = 'transaction_count';
      } else {
        vm.order.field = 'transaction_value';
      }

      vm.report.data = $filter('orderBy')(vm.report.data, vm.order.field, true);
    };

    vm.detailTransaction = function(item) {
      $uibModal.open({
        animation: true,
        size: 'md',
        // backdrop: 'static',
        templateUrl: 'app/components/modals/listTransaksi/listTransaksi.html',
        controller: 'ListTransaksiController as vm',
        resolve: {
          data: function () {
            return {
              customer: item,
              filter: vm.filter,
              dropship: 0
            };
          }
        }
      });
    };

    vm.refreshData = function () {
      vm.initView();
    };

    vm.initView(1);
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportProductController', MainReportProductController);

  /** @ngInject */
  function MainReportProductController(d3, LOCATIONHandling, $log, moment, APIHandling, $filter, $timeout, _) {

    var vm = this;
    vm.today = new Date();

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.collapseReport = {
      primary: { graph: false, table: true},
      location: { graph: true, table: true},
      time: { graph: true, table: true}
    };

    vm.options = {
      chart: {
        type: 'pieChart',
        height: 500,
        x: function(d){
          if (vm.filter.mode === 0) {
            return d.nama;
          } else if (vm.filter.mode === 1) {
            return d.size;
          }

        },
        y: function(d){return d[vm.order.field];},
        showLabels: true,
        duration: 500,
        labelThreshold: 0.01,
        labelSunbeamLayout: true,
        legend: {
            margin: {
                top: 5,
                right: 15,
                bottom: 5,
                left: 0
            }
        },
        showLegend: true,
        legendPosition: 'right',
        pie: {
          dispatch: {
            elementClick: function (info){
              if (vm.filter.mode === 0) {
                vm.changeProduct(info.data);
              }
            }
          }
        }
      }
    };

    vm.distribusi = {
      lokasi: {
        data: null,
        option: null
      },
      waktu: {
        data: null,
        periode: 'd',
        format: '%d/%m/%Y',
        option: {
          chart: {
            type: 'lineChart',
            height: 450,
            margin : {
              top: 20,
              right: 30,
              bottom: 30,
              left: 50
            },
            x: function(d){ return d.periode; },
            y: function(d){ return d.total; },
            useInteractiveGuideline: true,
            xAxis: {
              tickFormat: function(d){
                return d3.time.format(vm.distribusi.waktu.format)(new Date(d));
              }
            }
          }
        }

      }
    };

    vm.source = {
      provinsi: LOCATIONHandling.provinsiRO,
      kabupaten: null,
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today,
      info: []
    };

    vm.filter = {
      page : 1,
      per_page :500,
      scope : 0,
      area: 0,
      tgl_min : null,
      tgl_max : null,
      order_by : 'by_nilai',
      sorting: 'desc',
      mode: 0
    };

    vm.order = {
      nilai_produk: false,
      jumlah_produk: false,
      field: 'jumlah_produk'
    };

    vm.preparePrimaryGraph = function () {
      /** Beri delay agar UI siap dulu, baru render grafik. Jika tidak, grafik berantakan */
      $timeout(function () {
        vm.report.graph = _.cloneDeep(vm.report.data);
      }, 20);
    };

    vm.getLocationDistributionReport = function () {
      if (vm.filter.mode === 1) {
        var filter = _.cloneDeep(vm.filter);
        filter.mode = 2;

        APIHandling.post('order/lap-produk', filter, true).then(function (response) {
          vm.distribusi.lokasi.data = response.data;

          if (!vm.collapseReport.location.graph) {
            vm.prepareLocationDistributionGraph();
          }

        });

      }
    };

    vm.prepareLocationDistributionGraph = function () {
      /** Beri delay agar UI siap dulu, baru render grafik. Jika tidak, grafik berantakan */
      $timeout(function () {
        vm.distribusi.lokasi.graph = _.cloneDeep(vm.distribusi.lokasi.data.data);
      }, 20);
    };

    vm.getTimeDistributionReport = function (satuan) {
      var filterWaktu = _.cloneDeep(vm.filter);
      filterWaktu.sorting = 'asc';
      filterWaktu.periode = satuan;
      filterWaktu.mode = 3;
      filterWaktu.order_by = null;
      // vm.collapseReport.time.graph = false;

      APIHandling.post('order/lap-produk', filterWaktu, true).then(function (response) {
        vm.distribusi.waktu.data = response.data;

        if (!vm.collapseReport.time.graph) {
          vm.prepareTimeDistributionGraph(satuan);
        }

      });
    };

    vm.prepareTimeDistributionGraph = function (satuan) {
      var jumlah = [];
      var nilai = [];
      var field;

      if (satuan === 'd') {
        vm.distribusi.waktu.format = '%d/%m/%Y';
        field = 'tgl';
      } else if (satuan === 'w') {
        vm.distribusi.waktu.format = '%U';
        field = 'tgl';
      } else if (satuan === 'm') {
        vm.distribusi.waktu.format = '%b %Y';
        field = 'tgl_format';
      }

      _.each(vm.distribusi.waktu.data.data, function (n) {
        jumlah.push({
          periode: moment(n[field]),
          total: n.jumlah_produk * 1
        });

        nilai.push({
          periode: moment(n[field]),
          total: (n.nilai_produk * 1)/1000000
        });
      });

      vm.distribusi.waktu.graph = [
        {
          values: jumlah,
          key: 'Jumlah Produk',
          area: true,
          color: '#09f'
        },
        {
          values: nilai,
          key: 'Nilai Produk (Juta)',
          area: true,
          color: '#f90'
        }

      ];
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      vm.filter.tgl_min = moment(vm.source.tgl_min).format('YYYY-MM-DD');
      vm.filter.tgl_max = moment(vm.source.tgl_max).format('YYYY-MM-DD');
      vm.collapseReport.primary.graph = false;

      APIHandling.post('order/lap-produk', vm.filter, true).then(function (response) {

        vm.report = response.data;

        vm.reportAsli = _.cloneDeep(response.data.data);

        vm.report.total = {
          jumlah: 0,
          nilai: 0,
          hpp: 0
        };

         _.each(vm.report.data, function(n) {

           /** Jika mode 1 yaitu tampilkan per produk, dibagi berdasar size */
           if (vm.filter.mode === 1) {
             n.detail = angular.fromJson(n.detail);

             var size;

             if (n.detail.attributes) {
               size = _.find(n.detail.attributes, function (o) {
                 return o.name === 'SIZE';
               });
             } else {
               size = _.find(n.detail, function (o) {
                 return o.name === 'SIZE';
               });
             }

             n.size = $filter('uppercase')(size.option);
           }

           n.jumlah_produk = n.jumlah_produk * 1;
           n.nilai_produk = n.nilai_produk * 1;
           n.nilai_hpp = n.nilai_hpp * 1;

           vm.report.total.jumlah = (vm.report.total.jumlah * 1) + n.jumlah_produk;
           vm.report.total.nilai = (vm.report.total.nilai * 1) + n.nilai_produk;
           vm.report.total.hpp = (vm.report.total.hpp * 1) + n.nilai_hpp;
         });

         if (!vm.collapseReport.primary.graph) {
           vm.preparePrimaryGraph();
         }

         if (vm.filterProduk.filter) {
           vm.filterProduk.change();
         }

      });

      if (vm.filter.mode === 1) {

        vm.distribusi.lokasi.option = _.cloneDeep(vm.options);

        vm.distribusi.lokasi.option.chart.x = function(d) {
          return d.wilayah;
        };

        vm.distribusi.lokasi.option.chart.y = function(d) {
          return d.jumlah_produk;
        };

      }

    };

    vm.changeTimeChartPeriode = function (periode) {
      vm.getTimeDistributionReport(periode);
    };

    vm.resetDataOnChangeProduct = function () {
      vm.filterProduk.filter = null;

      vm.collapseReport.location = {graph: true, table: true};
      vm.collapseReport.time = {graph: true, table: true};

      vm.distribusi.lokasi.data = null;
      vm.distribusi.waktu.data = null;

    };

    vm.changeProduct = function (product) {
      vm.filter.mode = 1;
      vm.filter.by_nama = product.nama;
      vm.source.info.push(product);
      vm.resetDataOnChangeProduct();
      vm.initView(1);
    };

    vm.productUp = function () {
      vm.filter.by_nama = null;
      vm.source.info.pop();
      vm.filter.mode = 0;
      vm.resetDataOnChangeProduct();
      vm.initView(1);
    };

    vm.changeOrder = function (field) {
      vm.order[field] = !vm.order[field];
      vm.report.data = $filter('orderBy')(vm.report.data, field, vm.order[field]);
    };

    vm.switchField = function () {

      if (vm.order.field === 'nilai_produk') {
        vm.order.field = 'jumlah_produk';
      } else {
        vm.order.field = 'nilai_produk';
      }

      vm.report.data = $filter('orderBy')(vm.report.data, vm.order.field, true);
    };

    vm.timeTemplate = {
      value: '2',
      change: function (template) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source.tgl_max = vm.today;
            break;
          case '2':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source.tgl_max = vm.today;
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = new Date(vm.today.getFullYear(), vm.today.getMonth(), 0);
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '5':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source.tgl_min = new Date(year, 0, 1);
            vm.source.tgl_max = new Date(year, 11, 31);
            break;
          default:
            break;
        }

        if (template !== '6') {
          vm.initView();

          if (vm.distribusi.waktu.data) {
            vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
          }

          if (vm.distribusi.lokasi.data) {
            vm.getLocationDistributionReport();
          }
        }
      }
    };

    vm.refreshData = function () {
      vm.initView();

      if (vm.distribusi.waktu.data) {
        vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
      }

      if (vm.distribusi.lokasi.data) {
        vm.getLocationDistributionReport();
      }
    };

    vm.filterProduk = {
      filter: '',
      change: function () {
        /** Delay eksekusi agar grafik tidak kacau */
        $timeout(function () {
          vm.report.data = _.cloneDeep(vm.reportAsli);
          vm.report.data = $filter('filter')(vm.report.data, {nama: vm.filterProduk.filter});

          vm.report.total.jumlah = 0;
          vm.report.total.nilai = 0;
          vm.report.total.hpp = 0;

          _.each(vm.report.data, function (n) {
            vm.report.total.jumlah = (vm.report.total.jumlah * 1) + (n.jumlah_produk * 1);
            vm.report.total.nilai = (vm.report.total.nilai * 1) + (n.nilai_produk * 1);
            vm.report.total.hpp = (vm.report.total.hpp * 1) + (n.nilai_hpp * 1);
          });

          if (!vm.collapseReport.primary.graph) {
            vm.preparePrimaryGraph();
          } else {
            vm.report.graph = null;
          }

        }, 10);
      }
    };

    vm.changeCollapsePrimaryReport = function (btn) {
      if (!vm.report.data) {
        vm.initView();
      } else if (btn === 1) {
        if (!vm.collapseReport.primary.graph) {
          vm.preparePrimaryGraph();
        }
      }
    };

    vm.changeCollapseTimeReport = function (btn) {
      // vm.filterProduk.filter = null;

      if (!vm.distribusi.waktu.data) {
        vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
      } else if (btn === 1) {
        if (!vm.collapseReport.time.graph) {
          vm.prepareTimeDistributionGraph(vm.distribusi.waktu.periode);
        }
      }

    };

    vm.changeCollapseLocationReport = function (btn) {

      if (!vm.distribusi.lokasi.data) {
        vm.getLocationDistributionReport();
      } else if (btn === 1) {
        if (!vm.collapseReport.location.graph) {
          vm.prepareLocationDistributionGraph();
        }
      }

    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportLocationController', MainReportLocationController);

  /** @ngInject */
  function MainReportLocationController(d3, LOCATIONHandling, $log, moment, APIHandling, $filter, $timeout, $uibModal, _) {

    var vm = this;
    vm.today = new Date();

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.source = {
      provinsi: LOCATIONHandling.provinsiRO,
      kabupaten: null,
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today,
      info: []
    };

    vm.filter = {
      page : 1,
      per_page :500,
      scope : 0,
      area: 0,
      tgl_min : null,
      tgl_max : null,
      order_by : 'by_nilai',
      sorting: 'desc'
    };

    vm.order = {
      nilai_trans: false,
      jumlah_trans: false,
      field: 'nilai_trans'
    };

    vm.collapseReport = {
      primary: { graph: false, table: true},
      product: { graph: true, table: true},
      time: { graph: true, table: true},
      customer: { graph: true, table: true}
    };

    vm.options = {
      chart: {
        type: 'pieChart',
        height: 500,
        x: function(d){return d.wilayah;},
        y: function(d){return d[vm.order.field];},
        showLabels: true,
        duration: 500,
        labelThreshold: 0.01,
        labelSunbeamLayout: true,
        legend: {
            margin: {
                top: 5,
                right: 15,
                bottom: 5,
                left: 0
            }
        },
        showLegend: true,
        legendPosition: 'right',
        pie: {
          dispatch: {
            elementClick: function (info){
              if ((info.data.wilayah_id * 1) !== 0) {
                vm.changeLocation(info.data);
              }
            }
          }
        }
      }
    };

    vm.distribusi = {
      produk: {
        data: null,
        option: null
      },
      waktu: {
        data: null,
        periode: 'd',
        format: '%d/%m/%Y',
        option: {
          chart: {
            type: 'lineChart',
            height: 450,
            margin : {
              top: 20,
              right: 30,
              bottom: 30,
              left: 50
            },
            x: function(d){ return d.periode; },
            y: function(d){ return d.total; },
            useInteractiveGuideline: true,
            xAxis: {
              tickFormat: function(d){
                return d3.time.format(vm.distribusi.waktu.format)(new Date(d));
              }
            }
          }
        }

      },
      konsumen: {
        data: null
      }
    };

    vm.getTimeDistributionReport = function (satuan) {
      var filterWaktu = _.cloneDeep(vm.filter);
      filterWaktu.sorting = 'asc';
      filterWaktu.periode = satuan;
      // vm.collapseReport.time.graph = false;

      APIHandling.post('order/lap-waktu', filterWaktu, true).then(function (response) {
        vm.distribusi.waktu.data = response.data;

        if (!vm.collapseReport.time.graph) {
          vm.prepareTimeDistributionGraph(satuan);
        }

      });
    };

    vm.prepareTimeDistributionGraph = function (satuan) {
      var jumlah = [];
      var nilai = [];
      var field;

      if (satuan === 'd') {
        vm.distribusi.waktu.format = '%d/%m/%Y';
        field = 'tgl';
      } else if (satuan === 'w') {
        vm.distribusi.waktu.format = '%U';
        field = 'tgl';
      } else if (satuan === 'm') {
        vm.distribusi.waktu.format = '%b %Y';
        field = 'tgl_format';
      }

      _.each(vm.distribusi.waktu.data.data, function (n) {
        jumlah.push({
          periode: moment(n[field]),
          total: n.jumlah_trans * 1
        });

        nilai.push({
          periode: moment(n[field]),
          total: (n.nilai_trans * 1)/1000000
        });
      });

      vm.distribusi.waktu.graph = [
        {
          values: jumlah,
          key: 'Jumlah Transaksi',
          area: true,
          color: '#09f'
        },
        {
          values: nilai,
          key: 'Nilai Transaksi (Juta)',
          area: true,
          color: '#f90'
        }

      ];
    };

    vm.getTopCustomer = function (order_by) {

      $log.info('jalan lho');

      // if (!vm.distribusi.konsumen.data) {
        var filterKonsumen = _.cloneDeep(vm.filter);
        filterKonsumen.order_by = order_by;
        filterKonsumen.sorting = 'desc';
        filterKonsumen.per_page = 10;

        APIHandling.post('order/lap-cust', filterKonsumen, true).then(function (response) {
          vm.distribusi.konsumen.data = response.data;
        });
      // }

    };

    vm.getProductReport = function () {
      if (vm.filter.scope > 0) {
        var filter = _.cloneDeep(vm.filter);
        filter.mode = 0;
        filter.order_by = 'by_jumlah';
        // vm.collapseReport.product.graph = false;

        APIHandling.post('order/lap-produk', filter, true).then(function (response) {
          vm.distribusi.produk.data = response.data;

          /** Untuk filter */
          vm.distribusi.produk.data_asli = _.cloneDeep(response.data.data);

          vm.distribusi.produk.data.total_produk = 0;

          _.each(vm.distribusi.produk.data.data, function(n) {
            n.jumlah_produk = n.jumlah_produk * 1;
            vm.distribusi.produk.data.total_produk = vm.distribusi.produk.data.total_produk + n.jumlah_produk;
          });

          if (!vm.collapseReport.product.graph) {
            vm.prepareProductDistributionGraph();
          }

        });
      }
    };

    vm.prepareProductDistributionGraph = function () {

      /** Beri delay agar UI siap dulu, baru render grafik. Jika tidak, grafik berantakan */
      $timeout(function () {
        vm.distribusi.produk.graph = _.cloneDeep(vm.distribusi.produk.data.data);
      }, 20);

    };

    vm.showCustomerDetail = function (cust_id, cust_uuid) {
      $uibModal.open({
        animation: true,

        templateUrl: 'app/components/modals/DetailCustomer/DetailCustomerDialog.html',
        controller: 'DetailCustomerDialogController as vm',
        resolve: {
          data: function () {
            return {
              id: cust_uuid ? cust_uuid : cust_id,
              isOresell: cust_uuid ? true : false,
            };
          }
        }
      });
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      vm.filter.tgl_min = moment(vm.source.tgl_min).format('YYYY-MM-DD');
      vm.filter.tgl_max = moment(vm.source.tgl_max).format('YYYY-MM-DD');
      vm.collapseReport.primary.graph = false;

      APIHandling.post('order/lap-wilayah', vm.filter, true).then(function (response) {
        vm.report = response.data;
        vm.report.total = {
          trans: 0,
          nilai: 0
        };

         _.each(vm.report.data, function(n) {
           n.jumlah_trans = n.jumlah_trans * 1;
           n.nilai_trans = n.nilai_trans * 1;
           vm.report.total.trans = (vm.report.total.trans * 1) + n.jumlah_trans;
           vm.report.total.nilai = (vm.report.total.nilai * 1) + n.nilai_trans;
         });

      });

      if (vm.filter.scope > 0) {
        vm.distribusi.produk.option = _.cloneDeep(vm.options);

        vm.distribusi.produk.option.chart.x = function (d) {
          return d.nama;
        };

        vm.distribusi.produk.option.chart.y = function (d) {
          return d.jumlah_produk;
        };

        vm.distribusi.produk.option.chart.pie = {
          dispatch: {
            elementClick: function (){
              $log.info('NOOP');
            }
          }
        };
      }

    };

    vm.resetDataOnChangeLocation = function () {
      vm.filterProduk.filter = null;

      vm.collapseReport.product = {graph: true, table: true};
      vm.collapseReport.time = {graph: true, table: true};
      vm.collapseReport.customer.table = true;

      vm.distribusi.produk.data = null;
      vm.distribusi.waktu.data = null;
      vm.distribusi.konsumen.data = null;

    };

    vm.changeLocation = function (area) {
      if (vm.filter.scope < 2) {
        vm.filter.area = area.wilayah_id;
        vm.filter.scope = (vm.filter.scope * 1) + 1;
        vm.source.info.push(area);

        /** Reset nilai - nilai */
        vm.resetDataOnChangeLocation();
        /** Update view */
        vm.initView(1);
      }
    };

    vm.changeTimeChartPeriode = function (periode) {
      vm.getTimeDistributionReport(periode);
    };

    vm.backUpArea = function () {
      if (vm.filter.scope > 0) {
        vm.source.info.pop();
        vm.filter.scope = vm.filter.scope - 1;

        if (vm.filter.scope === 0) {
          vm.filter.area = 0;
        } else {
          vm.filter.area = vm.source.info[vm.filter.scope -1].wilayah_id;
        }

        /** Reset nilai - nilai */
        vm.resetDataOnChangeLocation();

        vm.initView(1);
      }
    };

    vm.changeOrder = function (field) {
      vm.order[field] = !vm.order[field];
      vm.report.data = $filter('orderBy')(vm.report.data, field, vm.order[field]);
    };

    vm.switchField = function () {

      if (vm.order.field === 'nilai_trans') {
        vm.order.field = 'jumlah_trans';
      } else {
        vm.order.field = 'nilai_trans';
      }

      vm.report.data = $filter('orderBy')(vm.report.data, vm.order.field, true);
    };

    vm.timeTemplate = {
      value: '2',
      change: function (template) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source.tgl_max = vm.today;
            break;
          case '2':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source.tgl_max = vm.today;
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = new Date(vm.today.getFullYear(), vm.today.getMonth(), 0);
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source.tgl_min = new Date(year, month, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '5':
            vm.source.tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source.tgl_max = vm.today;
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source.tgl_min = new Date(year, 0, 1);
            vm.source.tgl_max = new Date(year, 11, 31);
            break;
          default:
            break;
        }

        if (template !== '6') {
          vm.initView();

          if (vm.distribusi.waktu.data) {
            vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
          }

          if (vm.distribusi.produk.data) {
            vm.getProductReport();
          }

          vm.getTopCustomer('by_nilai');

        }

      }
    };

    vm.refreshData = function () {
      vm.initView();

      if (vm.distribusi.waktu.data) {
        vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
      }

      if (vm.distribusi.produk.data) {
        vm.getProductReport();
      }

      vm.getTopCustomer('by_nilai');

    };

    vm.filterProduk = {
      filter: '',
      change: function () {
        /** Delay eksekusi agar grafik tidak kacau */
        $timeout(function () {
          vm.distribusi.produk.data.data = _.cloneDeep(vm.distribusi.produk.data_asli);
          vm.distribusi.produk.data.data = $filter('filter')(vm.distribusi.produk.data.data, {nama: vm.filterProduk.filter});
          vm.distribusi.produk.data.total_produk = _.reduce(vm.distribusi.produk.data.data, function (m, n) {
            return m + (n.jumlah_produk * 1);
          }, 0);

          if (!vm.collapseReport.product.graph) {
            vm.distribusi.produk.graph = _.cloneDeep(vm.distribusi.produk.data.data);
          }

        }, 10);
      }
    };

    vm.changeCollapseTimeReport = function (btn) {
      vm.filterProduk.filter = null;

      if (!vm.distribusi.waktu.data) {
        vm.getTimeDistributionReport(vm.distribusi.waktu.periode);
      } else if (btn === 1) {
        if (!vm.collapseReport.time.graph) {
          vm.prepareTimeDistributionGraph(vm.distribusi.waktu.periode);
        }
      }

    };

    vm.changeCollapseProductReport = function (btn) {

      if (!vm.distribusi.produk.data) {
        vm.getProductReport();
      } else if (btn === 1) {
        if (!vm.collapseReport.product.graph) {
          vm.prepareProductDistributionGraph();
        }
      }

    };

    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportCompareController', MainReportCompareController);

  /** @ngInject */
  function MainReportCompareController(d3, LOCATIONHandling, $log, moment, APIHandling, $filter, $timeout, $q, $uibModal, _) {

    var vm = this;
    vm.today = new Date();
    vm.report = [{
      key: 'Laporan Nilai Transaksi',
      values: [],
      labels: ['Bulan Kemarin', 'Bulan Ini'],
      colors: ['#09f', '#f90']
    }];

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.getPreviousMonth = function () {

      var month = vm.today.getMonth() - 1;
      var year = vm.today.getFullYear();

      if (month < 0) {
        month = 11;
        year = year - 1;
      }

      return {
        tgl_min : new Date(year, month, 1),
        tgl_max : new Date(vm.today.getFullYear(), vm.today.getMonth(), 0)
      };
    };

    vm.source = [
      vm.getPreviousMonth(),
      {
        tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
        tgl_max: vm.today
      }
    ];

    vm.filter = {
      page : 1,
      per_page :500,
      scope : 0,
      area: 0,
      tgl_min : null,
      tgl_max : null,
      order_by : 'by_nilai',
      sorting: 'desc'
    };

    vm.collapseReport = {
      primary: { graph: false, table: true}
    };

    vm.options = {
      "chart": {
        "type": "discreteBarChart",
        "height": 450,
        "x": function(d){return d.label;},
        "y": function(d){return (d.value / 1000000);},
        "margin": {
          "top": 20,
          "right": 20,
          "bottom": 50,
          "left": 55
        },
        "showValues": true,
        "duration": 500,
        "xAxis": {
          "axisLabel": "Seri Data"
        },
        "yAxis": {
          "axisLabel": "Nilai Transaksi (juta)",
          "axisLabelDistance": -10
        }
      }
    };

    vm.initView = function (page) {

      var req = [];
      var report = [];

      vm.filter.page = page;

      vm.collapseReport.primary.graph = false;

      _.each(vm.source, function (source, i) {

        vm.filter.tgl_min = moment(source.tgl_min).format('YYYY-MM-DD');
        vm.filter.tgl_max = moment(source.tgl_max).format('YYYY-MM-DD');

        req[i] = APIHandling.post('order/lap-wilayah', _.cloneDeep(vm.filter), true);

      });

      $q.all([req[0], req[1]]).then(function (response) {

        _.each(response, function (data, index) {

          report.push({
            label: vm.report[0].labels[index],
            value: (data.data.total_nilai_trans * 1),
            color: vm.report[0].colors[index]
          });
        });

        vm.report[0].values = _.cloneDeep(report);

      });

    };

    vm.timeTemplate = {
      timeOne: '3',
      timeTwo: '2',
      change: function (template, n) {
        var month;
        var year;

        switch (template) {
          case '1':
            vm.source[n].tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), vm.today.getDate() - 6);
            vm.source[n].tgl_max = vm.today;
            vm.report[0].labels[n] = '7 Hari Terakhir';
            break;
          case '2':
            vm.source[n].tgl_min = new Date(vm.today.getFullYear(), vm.today.getMonth(), 1);
            vm.source[n].tgl_max = vm.today;
            vm.report[0].labels[n] = 'Bulan ini';
            break;
          case '3':
            month = vm.today.getMonth() - 1;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11;
              year = year - 1;
            }

            var tmp = vm.getPreviousMonth();

            vm.source[n].tgl_min = tmp.tgl_min;
            vm.source[n].tgl_max = tmp.tgl_max;
            vm.report[0].labels[n] = 'Bulan Kemarin';
            break;
          case '4':
            month = vm.today.getMonth() - 5;
            year = vm.today.getFullYear();

            if (month < 0) {
              month = 11 + month;
              year = year - 1;
            }

            vm.source[n].tgl_min = new Date(year, month, 1);
            vm.source[n].tgl_max = vm.today;
            vm.report[0].labels[n] = '6 Bulan Terakhir';
            break;
          case '5':
            vm.source[n].tgl_min = new Date(vm.today.getFullYear(), 0, 1);
            vm.source[n].tgl_max = vm.today;
            vm.report[0].labels[n] = 'Tahun Ini';
            break;
          case '7':
            year = vm.today.getFullYear() - 1;
            vm.source[n].tgl_min = new Date(year, 0, 1);
            vm.source[n].tgl_max = new Date(year, 11, 31);
            vm.report[0].labels[n] = 'Tahun Kemarin';
            break;
          default:
            vm.report[0].labels[n] = 'Data Custom Seri ' + (n + 1);
            break;
        }

      }
    };



    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller(
      'MainPosTransactionPendingController',
      MainPosTransactionPendingController
    );

  /** @ngInject */
  function MainPosTransactionPendingController(
    $log,
    APIHandling,
    moment,
    _,
    $uibModal,
    $scope,
    Papa,
    saveAs,
    toastr,
    $window
  ) {
    var vm = this;
    vm.transactionList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = $window.sessionStorage.getItem('POS_PENDING_FILTER');

    if (vm.filter) {
      vm.filter = angular.fromJson(vm.filter);

      if (vm.filter.tgl_min) {
        vm.filter.tgl_min = new Date(vm.filter.tgl_min);
      }

      if (vm.filter.tgl_max) {
        vm.filter.tgl_max = new Date(vm.filter.tgl_max);
      }
    } else {
      vm.filter = {
        page: 1,
        per_page: 10,
        by_pembeli: null,
        by_id: null,
        tgl_min: null,
        tgl_max: null,
        mode: 2 /*  mode 0 = semua, 1 = dibayar, 2 = pending */,
        tgl_opt: 4 /* Di antara tgl_min dan tgl_max */,
        by_reseller_id: null,
        by_marketplace_id: null,
        by_dropship: null,
      };
    }

    vm.showDetail = function(id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl:
          'app/components/modals/DetailTransaksi/DetailTransaksiDialog.html',
        controller: 'DetailTransaksiDialogController as vm',
        resolve: {
          data: function() {
            return id;
          },
        },
      });
    };

    vm.showCustomerDetail = function(cust_id, isOresell) {
      $uibModal.open({
        animation: true,

        templateUrl:
          'app/components/modals/DetailCustomer/DetailCustomerDialog.html',
        controller: 'DetailCustomerDialogController as vm',
        resolve: {
          data: function() {
            return {
              id: cust_id,
              isOresell: isOresell,
            };
          },
        },
      });
    };

    vm.inProcess = false;

    function getData(page, filter, currentData, callback) {
      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }
      filter.per_page = 500;
      var order = currentData;

      filter.page = page;
      filter.order_by = 'by_tgl';
      filter.sorting = 'asc';

      APIHandling.get('order/list', filter).then(
        function(response) {
          order = order.concat(response.data.data);

          if (response.data.data.length === filter.per_page) {
            getData(page + 1, filter, order, callback);
          } else {
            callback(order);
          }
        },
        function(error) {
          $log.error(error);
          angular.element('.loading-animation').hide();
          $scope.main.message = '';
          vm.inProcess = false;
          toastr.error(
            'Terjadi kesalahan saat download riwayat transaksi',
            'Gagal'
          );
        }
      );
    }

    vm.downloadTransaction = function() {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format('YYYY-MM-DD')
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format('YYYY-MM-DD')
        : null;

      getData(1, filter, [], function(data) {
        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function(item) {
          result.push({
            id: item.id,
            waktu: item.tgl,
            total_harga_produk: item.product_price_total * 1,
            total_diskon_produk: item.discount_product_total * 1,
            total_diskon_transaksi: item.discount_transaction_total * 1,
            total_biaya: item.total_lain_lain * 1,
            total_tagihan_dibayar: item.total_akhir * 1,
            kasir: item.kasir,
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true,
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
        var filename = 'pending_transaction_history_';

        if (vm.filter.tgl_min !== null && vm.filter.tgl_max !== null) {
          filename = filename + vm.filter.tgl_min + '_to_' + vm.filter.tgl_max;
        } else {
          filename = filename + 'all_time';
        }

        saveAs(blob, filename + '_.csv');
      });
    };

    vm.downloadReport = function() {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format('YYYY-MM-DD')
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format('YYYY-MM-DD')
        : null;

      getData(1, filter, [], function(data) {
        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function(item) {
          result.push({
            id: item.id,
            waktu: item.tgl,
            penerimaan: item.total_akhir * 1,
            hpp: item.hpp * 1,
            profit_bruto: item.profit * 1,
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true,
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
        var filename = 'pending_laporan_keuangan_';

        if (vm.filter.tgl_min !== null && vm.filter.tgl_max !== null) {
          filename = filename + vm.filter.tgl_min + '_to_' + vm.filter.tgl_max;
        } else {
          filename = filename + 'all_time';
        }

        saveAs(blob, filename + '_.csv');
      });
    };

    vm.cancelOresellTransaction = function(transaction) {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl:
          'app/components/modals/cancelTransaction/cancelTransactionDialog.html',
        controller: 'CancelTransactionDialogController as vm',
        resolve: {
          data: function() {
            return {
              resume: transaction,
            };
          },
        },
      });

      modalInstance.result.then(
        function() {
          vm.initView(vm.filter.page);
        },
        function() {
          $log.info('Cancel');
        }
      );
    };

    vm.cancelShopeeTransaction = function(transaction) {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl:
          'app/components/modals/cancelTransaction/cancelTransactionDialog.html',
        controller: 'CancelTransactionDialogController as vm',
        resolve: {
          data: function() {
            return {
              resume: transaction,
            };
          },
        },
      });

      modalInstance.result.then(
        function() {
          vm.initView(vm.filter.page);
        },
        function() {
          $log.info('Cancel');
        }
      );
    };

    vm.processOresellTransaction = function(transaction) {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: true,
        backdrop: 'static',
        templateUrl:
          'app/components/modals/processOresellTransaction/ProcessOresellTransactionDialog.html',
        controller: 'ProcessOresellTransactionDialogController as vm',
        resolve: {
          data: function() {
            return {
              resume: transaction,
            };
          },
        },
      });

      modalInstance.result.then(
        function() {
          vm.initView(vm.filter.page);
        },
        function() {
          $log.info('Cancel');
        }
      );
    };

    vm.initView = function(page) {
      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format('YYYY-MM-DD')
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format('YYYY-MM-DD')
        : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      /** Simpan data filter di session storage */
      $window.sessionStorage.setItem(
        'POS_PENDING_FILTER',
        angular.toJson(vm.filter)
      );

      APIHandling.get('order/list', filter).then(function(response) {
        if (page === 1) {
          vm.maxPage = response.data.max_page * 1 || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        _.each(response.data.data, function(n) {
          n.lain_lain = angular.fromJson(n.lain_lain);
        });

        vm.transactionList = response.data.data;
        vm.shownPage = filter.page;
      });
    };

    vm.showCashierNote = function(item) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/cashierNote/cashierNoteDialog.html',
        controller: 'CashierNoteDialogController as vm',
        resolve: {
          data: function() {
            return {
              transaksi: item,
            };
          },
        },
      });
    };

    vm.changePage = function(page) {
      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }
    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function(page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(vm.filter.page);
  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller(
      "MainPosTransactionListController",
      MainPosTransactionListController
    );

  /** @ngInject */
  function MainPosTransactionListController(
    $log,
    APIHandling,
    moment,
    _,
    $uibModal,
    $scope,
    Papa,
    saveAs,
    toastr,
    $q,
    STRUKHandling,
    ADDRESSHandling,
    TRXHandling
  ) {
    var vm = this;
    vm.transactionList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      by_id: null,
      by_pembeli: null,
      tgl_min: null,
      tgl_max: null,
      tgl_opt: 4 /* Di antara tgl_min dan tgl_max */,
      order_by: "by_tgl",
      sorting: "desc",
    };

    vm.showDetail = function (id) {
      var instance = $uibModal.open({
        animation: true,
        size: "lg",
        templateUrl:
          "app/components/modals/DetailTransaksi/DetailTransaksiDialog.html",
        controller: "DetailTransaksiDialogController as vm",
        resolve: {
          data: function () {
            return id;
          },
        },
      });

      instance.result.then(
        function () {},
        function () {
          vm.initView(vm.filter.page);
        }
      );
    };

    vm.itemCheckbox = [];

    vm.inProcess = false;

    vm.changeCheckAll = function () {
      for (var i = 0; i < 10; i++) {
        vm.itemCheckbox[i] = vm.checkAll;
      }
    };

    vm.clearSelection = function () {
      vm.checkAll = false;
      for (var i = 0; i < 10; i++) {
        vm.itemCheckbox[i] = false;
      }
    };

    vm.procesPrint = function (target) {
      var toPrint = [];

      _.each(vm.itemCheckbox, function (item, n) {
        if (item && vm.transactionList[n]) {
          toPrint.push(vm.getDetailTransaction(vm.transactionList[n].id));
        }
      });

      if (_.isEmpty(toPrint)) {
        toastr.info(
          "Pilih dulu trasaksi yang akan diprint",
          "Tidak ada transaksi yang dipilih"
        );
      } else {
        $q.all(toPrint).then(function (res) {
          if (target === 1) {
            STRUKHandling.bulkPrintPOS58(res);
          } else {
            var data = [];
            var listId = [];

            _.each(res, function (trx) {
              var receiverAddress =
                (trx.shipping_alamat || "") +
                " " +
                (trx.shipping_kec || "") +
                " " +
                (trx.shipping_kab || "") +
                " " +
                (trx.shipping_prov || "") +
                " " +
                (trx.lain_lain.kode_pos || "");

              var sender = {
                name: "Zafrada",
                phone: "6285334988010",
              };

              if (trx.dropship * 1 === 1) {
                sender = {
                  name: trx.lain_lain.dropship.sender.nama || "",
                  phone: trx.lain_lain.dropship.sender.hp
                    ? trx.lain_lain.dropship.sender.hp
                    : trx.lain_lain.dropship.alamat_sender,
                };
              } else if (trx.dropship * 1 === 2) {
                sender = {
                  name: trx.lain_lain.dropship.sender.nama || "",
                  phone: trx.lain_lain.dropship.sender.hp
                    ? trx.lain_lain.dropship.sender.hp
                    : "",
                };

                if (trx.lain_lain.dropship.customSender) {
                  if (trx.lain_lain.dropship.customSender.use === "1") {
                    sender = {
                      name: trx.lain_lain.dropship.customSender.nama,
                      phone: trx.lain_lain.dropship.customSender.hp,
                    };
                  }
                }

                listId.push(trx.id);
              }

              data.push({
                receiver: {
                  name: trx.pembeli,
                  address: receiverAddress,
                  phone: trx.lain_lain.hp || "",
                },
                sender: sender,
                expedition: {
                  name: trx.ekspedisi ? trx.ekspedisi.toUpperCase() : "",
                  service: trx.ekspedisi_service
                    ? trx.ekspedisi_service.toUpperCase()
                    : "",
                  jobNumber: trx.lain_lain.jobNumber
                    ? trx.lain_lain.jobNumber
                    : "",
                },
              });
            });

            ADDRESSHandling.bulkPrintPOS58(data);

            APIHandling.post("order/bulk-mark-print", { list_id: listId }).then(
              function () {
                vm.initView(vm.filter.page);
              },
              function (error) {
                angular.error(error);
                toastr.error(
                  "Gagal menandai transaksi sudah cetak alamat. Coba klik lagi tombol cetak lalu ketika keluar dialog preview, klik cancel.",
                  "Gagal tandai transaksi"
                );
              }
            );
          }
        });
      }
    };

    function getData(page, filter, currentData, callback) {
      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }
      filter.per_page = 500;
      var order = currentData;

      filter.page = page;
      filter.order_by = "by_tgl";
      filter.sorting = "asc";

      APIHandling.get("order/list", filter).then(
        function (response) {
          order = order.concat(response.data.data);

          if (response.data.data.length === filter.per_page) {
            getData(page + 1, filter, order, callback);
          } else {
            callback(order);
          }
        },
        function (error) {
          $log.error(error);
          angular.element(".loading-animation").hide();
          $scope.main.message = "";
          vm.inProcess = false;
          toastr.error(
            "Terjadi kesalahan saat download riwayat transaksi",
            "Gagal"
          );
        }
      );
    }

    vm.downloadTransaction = function () {
      vm.inProcess = true;
      $scope.main.message = "Mendownload data dari server...";
      angular.element(".loading-animation").show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format("YYYY-MM-DD")
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format("YYYY-MM-DD")
        : null;

      getData(1, filter, [], function (data) {
        $scope.main.message = "Konversi ke csv";
        var result = [];

        _.each(data, function (item) {
          result.push({
            id: item.id,
            waktu: item.tgl,
            total_harga_produk: item.product_price_total * 1,
            total_diskon_produk: item.discount_product_total * 1,
            total_diskon_transaksi: item.discount_transaction_total * 1,
            total_biaya: item.total_lain_lain * 1,
            total_tagihan_dibayar: item.total_akhir * 1,
            kasir: item.kasir,
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true,
        });

        angular.element(".loading-animation").hide();
        $scope.main.message = "";
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = "transaction_history_";

        if (vm.filter.tgl_min !== null && vm.filter.tgl_max !== null) {
          filename = filename + vm.filter.tgl_min + "_to_" + vm.filter.tgl_max;
        } else {
          filename = filename + "all_time";
        }

        saveAs(blob, filename + "_.csv");
      });
    };

    vm.downloadFull = function () {
      vm.inProcess = true;
      $scope.main.message = "Mendownload data dari server...";
      angular.element(".loading-animation").show();

      var filter = _.cloneDeep(vm.filter);

      filter.with_product = 1;

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format("YYYY-MM-DD")
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format("YYYY-MM-DD")
        : null;

      getData(1, filter, [], function (data) {
        $scope.main.message = "Konversi ke csv";
        var result = [];

        _.each(data, function (item) {
          item.lain_lain = angular.fromJson(item.lain_lain);

          result.push(item);
        });

        var text = angular.toJson(result);

        angular.element(".loading-animation").hide();
        $scope.main.message = "";
        vm.inProcess = false;

        var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
        var filename = "transaction_detail_";

        if (vm.filter.tgl_min !== null && vm.filter.tgl_max !== null) {
          filename = filename + vm.filter.tgl_min + "_to_" + vm.filter.tgl_max;
        } else {
          filename = filename + "all_time";
        }

        saveAs(blob, filename + "_.json");
      });
    };

    vm.downloadReport = function () {
      vm.inProcess = true;
      $scope.main.message = "Mendownload data dari server...";
      angular.element(".loading-animation").show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format("YYYY-MM-DD")
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format("YYYY-MM-DD")
        : null;

      getData(1, filter, [], function (data) {
        $scope.main.message = "Konversi ke csv";
        var result = [];

        _.each(data, function (item) {
          result.push({
            id: item.id,
            waktu: item.tgl,
            penerimaan: item.total_akhir * 1,
            hpp: item.hpp * 1,
            profit_bruto: item.profit * 1,
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true,
        });

        angular.element(".loading-animation").hide();
        $scope.main.message = "";
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = "laporan_keuangan_";

        if (vm.filter.tgl_min !== null && vm.filter.tgl_max !== null) {
          filename = filename + vm.filter.tgl_min + "_to_" + vm.filter.tgl_max;
        } else {
          filename = filename + "all_time";
        }

        saveAs(blob, filename + "_.csv");
      });
    };

    vm.printTransaction = function() {
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format("YYYY-MM-DD")
        : moment(vm.today).format("YYYY-MM-DD");
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format("YYYY-MM-DD")
        : moment(vm.today).format("YYYY-MM-DD");

      getData(1, filter, [], function (data) {
        TRXHandling.print(data);
      });
    };

    vm.showCustomerDetail = function (cust_id, isOresell) {
      $uibModal.open({
        animation: true,

        templateUrl:
          "app/components/modals/DetailCustomer/DetailCustomerDialog.html",
        controller: "DetailCustomerDialogController as vm",
        resolve: {
          data: function () {
            return {
              id: cust_id,
              isOresell: isOresell,
            };
          },
        },
      });
    };

    vm.initView = function (page) {
      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min
        ? moment(filter.tgl_min).format("YYYY-MM-DD")
        : null;
      filter.tgl_max = filter.tgl_max
        ? moment(filter.tgl_max).format("YYYY-MM-DD")
        : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      APIHandling.get("order/list", filter).then(
        function (response) {
          if (page === 1) {
            vm.maxPage = response.data.max_page * 1 || 1;
          }

          /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
          if (page === vm.maxPage) {
            vm.isLastPage = true;
          } else {
            vm.isLastPage = false;
          }

          _.each(response.data.data, function (n) {
            // n.tgl = n.tgl.replace(' ', 'T');
            n.lain_lain = angular.fromJson(n.lain_lain);
          });

          vm.transactionList = response.data.data;
          vm.shownPage = filter.page;

          vm.clearSelection();

          // _.each(vm.transactionList, function (n) {
          //   n.lain_lain = angular.fromJson(n.lain_lain);
          // });
        },
        function (error) {
          $log.error(error);
          if (error.status === 408) {
            toastr.error(error.data.message, "Terjadi Kesalahan");
          } else {
            toastr.error(
              "Terjadi kesalahan saat mengambil data transaksi",
              "Terjadi Kesalahan"
            );
          }
        }
      );
    };

    vm.entryResi = function (transaksi, baru) {
      var modal = $uibModal.open({
        animation: true,

        templateUrl: "app/components/modals/entryResi/entryResiDialog.html",
        controller: "EntryResiDialogController as vm",
        resolve: {
          data: function () {
            return {
              transaksi: transaksi,
              baru: baru,
            };
          },
        },
      });

      modal.result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.setStatusResi = function (item) {
      var status = "";

      if (item.status === "selesai") {
        if (!item.lain_lain.no_resi) {
          status = "";
        } else if (
          item.lain_lain.no_resi.length > 0 &&
          item.lain_lain.status_sms === 1
        ) {
          status = "check-success";
        } else if (
          item.lain_lain.no_resi.length > 0 &&
          item.lain_lain.status_sms !== 1
        ) {
          status = "check-warning";
        }
      }

      return status;
    };

    vm.changeProcess = function (item) {
      var isProcessed = item.lain_lain.processed ? false : true;

      APIHandling.post(
        "order/set-status-trans",
        {
          id: item.id,
          processed: isProcessed,
          status_trans: item.status,
          status_resi: item.lain_lain.status_sms || -1,
        },
        true
      ).then(
        function () {
          vm.initView(vm.filter.page);
        },
        function (error) {
          $log.error(error);
          toastr.error("Gagal menandai transaksi", "Gagal");
        }
      );
    };

    vm.changeStatus = function (item) {
      var status_trans = item.status === "dibayar" ? "selesai" : "dibayar";
      var status_resi = item.lain_lain.status_sms || -1;
      var isProcessed = item.lain_lain.processed;

      APIHandling.post(
        "order/set-status-trans",
        {
          id: item.id,
          status_trans: status_trans,
          status_resi: status_resi,
          processed: isProcessed,
        },
        true
      ).then(
        function () {
          vm.initView(vm.filter.page);
        },
        function (error) {
          $log.error(error);
          toastr.error("Gagal ubah status transaksi", "Gagal");
        }
      );
    };

    vm.showCashierNote = function (item) {
      $uibModal.open({
        animation: true,
        templateUrl: "app/components/modals/cashierNote/cashierNoteDialog.html",
        controller: "CashierNoteDialogController as vm",
        resolve: {
          data: function () {
            return {
              transaksi: item,
            };
          },
        },
      });
    };

    vm.changePage = function (page) {
      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }
    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.getDetailTransaction = function (id) {
      var q = $q.defer();

      APIHandling.get("order/get", { id: id }).then(
        function (response) {
          var map = [];
          var produk_jual = [];
          var transaksi = response.data;

          /* Data lain_lain dalam bentuk JSON, perlu diparse agar bisa diproses */
          transaksi.lain_lain = angular.fromJson(transaksi.lain_lain);

          /* Siapkan array untuk menyimpan data produk unik */
          transaksi.produk_unik = [];

          _.each(response.data.produk_jual, function (item) {
            var index = _.indexOf(map, item.produk_id);

            if (index < 0) {
              map.push(item.produk_id);

              var detail = angular.fromJson(item.detail);

              if (detail.attributes) {
                item.ukuran = _.find(detail.attributes, function (o) {
                  return o.name === "SIZE";
                });
              } else {
                item.ukuran = _.find(detail, function (o) {
                  return o.name === "SIZE";
                });
              }

              item.family = _.find(detail.attributes, function (o) {
                return o.name === "FAMILY";
              });

              produk_jual.push(item);
            } else {
              produk_jual[index].jumlah =
                produk_jual[index].jumlah * 1 + item.jumlah * 1;
              produk_jual[index].discount_persen =
                produk_jual[index].discount_persen * 1 +
                item.discount_persen * 1;
              produk_jual[index].discount_nominal =
                produk_jual[index].discount_nominal * 1 +
                item.discount_nominal * 1;
            }
          });

          transaksi.produk_unik = produk_jual;
          transaksi.lain_lain = angular.fromJson(transaksi.lain_lain);

          q.resolve(transaksi);
        },
        function (error) {
          q.reject(error);
        }
      );

      return q.promise;
    };

    vm.initView(1);
  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainPosProductTransactionListController', MainPosProductTransactionListController);

  /** @ngInject */
  function MainPosProductTransactionListController($log, APIHandling, ProductTransaction, moment, _, $uibModal, $scope, Papa, saveAs, toastr) {

    var vm = this;
    vm.transactionList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;
    vm.resume = {};

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page: 1,
      per_page: 10,
      transaction_id: null,
      sku: null,
      product_name: null,
      tgl_min: new Date(vm.today.getFullYear(), vm.today.getMonth(), 1),
      tgl_max: vm.today,
      sorting: 'desc',
      order_status: 'process'
    };

    vm.showDetail = function (id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/DetailTransaksi/DetailTransaksiDialog.html',
        controller: 'DetailTransaksiDialogController as vm',
        resolve: {
          data: function () {
            return id;
          }
        }
      });
    };

    vm.inProcess = false;

    function getData(page, filter, currentData, callback) {

      filter.per_page = 500;
      var order = currentData;

      filter.page = page;
      filter.sorting = 'asc';

      ProductTransaction.list(filter).then(function (response) {

        _.each(response.data.data, function (item) {
          var detail = angular.fromJson(item.detail);
          item.family = _.find(detail.attributes, function (o) {
            return o.name === 'FAMILY';
          });
          item.harga_akhir = (item.harga_jual * item.jumlah) - item.discount_total;
          item.margin = item.harga_akhir - (item.harga_beli * item.jumlah);
        });

        order = order.concat(response.data.data);

        if (response.data.data.length === filter.per_page) {
          getData(page + 1, filter, order, callback);
        } else {
          callback(order);
        }
      }, function (error) {
        $log.error(error);
        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;
        toastr.error('Terjadi kesalahan saat download riwayat transaksi', 'Gagal');
      });
    }

    vm.downloadTransaction = function () {

      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            waktu: item.tgl,
            order: item.order_id,
            sku: item.sku,
            nama: item.nama,
            size: item.size,
            family: item.family ? item.family.option : null,
            qty: item.jumlah,
            harga: (item.harga_jual * item.jumlah),
            diskon: (item.discount_total * 1),
            bayar: (item.harga_akhir * 1),
            hpp: (item.harga_beli * item.jumlah),
            margin: (item.margin * 1)
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'product_transaction';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      ProductTransaction.list(filter).then(function (response) {
        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
          vm.resume = response.data.resume;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        _.each(response.data.data, function (item) {
          var detail = angular.fromJson(item.detail);
          item.family = _.find(detail.attributes, function (o) {
            return o.name === 'FAMILY';
          });
          item.harga_akhir = (item.harga_jual * item.jumlah) - item.discount_total;
          item.margin = item.harga_akhir - (item.harga_beli * item.jumlah);
        });

        vm.transactionList = response.data.data;

        vm.shownPage = filter.page;

      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data transaksi', 'Terjadi Kesalahan');
        }
      });
    };



    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainPosProcessPendingController', MainPosProcessPendingController);

  /** @ngInject */
  function MainPosProcessPendingController($log, _, toastr, APIHandling, $uibModal, moment, $state, $stateParams) {

    var vm = this;
    vm.id = $stateParams.id;
    vm.product = [];
    vm.inProcess = false;

    function getProductSize (item) {
      // var size;

      /** Dapatkan data ukuran produk */
      // if (item.detail.attributes) {
      //   size = _.find(item.detail.attributes, function (o) {
      //     return o.name === 'SIZE';
      //   }).option;
      // } else {
      //   size = _.find(item.detail, function (o) {
      //     return o.name === 'SIZE';
      //   }).option;
      // }

      return item.size;
    }

    vm.initResume = function () {
      vm.resume = {
          total_akhir: 0,
          bayar: 0,
          discount_transaction_total: 0,
          sisa_kembali: 0
      };
    };

    vm.calculateTotal = function () {

      var total = _.reduce(vm.product, function (sum, item) {
          return (sum * 1) + (item.total * 1);
      }, 0);

      vm.resume.total = total;
    };

    vm.getProducts = function (search) {
      if (search.length > 3) {
        APIHandling.get('produk/list', {search : search, only_with_sku: 1}).then(function (response) {
            vm.productList = response.data.data;
        });
      }
    };

    vm.verifyProductStock = function () {

      var list_id = _.map(vm.product, 'produk_id');

      APIHandling.get('produk/list', { list_produk_id: list_id }).then(function (response) {

        _.each(vm.product, function (n) {

          var item = _.find(response.data.data, { id: n.produk_id });
          n.jumlah_max = (item.jumlah * 1) + (n.jumlah_original * 1);

        });

      }, function () {
        toastr.error('Gagal cek stok produk', 'Gangguan');
      });
    };

    vm.stockHabis = function (item) {
      $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/components/modals/stockHabis/stockHabis.html',
        controller: 'StockHabisController as vm',
        resolve: {
          data: function () {
            return {
              product: item
            };
          }
        }
      });
    };

    vm.calculateItemTotal = function (item) {
      item.discount_total = ( ( item.discount_persen / 100 ) * ( item.harga_jual * item.jumlah ) ) + (item.discount_nominal * 1);
      item.total = ( item.harga_jual * item.jumlah ) - (item.discount_total * 1);
    };

    vm.changeStock = function (item) {
      if (item.jumlah >= 1) {
        vm.calculateItemTotal(item);
        vm.calculateTotal();
      }
    };

    vm.addProduct = function (sku) {

      /* Cek apakah ada produk dengan kode SKU yang dimasukkan  */
      APIHandling.get('produk/list', {by_sku: sku}).then(function (response) {

          var l = response.data.data.length;

          /* Jika tidak ada, beri pesan error */
          if (l === 0) {
            toastr.error('Tidak ada produk dengan kode SKU: ' + sku, 'Produk tidak ada');
          } else if (response.data.data.length > 1) {
            toastr.error('Ada lebih dari 1 produk dengan SKU: ' + sku + '.<br><br>Terjadi kesalahan data. <strong>Segera Hubungi Administrator!!</strong>', 'Kesalahan Data');
          } else if ((l === 1) && (response.data.data[0].status ==='nw')) {
            toastr.error('Produk dengan Woo ID: ' + response.data.data[0].woo_id + ' dan SKU: ' + sku + ' hanya ada di sistem POS, dan tidak ada di Website.<br><br>Terjadi kesalahan data. <strong>Segera hubungi Administrator</strong>', 'Kesalahan Data');
          } else if ((l === 1) && (response.data.data[0].status ==='ok')) {
            var item = response.data.data[0];

            /* Jika ada, maka cek apa sudah ada di daftar atau belum */
            var tmp = _.find(vm.product, function (o) {
                return o.sku === item.sku;
            });

            /* Jika belum ada di daftar, maka masukkan dan tambahkan qty + 1 */
            if ( _.isUndefined(tmp)) {

              if (item.jumlah > 0) {

                item.detail = angular.fromJson(item.detail);

                var newProduct = {
                  produk_id: item.id,
                  sku: item.sku,
                  nama: item.nama,
                  detail: item.detail,
                  harga_jual: item.harga * 1,
                  jumlah: 1,
                  total: item.harga * 1,
                  discount_persen: 0,
                  discount_nominal: 0,
                  discount_total: 0,
                  jumlah_max: item.jumlah * 1,

                  /** Tambahan */
                  size: item.size,
                  weight: item.weight,
                  ket: item.ket,
                  family: _.find(item.detail.attributes, function(o) {
                    return o.name === "FAMILY";
                  })
                };

                /** Dapatkan data ukuran produk */
                newProduct.size = getProductSize(item);

                vm.product.unshift(newProduct);

                vm.calculateTotal();

              } else {
                // alert('Stok ' + item.sku + ' kosong atau tidak cukup');
                vm.stockHabis(item);
              }
            } else {
              if (item.jumlah >= ((tmp.jumlah * 1) + 1)) {
                /* Jika sudah ada, maka cukup tambahkan qty + 1 dan kalkulasi ulang total harga_jual */
                tmp.jumlah = (tmp.jumlah * 1) + 1;
                vm.changeStock(tmp);
              } else {
                // alert('Stok ' + item.sku + ' kosong atau tidak cukup');
                vm.stockHabis(item);
              }
            }
          }

      }, function (error) {
        /* Jika terjadi kesalahan saat http request */
        $log.error(error);
        toastr.error('Terjadi kesalahan saat mengambil data produk', 'Gagal');
      }).finally(function () {
          /*  Reset isi input untuk pengisian berikutnya */
          vm.sku = null;
          vm.selectedProduct = null;
      });

    };

    vm.addViaSKU = function (event) {
        /* Jika tombol enter ditekan  */
        /* Pastikan sku ada isinya sebelum diproses */
        if ((event.which === 13) && (vm.sku)) {
            vm.addProduct(vm.sku);
        }
    };

    vm.addViaSelect = function () {

        vm.addProduct(vm.selectedProduct.sku);
    };

    vm.removeStock = function (index) {

        vm.product.splice(index, 1);

        vm.calculateTotal();

    };

    vm.dialogBayar = function () {
        var modalInstance = $uibModal.open({
          animation: true,
          keyboard: false,
          backdrop: 'static',
          size: 'lg',
          templateUrl: 'app/components/modals/bayarDialog/BayarDialog.html',
          controller: 'BayarDialogController as vm',
          resolve: {
            data: function () {
              return {
                resume: vm.resume,
                product: vm.product,
                pembayaran: vm.pembayaran,
                id: vm.id
              };
            }
          }
        });

        modalInstance.result.then(function () {
          $state.go('main.pos.pending');
        }, function () {
          vm.verifyProductStock();
        });
    };

    vm.cancelTransaction = function() {
      var modalInstance = $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/components/modals/cancelTransaction/cancelTransactionDialog.html',
        controller: 'CancelTransactionDialogController as vm',
        resolve: {
          data: function () {
            return {
              resume: vm.resume
            };
          }
        }
      });

      modalInstance.result.then(function () {
        $state.go('main.pos.pending');
      }, function () {
        $log.info('Cancel');
      });
    };

    vm.initView = function () {
      vm.initResume();
      APIHandling.get('order/get', {id: $stateParams.id}).then( function (response) {

        if (response.data.cust_uuid !== null) {
          toastr.error('Transaksi Otoresell, tidak boleh diedit', "Transaksi Oresell");
          $state.go('main.pos.pending');
        }

        vm.resume = response.data;
        vm.resume.lain_lain = angular.fromJson(vm.resume.lain_lain);
        vm.pembayaran = response.data.pembayaran.data;
        // $log.debug(response.data);
        // $log.debug(response.data.pembayaran);
        // $log.debug(response.data.pembayaran.data);
        // $log.debug(vm.pembayaran);

        var map = [];
        var produk_jual = [];
        // vm.transaksi = response.data;
        vm.product = [];

        /* Data produk di server dipercah - pecah berdasar FIFO stok, */
        /* karena itu perlu dikelompokkan ulang berdasarkan id produk sehingga tidak terjadi duplikasi produk */
        _.each(response.data.produk_jual, function (item) {

          var index = _.indexOf(map, item.produk_id);

          if ( index < 0 ) {
            map.push(item.produk_id);
            produk_jual.push(item);
          } else {
            produk_jual[index].jumlah = (produk_jual[index].jumlah * 1) + (item.jumlah * 1);
            produk_jual[index].discount_persen = (produk_jual[index].discount_persen * 1) + (item.discount_persen * 1);
            produk_jual[index].discount_nominal = (produk_jual[index].discount_nominal * 1) + (item.discount_nominal * 1);
          }
        });

        vm.product = produk_jual;

        _.each(vm.product, function (item) {
          /* Jumlah max adalah jumlah yang sudah dipesan ditambah jumlah stok yang masih tersedia */
          item.jumlah_max = (item.jumlah * 1) + (item.current_stok * 1);
          item.jumlah_original = (item.jumlah * 1);

          item.detail = angular.fromJson(item.detail);

          /** Dapatkan data ukuran produk */
          item.size = getProductSize(item);

          /** Dapatkan data family produk */
          item.family = _.find(item.detail.attributes, function (o) {
            return o.name === 'FAMILY';
          });

          /* Hitung total masing - masing item */
          vm.calculateItemTotal(item);
        });

        /* Hitung total semua item */
        vm.calculateTotal();

      }, function (error) {
        if (error.status === 404) {
          toastr.error('Transaksi pending dengan id ' + $stateParams.id + ' tidak ditemukan', 'Gagal');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data transaksi', 'Gagal');
          $log.error(error);
        }
      });
    };

    vm.bulk = {
      persen: {
        show: false,
        value: 0,
        change: function () {
          _.each(vm.product, function (item) {
            item.discount_persen = vm.bulk.persen.value;
            vm.changeStock(item);
          });
          vm.calculateTotal();
        }
      },
      nominal: {
        show: false,
        value: 0,
        change: function () {
          _.each(vm.product, function (item) {
            item.discount_nominal = vm.bulk.nominal.value;
            vm.changeStock(item);
          });
          vm.calculateTotal();
        }
      }
    };

    vm.initView();

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainPosPaymentHistoryController', MainPosPaymentHistoryController);

  /** @ngInject */
  function MainPosPaymentHistoryController($log, APIHandling, moment, _, $uibModal, $scope, Papa, saveAs, toastr) {

    var vm = this;
    vm.paymentList;
    vm.isLastPage = false;
    vm.today = new Date();
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.filter = {
      page : 1,
      per_page :10,
      by_sku : null,
      tgl_min : null,
      tgl_max : null,
      mode : 1, /* mode 0 = semua, 1 = dibayar, 2 = pending */
      tgl_opt : 4 /* Di antara tgl_min dan tgl_max */
    };

    vm.showDetail = function (id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/components/modals/DetailTransaksi/DetailTransaksiDialog.html',
        controller: 'DetailTransaksiDialogController as vm',
        resolve: {
          data: function () {
            return id;
          }
        }
      });
    };

    vm.inProcess = false;

    vm.initView = function (page) {

      vm.filter.page = page;
      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }

      filter.order_by = 'by_tgl';
      filter.sorting =  'desc';
      filter.by_nominal = filter.by_nominal || null;

      APIHandling.get('payment/list', filter).then(function (response) {
        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.paymentList = response.data.data;
        vm.shownPage = filter.page;
      }, function (error) {
        $log.error(error);
        if (error.status === 408) {
          toastr.error(error.data.message, 'Terjadi Kesalahan');
        } else {
          toastr.error('Terjadi kesalahan saat mengambil data pembayaran', 'Terjadi Kesalahan');
        }
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page))  {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainPosCashierController', MainPosCashierController);

  /** @ngInject */
  function MainPosCashierController($log, _, toastr, APIHandling, $uibModal, store) {

    var vm = this;
    vm.product = [];
    vm.inProcess = false;

    vm.initResume = function () {
      vm.resume = {
          total_akhir: 0,
          bayar: 0,
          discount_transaction_total: 0,
          sisa_kembali: 0
      };
    };

    vm.verifyProductStock = function () {

      var list_id = _.map(vm.product, 'produk_id');

      APIHandling.get( 'produk/list', { list_produk_id: list_id }).then(function (response) {

        _.each(vm.product, function (n) {

          var item = _.find(response.data.data, { id: n.produk_id });
          n.jumlah_max = item.jumlah;

        });

      }, function () {
        toastr.error('Gagal cek stok produk', 'Gangguan');
      });
    };

    vm.initView = function () {
        vm.initResume();

        var product = store.get('order') || [];
        vm.product = _.cloneDeep(product);

        if (vm.product.length > 0) {
          vm.verifyProductStock();
        }
    };

    vm.getProducts = function (search) {
      if (search.length >= 3) {
        APIHandling.get('produk/list', {search : search, only_with_sku: 1}).then(function (response) {
            vm.productList = response.data.data;
        });
      }
    };

    vm.calculateTotal = function () {
        var total = _.reduce(vm.product, function (sum, item) {
            return (sum * 1) + (item.total * 1);
        }, 0);

        vm.resume.total = total;
    };

    vm.stockHabis = function (item) {
      $uibModal.open({
        animation: true,
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'app/components/modals/stockHabis/stockHabis.html',
        controller: 'StockHabisController as vm',
        resolve: {
          data: function () {
            return {
              product: item
            };
          }
        }
      });
    };

    vm.changeStock = function (item) {

        if (item.jumlah >= 1) {
          item.discount_total = ((item.discount_persen / 100) * (item.harga_jual * item.jumlah)) + (item.discount_nominal * 1);
          item.total = (item.harga_jual * item.jumlah) - (item.discount_total * 1);
          store.set('order', vm.product);
          vm.calculateTotal();
        }
    };

    vm.addProduct = function (sku) {

      /* Cek apakah ada produk dengan kode SKU yang dimasukkan  */
      APIHandling.get('produk/list', {by_sku: sku}).then(function (response) {

          var l = response.data.data.length;

          /* Jika tidak ada, beri pesan error */
          if (l === 0) {
            toastr.error('Tidak ada produk dengan kode SKU: ' + sku, 'Produk tidak ada');
          } else if (response.data.data.length > 1) {
            toastr.error('Ada lebih dari 1 produk dengan SKU: ' + sku + '.<br><br>Ada kesalahan data. <strong>Segera Hubungi Administrator!!</strong>', 'Kesalahan Data');
          } else if ((l === 1) && (response.data.data[0].status ==='nw')) {
            toastr.error('Produk dengan Woo ID: ' + response.data.data[0].woo_id + ' dan SKU: ' + sku + ' hanya ada di sistem POS, dan tidak ada di Website.<br><br>Terjadi kesalahan data. <strong>Segera hubungi Administrator</strong>', 'Kesalahan Data');
          } else if ((l === 1) && (response.data.data[0].status ==='ok')) {
            var item = response.data.data[0];

            /* Jika ada, maka cek apa sudah ada di daftar atau belum */
            var tmp = _.find(vm.product, function (o) {
                return o.sku === item.sku;
            });

            /* Jika belum ada di daftar, maka masukkan dan tambahkan qty + 1 */
            if ( _.isUndefined(tmp)) {

              if (item.jumlah > 0) {

                item.detail = angular.fromJson(item.detail);

                var newProduct = {
                    produk_id   : item.id,
                    sku         : item.sku,
                    nama        : item.nama,
                    detail      : item.detail,
                    harga_jual  : (item.harga * 1),
                    jumlah      : 1,
                    total       : (item.harga * 1),
                    discount_persen : 0,
                    discount_nominal : 0,
                    discount_total : 0,
                    jumlah_max : (item.jumlah * 1),

                    /** Tambahan */
                    size: item.size,
                    weight: item.weight,
                    ket: item.ket,
                    family: _.find(item.detail.attributes, function (o) {
                      return o.name === 'FAMILY';
                    })
                };

                /** Dapatkan data ukuran produk */
                /** Ini cara lama, tabel baru sudah ada elemen size */
                // if (item.detail.attributes) {
                //   newProduct.size = _.find(item.detail.attributes, function (o) {
                //     return o.name === 'SIZE';
                //   }).option;
                // } else {
                //   newProduct.size = _.find(item.detail, function (o) {
                //   return o.name === 'SIZE';
                //   }).option;
                // }

                vm.product.unshift(newProduct);

                vm.calculateTotal();

                store.set('order', vm.product);
              } else {
                // alert('Stok ' + item.sku + ' kosong atau tidak cukup');
                vm.stockHabis(item);
              }
            } else {
              if (item.jumlah >= ((tmp.jumlah * 1) + 1)) {
                /* Jika sudah ada, maka cukup tambahkan qty + 1 dan kalkulasi ulang total harga_jual */
                tmp.jumlah = (tmp.jumlah * 1) + 1;
                vm.changeStock(tmp);
              } else {
                // alert('Stok ' + item.sku + ' kosong atau tidak cukup');
                vm.stockHabis(item);
              }
            }
          }

      }, function (error) {
        /* Jika terjadi kesalahan saat http request */
        $log.error(error);
        toastr.error('Terjadi kesalahan saat mengambil data produk', 'Gagal');
      }).finally(function () {
          /*  Reset isi input untuk pengisian berikutnya */
          vm.sku = null;
          vm.selectedProduct = null;
      });

    };

    vm.addViaSKU = function (event) {
        /* Jika tombol enter ditekan  */
        /* Pastikan sku ada isinya sebelum diproses */
        if ((event.which === 13) && (vm.sku)) {
            vm.addProduct(vm.sku);
        }
    };

    vm.addViaSelect = function () {

        vm.addProduct(vm.selectedProduct.sku);
    };

    vm.removeStock = function (index, item) {

        $log.info(item);

        vm.product.splice(index, 1);

        store.set('order', vm.product);

        vm.calculateTotal();

    };

    vm.clearTransaction = function () {

      vm.product = [];
      store.set('order', vm.product);
      vm.initResume();
      vm.calculateTotal();
    };

    vm.dialogBayar = function () {
        $log.info('Buka dialog bayar');
        $log.info('Data resume');
        $log.info(vm.resume);

        $log.info('Data produk');
        $log.info(vm.product);

        var modalInstance = $uibModal.open({
          animation: true,
          keyboard: false,
          backdrop: 'static',
          size: 'lg',
          templateUrl: 'app/components/modals/bayarDialog/BayarDialog.html',
          controller: 'BayarDialogController as vm',
          resolve: {
            data: function () {
              return {
                resume: vm.resume,
                product: vm.product,
                id: null
              };
            }
          }
        });

        modalInstance.result.then(function () {
          vm.clearTransaction();
        }, function () {
          vm.verifyProductStock();
        });
    };

    vm.bulk = {
      persen: {
        show: false,
        value: 0,
        change: function () {
          _.each(vm.product, function (item) {
            item.discount_persen = vm.bulk.persen.value;
            vm.changeStock(item);
          });
          vm.calculateTotal();
        }
      },
      nominal: {
        show: false,
        value: 0,
        change: function () {
          _.each(vm.product, function (item) {
            item.discount_nominal = vm.bulk.nominal.value;
            vm.changeStock(item);
          });
          vm.calculateTotal();
        }
      }
    };

    vm.initView();
    vm.calculateTotal();

  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller(
      "MainAdministrasiWhatsappController",
      MainAdministrasiWhatsappController
    );

  /** @ngInject */
  function MainAdministrasiWhatsappController(toastr, APIHandling) {
    var vm = this;

    vm.nomor = null;
    vm.pesan = null;

    vm.inProcess = false;

    function preparePhone(phone) {
      /** Hilangkan semua karakter non-digit */
      var number = phone.replace(/\D/g, "");

      /** Ganti angka 0 menjadi 62 di awal nomor */
      number = number.replace(/^0/, "62");

      return number;
    }

    vm.sendMessage = function () {
      var number = preparePhone(vm.nomor);
      APIHandling.post("whatsapp/send-message", { number: number, message: vm.pesan }).then(
        function () {
          toastr.success("Berhasil mengirim pesan", "Sukses");
        },
        function () {
          toastr.error("Gagal mengirim pesan", "Gagal");
        }
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiUsersController', MainAdministrasiUsersController);

  /** @ngInject */
  function MainAdministrasiUsersController(APIHandling, $log, $uibModal, $filter) {

    var vm = this;
    vm.userList;
    vm.currentUser = APIHandling.getCurrentUser();

    vm.initView = function () {
      APIHandling.get('user/list').then(function (response) {
        vm.userList = $filter('fm-detail') (response.data.data);
      });
    };

    vm.userModal = function (user) {

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/editUser/editUserDialog.html',
        controller: 'EditUserDialogController as vm',
        resolve: {
          data: function () {
            return user;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.deleteUser = function (user) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/deleteUser/deleteUserDialog.html',
        controller: 'DeleteUserDialogController as vm',
        resolve: {
          data: function () {
            return user;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView();
      });
    };

    vm.initView();

  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiTiktokController', MainAdministrasiTiktokController);

  /** @ngInject */
  function MainAdministrasiTiktokController($log, XLSX, _, APIHandling, saveAs, $q, toastr) {
    var vm = this;

    vm.inProcess = false;
    vm.doSync = false;
    vm.connectURL = null;
    vm.isConnected = false;

    var uploadFile = angular.element('#uploadedFile');

    uploadFile.on('change', function (e) {

      var file = e.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {

        angular.element('.loading-animation').show();

        var data = e.target.result;
        var workbook = XLSX.read(data, { type: 'binary'});

        var allPromises = [];

        /**
         *  Posisi [SKU, STOK]:
         *  Contoh:
         *  [I, L], [N, Q], [S, V], [X, AA], [AC, AF], [AH, AK], [AM, AP], [AR, AU], [AW, AZ],
         *  [BB, BE], [BG, BJ], [BL, BO], [BQ, BT], [BV, BY], [CA, CD]
         *
         *  Sesuaikan dengan posisi yg ada di file excel dari Tiktok
         */
        var dataPosition = [
          ['I', 'H']
        ];

        // console.log(workbook);
        var ws = workbook.Sheets.Template;

        //** Area kerjanya */
        /**
         * Data mulai dari baris ke-6
         */
        var minRow = 5;

        /** ws['!ref'] berisi data range worksheed. Contoh isinya: A1:CD984 */
        /** Ambil data baris terakhir dari hasil tsb. Gunakan regex untuk ambil data barisnya. */
        // var maxRow = ws['!ref'].split(':')[1].match(/\d+$/)[0] * 1;
        // $log.info(Object.keys(ws).pop().match(/\d+$/)[0] * 1);

        /**
         * Sayangnya data range dari tiktok tidak valid. Terpaksa cari cara lain
         * untuk mendapatkan range worksheet.
         */
        var lastCell = Object.keys(ws).pop();
        var maxRow = lastCell.match(/\d+$/)[0] * 1;


        /**
         * Coba perbaiki metadata
         */
        ws['!ref'] = 'A1:' + lastCell;

        $log.info('Total baris dibaca: ' + maxRow);
        var i;

        var dataProduct = [];
        var dataOnServer = [];
        var list_sku = [];

        for (i = minRow; i <= maxRow; i++) {

          // $log.info('Baca data baris: ' + i);


          _.each(dataPosition, function (n) {
            var sku = ws[n[0] + i] ? ws[n[0] + i].v : null;
            if (sku) {

              dataProduct.push({
                sku: sku.trim(),
                row: i,
                column: n
              });

              list_sku.push(sku);

              // var stok = ws[n[1] + i] ? ws[n[1] + i].v : null;
              // $log.log('SKU: ' + sku + ' stok: ' + stok);
            }

          });
        }

        if (list_sku.length > 0) {

          var skuChunk = _.chunk(list_sku, 100);

          // $log.info(skuChunk);

          _.each(skuChunk, function (list) {
            var filter = {
              list_sku: list,
              per_page: 100
            };

            var tmp = APIHandling.get('produk/list', filter);

            allPromises.push(tmp);
          });

        }



        $q.all(allPromises).then(function (result) {

          // $log.info('Selesai semua proses. Download hasil');
          // $log.info(result);

          _.each(result, function (dataRow) {
            dataOnServer = dataOnServer.concat(dataRow.data.data);
          });

          // $log.info(dataOnServer);
          // $log.info(dataProduct);

          _.each(dataProduct, function (product) {

            // $log.info('Proses produk');
            // $log.info(product);

            var tmp = _.find(dataOnServer, function (n) {
              return n.sku == product.sku;
            });

            if (tmp) {
              var jumlah = tmp.jumlah;

              if( ws[product.column[1] + product.row].v != jumlah) {
                // $log.info(ws[product.column[1] + product.row]);
                ws[product.column[1] + product.row].v = jumlah;
                ws[product.column[1] + product.row].t = 's';
                ws[product.column[1] + product.row].w = jumlah.toString();
                ws[product.column[1] + product.row].h = jumlah.toString();
              }

              // $log.info('SKU: ' + product.sku + ' stok akhir: ' + jumlah);
            }


          });

          var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };

          var wbout = XLSX.write(workbook, wopts);

          function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }

          saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "result.xlsx");
          angular.element('.loading-animation').hide();
        });

      };

      reader.readAsBinaryString(file);

    });

    vm.syncProduct = function () {
      vm.inProcess = true;
      APIHandling.get('newtiktok/sync-product').then(function (response) {
        vm.inProcess = false;
        vm.doSync = true;
        $log.info(response);
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal sinkronisasi produk Tiktok');
      });
    };

    vm.generateURL = function() {
      vm.inProcess = true;
      APIHandling.get('newtiktok/generate-url').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.connectURL = response.data.url;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal generate URL koneksi TikTok Store');
      });
    };

    vm.initView = function () {
      vm.inProcess = true;
      APIHandling.get('newtiktok/check-connected').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.isConnected = response.data.isConnected;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal cek koneksi Tiktok Store');
      });
    };

    vm.initView();


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiSinkronisasiController', MainAdministrasiSinkronisasiController);

  /** @ngInject */
  function MainAdministrasiSinkronisasiController($log, _, moment, toastr, APIHandling, $scope) {

    var vm = this;
    vm.inProcess = false;
    vm.importValid = true;

    vm.today = new Date();

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.option = {
      all : '1',
      updated_min : null,
      updated_max : null
    };

    vm.option1 = {
      updated_min : null,
      updated_max : null,
      jamAwal : null,
      jamAkhir : null
    };

    vm.time = {
      min: null,
      max: null
    };

    vm.updateProductWoo = function (type) {

        vm.inProcess = true;
        var option = {
          all: vm.option.all
        };

        switch(type) {
          case 0:
            option.updated_min = moment().hour(0).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss');
            option.updated_max = moment().hour(23).minute(59).second(59).format('YYYY-MM-DD HH:mm:ss');
            break;
          case 1:
            option.updated_min = null;
            option.updated_max = null;
            break;
          case 2:
            option = _.cloneDeep(vm.option);
            option.updated_min = option.updated_min ? moment(option.updated_min).hour(0).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss') : null;
            option.updated_max = option.updated_max ? moment(option.updated_max).hour(23).minute(59).second(59).format('YYYY-MM-DD HH:mm:ss') : null;
            break;
        }

        APIHandling.post('produk/update-woo', option, true).then(function () {
            toastr.info('Proses update data di Woocoomerce sedang berjalan.<br><br><strong>Anda tidak perlu menunggu dan bisa melanjutkan pekerjaan lain</strong>', 'Proses Berjalan', {timeOut: 20000});
        }, function (error) {
            toastr.error('Gagal update data produk di Woocoomerce', 'Upate gagal');
            $log.debug(error);
        }).finally(function () {
            vm.inProcess = false;
            // $scope.main.message = '';
            // angular.element('.loading-animation').hide();
        });
    };


    /**
     * Import produk dari Woocoomerce
     * Params: type integer (0: perubahan hari ini, 1: semua produk, 2: custom time range)
     */
    vm.importProductWoo = function (type) {

      var data = {
        updated_at_min: null,
        updated_at_max: null
      };

      switch(type) {
        case 0:

          /** Woo sudah menyimpan sesuai setting WP, dalam hal ini UTC+7 */
          data = {
            updated_at_min: moment().hour(0).minute(0).second(0).format('YYYY-MM-DDTHH:mm:ss'),
            updated_at_max: moment().format('YYYY-MM-DDTHH:mm:ss')
          };
          break;
        case 1:
          break;
        case 2:

          /** Woo sudah menyimpan sesuai setting WP, dalam hal ini UTC+7 */
          data = {
            updated_at_min: vm.option1.updated_min ? moment(vm.time.min).format('YYYY-MM-DDTHH:mm:ss') : null,
            updated_at_max: vm.option1.updated_max ? moment(vm.time.max).format('YYYY-MM-DDTHH:mm:ss') : null
          };
          break;
      }

      vm.inProcess = true;
      $scope.main.message = 'Mengambil data produk dari web ke aplikasi Simple POS. Harap tunggu...';
      angular.element('.loading-animation').show();

      APIHandling.get('produk/import-woo', data).then(function () {
          toastr.success('Berhasil import data dari Woocoomerce ke aplikasi', 'Import berhasil');
      }, function (error) {
          toastr.error('Gagal import data produk dari Woocoomerce', 'Import gagal');
          $log.debug(error);
      }).finally(function () {
          vm.inProcess = false;
          $scope.main.message = '';
          angular.element('.loading-animation').hide();
      });
    };

    vm.checkValid = function () {

      var valid = ((vm.option1.updated_min && vm.option1.jamAwal && vm.option1.updated_max && vm.option1.jamAkhir ) || (!vm.option1.updated_min && !vm.option1.jamAwal && !vm.option1.updated_max && !vm.option1.jamAkhir ));

      if (valid && vm.option1.updated_min) {
        vm.time.min = new Date(vm.option1.updated_min.getFullYear(), vm.option1.updated_min.getMonth(), vm.option1.updated_min.getDate(), vm.option1.jamAwal.getHours(), vm.option1.jamAwal.getMinutes());

        vm.time.max = new Date(vm.option1.updated_max.getFullYear(), vm.option1.updated_max.getMonth(), vm.option1.updated_max.getDate(), vm.option1.jamAkhir.getHours(), vm.option1.jamAkhir.getMinutes());

        vm.importValid = (valid && (vm.time.min < vm.time.max));
      } else {
        vm.importValid = valid;
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiShopeeController', MainAdministrasiShopeeController);

  /** @ngInject */
  function MainAdministrasiShopeeController($log, XLSX, _, APIHandling, saveAs, $q, toastr) {
    var vm = this;

    vm.inProcess = false;
    vm.doSync = false;
    vm.connectURL = null;
    vm.isConnected = false;
    vm.minRow = 6;
    vm.skuColumn = 'F';
    vm.stockColumn = 'H';

    var uploadFile = angular.element('#uploadedFile');

    uploadFile.on('change', function (e) {

      var file = e.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {

        angular.element('.loading-animation').show();

        var data = e.target.result;
        var workbook = XLSX.read(data, { type: 'binary'});

        var allPromises = [];

        /**
         *  Posisi [SKU, STOK]:
         *  Contoh:
         *  [I, L], [N, Q], [S, V], [X, AA], [AC, AF], [AH, AK], [AM, AP], [AR, AU], [AW, AZ],
         *  [BB, BE], [BG, BJ], [BL, BO], [BQ, BT], [BV, BY], [CA, CD]
         *
         *  Sesuaikan dengan posisi yg ada di file excel dari Shopee
         */
        var dataPosition = [
          [vm.skuColumn, vm.stockColumn]
        ];

        $log.info(dataPosition);

        // console.log(workbook);
        var ws = workbook.Sheets.Sheet1;

        //** Area kerjanya */
        /**
         * Data mulai dari baris ke-7
         */
        var minRow = vm.minRow;
        $log.info('Baris awal: ' + minRow);

        /** ws['!ref'] berisi data range worksheed. Contoh isinya: A1:CD984 */
        /** Ambil data baris terakhir dari hasil tsb. Gunakan regex untuk ambil data barisnya. */
        var maxRow = ws['!ref'].split(':')[1].match(/\d+$/)[0] * 1;
        $log.info('Total baris dibaca: ' + maxRow);
        var i;

        var dataProduct = [];
        var dataOnServer = [];
        var list_sku = [];

        for (i = minRow; i <= maxRow; i++) {

          // $log.info('Baca data baris: ' + i);


          _.each(dataPosition, function (n) {
            var sku = ws[n[0] + i] ? ws[n[0] + i].v : null;
            if (sku) {

              dataProduct.push({
                sku: sku.trim(),
                row: i,
                column: n
              });

              list_sku.push(sku);

              // var stok = ws[n[1] + i] ? ws[n[1] + i].v : null;
              // $log.log('SKU: ' + sku + ' stok: ' + stok);
            }

          });
        }

        if (list_sku.length > 0) {

          var skuChunk = _.chunk(list_sku, 100);

          // $log.info(skuChunk);

          _.each(skuChunk, function (list) {
            var filter = {
              list_sku: list,
              per_page: 100
            };

            var tmp = APIHandling.get('produk/list', filter);

            allPromises.push(tmp);
          });

        }



        $q.all(allPromises).then(function (result) {

          // $log.info('Selesai semua proses. Download hasil');
          // $log.info(result);

          _.each(result, function (dataRow) {
            dataOnServer = dataOnServer.concat(dataRow.data.data);
          });

          // $log.info(dataOnServer);
          // $log.info(dataProduct);

          _.each(dataProduct, function (product) {

            // $log.info('Proses produk');
            // $log.info(product);

            var tmp = _.find(dataOnServer, function (n) {
              return n.sku == product.sku;
            });

            if (tmp) {
              var jumlah = tmp.jumlah;

              ws[product.column[1] + product.row].v = jumlah;

              // $log.info('SKU: ' + product.sku + ' stok akhir: ' + jumlah);
            }


          });

          var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };

          var wbout = XLSX.write(workbook, wopts);

          function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }

          saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "result.xlsx");
          angular.element('.loading-animation').hide();
        });

      };

      reader.readAsBinaryString(file);

    });

    vm.syncProduct = function () {
      vm.inProcess = true;
      APIHandling.get('newshopee/sync-product').then(function (response) {
        vm.inProcess = false;
        vm.doSync = true;
        $log.info(response);
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal sinkronisasi produk Shopee');
      });
    };

    vm.generateURL = function() {
      vm.inProcess = true;
      APIHandling.get('newshopee/generate-url').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.connectURL = response.data.url;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal generate URL koneksi Shopee Store');
      });
    };

    vm.initView = function () {
      vm.inProcess = true;
      APIHandling.get('newshopee/check-connected').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.isConnected = response.data.isConnected;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal cek koneksi Shopee Store');
      });
    };

    vm.initView();


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiProductDoubleController', MainAdministrasiProductDoubleController);

  /** @ngInject */
  function MainAdministrasiProductDoubleController($log, APIHandling, toastr) {

    var vm = this;

    vm.productList = [];

    vm.deleteDobel = function() {
      APIHandling.post('produk/delete-dobel', null, true).then(function (response) {
        toastr.success('Berhasil hapus ' + response.data.total_row_deleted + ' produk dobel', 'Berhasil');
        vm.initView();
      }, function (error) {
        toastr.error('Gagal hapus dobel', 'Gagal');
        $log.error(error);
      });
    };

    vm.initView = function () {

      APIHandling.get('produk/list-dobel').then(function (response) {
        vm.productList = response.data;
      });
    };

    vm.initView();

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiProductController', MainAdministrasiProductController);

  /** @ngInject */
  function MainAdministrasiProductController($log, APIHandling, $filter, toastr, $scope, $window, $uibModal, _) {

    var vm = this;

    vm.productList = [];
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.itemCheckbox = [];
    vm.shownPage = 1;

    vm.filter = {
      by_sku : null,
      search : null,
      only_with_sku: 1,
      only_with_stok: 0,
      per_page : 10,
      woo_only: 0
    };

    vm.verify = function () {

      $scope.main.message = 'Melakukan proses verifikasi produk. Harap tunggu...';
      angular.element('.loading-animation').show();

      APIHandling.get('compare-woo').then(function () {
        toastr.success('Berhasil melakukan verifikasi ulang produk', 'Selesai');
      }, function (error) {
        toastr.error('Terjadi kesalahan saat proses verifikasi ulang produk', 'Gagal');
        $log.error(error);
      }).finally (function () {
        $scope.main.message = '';
        angular.element('.loading-animation').hide();
      });
    };

    vm.changeCheckAll = function () {

      for (var i = 0; i < 10; i++) {
        vm.itemCheckbox[i] = vm.checkAll;
      }

    };

    vm.clearSelection = function () {
      vm.checkAll = false;
      for (var i = 0; i < 10; i++) {
        vm.itemCheckbox[i] = false;
      }
    };

    vm.deleteSelected = function () {
      var toDel = [];

      _.each(vm.itemCheckbox, function (item, n) {
        if (item && vm.productList[n]) {
          if (vm.productList[n].status === 'nw') {
            toDel.push(vm.productList[n].id);
          }
        }
      });

      if (_.isEmpty(toDel)) {
        toastr.info('Pilih dulu produk - produk yang akan dihapus', 'Tidak ada produk yang dipilih');
      } else {
        APIHandling.post('produk/delete', {list_id: toDel}, true).then(function () {
          vm.initView(1);
          toastr.success('Berhasil menghapus produk - produk yang dipilih', 'Berhasi hapus');
        }, function (error) {
          $log.error(error);

          if (error.status === 423) {
            toastr.error('Tidak bisa menghapus produk yang masih memiliki stok', 'Gagal hapus');
          } else if (error.status === 404) {
            toastr.error('Produk yang hendak dihapus sudah tidak ada', 'Gagal hapus');
          } else {
            toastr.error('Terjadi kesalahan saat proses menghapus produk', 'Gagal hapus');
          }

        });
      }
    };

    vm.deleteNonWoo = function () {
      var confirm = $window.confirm('Anda hendak menghapus SEMUA produk yg tidak ada di website. Yakin ?');

      if (confirm) {
        APIHandling.post('produk/delete-nw', null, true).then(function () {
          vm.initView(1);
          toastr.success('Berhasil menghapus produk - produk yang tidak ada di web', 'Berhasi hapus');
        }, function (error) {
          $log.error(error);
          toastr.error('Terjadi kesalahan saat proses menghapus produk', 'Gagal hapus');
        });
      }

    };

    vm.editDiskonOtoreseller = function (item) {
      $uibModal.open({
        animation: true,
        size: 'md',
        templateUrl: 'app/components/modals/editDiskonOtoreseller/editDiskonOtoresellerDialog.html',
        controller: 'EditDiskonOtoresellerDialogController as vm',
        resolve: {
          data: function () {
            return item;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.syncProduk = function (item) {
      APIHandling.get('update-from-woo', { id: item.woo_id }).then(function () {
        toastr.success('Berhasil sync produk', 'Sukses');
        vm.initView(vm.filter.page);
      }, function () {
          toastr.error('Gagal sync produk', 'Gagal');
      });
    };

    vm.initView = function (page) {

      vm.filter.page = page;

      /* Pastikan search ada isinya atay null, kalau tidak, akan memperoleh hasil query yang salah */
      vm.filter.search = vm.filter.search || null;

      var filter = _.cloneDeep(vm.filter);

      APIHandling.get('produk/list', filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        /* Filter data detail produk, ubah yang sebelumnya cuma data teks, menjadi object */
        vm.productList = $filter ('fm-detail') (response.data.data);
        vm.shownPage = filter.page;
        vm.clearSelection();

      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page))  {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiOresellBroadcastController', MainAdministrasiOresellBroadcastController);

  /** @ngInject */
  function MainAdministrasiOresellBroadcastController($log, Oresell) {
    var vm = this;

    vm.broadcast = {
      title: null,
      message: null,
    };

    vm.submitBroadcast = function () {
      $log.log(vm.broadcast);
      Oresell.broadcast.send(vm.broadcast).then(function (result) {
        $log.log(result);
      });
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiOresellController', MainAdministrasiOresellController);

  /** @ngInject */
  function MainAdministrasiOresellController($uibModal, $log, Oresell, Papa, saveAs, toastr, $scope, _) {
    var vm = this;

    vm.filter = {
      page: 1,
      email: null,
      name: null,
      level: null,
      status: null,
      gclid: null
    };

    vm.isLastPage = false;
    vm.maxPage = null;

    vm.statusReseller = function (reseller) {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/editStatusResellerDialog/editStatusResellerDialog.html',
        controller: 'EditStatusResellerDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.upline = function (reseller) {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/uplineResellerDialog/uplineResellerDialog.html',
        controller: 'UplineResellerDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deposit = function (reseller) {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/editDepositDialog/editDepositDialog.html',
        controller: 'EditDepositDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      }).result.then(function() {
        vm.initView(vm.filter.page);
      });
    };

    vm.setDiscountLevelReseller = function () {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/diskonLevelResellerDialog/diskonLevelResellerDialog.html',
        controller: 'DiskonLevelResellerDialogController as vm'
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.resetPasswordReseller = function (reseller) {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/resetPasswordResellerDialog/resetPasswordResellerDialog.html',
        controller: 'ResetPasswordResellerDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      });
    };

    vm.settingOresell = function () {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/settingOtoresellDialog/settingOtoresellDialog.html',
        controller: 'SettingOtoresellDialogController as vm'
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.toggleGCLID = function() {
      vm.filter.gclid = vm.filter.gclid ? null : 1;
      vm.getReseller(1);
    };

    vm.getReseller = function (page) {

      vm.filter.page = page || vm.filter.page;

      var filter = _.cloneDeep(vm.filter);

      Oresell.reseller.list(vm.filter).then(function (response) {
        vm.resellerList = response.data.users;

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.shownPage = filter.page;
      }, function (error) {
        $log.error(error);
      });
    };

    vm.showDetail = function(reseller) {
      $uibModal
        .open({
          animation: true,
          size: 'md',
          backdrop: 'static',
          templateUrl:
            'app/components/modals/DetailReseller/DetailResellerDialog.html',
          controller: 'DetailResellerDialogController as vm',
          resolve: {
            data: function () {
              return reseller;
            },
          },
        });
    };

    vm.deleteReseller = function(reseller) {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/deleteReseller/deleteResellerDialog.html',
        controller: 'DeleteResellerDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.deleteInactiveReseller = function () {
      $uibModal.open({
        animation: true,
        size: 'md',
        backdrop: 'static',
        templateUrl: 'app/components/modals/deleteInactiveReseller/deleteInactiveResellerDialog.html',
        controller: 'DeleteInactiveResellerDialogController as vm'
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    function getData(page, filter, currentData, callback) {


      filter.per_page = 500;
      var reseller = currentData;

      filter.page = page;

      Oresell.reseller.list(filter).then(function (response) {

        reseller = reseller.concat(response.data.users);

        if (response.data.users.length === filter.per_page) {
          getData(page + 1, filter, reseller, callback);
        } else {
          callback(reseller);
        }
      }, function (error) {
        $log.error(error);
        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;
        toastr.error('Terjadi kesalahan saat download riwayat transaksi', 'Gagal');
      });
    }

    vm.downloadReseller = function () {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            username: item.email,
            nama: item.name,
            phone: item.phone,
            level: item.level_description,
            saldo_deposit: (item.balance * 1),
            status: item.status
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'reseller_';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.listDeposit = function(reseller) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        backdrop: 'static',
        templateUrl: 'app/components/modals/listOtoresellDepositDialog/listOtoresellDepositDialog.html',
        controller: 'ListOtoresellDepositDialogController as vm',
        resolve: {
          data: function () {
            return reseller;
          }
        }
      }).result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView = function (page) {
      vm.getReseller(page);
    };

    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller(
      'MainAdministrasiMutasiOresellController',
      MainAdministrasiMutasiOresellController
    );

  /** @ngInject */
  function MainAdministrasiMutasiOresellController(
    $uibModal,
    $log,
    Oresell,
    _,
    moment,
    $scope,
    toastr,
    $filter,
    Papa,
    saveAs
  ) {
    var vm = this;

    vm.filter = {
      page: 1,
      tglAwal: null,
      tglAkhir: null,
      id: null,
      type: null,
      flow: null,
      debet: null,
      credit: null,
      description: null,
      user: null
    };

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.isLastPage = false;
    vm.maxPage = null;


    vm.listDeposit = function(page) {
      vm.filter.page = page || vm.filter.page;

      var filter = _.cloneDeep(vm.filter);

      filter.tglAwal = vm.filter.tglAwal
        ? moment(vm.filter.tglAwal).format('YYYY-MM-DD')
        : null;
      filter.tglAkhir = vm.filter.tglAkhir
        ? moment(vm.filter.tglAkhir).format('YYYY-MM-DD')
        : null;

      Oresell.reseller.listDeposit(filter).then(
        function(response) {
          vm.depositList = response.data;

          _.each(vm.depositList.deposit, function(n) {
            var tmp = n.description.split('#');

            if (tmp.length > 1) {
              tmp = tmp[1].split(' ');
              n.trxId = tmp[0];
            }
          });

          if (page === 1) {
            vm.maxPage = response.data.max_page * 1 || 1;
          }

          /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
          if (page === vm.maxPage) {
            vm.isLastPage = true;
          } else {
            vm.isLastPage = false;
          }

          vm.shownPage = filter.page;
        },
        function(error) {
          $log.error(error);
        }
      );
    };

    function getData(page, filter, currentData, callback) {

      filter.per_page = 500;
      var mutationData = currentData;

      filter.page = page;

      Oresell.reseller.listDeposit(filter).then(function (response) {
        mutationData = mutationData.concat(response.data.deposit);

        if (response.data.deposit.length === filter.per_page) {
          getData(page + 1, filter, mutationData, callback);
        } else {
          callback(mutationData);
        }


      }, function (error) {
        $log.error(error);
          angular.element(".loading-animation").hide();
          $scope.main.message = "";
          vm.inProcess = false;
          toastr.error(
            "Terjadi kesalahan saat download mutasi reseller",
            "Gagal"
          );
      });
    }

    vm.downloadMutasi = function () {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.tglAwal = vm.filter.tglAwal
        ? moment(vm.filter.tglAwal).format('YYYY-MM-DD')
        : null;
      filter.tglAkhir = vm.filter.tglAkhir
        ? moment(vm.filter.tglAkhir).format('YYYY-MM-DD')
        : null;

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            waktu: item.trx_date,
            reseller: item.owner,
            bank: item.bank,
            jenis: item.type,
            keterangan: item.description,
            debet: item.debet * 1,
            kredit: item.credit * 1,
            saldo: item.balance * 1,
            user: item.updated_by
          });
        });

        result = $filter('orderBy')(result, 'waktu', false);

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'mutasi_reseller';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.detailTrx = function(id) {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl:
          'app/components/modals/DetailTransaksi/DetailTransaksiDialog.html',
        controller: 'DetailTransaksiDialogController as vm',
        resolve: {
          data: function() {
            return id;
          },
        },
      });
    };

    vm.changePage = function(page) {
      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }
    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function(page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView = function(page) {
      vm.listDeposit(page);
    };

    vm.initView(1);
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiLogLevelOresellController', MainAdministrasiLogLevelOresellController);

  /** @ngInject */
  function MainAdministrasiLogLevelOresellController($uibModal, $log, Oresell, _, moment) {
    var vm = this;

    vm.filter = {
      page: 1,
      user: null,
      startDate: null,
      endDate: null,
      per_page: 10
    };

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.isLastPage = false;
    vm.maxPage = null;

    vm.listLogLevel = function (page) {

      vm.filter.page = page || vm.filter.page;

      var filter = _.cloneDeep(vm.filter);

      filter.startDate = vm.filter.startDate ? moment(vm.filter.startDate).format('YYYY-MM-DD') : null;
      filter.endDate = vm.filter.endDate ? moment(vm.filter.endDate).format('YYYY-MM-DD') : null;

      Oresell.reseller.logLevel(filter).then(function (response) {
        vm.logLevelList = response.data;

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.shownPage = filter.page;
      }, function (error) {
        $log.error(error);
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView = function (page) {
      vm.listLogLevel(page);
    };

    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiLogDepositOresellController', MainAdministrasiLogDepositOresellController);

  /** @ngInject */
  function MainAdministrasiLogDepositOresellController($scope, Papa, saveAs, toastr, $log, Oresell, _, moment, $filter) {
    var vm = this;

    vm.filter = {
      page: 1,
      user: null,
      startDate: null,
      endDate: null,
      bank: null
    };

    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.isLastPage = false;
    vm.maxPage = null;

    vm.listDeposit = function (page) {

      vm.filter.page = page || vm.filter.page;

      var filter = _.cloneDeep(vm.filter);

      filter.startDate = vm.filter.startDate ? moment(vm.filter.startDate).format('YYYY-MM-DD') : null;
      filter.endDate = vm.filter.endDate ? moment(vm.filter.endDate).format('YYYY-MM-DD') : null;

      Oresell.reseller.logDeposit(filter).then(function (response) {
        vm.depositList = response.data;

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.shownPage = filter.page;
      }, function (error) {
        $log.error(error);
      });
    };

    function getData(page, filter, currentData, callback) {

      filter.per_page = 500;
      var logData = currentData;

      filter.page = page;

      Oresell.reseller.logDeposit(filter).then(function (response) {
        logData = logData.concat(response.data.data);

        if (response.data.data.length === filter.per_page) {
          getData(page + 1, filter, logData, callback);
        } else {
          callback(logData);
        }


      }, function (error) {
        $log.error(error);
          angular.element(".loading-animation").hide();
          $scope.main.message = "";
          vm.inProcess = false;
          toastr.error(
            "Terjadi kesalahan saat download log deposit reseller",
            "Gagal"
          );
      });
    }

    vm.downloadLog = function () {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.startDate = vm.filter.startDate ? moment(vm.filter.startDate).format('YYYY-MM-DD') : null;
      filter.endDate = vm.filter.endDate ? moment(vm.filter.endDate).format('YYYY-MM-DD') : null;

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            waktu: item.trx_date,
            reseller: item.owner,
            bank: item.bank,
            keterangan: item.description,
            debet: item.debet * 1,
            kredit: item.credit * 1,
            saldo: item.balance * 1
          });
        });

        result = $filter('orderBy')(result, 'waktu', false);

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'log_deposit_reseller';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView = function (page) {
      vm.listDeposit(page);
    };

    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiLazadaController', MainAdministrasiLazadaController);

  /** @ngInject */
  function MainAdministrasiLazadaController($log, XLSX, _, moment, APIHandling, saveAs, $q, toastr) {
    var vm = this;

    vm.inProcess = false;
    vm.doSync = false;
    vm.connectURL = null;
    vm.isConnected = false;

    vm.today = new Date();
    vm.startDate = vm.today;
    vm.endDate = vm.today;
    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };

    var uploadFile = angular.element('#uploadedFile');

    uploadFile.on('change', function (e) {

      $log.info(e.target.files);

      var file = e.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {

        angular.element('.loading-animation').show();

        var data = e.target.result;
        var workbook = XLSX.read(data, { type: 'binary'});

        var allPromises = [];

        /**
         *  Posisi [SKU, STOK]:
         *  Contoh:
         *  [I, L], [N, Q], [S, V], [X, AA], [AC, AF], [AH, AK], [AM, AP], [AR, AU], [AW, AZ],
         *  [BB, BE], [BG, BJ], [BL, BO], [BQ, BT], [BV, BY], [CA, CD]
         *
         *  Sesuaikan dengan posisi yg ada di file excel dari Lazada
         */
        var dataPosition = [
          ['M', 'H']
        ];

        // console.log(workbook);
        var ws = workbook.Sheets.template;

        //** Area kerjanya */
        /**
         * Data mulai dari baris ke-5
         */
        var minRow = 4;

        $log.info(ws);

        /** ws['!ref'] berisi data range worksheed. Contoh isinya: A1:CD984 */
        /** Ambil data baris terakhir dari hasil tsb. Gunakan regex untuk ambil data barisnya. */
        var maxRow = ws['!ref'].split(':')[1].match(/\d+$/)[0] * 1;
        $log.info('Total baris dibaca: ' + maxRow);
        var i;

        var dataProduct = [];
        var dataOnServer = [];
        var list_sku = [];

        for (i = minRow; i <= maxRow; i++) {

          // $log.info('Baca data baris: ' + i);


          _.each(dataPosition, function (n) {
            var sku = ws[n[0] + i] ? ws[n[0] + i].v : null;
            if (sku) {

              dataProduct.push({
                sku: sku.trim(),
                row: i,
                column: n
              });

              list_sku.push(sku);

              // var stok = ws[n[1] + i] ? ws[n[1] + i].v : null;
              // $log.log('SKU: ' + sku + ' stok: ' + stok);
            }

          });
        }

        if (list_sku.length > 0) {

          var skuChunk = _.chunk(list_sku, 100);

          // $log.info(skuChunk);

          _.each(skuChunk, function (list) {
            var filter = {
              list_sku: list,
              per_page: 100
            };

            var tmp = APIHandling.get('produk/list', filter);

            allPromises.push(tmp);
          });

        }



        $q.all(allPromises).then(function (result) {

          // $log.info('Selesai semua proses. Download hasil');
          // $log.info(result);

          _.each(result, function (dataRow) {
            dataOnServer = dataOnServer.concat(dataRow.data.data);
          });

          // $log.info(dataOnServer);
          // $log.info(dataProduct);

          _.each(dataProduct, function (product) {

            // $log.info('Proses produk');
            // $log.info(product);

            var tmp = _.find(dataOnServer, function (n) {
              return n.sku == product.sku;
            });

            if (tmp) {
              var jumlah = tmp.jumlah;

              ws[product.column[1] + product.row].v = jumlah;

              // $log.info('SKU: ' + product.sku + ' stok akhir: ' + jumlah);
            }


          });

          var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };

          var wbout = XLSX.write(workbook, wopts);

          function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }

          saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "result.xlsx");
          angular.element('.loading-animation').hide();
        });

      };

      reader.readAsBinaryString(file);

    });

    vm.syncProduct = function () {
      vm.inProcess = true;
      var startDate = moment(vm.startDate).format('YYYY-MM-DD') + 'T00:00:00';
      var endDate = moment(vm.endDate).format('YYYY-MM-DD') + 'T23:59:59';

      APIHandling.get('lazada/sync-product', {startDate: startDate, endDate: endDate}).then(function (response) {
        vm.inProcess = false;
        vm.doSync = true;
        $log.info(response);
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal sinkronisasi produk Lazada');
      });
    };

    vm.generateURL = function() {
      vm.inProcess = true;
      APIHandling.get('lazada/generate-url').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.connectURL = response.data.url;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal generate URL koneksi Lazada Store');
      });
    };

    vm.initView = function () {
      vm.inProcess = true;
      APIHandling.get('lazada/check-connected').then(function (response) {
        vm.inProcess = false;
        $log.info(response.data);
        vm.isConnected = response.data.isConnected;
      }, function (error) {
        vm.inProcess = false;
        $log.error(error);
        toastr.error('Gagal cek koneksi Lazada Store');
      });
    };

    vm.initView();
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiContactOresellController', MainAdministrasiContactOresellController);

  /** @ngInject */
  function MainAdministrasiContactOresellController($log, Oresell, Papa, saveAs, toastr, $scope, _) {
    var vm = this;

    vm.filter = {
      page: 1,
      search: null,
      by_hp: null,
      reseller: null,
      per_page: 10
    };

    vm.isLastPage = false;
    vm.maxPage = null;

    vm.getReseller = function (page) {

      vm.filter.page = page || vm.filter.page;

      var filter = _.cloneDeep(vm.filter);

      Oresell.contact.list(vm.filter).then(function (response) {
        vm.resellerContactList = response.data.contact;

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (response.data.contact.length < vm.filter.per_page) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.shownPage = filter.page;
      }, function (error) {
        $log.error(error);
      });
    };

    function getData(page, filter, currentData, callback) {


      filter.per_page = 500;
      var contactList = currentData;

      filter.page = page;

      Oresell.contact.list(filter).then(function (response) {

        contactList = contactList.concat(response.data.contact);

        if (response.data.contact.length === filter.per_page) {
          getData(page + 1, filter, contactList, callback);
        } else {
          callback(contactList);
        }
      }, function (error) {
        $log.error(error);
        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;
        toastr.error('Terjadi kesalahan saat download riwayat transaksi', 'Gagal');
      });
    }

    vm.downloadContact = function () {
      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];

        _.each(data, function (item) {
          result.push({
            nama: item.nama,
            email: item.email,
            hp: item.hp,
            alamat: item.alamat,
            kecamatan: item.kec,
            kabupaten: item.kab,
            provinsi: item.prov,
            kode_pos: item.kode_pos,
            reseller: item.owner,
            id: item.id
          });
        });

        var csv = Papa.unparse(result, {
          worker: false,
          skipEmptyLines: true
        });

        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;

        var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
        var filename = 'contact_reseller_';

        saveAs(blob, filename + "_.csv");

      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView = function (page) {
      vm.getReseller(page);
    };

    vm.initView(1);


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiJubelioController', MainAdministrasiJubelioController);

  /** @ngInject */
  function MainAdministrasiJubelioController($log, Papa, _, APIHandling, saveAs, $q) {
    var vm = this;

    vm.inProcess = false;
    vm.skuField = 'item_code';
    vm.stockField = 'qty_in_base';
    vm.priceField = 'cost';

    var uploadFile = angular.element('#uploadedFile');

    uploadFile.on('change', function (e) {

      var file = e.target.files[0];



      function processAfterRead(results) {
        var allPromises = [];
        var dataProduct = results.data;
        var dataOnServer = [];

        var list_sku = _.map(results.data, 'item_code');

        if (list_sku.length > 0) {

          var chunkList = _.chunk(list_sku, 50);

          _.each(chunkList, function (list) {
            var filter = {
              list_sku: list,
              per_page: 50
            };

            var tmp = APIHandling.get('produk/list', filter);

            allPromises.push(tmp);
          });

          $q.all(allPromises).then(function (result) {

            _.each(result, function (dataRow) {
              dataOnServer = dataOnServer.concat(dataRow.data.data);
            });

            _.each(dataProduct, function (product) {

              $log.info('Proses produk');
              $log.info(product[vm.skuField.trim()]);

              // var jumlah = $filter('filter')(dataOnServer, { 'sku': product.sku })[0].jumlah;
              var tmp = _.find(dataOnServer, function (n) {
                return n.sku == product[vm.skuField.trim()];
              });

              if (tmp) {
                var jumlah = tmp.jumlah;
                var extra = angular.fromJson(tmp.extra);
                product[vm.stockField.trim()] = jumlah;
                product[vm.priceField.trim()] = extra.harga_beli * 1;

                $log.info('SKU: ' + product[vm.skuField.trim()] + ' stok akhir: ' + jumlah);
              }


            });

            var csv = Papa.unparse(dataProduct, {
              delimiter: ",",
              quotes: true,
              header: true,
              newline: "\n",
              encoding: "UTF-8"
            });

            saveAs(new Blob([csv], { type: "text/csv;charset=utf-8" }), "jubelio.csv");
          });
        }

      }

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        delimiter: ",",
        complete: processAfterRead
      });

    });


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiFacebookController', MainAdministrasiFacebookController);

  /** @ngInject */
  function MainAdministrasiFacebookController($log, APIHandling, moment, _, $scope, Papa, saveAs, toastr, $q, CUSTOMERHandling) {
    var vm = this;

    vm.filter = {
      page: 1,
      per_page: 10,
      by_id: null,
      by_pembeli: null,
      tgl_min: null,
      tgl_max: null,
      tgl_opt: 4, /* Di antara tgl_min dan tgl_max */
      order_by: 'by_tgl',
      sorting: 'desc'
    };

    vm.datePicker = {};
    vm.openDatePicker = function($event, key) {
        $event.preventDefault();
        $event.stopPropagation();

        vm.datePicker[key] = !vm.datePicker[key];
    };


    vm.inProcess = false;

    function getData(page, filter, currentData, callback) {

      if (!filter.tgl_max) {
        filter.tgl_opt = 3;
      }
      filter.per_page = 500;
      var order = currentData;

      filter.page = page;
      filter.order_by = 'by_tgl';
      filter.sorting = 'asc';

      APIHandling.get('order/list', filter).then(function (response) {

        order = order.concat(response.data.data);

        if (response.data.data.length === filter.per_page) {
          getData(page + 1, filter, order, callback);
        } else {
          callback(order);
        }
      }, function (error) {
        $log.error(error);
        angular.element('.loading-animation').hide();
        $scope.main.message = '';
        vm.inProcess = false;
        toastr.error('Terjadi kesalahan saat download data', 'Gagal');
      });
    }

    vm.downloadTransaction = function () {

      vm.inProcess = true;
      $scope.main.message = 'Mendownload data dari server...';
      angular.element('.loading-animation').show();

      var filter = _.cloneDeep(vm.filter);

      filter.tgl_min = filter.tgl_min ? moment(filter.tgl_min).format('YYYY-MM-DD') : null;
      filter.tgl_max = filter.tgl_max ? moment(filter.tgl_max).format('YYYY-MM-DD') : null;

      getData(1, filter, [], function (data) {

        $scope.main.message = 'Konversi ke csv';
        var result = [];
        var resultAsync = [];


        _.each(data, function (item) {

          item.lain_lain = angular.fromJson(item.lain_lain);

          if (item.lain_lain.email || item.lain_lain.hp) {
            result.push({
              email: item.lain_lain.email ? item.lain_lain.email : null,
              phone: item.lain_lain.hp ? preparePhone(item.lain_lain.hp) : null,
              ct: item.shipping_kab,
              country: 'ID',
              event_name: 'Purchase',
              event_time: prepareTime(item.tgl),
              value: (item.total_akhir * 1) - (item.total_lain_lain * 1),
              currency: 'IDR',
              order_id: item.id
            });
          } else if ((item.dropship * 1) === 2) {
            /**
             * Jika ada transaksi oresell yg tidak ada data no hp / email
             * maka ambil dulu datanya dari contact oresell
             */
            if ((!item.lain_lain.email) && (!item.lain_lain.hp)) {
              var q = $q.defer();

              CUSTOMERHandling.getCustomer(item.cust_uuid, true).then(function (response) {
                if (response.data.alamat) {

                  item.lain_lain.email = response.data.email;
                  item.lain_lain.hp = response.data.hp;

                  q.resolve({
                    email: item.lain_lain.email ? item.lain_lain.email : null,
                    phone: item.lain_lain.hp ? preparePhone(item.lain_lain.hp) : null,
                    ct: item.shipping_kab,
                    country: 'ID',
                    event_name: 'Purchase',
                    event_time: prepareTime(item.tgl),
                    value: (item.total_akhir * 1) - (item.total_lain_lain * 1),
                    currency: 'IDR',
                    order_id: item.id
                  });

                }
              }, function (error) {
                q.reject(error);
              });

              resultAsync.push(q.promise);
            }
          }

        });

        /**
         * Jika ada data async yg diambil dari contact oresell
         */
        if (resultAsync.length > 0) {
          $q.allSettled(resultAsync).then(function (item) {
            _.each(item, function(n) {
              if (n.state === 'fulfilled') {
                result.push(n.value);
              }
            });

            var csv = Papa.unparse(result, {
              worker: false,
              skipEmptyLines: true
            });

            angular.element('.loading-animation').hide();
            $scope.main.message = '';
            vm.inProcess = false;

            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });

            saveAs(blob, 'Offline_Events.csv');
          });
        } else {
          var csv = Papa.unparse(result, {
            worker: false,
            skipEmptyLines: true
          });

          angular.element('.loading-animation').hide();
          $scope.main.message = '';
          vm.inProcess = false;

          var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });

          saveAs(blob, 'Offline_Events.csv');
        }

      });
    };

    function preparePhone(phone) {
      /** Hilangkan semua karakter non-digit */
      var number = phone.replace(/\D/g, '');

      /** Ganti angka 0 menjadi 62 di awal nomor */
      number = number.replace(/^0/, '62');

      return number;
    }

    function prepareTime(timeEvent) {
      var t = timeEvent.replace(/ /,'T');
      t = t + '+07:00';

      return t;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiCategoryController', MainAdministrasiCategoryController);

  /** @ngInject */
  function MainAdministrasiCategoryController(APIHandling, $log, $uibModal) {

    var vm = this;
    vm.categoryList = [];
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.shownPage = 1;

    vm.filter = {
      name: null,
      per_page: 10,
      page: 1
    };

    vm.initView = function (page) {

      vm.filter.page = page;

      APIHandling.get('produk/list-kategori', vm.filter).then(function (response) {
        vm.categoryList = response.data.data;

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        vm.shownPage = vm.filter.page;

      });
    };

    vm.setDiscount = function (item) {

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/modals/editDiskonKategoriOtoreseller/editDiskonKategoriOtoresellerDialog.html',
        controller: 'EditDiskonKategoriOtoresellerDialogController as vm',
        resolve: {
          data: function () {
            return item;
          }
        }
      });

      modalInstance.result.then(function () {
        vm.initView(vm.filter.page);
      });
    };

    vm.changePage = function (page) {

      /** Hanya cek apakah page === defined, karena untuk nilai yang invalid, otomatis hasilnya undefined */
      if (angular.isDefined(page)) {
        vm.initView(page);
      }

    };

    /** Jika page yang dimasukkan invalid, maka balikkan ke nilai page yang sedang tampil ketika blur dari input */
    vm.onPageBlur = function (page) {
      if (angular.isUndefined(page)) {
        vm.shownPage = vm.filter.page;
      }
    };

    vm.initView(1);

  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiBukalapakController', MainAdministrasiBukalapakController);

  /** @ngInject */
  function MainAdministrasiBukalapakController($uibModal, $scope, $log, XLSX, _, APIHandling, $filter, saveAs, $q, Papa) {
    // var vm = this;

    var uploadFile = angular.element('#uploadedFile');

    uploadFile.on('change', function (e) {

      var file = e.target.files[0];

      var reader = new FileReader();


      function processAfterRead(results) {
        var allPromises = [];
        var dataProduct = results.data;
        var dataOnServer = [];

        var list_sku = _.map(results.data, 'SKU');

        if (list_sku.length > 0) {

          var chunkList = _.chunk(list_sku, 50);

          _.each(chunkList, function (list) {
            var filter = {
              list_sku: list,
              per_page: 50
            };

            var tmp = APIHandling.get('produk/list', filter);

            allPromises.push(tmp);
          });

          $q.all(allPromises).then(function (result) {

            _.each(result, function (dataRow) {
              dataOnServer = dataOnServer.concat(dataRow.data.data);
            });

            _.each(dataProduct, function (product) {

              $log.info('Proses produk');
              $log.info(product.SKU);

              // var jumlah = $filter('filter')(dataOnServer, { 'sku': product.sku })[0].jumlah;
              var tmp = _.find(dataOnServer, function (n) {
                return n.sku == product.SKU;
              });

              if (tmp) {
                var jumlah = tmp.jumlah;
                product.Stok = jumlah;

                $log.info('SKU: ' + product.SKU + ' stok akhir: ' + jumlah);
              }


            });

            var csv = Papa.unparse(dataProduct, {
              delimiter: ",",
              quotes: false,
              header: true,
              newline: "\n",
              encoding: "UTF-8"
            });

            saveAs(new Blob([csv], { type: "text/csv;charset=utf-8" }), "bukalapak.csv");
          });
        }

      }

      reader.onload = function (e) {
        var data = e.target.result;

        Papa.parse(data, {
          header: true,
          skipEmptyLines: true,
          delimiter: ",",
          complete: processAfterRead
        });
      };

      reader.readAsBinaryString(file);

    });



  }
})();

(function () {
  "use strict";

  angular.module("fmuslimPosClient").factory("TRXHandling", TRXHandling);

  function TRXHandling(_, $window, $filter) {
    var instance = this;

    instance.print = function (transaction) {
      var strContent =
        '<!DOCTYPE html><html lang="en"> <head> <meta charset="UTF-8"/> <meta http-equiv="X-UA-Compatible" content="IE=edge"/> <meta name="viewport" content="width=device-width, initial-scale=1.0"/> <title>Transaksi</title> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css" integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic=" crossorigin="anonymous"/> <link rel="preconnect" href="https://fonts.googleapis.com"/> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/> <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,300italic,700,700italic"/> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"/> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/milligram@1.4.1/dist/milligram.min.css" integrity="sha256-baSxKEISHdSAWiipPkWRuquIMjgNIR//a++CyhnQdIM=" crossorigin="anonymous"/> <style>@page{size: A4;} body.A4long     .sheet { width: 210mm; } @media print { body.A4long { width: 210mm } }  tr, td {vertical-align: text-top;} </style> </head> <body class="A4long"> <section class="sheet padding-10mm"> <h5>Daftar Transaksi</h5> <table> <thead> <tr> <th>Tgl</th> <th>Trx ID</th> <th>Nama</th> <th>Alamat</th> <th>Catatan</th> </tr></thead> <tbody>';

      _.each(transaction, function (item) {

        item.lain_lain = angular.fromJson(item.lain_lain);

        strContent =
          strContent +
          "<tr> <td>" +
          $filter("udate")(item.tgl, "dd-MM-yyyy HH:mm:ss") +
          "</td><td>" +
          item.id +
          "</td><td>" +
          item.pembeli +
          "</td><td>";

        if (item.shipping_alamat) {
          strContent = strContent + item.shipping_alamat;
        }

        strContent = strContent + "</td><td>";

        if (item.lain_lain.customerNote) {
          strContent = strContent + item.lain_lain.customerNote + "<br>";
        }

        if (item.lain_lain.jobNumber) {
          strContent = strContent + "No Resi: " + item.lain_lain.jobNumber;
        }

        strContent = strContent + "</td></tr>";
      });

      strContent = strContent + "</tbody> </table> </section> </body></html>";

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    return this;
  }
})();

(function () {
  "use strict";

  angular.module("fmuslimPosClient").factory("STRUKHandling", STRUKHandling);

  function STRUKHandling(pdfMake, _, $filter, $log, store, $window) {
    var instance = this;

    var log = store.get("logPrint") || [];

    instance.printNormal = function (data, note) {
      var tableContent = [
        ["Deskripsi", "Harga", "Jml", "Diskon Produk", "Total"],
      ];

      _.each(data.produk_unik, function (item) {
        var baris = [];
        // var size = item.size ? item.size.toString().toUpperCase() : '';

        var detail = angular.fromJson(item.detail);
        var family;

        if (detail.attributes) {
          family = _.find(detail.attributes, function (o) {
            return o.name === "FAMILY";
          });
        }

        if (family) {
          family = "\nFamily: " + family.option;
        } else {
          family = "";
        }

        baris = [
          { text: item.nama + " " + item.ket },
          { text: $filter("number")(item.harga_jual, 2), style: "number" },
          { text: $filter("number")(item.jumlah, 0), style: "number" },
          {
            text: $filter("number")(
              item.discount_nominal * 1 +
                (item.discount_persen / 100) *
                  (item.jumlah * 1) *
                  item.harga_jual,
              2
            ),
            style: "number",
          },
          {
            text: $filter("number")(
              item.jumlah * 1 * (item.harga_jual * 1) -
                (item.discount_nominal * 1 +
                  (item.discount_persen / 100) *
                    (item.jumlah * 1) *
                    item.harga_jual),
              2
            ),
            style: "number",
          },
        ];

        tableContent.push(baris);
      });

      tableContent.push([
        { text: "Jumlah", colSpan: 4, alignment: "right" },
        {},
        {},
        {},
        {
          text: $filter("number")(
            data.total_akhir * 1 +
              data.discount_transaction_total * 1 -
              data.total_lain_lain * 1 || 0,
            2
          ),
          style: "number",
        },
      ]);

      tableContent.push([
        { text: "Biaya kirim dll", colSpan: 4, alignment: "right" },
        {},
        {},
        {},
        {
          text: $filter("number")(data.total_lain_lain * 1, 2),
          style: "number",
        },
      ]);

      tableContent.push([
        { text: "Diskon Transaksi", colSpan: 4, alignment: "right" },
        {},
        {},
        {},
        {
          text: $filter("number")(data.discount_transaction_total || 0, 2),
          style: "number",
        },
      ]);

      tableContent.push([
        { text: "Total", colSpan: 4, alignment: "right", bold: true },
        {},
        {},
        {},
        {
          text: $filter("number")(data.total_akhir, 2),
          style: "number",
          bold: true,
        },
      ]);

      var docDefinition = {
        pageSize: "A6",
        pageOrientation: "landscape",
        pageMargins: [20, 20, 20, 20],

        content: [
          {
            text: data.dropship != 2 ? "Zafrada.com" : "",
            style: "header",
          },
          {
            columns: [
              {
                columns: [
                  { text: "Nomor Struk", width: "25%" },
                  { text: ":", alignment: "center", width: "5%" },
                  { text: "#" + data.id, width: "60%" },
                ],
                width: "50%",
              },
              {
                text:
                  "Tanggal  :  " +
                  $filter("udate")(data.tgl, "dd-MM-yyyy HH:mm:ss"),
                alignment: "right",
                width: "50%",
              },
            ],
          },
          {
            columns: [
              {
                columns: [
                  { text: "Pembeli", width: "25%" },
                  { text: ":", alignment: "center", width: "5%" },
                  { text: data.pembeli, width: "60%" },
                ],
                width: "50%",
              },
            ],
          },
          {
            style: "tableProduct",
            table: {
              widths: ["35%", "20%", "5%", "20%", "20%"],
              headerRows: 1,
              body: tableContent,
            },
          },
          {
            text: note ? "Catatan: " + note.note : "",
          },
          {
            text: data.lain_lain.jobNumber ? "Resi Dropship: " + (data.lain_lain.ekspedisiMP !== 'other' ? data.lain_lain.ekspedisiMP : data.lain_lain.ekspedisiMPOther ) + " - " + data.lain_lain.jobNumber : "",
          },
          {
            text: data.lain_lain.customerNote ? "Catatan Reseller: " + data.lain_lain.customerNote : "",
          }
        ],
        defaultStyle: {
          font: "CrimsonText",
          fontSize: 8,
        },
        styles: {
          spclass: {
            fontSize: 4,
          },
          tableProduct: {
            margin: [0, 5, 0, 15],
          },
          header: {
            font: "CrimsonText",
            fontSize: 12,
            bold: true,
          },
          number: {
            font: "CourierPrime",
            alignment: "right",
            fontSize: 8,
            marginTop: 2,
          },
        },
      };

      /*  Masukkan list produk ke dalam doc */
      // docDefinition.content.splice(9, 0, produk);

      pdfMake.fonts = {
        CourierPrime: {
          normal: "CourierPrime.ttf",
          bold: "CourierPrimeBold.ttf",
          italics: "CourierPrimeItalic.ttf",
          bolditalics: "CourierPrimeBoldItalic.ttf",
        },
        CrimsonText: {
          normal: "CrimsonText-Roman.ttf",
          bold: "CrimsonText-Bold.ttf",
          italics: "CrimsonText-Italic.ttf",
          bolditalics: "CrimsonText-BoldItalic.ttf",
        },
      };

      /* Log data untuk debug */
      $log.debug("Data diterima");
      $log.info(data);
      $log.debug("Doc Definition");
      $log.info(docDefinition);
      log.unshift({
        time: new Date(),
        data: data,
        docDefinition: docDefinition,
      });
      log.splice(5, 1000);

      store.set("logPrint", log);
      // $log.info(angular.toJson(docDefinition));

      pdfMake.createPdf(docDefinition).print();
    };

    instance.printPOS58 = function (data, note) {
      var strContent =
        '<!DOCTYPE html><html lang="en">  <head>    <meta charset="UTF-8" />    <meta http-equiv="X-UA-Compatible" content="IE=edge" />    <meta name="viewport" content="width=device-width, initial-scale=1.0" />    <title>Struk</title>    <link      rel="stylesheet"      href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"    />    <link      rel="stylesheet"      href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css"      integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic="      crossorigin="anonymous"    />    <style>      body.CUST .sheet {        width: 56mm;      }      @media print {        body.CUST {          width: 56mm;        }      }      @page {        size: portrait;      }      .sheet.padding-5mm {        padding: 5mm;        border-bottom: 1px dashed #000;      }      h1 {        font-size: 12pt;        font-weight: bold;      }      body {        font-family: "Roboto Mono", Courier, monospace;        font-size: 9pt;        box-sizing: border-box;      }      p {        margin-top: 0;        margin-bottom: 0;      }      table {        width: 100%;      }      td {        vertical-align: text-top;      }      th {        text-align: left;      }      .text-price {        text-align: right;        margin-right: 5pt;        font-weight: bold;      }      .text-right {        text-align: right;      }      #table-product {        border-top: 1px dashed #000;        margin-top: 10pt;      }      #table-product td {        border-bottom: 1px dashed #000;        padding-top: 5pt;        padding-bottom: 5pt;      }      #totalRow th,      #totalRow td {        border-top: 1px dashed #000;        padding-top: 5pt;        padding-bottom: 5pt;      }    </style>  </head>  <body class="CUST" onload="window.print();window.close();">    <section class="sheet padding-5mm">      <h1>Zafrada</h1>      <p>No: #' +
        data.id +
        "</p>      <p>" +
        $filter("udate")(data.tgl, "dd-MM-yyyy HH:mm:ss") +
        "</p>      <p><strong>" +
        data.pembeli +
        '</strong></p>      <table id="table-product">';

      _.each(data.produk_unik, function (item, index) {
        var detail = angular.fromJson(item.detail);
        var family;

        if (detail.attributes) {
          family = _.find(detail.attributes, function (o) {
            return o.name === "FAMILY";
          });
        }

        if (family) {
          family = "\nFamily: " + family.option;
        } else {
          family = "";
        }

        strContent =
          strContent +
          '<tr><td class="text-right">' +
          (index + 1) +
          "</td><td><p><strong>" +
          item.nama +
          " " +
          item.ket +
          "</strong></p><p>" +
          $filter("number")(item.jumlah, 0) +
          " x " +
          $filter("number")(item.harga_jual, 0) +
          "<br />Diskon: " +
          $filter("number")(
            item.discount_nominal * 1 +
              (item.discount_persen / 100) *
                (item.jumlah * 1) *
                item.harga_jual,
            0
          ) +
          '</p><p class="text-price">' +
          $filter("number")(
            item.jumlah * 1 * (item.harga_jual * 1) -
              (item.discount_nominal * 1 +
                (item.discount_persen / 100) *
                  (item.jumlah * 1) *
                  item.harga_jual),
            0
          ) +
          "</p></td> </tr>";
      });

      strContent =
        strContent +
        '</table><table> <tr><th scope="row">Jml</th><td><p class="text-price">' +
        $filter("number")(
          data.total_akhir * 1 +
            data.discount_transaction_total * 1 -
            data.total_lain_lain * 1 || 0,
          0
        ) +
        '</p></td>        </tr>        <tr>          <th scope="row">Biaya</th>          <td><p class="text-price">' +
        $filter("number")(data.total_lain_lain * 1, 0) +
        '</p></td>        </tr>        <tr>          <th scope="row">Diskon</th>          <td><p class="text-price">' +
        $filter("number")(data.discount_transaction_total || 0, 0) +
        '</p></td>        </tr>        <tr id="totalRow">          <th scope="row">TOTAL</th>          <td><p class="text-price">' +
        $filter("number")(data.total_akhir, 0) +
        "</p></td>        </tr>      </table> ";

      if (data.lain_lain.jobNumber) {
        strContent =
          strContent +
          '<p style="margin-top: 12pt"><strong>Resi Online</strong>:<br>' +
          data.lain_lain.jobNumber +
          "</p>";
      }

      if (data.lain_lain.customerNote) {
        strContent =
          strContent +
          '<p style="margin-top: 12pt"><strong>Catatan Konsumen:</strong><br>' +
          data.lain_lain.customerNote +
          "</p>";
      }

      if (note) {
        strContent =
          strContent +
          '<p style="margin-top: 12pt"><strong>Catatan:</strong><br>' +
          note.note +
          "</p>";
      }

      strContent = strContent + '<p style="margin-top: 12pt; padding-top: 10pt; border-top: 1px dashed #000;" ><strong>Disclaimer:</strong> Barang yg sudah dibeli tidak bisa ditukar/dikembalikan kecuali dg perjanjian.</p><br><p><strong>Syarat pengembalian:</strong></p><ul style="padding-left: 15px;" ><li>Maksimal 1 x 24 jam</li><li>Pastikan label tag baju masih lengkap</li><li>Tidak ada bau parfum</li><li>Tunjukan nota pembelian</li></ul><p>Terimakasih atas kunjungannya.</p><br><p>Silahkan datang kembali.</p></section>  </body></html>';

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    instance.print = function (type, data, note) {
      if (type === 0) {
        this.printNormal(data, note);
      } else {
        this.printPOS58(data, note);
      }
    };

    instance.bulkPrintPOS58 = function (data) {
      var strContent =
        '<!DOCTYPE html><html lang="en">  <head>    <meta charset="UTF-8" />    <meta http-equiv="X-UA-Compatible" content="IE=edge" />    <meta name="viewport" content="width=device-width, initial-scale=1.0" />    <title>Struk</title>    <link      rel="stylesheet"      href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"    />    <link      rel="stylesheet"      href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css"      integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic="      crossorigin="anonymous"    />    <style>      body.CUST .sheet {        width: 56mm;      }      @media print {        body.CUST {          width: 56mm;        }      }      @page {        size: portrait;      }      .sheet.padding-5mm {        padding: 5mm;padding-top:0;padding-bottom:0;        border-bottom: 1px dashed #000;      }      h1 {        font-size: 12pt;        font-weight: bold;      }      body {        font-family: "Roboto Mono", Courier, monospace;        font-size: 9pt;        box-sizing: border-box;      }      p {        margin-top: 0;        margin-bottom: 0;      }      table {        width: 100%;      }      td {        vertical-align: text-top;      }      th {        text-align: left;      }      .text-price {        text-align: right;        margin-right: 5pt;        font-weight: bold;      }      .text-right {        text-align: right;      }      #table-product {        border-top: 1px dashed #000;        margin-top: 10pt;      }      #table-product td {        border-bottom: 1px dashed #000;        padding-top: 5pt;        padding-bottom: 5pt;      }      #totalRow th,      #totalRow td {        border-top: 1px dashed #000;        padding-top: 5pt;        padding-bottom: 5pt;     } .content { border-bottom: 1px dashed #000;padding-top: 5mm;padding-bottom: 5mm; }     </style>  </head>  <body class="CUST" onload="window.print();window.close();" ><section class="sheet padding-5mm">      ';

      _.each(data, function (transaction) {
        strContent =
          strContent +
          '<div class="content"><h1>Zafrada</h1>      <p>No: #' +
          transaction.id +
          "</p>      <p>" +
          $filter("udate")(transaction.tgl, "dd-MM-yyyy HH:mm:ss") +
          "</p>      <p><strong>" +
          transaction.pembeli +
          '</strong></p>      <table id="table-product">';

        _.each(transaction.produk_unik, function (item, index) {
          var detail = angular.fromJson(item.detail);
          var family;

          if (detail.attributes) {
            family = _.find(detail.attributes, function (o) {
              return o.name === "FAMILY";
            });
          }

          if (family) {
            family = "\nFamily: " + family.option;
          } else {
            family = "";
          }

          strContent =
            strContent +
            '<tr><td class="text-right">' +
            (index + 1) +
            "</td><td><p><strong>" +
            item.nama +
            " " +
            item.ket +
            "</strong></p><p>" +
            $filter("number")(item.jumlah, 0) +
            " x " +
            $filter("number")(item.harga_jual, 0) +
            "<br />Diskon: " +
            $filter("number")(
              item.discount_nominal * 1 +
                (item.discount_persen / 100) *
                  (item.jumlah * 1) *
                  item.harga_jual,
              0
            ) +
            '</p><p class="text-price">' +
            $filter("number")(
              item.jumlah * 1 * (item.harga_jual * 1) -
                (item.discount_nominal * 1 +
                  (item.discount_persen / 100) *
                    (item.jumlah * 1) *
                    item.harga_jual),
              0
            ) +
            "</p></td> </tr>";
        });

        strContent =
          strContent +
          '</table><table> <tr><th scope="row">Jml</th><td><p class="text-price">' +
          $filter("number")(
            transaction.total_akhir * 1 +
              transaction.discount_transaction_total * 1 -
              transaction.total_lain_lain * 1 || 0,
            0
          ) +
          '</p></td>        </tr>        <tr>          <th scope="row">Biaya</th>          <td><p class="text-price">' +
          $filter("number")(transaction.total_lain_lain * 1, 0) +
          '</p></td>        </tr>        <tr>          <th scope="row">Diskon</th>          <td><p class="text-price">' +
          $filter("number")(transaction.discount_transaction_total || 0, 0) +
          '</p></td>        </tr>        <tr id="totalRow">          <th scope="row">TOTAL</th>          <td><p class="text-price">' +
          $filter("number")(transaction.total_akhir, 0) +
          "</p></td>        </tr>      </table> ";

        if (transaction.lain_lain.jobNumber) {
          strContent =
            strContent +
            '<p style="margin-top: 12pt"><strong>Resi Online</strong>:<br>' +
            transaction.lain_lain.jobNumber +
            "</p>";
        }

        if (transaction.lain_lain.customerNote) {
          strContent =
            strContent +
            '<p style="margin-top: 12pt"><strong>Catatan Konsumen</strong>:<br>' +
            transaction.lain_lain.customerNote +
            "</p>";
        }

        // if (note) {
        //   strContent =
        //     strContent +
        //     '<p style="margin-top: 12pt"><strong>Catatan:</strong><br>' +
        //     note.note +
        //     "</p>";
        // }

        strContent = strContent + '<p style="margin-top: 12pt; padding-top: 10pt; border-top: 1px dashed #000;" ><strong>Disclaimer:</strong> Barang yg sudah dibeli tidak bisa ditukar/dikembalikan kecuali dg perjanjian.</p><br><p><strong>Syarat pengembalian:</strong></p><ul style="padding-left: 15px;" ><li>Maksimal 1 x 24 jam</li><li>Pastikan label tag baju masih lengkap</li><li>Tidak ada bau parfum</li><li>Tunjukan nota pembelian</li></ul><p>Terimakasih atas kunjungannya.</p><br><p>Silahkan datang kembali.</p></div>';
      });

      strContent = strContent + "</section></body></html>";

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    return this;
  }
})();

/* eslint-disable comma-dangle */
(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .factory("RESIHandling", RESIHandling);

  function RESIHandling(pdfMake, _, $filter, $log, $window) {
    var instance = this;


    instance.print = function (ekspedisi, jobNumber) {
      /** Handle alamat pengirim */


      var strContent =
        '<!DOCTYPE html><html lang="en"> <head> <meta charset="UTF-8"/> <meta http-equiv="X-UA-Compatible" content="IE=edge"/> <meta name="viewport" content="width=device-width, initial-scale=1.0"/> <title>Alamat</title> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"/> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css" integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic=" crossorigin="anonymous"/> <link rel="preconnect" href="https://fonts.googleapis.com"/> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/><style>body.A6 .sheet{width: 105mm; height: 148mm;}body.A6.landscape .sheet{width: 149mm; height: 104mm;}@page{size: A6 landscape;}body{font-family: "Roboto Mono", Courier, monospace;}table{width: 100%; vertical-align: text-top;}tr, td{vertical-align: text-top;}</style> </head> <body class="A6 landscape" onload="window.print();window.close();"  ><section class="sheet padding-10mm"><p>Resi Pengiriman</p><p style="font-size: 2em;">' + ekspedisi + '</p><p style="font-size: 2.5em;" ><strong>' + jobNumber + '</strong></p><div style="border:2px solid #000;" ><p style="text-align:center;font-size: 0.9em;color:red"><strong>DISCLAIMER: Komplain wajib menyertakan video unboxing</strong></p></div></section></body></html>';

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    return this;
  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('ProductTransaction', ProductTransaction);

  function ProductTransaction(APIHandling) {
    var instance = this;

    instance.list = function(filter) {
      return APIHandling.get('order/list-produk', filter);
    };

    return instance;

  }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('Oresell', Oresell);

  function Oresell(APIHandling) {
    var instance = this;

    instance.contact = {
      get: function (id) {
        return APIHandling.get('oresell/kontak/get', {id: id});
      },
      list: function (filter) {
        return APIHandling.get('oresell/kontak/list', filter);
      }
    };

    instance.reseller = {
      list: function (filter) {
        return APIHandling.get('oresell/reseller/list', filter);
      },
      listDeposit: function (filter) {
        return APIHandling.get('oresell/reseller/list-deposit', filter);
      },
      logDeposit: function (filter) {
        return APIHandling.get('oresell/reseller/get-log-deposit', filter);
      },
      logLevel: function (filter) {
        return APIHandling.get('oresell/reseller/get-log-level', filter);
      },
      status: function (data) {
        return APIHandling.post('oresell/reseller/status', data, true);
      },
      setUpline: function (data) {
        return APIHandling.post('oresell/reseller/set-upline', data, true);
      },
      getDiscount: function () {
        return APIHandling.get('oresell/reseller/level-discount');
      },
      setDiscount: function (data) {
        return APIHandling.post('oresell/reseller/set-level-discount', {data: data}, true);
      },
      getSetting: function () {
        return APIHandling.get('oresell/reseller/get-setting');
      },
      setSetting: function (data) {
        return APIHandling.post('oresell/reseller/set-setting', { data: data }, true);
      },
      resetPassword: function (data) {
        return APIHandling.post('oresell/reseller/reset-password', {data: data}, true);
      }
    };

    instance.deposit = {
      change: function (data) {
        return APIHandling.post('oresell/deposit', {deposit: data}, true);
      }
    };

    instance.ticket = {
      list: function (status, user) {
        return APIHandling.get('oresell/ticket', {status: status, user: user}, true);
      }
    };

    instance.order = {
      process: function(id) {
        return APIHandling.post('oresell/order/process', { id: id }, true);
      }
    };

    instance.broadcast = {
      send: function (data) {
        return APIHandling.post('oresell/broadcast/send', {data: data}, true);
      }
    };

    return instance;

  }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('OrderNote', orderNote);

  function orderNote(APIHandling) {
    var instance = this;

    instance.create = function(data) {
      return APIHandling.post('order-note/create', data);
    };

    instance.list = function(transaction_id) {
      return APIHandling.get('order-note/list', {
        transaction_id: transaction_id,
      });
    };

    return instance;
  }

})();

(function() {
  'use strict';

  angular.module('fmuslimPosClient').factory('draft', DraftService);

  function DraftService(APIHandling) {
    var instance = this;

    /**
     * Struktur data = {
     *  id: null,
     *  draft: []
     * }
     */
    instance.create = function(data) {
      return APIHandling.post('draft/create', data);
    };

    instance.update = function(data) {
      return APIHandling.post('draft/update', data);
    };

    instance.process = function(data) {
      return APIHandling.post('draft/process', data);
    };

    instance.delete = function(data) {
      return APIHandling.post('draft/delete', { id: data.id });
    };

    instance.list = function(type) {
      return APIHandling.get('draft/list', { type: type });
    };

    return instance;
  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('LOGHandling', LOGHandling);

    function LOGHandling($log, ngDexie, moment) {
      var instance = this;

      instance.log = function (data) {
        $log.log(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'log', log: data});
      };

      instance.debug = function (data) {
        $log.debug(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'debug', log: data}).then(function () {
          $log.info('Simpan log ' + data.comment);
        }, function (error) {
          $log.warn({msg: 'Gagal menyimpan log ' + data.comment, err: error});
        });
      };

      instance.info = function (data) {
        $log.info(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'info', log: data});
      };

      instance.warn = function (data) {
        $log.warn(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'warn', log: data});
      };

      instance.error = function (data) {
        $log.log(data);
        ngDexie.put('logs', {timestamp: moment().format('DD-MM-YYYY HH:mm:ss'), type: 'error', log: data});
      };

      instance.getLog = function (option, callback) {
        $log.log(option);
        ngDexie.list('logs').then(function (data) {
          callback (data);
        });
      };

      return instance;

    }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('LOCATIONHandling', LOCATIONHandling);

  function LOCATIONHandling(APIHandling, $http) {
      var instance = this;

      // instance.provinsi = ["ACEH", "SUMATERA UTARA", "SUMATERA BARAT", "RIAU", "JAMBI", "SUMATERA SELATAN", "BENGKULU", "LAMPUNG", "KEPULAUAN BANGKA BELITUNG", "KEPULAUAN RIAU", "DKI JAKARTA", "JAWA BARAT", "JAWA TENGAH", "DI YOGYAKARTA", "JAWA TIMUR", "BANTEN", "BALI", "NUSA TENGGARA BARAT", "NUSA TENGGARA TIMUR", "KALIMANTAN BARAT", "KALIMANTAN TENGAH", "KALIMANTAN SELATAN", "KALIMANTAN TIMUR", "KALIMANTAN UTARA", "SULAWESI UTARA", "SULAWESI TENGAH", "SULAWESI SELATAN", "SULAWESI TENGGARA", "GORONTALO", "SULAWESI BARAT", "MALUKU", "MALUKU UTARA", "PAPUA BARAT", "PAPUA"];

      instance.provinsiRO = [
                              {
                                  "id": "1",
                                  "text": "Bali",
                                  "kode": "BA"
                              },
                              {
                                  "id": "2",
                                  "text": "Bangka Belitung",
                                  "kode": "BB"
                              },
                              {
                                  "id": "3",
                                  "text": "Banten",
                                  "kode": "BT"
                              },
                              {
                                  "id": "4",
                                  "text": "Bengkulu",
                                  "kode": "BE"
                              },
                              {
                                  "id": "5",
                                  "text": "DI Yogyakarta",
                                  "kode": "YO"
                              },
                              {
                                  "id": "6",
                                  "text": "DKI Jakarta",
                                  "kode": "JK"
                              },
                              {
                                  "id": "7",
                                  "text": "Gorontalo",
                                  "kode": "GO"
                              },
                              {
                                  "id": "8",
                                  "text": "Jambi",
                                  "kode": "JA"
                              },
                              {
                                  "id": "9",
                                  "text": "Jawa Barat",
                                  "kode": "JB"
                              },
                              {
                                  "id": "10",
                                  "text": "Jawa Tengah",
                                  "kode": "JT"
                              },
                              {
                                  "id": "11",
                                  "text": "Jawa Timur",
                                  "kode": "JI"
                              },
                              {
                                  "id": "12",
                                  "text": "Kalimantan Barat",
                                  "kode": "KB"
                              },
                              {
                                  "id": "13",
                                  "text": "Kalimantan Selatan",
                                  "kode": "KS"
                              },
                              {
                                  "id": "14",
                                  "text": "Kalimantan Tengah",
                                  "kode": "KT"
                              },
                              {
                                  "id": "15",
                                  "text": "Kalimantan Timur",
                                  "kode": "KI"
                              },
                              {
                                  "id": "16",
                                  "text": "Kalimantan Utara",
                                  "kode": "KU"
                              },
                              {
                                  "id": "17",
                                  "text": "Kepulauan Riau",
                                  "kode": "KR"
                              },
                              {
                                  "id": "18",
                                  "text": "Lampung",
                                  "kode": "LA"
                              },
                              {
                                  "id": "19",
                                  "text": "Maluku",
                                  "kode": "MA"
                              },
                              {
                                  "id": "20",
                                  "text": "Maluku Utara",
                                  "kode": "MU"
                              },
                              {
                                  "id": "21",
                                  "text": "Nanggroe Aceh Darussalam (NAD)",
                                  "kode": "AC"
                              },
                              {
                                  "id": "22",
                                  "text": "Nusa Tenggara Barat (NTB)",
                                  "kode": "NB"
                              },
                              {
                                  "id": "23",
                                  "text": "Nusa Tenggara Timur (NTT)",
                                  "kode": "NT"
                              },
                              {
                                  "id": "24",
                                  "text": "Papua",
                                  "kode": "PA"
                              },
                              {
                                  "id": "25",
                                  "text": "Papua Barat",
                                  "kode": "PB"
                              },
                              {
                                  "id": "26",
                                  "text": "Riau",
                                  "kode": "RI"
                              },
                              {
                                  "id": "27",
                                  "text": "Sulawesi Barat",
                                  "kode": "SR"
                              },
                              {
                                  "id": "28",
                                  "text": "Sulawesi Selatan",
                                  "kode": "SN"
                              },
                              {
                                  "id": "29",
                                  "text": "Sulawesi Tengah",
                                  "kode": "ST"
                              },
                              {
                                  "id": "30",
                                  "text": "Sulawesi Tenggara",
                                  "kode": "SG"
                              },
                              {
                                  "id": "31",
                                  "text": "Sulawesi Utara",
                                  "kode": "SA"
                              },
                              {
                                  "id": "32",
                                  "text": "Sumatera Barat",
                                  "kode": "SB"
                              },
                              {
                                  "id": "33",
                                  "text": "Sumatera Selatan",
                                  "kode": "SS"
                              },
                              {
                                  "id": "34",
                                  "text": "Sumatera Utara",
                                  "kode": "SU"
                              }
                            ];

      instance.getKabupaten = function (prov_id) {
        return APIHandling.get('raja-ongkir/get-kab', {prov_id: prov_id});
      };

      instance.getKecamatan = function (search) {
        return APIHandling.get('ongkir/get-kec', {search: search});
      };

      instance.getListKab = function (search) {
        return $http.get('https://ongkir.idwebmobile.com/api/public/raja-ongkir/list-kab', {
          params : { by_nama: search, per_page: 100 },
          paramSerializer: '$httpParamSerializerJQLike'
        });
      };

      return instance;

    }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('DETAILHandling', DETAILHandling);

    function DETAILHandling(pdfMake, _, $filter, $log, store) {
      var instance = this;

      var log = store.get('logPrint') || [];

      instance.print = function (data) {
        var tableContent = [
          ['Deskripsi', 'Harga', 'Jml', 'Diskon Produk','Total']
        ];

        _.each(data.produk_unik, function (item) {

          var baris = [];
          var size = item.size ? item.size.toString().toUpperCase() : '';

          var detail = angular.fromJson(item.detail);
          var family;

          if (detail.attributes) {
            family = _.find(detail.attributes, function (o) {
              return o.name === 'FAMILY';
            });
          }

          if (family) {
            family = "\nFamily: " + family.option;
          } else {
            family = '';
          }

          baris = [
            { text: item.nama + ' ' + size + family },
            { text: $filter('number')(item.harga_jual, 2), style: 'number' },
            { text: $filter('number')(item.jumlah, 0), style: 'number' },
            { text: $filter('number')(((item.discount_nominal * 1) + ((item.discount_persen/100) * (item.jumlah * 1) * item.harga_jual)), 2), style: 'number' },
            { text: $filter('number')((((item.jumlah * 1) * (item.harga_jual * 1)) - ((item.discount_nominal * 1) + ((item.discount_persen/100) * (item.jumlah * 1) * item.harga_jual))), 2), style: 'number' }
          ];

          tableContent.push(baris);

        });

        tableContent.push([
          { text: 'Jumlah', colSpan: 4, alignment: 'right'},
          {}, {}, {},
          { text: $filter('number')((((data.total_akhir * 1) + (data.discount_transaction_total * 1) - (data.total_lain_lain * 1)) || 0), 2), style: 'number' }
        ]);

        tableContent.push([
          { text: 'Biaya Lain', colSpan: 4, alignment: 'right'},
          {}, {}, {},
          { text: $filter('number')(data.total_lain_lain || 0, 2), style: 'number' }
        ]);

        tableContent.push([
          { text: 'Diskon Transaksi', colSpan: 4, alignment: 'right'},
          {}, {}, {},
          { text: $filter('number')(data.discount_transaction_total || 0, 2), style: 'number' }
        ]);

        tableContent.push([
          { text: 'Total', colSpan: 4, alignment: 'right', bold: true },
          {},
          {},
          {},
          {
            text: $filter('number')(
              data.total_akhir * 1,
              2
            ),
            style: 'number',
            bold: true,
          },
        ]);


        var docDefinition = {
          pageSize: 'A6',
          pageOrientation: 'landscape',
          pageMargins: [ 20, 20, 20, 20 ],

          content: [
            {text: data.dropship != 2 ? 'Zafrada' : '', style: 'header'},
            {
              columns: [
                {
                  columns: [
                    { text: 'Nomor Trx', width: '25%' },
                    { text: ':', alignment: 'center', width: '5%' },
                    { text: '#' + data.id, width: '60%' }
                  ],
                  width: '50%'
                },
                { text: 'Tanggal  :  ' + $filter('udate')(data.tgl, 'dd-MM-yyyy HH:mm:ss'), alignment: 'right', width: '50%' }

              ]
            },
            {
              columns: [
                {
                  columns: [
                    { text: 'Pembeli', width: '25%' },
                    { text: ':', alignment: 'center', width: '5%' },
                    { text: data.pembeli, width: '60%' }
                  ],
                  width: '50%'
                }
              ]
            },
            {
              style: 'tableProduct',
              table: {
                widths: [ '35%', '20%', '5%', '20%', '20%' ],
								headerRows: 1,
                body: tableContent
              }
            }
          ],
          defaultStyle: {
            font: 'CrimsonText',
            fontSize: 8
          },
          styles: {
            spclass: {
              fontSize: 4
            },
            tableProduct: {
              margin: [0, 5, 0, 15]
            },
            header: {
              font: 'CrimsonText',
              fontSize: 12,
              bold: true
            },
            number: {
              font: 'CourierPrime',
              alignment: 'right',
              fontSize: 8,
              marginTop: 2
            }
         }
        };

        /*  Masukkan list produk ke dalam doc */
        // docDefinition.content.splice(9, 0, produk);

        pdfMake.fonts = {
          CourierPrime: {
            normal: 'CourierPrime.ttf',
            bold: 'CourierPrimeBold.ttf',
            italics: 'CourierPrimeItalic.ttf',
            bolditalics: 'CourierPrimeBoldItalic.ttf'
          },
          CrimsonText: {
            normal: 'CrimsonText-Roman.ttf',
            bold: 'CrimsonText-Bold.ttf',
            italics: 'CrimsonText-Italic.ttf',
            bolditalics: 'CrimsonText-BoldItalic.ttf'
          }
        };

        /* Log data untuk debug */
        $log.debug('Data diterima');
        $log.info(data);
        $log.debug('Doc Definition');
        $log.info(docDefinition);
        log.unshift({
          time: new Date(),
          data: data,
          docDefinition: docDefinition
        });
        log.splice(5, 1000);

        store.set('logPrint', log);
        // $log.info(angular.toJson(docDefinition));

        pdfMake.createPdf(docDefinition).download(data.id + '.pdf');
      };

      return this;

    }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('CUSTOMERHandling', CUSTOMERHandling);

    function CUSTOMERHandling(APIHandling, Oresell) {
      var instance = this;

      this.getCustomer = function (cust_id, isOresell) {

        if (isOresell) {
          return Oresell.contact.get(cust_id);
        } else {
          return APIHandling.get('kontak/get', { id: cust_id });
        }

      };

      this.listCustomer = function (params) {
        return APIHandling.get('kontak/list', params);
      };

      this.saveCustomer = function (data) {
        return APIHandling.post('kontak/save', data, true);
      };

      return instance;

    }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('AuthInterceptor', AuthInterceptor);

  /** @ngInject */
  function AuthInterceptor($q, $injector) {
    return {
        'responseError': function (rejection) {

            var invalidToken = false;

            if (rejection.status === 400) {
              invalidToken = true;
            }

            if (invalidToken || rejection.status === 401) {
                $injector.get('$state').go('login');
            }

            return $q.reject(rejection);
        }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .factory('APIHandling', APIHandling);

  function APIHandling($http, store, $q, $timeout, BASEURL, TIMEOUT) {
    var instance = this;

    /* Batas timeout http request, dalam ms */
    this.timeOutLimit = TIMEOUT;

    /* baseURL API Call */
    this.baseURL = BASEURL;

    this.httpRequest = function (method, endpoint, data, params, loading) {

      if (loading) {
        angular.element('.loading-animation').show();
      }

      /* Set timeout dan result sebagai promise */
      var timeout = $q.defer();
      var result = $q.defer();

      /* Set status timeout */
      var isTimeOut = false;

      /* Set timeout untuk resolve dalam jangka waktu yang ditentukan, yaitu timeOutLimit */
      $timeout(function () {
          /* Set status timeout menjadi true jika promise timeout resolved */
          isTimeOut = true;
          timeout.resolve();
      }, (instance.timeOutLimit));

      /* Lakukan http request, set timeout terjadi ketika promise timeout resolved, yaitu pada saat timeOutLimit */
      // var req = $http.get( instance.baseURL + endpoint, { params: data, timeout: timeout.promise, paramSerializer: '$httpParamSerializerJQLike' });

      var req = $http({
          method: method,
          url: instance.baseURL + endpoint,
          data: data,
          params: params,
          paramSerializer: '$httpParamSerializerJQLike',
          timeout: instance.timeOutLimit,
          headers: {
              'Accept': 'application/json;charset=utf-8',
              'Content-Type': 'application/json;charset=utf-8'
          }
      });

      req.then(function (response) {
        if (loading) {
          angular.element('.loading-animation').hide();
        }

        return result.resolve(response);
      }, function (error) {
          if (loading) {
            angular.element('.loading-animation').hide();
          }
        /*
          Jika status timeout === true, maka request belum dapat balasan saat timeout resolved, berarti request belum dapat response melebihi
          waktu timeout yang kita sediakan. Maka set response error dengan status 408 Request Timeout
        */
        if (isTimeOut) {
          result.reject({
            status: 408,
            statusText: 'Request Timeout',
            data: {
              message: 'Proses lebih lama dari ' + (instance.timeOutLimit / 1000) + ' detik dan belum mendapat balasan. Batalkan'
            }
          });
        } else {
            result.reject(error);
        }
      });

      return result.promise;
    };

    this.get = function (endpoint, params, loading) {
      // return $http.get( instance.baseURL + endpoint, { params: data, timeout: instance.timeOutLimit, paramSerializer: '$httpParamSerializerJQLike' });
      return instance.httpRequest('GET', endpoint, null, params, loading);
    };

    this.post = function (endpoint, data, loading) {
      // return $http.post( instance.baseURL + endpoint, data, { timeout: (instance.timeOutLimit) });
      return instance.httpRequest('POST', endpoint, data, null, loading);
    };

    this.login = function (username, password) {
      return $http(
            {
                method: 'POST',
                url: instance.baseURL + 'user/login',
                data: {uname : username, password: password},
                timeout: instance.timeOutLimit,
                skipAuthorization: true,
                headers: {
                    'Accept': 'application/json;charset=utf-8',
                    'Content-Type': 'application/json;charset=utf-8'
                }
            }
        );
    };

    this.getLiveStock = function (data) {
      return $http.get( instance.baseURL + 'daftar-produk', { params: data, timeout: instance.timeOutLimit, skipAuthorization: true, paramSerializer: '$httpParamSerializerJQLike' });
    };

    this.cleanLoginState = function () {
      store.remove('token');
      store.remove('info');
    };

    this.saveLoginState = function (loginData) {
      store.set('token', loginData.data.token);
      store.set('info', loginData.data.user);
    };

    this.getCurrentUser = function () {
      return store.get('info');
    };

    this.getInfoServer = function () {
      return $http.get(instance.baseURL + 'info');
    };

    return this;

  }
})();

/* eslint-disable comma-dangle */
(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .factory("ADDRESSHandling", ADDRESSHandling);

  function ADDRESSHandling(pdfMake, _, $filter, $log, $window) {
    var instance = this;

    instance.printNormal = function (data, address) {
      /** Handle alamat pengirim */
      var alamat;

      if (address.sender.selected !== "ethica") {
        alamat = [
          { text: "Pengirim:", style: "sender", bold: true },
          { text: address.sender.sender.nama || "", style: "sender" },
          {
            text: address.sender.sender.hp ? address.sender.sender.hp : "",
            style: "sender",
          },
        ];
      } else {
        alamat = [
          { text: 'Pengirim:', style: 'sender', bold: true },
          { text: 'Zafrada.com', style: 'sender' },
          { text: '+6285334988010', style: 'sender' },
        ];
      }

      /** Handle content */
      /**
       * 1. Siapkan alamat penerima, bisa berdasar data dari kontak atau dari data custom
       * 2. Gabungkan dengan data pengirim
       */
      var content;
      var penerima;

      if (address.receiver.selected === "custom") {
        penerima = [
          { text: address.receiver.receiver.nama, style: "name" },
          { text: address.receiver.receiver.address, style: "address" },
          { text: address.receiver.receiver.hp, style: "phone" },
        ];
      } else {
        penerima = [
          { text: data.nama, style: "name" },
          {
            text: (data.alamat || "") + " " + (data.kec || ""),
            style: "address",
          },
          {
            text:
              (data.kab || "") +
              " " +
              (data.prov || "") +
              " " +
              (data.kode_pos || ""),
            style: "address",
          },
          { text: data.hp || "", style: "phone" },
        ];
      }

      content = penerima.concat([
        { text: "   ", style: "sender" },
        {
          columns: [
            [
              { text: "Ekspedisi:", style: "expedition", bold: true },
              {
                text:
                  address.ekspedisi.nama + " - " + address.ekspedisi.service,
                style: "expedition",
                bold: true,
              },
              {
                text: address.ekspedisi.jobNumber
                  ? address.ekspedisi.jobNumber
                  : "",
                style: "expedition",
                bold: false,
              },
            ],
            alamat,
          ],
        },
      ]);

      var docDefinition = {
        pageSize: {
          width: 297.64,
          height: 595.28,
        } /** Lebar == lebar A6, tinggi == lebar A4 */,
        pageOrientation: "landscape",
        pageMargins: [20, 20, 20, 20],

        content: content,
        defaultStyle: {
          font: "CrimsonText",
          fontSize: 10,
        },
        styles: {
          name: {
            fontSize: 32,
            bold: true,
          },
          address: {
            fontSize: 18,
          },
          phone: {
            fontSize: 18,
          },
          expedition: {
            fontSize: 12,
          },
          sender: {
            fontSize: 12,
            alignment: "left",
          },
        },
      };

      pdfMake.fonts = {
        CourierPrime: {
          normal: "CourierPrime.ttf",
          bold: "CourierPrimeBold.ttf",
          italics: "CourierPrimeItalic.ttf",
          bolditalics: "CourierPrimeBoldItalic.ttf",
        },
        CrimsonText: {
          normal: "CrimsonText-Roman.ttf",
          bold: "CrimsonText-Bold.ttf",
          italics: "CrimsonText-Italic.ttf",
          bolditalics: "CrimsonText-BoldItalic.ttf",
        },
      };

      $log.warn(docDefinition);

      pdfMake.createPdf(docDefinition).print();
    };

    instance.printPOS58 = function (data, address) {
      /** Handle alamat pengirim */
      var alamat;

      if (address.sender.selected !== "ethica") {
        alamat = {
          name: address.sender.sender.nama || "",
          phone: address.sender.sender.hp ? address.sender.sender.hp : "",
        };
      } else {
        alamat = {
          name: "Zafrada",
          phone: "6285334988010",
        };
      }

      var penerima;

      if (address.receiver.selected === "custom") {
        penerima = {
          name: address.receiver.receiver.nama,
          address: address.receiver.receiver.address,
          phone: address.receiver.receiver.hp,
        };
      } else {
        penerima = {
          name: data.nama,
          address:
            (data.alamat || "") +
            " " +
            (data.kec || "") +
            " " +
            (data.kab || "") +
            " " +
            (data.prov || "") +
            " " +
            (data.kode_pos || ""),
          phone: data.hp || "",
        };
      }

      var strContent =
        '<!DOCTYPE html><html lang="en"> <head> <meta charset="UTF-8"/> <meta http-equiv="X-UA-Compatible" content="IE=edge"/> <meta name="viewport" content="width=device-width, initial-scale=1.0"/> <title>Alamat</title> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"/> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css" integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic=" crossorigin="anonymous"/> <link rel="preconnect" href="https://fonts.googleapis.com"/> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/><style>body.A6 .sheet{width: 105mm; height: 148mm;}body.A6.landscape .sheet{width: 149mm; height: 104mm;}@page{size: A6 landscape;}body{font-family: "Roboto Mono", Courier, monospace;}table{width: 100%; vertical-align: text-top;}tr, td{vertical-align: text-top;}</style> </head> <body class="A6 landscape" onload="window.print();window.close();" ><section class="sheet padding-10mm"> <h2>' +
        penerima.name +
        "</h2> <h4>" +
        penerima.address +
        "<br/>" +
        penerima.phone +
        '</h4> <table> <tr> <td style="width: 50%"> <h4> Ekspedisi:<br/>' +
        address.ekspedisi.nama;

      if (address.ekspedisi.service) {
        strContent = strContent +
        " - " +
        address.ekspedisi.service;
      }

      if (address.ekspedisi.jobNumber) {
        strContent = strContent + "<br>" + address.ekspedisi.jobNumber;
      }

      strContent =
        strContent +
        '</h4> </td><td style="width: 50%"> <h4> Pengirim:<br/>' +
        alamat.name +
        "<br/>" +
        alamat.phone +
        "</h4> </td></tr></table><div style='border:2px solid #000;' ><p style='text-align:center;font-size: 0.9em;'><strong>DISCLAIMER: Komplain wajib menyertakan video unboxing</strong></p></div></section></body></html>";

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    instance.print = function (type, data, address) {
      if (type === 0) {
        this.printNormal(data, address);
      } else {
        this.printPOS58(data, address);
      }
    };

    /**
     *
     * @param {sender: *, receiver: *, expedition: *}[] data
     */
    instance.bulkPrintPOS58 = function (data) {
      var strContent =
        '<!DOCTYPE html><html lang="en"> <head> <meta charset="UTF-8"/> <meta http-equiv="X-UA-Compatible" content="IE=edge"/> <meta name="viewport" content="width=device-width, initial-scale=1.0"/> <title>Alamat</title> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css"/> <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/paper-css@0.4.1/paper.min.css" integrity="sha256-TYbLI7iEcpj/xvgetSyNT1Y077kszG89bszeY8cZLic=" crossorigin="anonymous"/> <link rel="preconnect" href="https://fonts.googleapis.com"/> <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/><style>body.A6 .sheet{width: 105mm; height: 148mm;}body.A6.landscape .sheet{width: 149mm; height: 104mm;}@page{size: A6 landscape;}body{font-family: "Roboto Mono", Courier, monospace;}table{width: 100%; vertical-align: text-top;}tr, td{vertical-align: text-top;}</style> </head> <body class="A6 landscape" onload="window.print();window.close();" >';

      _.each(data, function (transaction) {
        strContent =
          strContent +
          '<section class="sheet padding-10mm"> <h2>' +
          transaction.receiver.name +
          "</h2> <h4>" +
          transaction.receiver.address +
          "<br/>" +
          transaction.receiver.phone +
          '</h4> <table> <tr> <td style="width: 50%"> <h4> Ekspedisi:<br/>' +
          transaction.expedition.name +
          " - " +
          transaction.expedition.service;

        if (transaction.expedition.jobNumber) {
          strContent = strContent + "<br>" + transaction.expedition.jobNumber;
        }

        strContent =
          strContent +
          '</h4> </td><td style="width: 50%"> <h4> Pengirim:<br/>' +
          transaction.sender.name +
          "<br/>" +
          transaction.sender.phone +
          " </h4> </td></tr></table><div style='border:2px solid #000;' ><p style='text-align:center;font-size: 0.9em;'><strong>DISCLAIMER: Komplain wajib menyertakan video unboxing</strong></p></div></section>";
      });

      strContent = strContent + "</body></html>";

      var popupWin = $window.open("", "_blank", "width=1200,height=600");
      popupWin.document.open();
      popupWin.document.write(strContent);
      popupWin.document.close();
    };

    return this;
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('UplineResellerDialogController', UplineResellerDialogController);

  /** @ngInject */
  function UplineResellerDialogController($uibModalInstance, $log, toastr, Oresell, data, _) {
    var vm = this;

    vm.dataReseller = _.cloneDeep(data);
    vm.resellerList = [];
    vm.selectedUpline;

    vm.process = function () {

      var data = _.cloneDeep(vm.dataReseller);

      if (vm.selectedUpline) {
        data.upline = vm.selectedUpline.email;
      } else {
        data.upline = null;
      }


      Oresell.reseller.setUpline(data).then(function () {
        toastr.success('Berhasil ubah upline', 'Proses Berhasil');
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat ubah upline', 'Proses Gagal');
        $log.error(error);
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    vm.getReseller = function (search) {
      if (search.length >= 3) {
        Oresell.reseller.list({search: search}).then(function (response) {
          vm.resellerList = response.data.users;
        }, function (error) {
          $log.error(error);
        });
      }
    };

    vm.clear = function () {
      vm.dataReseller.upline = null;
      vm.selectedUpline = null;
    };

    vm.initView = function () {
      if (vm.dataReseller.upline) {
        Oresell.reseller.list({email: vm.dataReseller.upline}).then(function (response) {
          vm.selectedUpline = response.data.users[0];
        }, function (error) {
          $log.error(error);
        });
      }
    };

    vm.initView();

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('StockHabisController', StockHabisController);

  /** @ngInject */
  function StockHabisController($uibModalInstance, data, $log) {
      var vm = this;
      $log.debug(data);
      vm.item = data.product;

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('SettingOtoresellDialogController', SettingOtoresellDialogController);

  /** @ngInject */
  function SettingOtoresellDialogController($uibModalInstance, $log, toastr, Oresell) {
    var vm = this;

    vm.setting = {
      fine: 0
    };

    vm.process = function () {
      Oresell.reseller.setSetting(vm.setting).then(function () {
        toastr.success('Berhasil simpan setting', 'Proses Berhasil');
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat simpan setting', 'Proses Gagal');
        $log.error(error);
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    Oresell.reseller.getSetting().then(function (response) {
      vm.setting = response.data.value;
    }, function (error) {
      $log.error(error);
      toastr.error('Gagal mengambil data setting', "Error");
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ResetPasswordResellerDialogController', ResetPasswordResellerDialogController);

  /** @ngInject */
  function ResetPasswordResellerDialogController($uibModalInstance, $log, toastr, Oresell, data) {
    var vm = this;

    vm.reseller = data;

    vm.process = function () {
      Oresell.reseller.resetPassword(vm.reseller).then(function () {
        toastr.success('Reset password reseller berhasil. Sistem telah mengirim email ke alamat reseller untuk memasukkan password baru', 'Proses Berhasil');
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat reset password reseller', 'Proses Gagal');
        $log.error(error);
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ProcessOresellTransactionDialogController', ProcessOresellTransactionDialogController);

  /** @ngInject */
  function ProcessOresellTransactionDialogController($uibModalInstance,  _, $log, Oresell, toastr, data) {
    var vm = this;
    vm.resume = data.resume;

    vm.finish = function () {

      Oresell.order.process({id: vm.resume.id}).then( function (response) {
        $log.debug(response);
        toastr.success('Berhasil memproses transaksi #' + vm.resume.id , 'Sukses');
        $uibModalInstance.close('Ok');
      }, function (error) {
        $log.error(error);
        toastr.error('Gagal memproses transaksi #' + vm.resume.id, 'Gagal');
      });
    };

    vm.batal = function () {
        $uibModalInstance.dismiss('batal');
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('PilihAlamatCetakDialogController', PilihAlamatCetakDialogController);

  /** @ngInject */
  function PilihAlamatCetakDialogController($uibModalInstance, data) {
    var vm = this;

    vm.data = data;

    vm.address = {
      selected: vm.data.dropship >=1 ? 'reseller' : 'ethica',
      sender: {
        nama: null,
        hp: null
      }
    };

    vm.customeraddress = {
      selected: 'transaction',
      receiver: {
        nama: null,
        hp: null
      }
    };

    vm.process = function () {

      $uibModalInstance.close({
          sender: vm.address,
          receiver: vm.customeraddress
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ListTransaksiController', ListTransaksiController);

  /** @ngInject */
   function ListTransaksiController($uibModalInstance, data, APIHandling, _, moment, $log, toastr) {
      var vm = this;

      vm.data = data;
      vm.filter = {
        page: 1,
        per_page: 10,
        by_id: null,
        by_pembeli: null,
        by_cust_id: ((vm.data.filter.dropship === 1) || (vm.data.filter.dropship === 2)) ? null : vm.data.customer.cust_id,
        by_reseller_id: ((vm.data.filter.dropship === 1) || (vm.data.filter.dropship === 2)) ? vm.data.customer.reseller_id : null,
        tgl_min: moment(vm.data.filter.tgl_min).format('YYYY-MM-DD'),
        tgl_max: moment(vm.data.filter.tgl_max).format('YYYY-MM-DD'),
        tgl_opt: 4, /* Di antara tgl_min dan tgl_max */
        order_by: 'by_tgl',
        sorting: 'desc'
      };

     vm.maxPage = 1;

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

      vm.getTransaction = function(page) {
        vm.filter.page = page;

        APIHandling.get('order/list', vm.filter).then(function (response) {
          if (page === 1) {
            vm.maxPage = (response.data.max_page * 1) || 1;
          }

          /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
          if (page === vm.maxPage) {
            vm.isLastPage = true;
          } else {
            vm.isLastPage = false;
          }

          vm.transactionList = response.data.data;
          vm.shownPage = vm.filter.page;

          _.each(vm.transactionList, function (n) {
            n.lain_lain = angular.fromJson(n.lain_lain);
          });
        }, function (error) {
          $log.error(error);
          if (error.status === 408) {
            toastr.error(error.data.message, 'Terjadi Kesalahan');
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data transaksi', 'Terjadi Kesalahan');
          }
        });
      };

      vm.getTransaction(1);

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ListOtoresellDepositDialogController', ListOtoresellDepositDialogController);

  /** @ngInject */
  function ListOtoresellDepositDialogController($uibModalInstance, $log, toastr, data, Oresell) {
    var vm = this;

    vm.reseller = data;
    vm.maxPage = 1;

    vm.filter = {
      page: 1,
      per_page: 10,
      id: data.email,
      tglAwal: null,
      tglAkhir: null,
      type: null,
      description: null
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    vm.getData = function(page) {
      vm.filter.page = page;

      Oresell.reseller.listDeposit(vm.filter).then(function (response) {
        if (response.data.max_page) {
          vm.maxPage = response.data.max_page;
        }

        vm.mutasi = response.data;
      }, function (error) {
        $log.error(error);
        toastr.error('Gagal mengambil data setting', "Error");
      });
    };

    vm.getData(1);

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ImportCSVDialogController', ImportCSVDialogController);

  /** @ngInject */
  function ImportCSVDialogController($uibModalInstance, $log, APIHandling, toastr, Papa, _) {
      var vm = this;
      vm.inProcess = false;

      vm.fields = {
        source: [
          {id: 'sku', nama: 'SKU Produk'},
          {id: 'nama', nama: 'Nama Produk'},
          {id: 'harga', nama: 'Harga Produk'},
          {id: 'weight', nama: 'Berat Produk'},
          {id: 'stok', nama: 'Perubahan Stok'}
        ],
        result: []
      };

      vm.finish = function () {
          $uibModalInstance.close('Ok');
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };


      var uploadData = function (data) {

          var payload = {
              data: data.data,
              fields : data.fields
          };

          APIHandling.post('produk/import-csv', payload, true).then(function () {
              toastr.success('Berhasil menyimpan data produk yang diimport', 'Simpan data berhasil');
              $uibModalInstance.close('Ok');
          }, function (error) {
              var msg;


              if ( error.status === 422 ) {

                msg = 'Format csv yang diimport tidak valid : ';

                for (var e in error.data) {
                    msg = msg + '<br /> * ' + error.data[e];
                }

              } else if ( error.status === 400 ) {

                msg = 'Data csv yang diimport tidak valid : <br />' + error.data[0] ;

              } else {
                $log.debug( error );
                msg = 'Import CSV tidak berhasil karena adanya kesalahan';
              }

              toastr.error(msg, 'Gagal Simpan Data', {
                closeButton: true,
                timeOut: 0
              });

          }).finally(function () {
              vm.inProcess = false;
              angular.element('.loading-animation').hide();
          });
      };

      vm.importTheFile = function () {

        if (!vm.inputFile) {
          toastr.error('Harap pilih terlebih dahulu file yang akan diimport', 'Import file gagal');
        }

        if (_.isEmpty(vm.fields.result)) {
          toastr.error('Harap pilih terlebih fields yang akan disimpan', 'Import file gagal');
        }

        if ((vm.inputFile) && (!_.isEmpty(vm.fields.result))) {

          vm.inProcess = true;
          angular.element('.loading-animation').show();

          var fields = [];

          _.each(vm.fields.result, function (n) {
            fields.push(n.id);
          });

          Papa.parse(vm.inputFile, {
              header: true,
              skipEmptyLines : true,
              complete: function(results) {
                  uploadData({
                    data : results.data,
                    fields : fields
                  });
              }
          });
        }
      };

  }

})();

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EntryResiDialogController', EntryResiDialogController);

  /** @ngInject */
  function EntryResiDialogController($uibModalInstance, $log, toastr, APIHandling, data, _) {
    var vm = this;
    vm.baru = data.baru;
    vm.transaksi = _.cloneDeep(data.transaksi);
    vm.numberPattern = /^\d+$/;

    vm.resi = {
      id: vm.transaksi.id,
      ekspedisi: 'jne',
      nama_ekspedisi: 'jne',
      no_resi: null,
      target: 's',
      nohp: null,
      original_ekspedisi: 'jne'
    };

    vm.finish = function () {

      APIHandling.post('order/resi', vm.resi, true).then(function () {
        toastr.success('Berhasil simpan resi transaksi #' + vm.resi.id, 'Resi Tersimpan');
        $uibModalInstance.close('Ok');
      }, function (error) {

        $log.error(error);

        switch (error.status) {
          case 404:
            toastr.warning('Resi tersimpan, tanpa SMS karena data pelanggan tidak ada', 'Resi Tersimpan');
            break;
          case 423:
            toastr.warning('Resi tersimpan, tanpa SMS karena tidak ada nomor HP pelanggan', 'Resi Tersimpan');
            break;
          case 422:
            toastr.warning('Resi tersimpan, tanpa SMS karena bukan pelanggan', 'Resi Tersimpan');
            break;
          default:
            toastr.error('Terjadi masalah saat menyimpan data. Gagal menyimpan resi transaksi.', 'Gagal simpan');
            break;
        }

        $uibModalInstance.close('NotFullOK');

      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    vm.changeEkspedisi = function () {
      if (vm.resi.ekspedisi !== 'lain') {
        vm.resi.nama_ekspedisi = vm.resi.ekspedisi;
      } else {
        vm.resi.nama_ekspedisi = null;
      }

    };

    vm.prepareNoHP = function () {
      if (vm.transaksi.dropship === 1) {
        vm.resi.nohp = vm.transaksi.lain_lain.dropship.sender.hp ? vm.transaksi.lain_lain.dropship.sender.hp : vm.transaksi.lain_lain.dropship.alamat_sender;
      } else if (vm.transaksi.dropship === 2) {
        vm.resi.nohp = vm.transaksi.lain_lain.dropship.sender.hp;
      }
    };

    vm.changeSMSTarget = function () {
      if (vm.resi.target === 's') {
        vm.prepareNoHP();
      } else {
        vm.resi.nohp = null;
      }
    };

    vm.init = function () {
      if (vm.transaksi.ekspedisi) {
        vm.resi.no_resi = vm.transaksi.no_resi;
        vm.resi.ekspedisi = vm.transaksi.ekspedisi;
        vm.resi.nama_ekspedisi = vm.transaksi.ekspedisi;
        // vm.resi.original_ekspedisi = vm.transaksi.ekspedisi;

        if (!vm.transaksi.lain_lain.original_ekspedisi) {
          vm.resi.original_ekspedisi = vm.transaksi.ekspedisi;
        }

        if (_.indexOf(['jne', 'J&T', 'pos', 'lion'], vm.transaksi.ekspedisi) < 0) {
          vm.resi.ekspedisi = 'lain';
        }

      }

      vm.prepareNoHP();
    };

    vm.init();

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditUserDialogController', EditUserDialogController);

  /** @ngInject */
  function EditUserDialogController($uibModalInstance,  _, $log, toastr, APIHandling, data) {
      var vm = this;
      vm.user = {};

      if (_.isUndefined(data)) {
        vm.user = {
          uname: null,
          password: null,
          confirm_password: null,
          detail: {
            name: null
          },
          new: 1
        };
      } else {
        vm.user.uname = data.uname;
        vm.user.detail = {
          name: data.detail ? data.detail.name : null
        };
        vm.user.group = data.group;
        vm.new = 0;
      }

      vm.finish = function () {

        APIHandling.post('user/save', vm.user, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil simpan data pengguna', 'Berhasil simpan');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data pengguna', 'Gagal simpan');
        }).finally( function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditStockDialogController', EditStockDialogController);

  /** @ngInject */
  function EditStockDialogController($uibModalInstance, $log, toastr, APIHandling, data, _) {
      var vm = this;
      vm.item = _.cloneDeep(data.item);

      vm.finish = function () {

        APIHandling.post('stok/edit', vm.item, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil simpan data stok', 'Berhasil simpan');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal simpan data stok', 'Gagal simpan');
        }).finally( function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditStatusResellerDialogController', EditStatusResellerDialogController);

  /** @ngInject */
  function EditStatusResellerDialogController($uibModalInstance, $log, toastr, Oresell, data, _) {
    var vm = this;

    vm.dataReseller = _.cloneDeep(data);

    if (vm.dataReseller.level === 0) {
      vm.dataReseller.level = 1;
    }
    vm.dataReseller.level = vm.dataReseller.level.toString();

    vm.process = function () {

      var data = _.cloneDeep(vm.dataReseller);
      data.level = data.level * 1;

      Oresell.reseller.status(data).then(function () {
        toastr.success('Berhasil ubah status', 'Proses Berhasil');
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat ubah status', 'Proses Gagal');
        $log.error(error);
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditDiskonOtoresellerDialogController', EditDiskonOtoresellerDialogController);

  /** @ngInject */
  function EditDiskonOtoresellerDialogController($uibModalInstance, $log, toastr, APIHandling, data, _) {
      var vm = this;
      vm.item = _.cloneDeep(data);

      vm.finish = function () {

        APIHandling.post('produk/set-diskon-otoresell', vm.item, true).then( function () {
          toastr.success('Berhasil simpan diskon', 'Berhasil simpan');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal simpan diskon', 'Gagal simpan');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditDiskonKategoriOtoresellerDialogController', EditDiskonKategoriOtoresellerDialogController);

  /** @ngInject */
  function EditDiskonKategoriOtoresellerDialogController($uibModalInstance, $log, toastr, APIHandling, data, _) {
      var vm = this;
      vm.item = _.cloneDeep(data);

      vm.finish = function () {

        APIHandling.post('produk/set-diskon-kategori', vm.item, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil simpan diskon', 'Berhasil simpan');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal simpan diskon', 'Gagal simpan');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('EditDepositDialogController', EditDepositDialogController);

  /** @ngInject */
  function EditDepositDialogController($uibModalInstance, $log, toastr, Oresell, data, _) {
    var vm = this;
    vm.inProcess = false;

    vm.deposit = {
      owner: null,
      debet: 0,
      credit: 0,
      type: 'DEPOSIT',
      ticket: null,
      description: null
    };

    vm.listTicket = [];

    // vm.getReseller = function (search) {
    //   Oresell.reseller.list({search: search}).then(function (response) {
    //     vm.resellerList = response.data.users;
    //   }, function (error) {
    //     $log.error(error);
    //   });
    // };

    vm.dataReseller = _.cloneDeep(data);

    vm.changeType = function () {
      vm.deposit.debet = 0;
      vm.deposit.credit = 0;
      vm.deposit.ticket = null;
      vm.deposit.bank = null;
    };

    vm.changeTicket = function () {
      if (vm.deposit.ticket) {
        vm.deposit.debet = vm.deposit.ticket.total_transfer * 1;
        vm.deposit.credit = 0;
        vm.deposit.bank = 'BCA';
      } else {
        vm.deposit.debet = 0;
        vm.deposit.credit = 0;
        vm.deposit.bank = null;
      }
    };

    vm.process = function () {

      vm.inProcess = true;

      var deposit = _.cloneDeep(vm.deposit);

      deposit.owner = vm.dataReseller.email;

      if (vm.deposit.type === 'DEPOSIT-C') {
        deposit.type = 'DEPOSIT';
      }

      if (vm.deposit.ticket) {
        deposit.ticket = vm.deposit.ticket.id;
      }

      Oresell.deposit.change(deposit).then(function (response) {
        $log.info(response.data);
        toastr.success('Berhasil memproses deposit', 'Proses Berhasil');
        vm.inProcess = false;
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat proses deposit', 'Proses Gagal');
          $log.error(error);
          vm.inProcess = false;
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    vm.initView = function () {
      Oresell.ticket.list('NEW', vm.dataReseller.email).then(function (response) {
        vm.listTicket = response.data.data;
      }, function (error) {
        toastr.error('Terjadi masalah saat proses cek tiket', 'Proses Gagal');
          $log.error(error);
          vm.inProcess = false;
      });
    };

    vm.initView();


  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DiskonLevelResellerDialogController', DiskonLevelResellerDialogController);

  /** @ngInject */
  function DiskonLevelResellerDialogController($uibModalInstance, $log, toastr, Oresell) {
    var vm = this;

    // vm.discount = {
    //   'silver': 20,
    //   'gold': 30,
    //   'platinum': 40
    // };

    vm.listLevel = [];

    vm.process = function () {
      Oresell.reseller.setDiscount(vm.listLevel).then(function () {
        toastr.success('Berhasil set diskon level', 'Proses Berhasil');
        $uibModalInstance.close('ok');
      }, function (error) {
        toastr.error('Terjadi masalah saat set diskon level', 'Proses Gagal');
        $log.error(error);
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };

    Oresell.reseller.getDiscount().then(function (response) {
      vm.listLevel = response.data;
    }, function (error) {
      $log.error(error);
      toastr.error('Gagal mengambil data level', "Error");
    });

  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DeleteResellerDialogController', DeleteResellerDialogController);

  /** @ngInject */
  function DeleteResellerDialogController($uibModalInstance,  _, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.user = data;

      vm.finish = function () {

        APIHandling.post('oresell/reseller/delete', {listId: [vm.user.email]}, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil menghapus reseller', 'Sukses hapus');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal menghapus reseller', 'Gagal hapus');
        }).finally(function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DeleteUserDialogController', DeleteUserDialogController);

  /** @ngInject */
  function DeleteUserDialogController($uibModalInstance,  _, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.user = data;

      vm.finish = function () {

        APIHandling.post('user/delete', {id: vm.user.id}, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil menghapus pengguna', 'Sukses hapus');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal menghapus pengguna', 'Gagal hapus');
        }).finally(function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DeleteInactiveResellerDialogController', DeleteInactiveResellerDialogController);

  /** @ngInject */
  function DeleteInactiveResellerDialogController($uibModalInstance,  _, $log, APIHandling, toastr) {
      var vm = this;

      vm.finish = function () {

        APIHandling.post('oresell/reseller/delete-inactive', null, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil menghapus reseller nonaktif', 'Sukses hapus');
        }, function (error) {
          $log.debug(error);
          toastr.error('Gagal menghapus reseller nonaktif', 'Gagal hapus');
        }).finally(function () {
          $uibModalInstance.close('Ok');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('ChangeStockDialogController', ChangeStockDialogController);

  /** @ngInject */
  function ChangeStockDialogController($uibModalInstance) {
    var vm = this;

    vm.finish = function () {
        $uibModalInstance.close('Ok');
    };

    vm.batal = function () {
        $uibModalInstance.dismiss('batal');
    };

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('CancelTransactionDialogController', CancelTransactionDialogController);

  /** @ngInject */
  function CancelTransactionDialogController($uibModalInstance,  _, $log, APIHandling, toastr, data) {
      var vm = this;
      vm.resume = data.resume;

      vm.finish = function () {

        APIHandling.post('order/cancel', {id: vm.resume.id}, true).then( function (response) {
          $log.debug(response);
          toastr.success('Berhasil membatalkan transaksi #' + vm.resume.id , 'Sukses');
          $uibModalInstance.close('Ok');
        }, function (error) {
          $log.error(error);
          toastr.error('Gagal membatalkan transaksi #' + vm.resume.id, 'Gagal');
        });
      };

      vm.batal = function () {
          $uibModalInstance.dismiss('batal');
      };

  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('CashierNoteDialogController', CashierNoteDialogController);

  /** @ngInject */
  function CashierNoteDialogController(
    $uibModalInstance,
    $log,
    toastr,
    _,
    data,
    OrderNote
  ) {
    var vm = this;
    vm.transaksi = _.cloneDeep(data.transaksi);
    vm.cashierNote = [];

    vm.userNote = null;

    vm.addNote = function() {
      OrderNote.create({
        transaction_id: vm.transaksi.id,
        note: vm.userNote,
      }).then(
        function(response) {
          toastr.success('Catatan ditambahkan', 'Sukses');
          vm.cashierNote.push(response.data);

          vm.userNote = null;
        },
        function(error) {
          $log.error(error);
          toastr.error('Gagal menambahkan catatan', 'Gagal');
        }
      );
    };

    vm.batal = function() {
      $uibModalInstance.dismiss('batal');
    };

    vm.init = function () {
      OrderNote.list(vm.transaksi.id).then(function(response) {
        vm.cashierNote = response.data;
      });
    };

    vm.init();
  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller("BayarDialogController", BayarDialogController);

  /** @ngInject */
  function BayarDialogController(
    $uibModalInstance,
    data,
    APIHandling,
    STRUKHandling,
    _,
    toastr,
    moment,
    store,
    $q,
    LOGHandling,
    LOCATIONHandling,
    ADDRESSHandling,
    RESIHandling,
    $log,
    $uibModal
  ) {
    var vm = this;
    vm.inProcess = false;

    vm.today = new Date();
    vm.datePicker = {};
    vm.openDatePicker = function ($event, key) {
      $event.preventDefault();
      $event.stopPropagation();

      vm.datePicker[key] = !vm.datePicker[key];
    };

    vm.additionalUI = {
      newCust: false,
      provinsi: LOCATIONHandling.provinsiRO,
      additionalAddress: false,
      onlyNumbers: /^\d+$/,
      custAct: [
        { act: "new", text: "Tambahkan konsumen baru" },
        { act: "search", text: "Cari konsumen dari CRM" },
      ],
      noCrm: true,
      kabupaten: [],
      kecamatan: [],
      hideProduct: true,
      selectedProv: {
        id: null,
        text: null,
      },
    };

    vm.product = _.cloneDeep(data.product);
    vm.resume = _.cloneDeep(data.resume);

    vm.resume.product_price_total = 0;
    vm.resume.discount_product_total = 0;

    vm.showBiayaLain = false;

    /** Pastikan isi vm.product.detail adalah object, bukan JSON */
    _.each(vm.product, function (n) {
      n.detail = angular.fromJson(n.detail);

      n.family = _.find(n.detail.attributes, function (o) {
        return o.name === "FAMILY";
      });

      vm.resume.discount_product_total =
        vm.resume.discount_product_total + n.discount_total;
      vm.resume.product_price_total =
        vm.resume.product_price_total + n.harga_jual * n.jumlah;
    });

    vm.ongkir = {
      show: false,
      ekspedisi: "jne",
      weight: _.reduce(
        vm.product,
        function (tmp, n) {
          // return tmp + ((n.detail.weight * 1) * (n.jumlah * 1));
          return tmp + n.weight * 1 * (n.jumlah * 1);
        },
        0
      ),
      calc: {
        weight: null,
        dest_kab: null,
        dest_kec: null,
        list_courier: [],
      },
      costlist: null,
      selectedCost: 0,
      index: null,
      toggleShow: function (index) {
        vm.ongkir.index = index;
        vm.ongkir.show = !vm.ongkir.show;
        vm.ongkir.showMore = true;

        if (vm.ongkir.show) {
          vm.ongkir.selectedCost = null;
          vm.calculateShipping();
        }
      },
      error: false,
      showMore: true,
    };

    vm.newCustomer = {};

    vm.print = false;
    vm.tmpBayar = [];
    vm.tglBayar = [];

    vm.status = {
      paid: false,
      print: false,
    };

    vm.getContact = function (search) {
      if (search.length >= 3) {
        var q = $q.defer();

        APIHandling.get("kontak/list", {
          search: search,
          page: 1,
          per_page: 100,
          by_status: 1,
        }).then(
          function (response) {
            q.resolve(response);
          },
          function (error) {
            var msg = "";

            if (error.status !== 404) {
              $log.error(error);
              msg = "Terjadi gangguan di server";
              toastr.error(msg, "Gagal");
            }

            q.reject(error);
          }
        );

        return q.promise;
      }
    };

    vm.addTermin = function () {
      vm.tmpBayar.push({
        id: 0,
        tgl: new Date(),
        metode_bayar: "Cash",
        nominal: 0,
      });
    };

    vm.addDiskon = function () {
      vm.resume.lain_lain.diskon.push({
        id: 0,
        jenis: "persen",
        nilai: 0,
      });
    };

    vm.addBiaya = function () {
      vm.resume.lain_lain.biaya.push({
        id: 0,
        jenis: "lain",
        nilai: 0,
      });
    };

    vm.removeTermin = function (index) {
      vm.pembayaran.splice(index, 1);
      vm.tmpBayar.splice(index, 1);
      vm.tglBayar.splice(index, 1);

      vm.calculateReturn();
    };

    vm.removeDiskon = function (index) {
      vm.resume.lain_lain.diskon.splice(index, 1);
      if (vm.resume.lain_lain.diskon.length === 0) {
        vm.addDiskon();
      }
      vm.calculateDiskon();
    };

    vm.removeBiaya = function (index) {
      vm.resume.lain_lain.biaya.splice(index, 1);
      if (vm.resume.lain_lain.biaya.length === 0) {
        vm.addBiaya();
      }
      vm.calculateBiaya();
    };

    vm.validasi = {
      diskonMax: {
        persen: 100,
        nominal: vm.resume.total,
      },
    };

    function initView() {
      if (data.id !== null) {
        /*
          Jika dari transaksi pending, parse json data lain_lain terlebih dahulu
        */
        vm.resume.lain_lain = angular.fromJson(vm.resume.lain_lain);
        vm.pembayaran = _.cloneDeep(data.pembayaran);

        /* Jika isi pembayaran kosong, bisa jadi karena belum  bayar atau karena data lama */
        if (_.isEmpty(vm.pembayaran)) {
          if (vm.resume.bayar * 1 > 0) {
            // Jika data lama, maka masukkan ke sebagai pembayaran dengan metode lain - lain
            vm.tmpBayar.push({
              id: 0,
              tgl: new Date(vm.resume.tgl),
              metode_bayar: "Lain - Lain",
              nominal: vm.resume.bayar,
            });
          } else {
            // Jika karena belum bayar, maka inisialisasi nilai
            vm.addTermin();
          }
        } else if (
          vm.pembayaran.length === 1 &&
          vm.pembayaran[0].nominal * 1 === 0
        ) {
          /**
           * Jika pembayaran cuma 1 dan nilainya 0, maka artinya belum bayar dan pending.
           * Beri default tanggalnya sama dengan tanggal sekarang
           */
          vm.addTermin();
        } else {
          _.each(vm.pembayaran, function (termin, n) {
            vm.tmpBayar[n] = _.cloneDeep(termin);
            vm.tmpBayar[n].tgl = new Date(termin.tgl);
          });
        }

        /**
         * Jika ada data alamat di transaksi, maka gunakan data tersebut.
         * Jika tidak ada, maka init alamat dengan data kosong
         * */
        if (data.resume.shipping_alamat) {
          vm.selectedCustomer = {
            id: 0,
            nama: vm.resume.pembeli,
            alamat: vm.resume.shipping_alamat,
            kec: vm.resume.shipping_kec,
            kec_id: vm.resume.shipping_kec_id,
            kab: vm.resume.shipping_kab,
            kab_id: vm.resume.shipping_kab_id,
            prov: vm.resume.shipping_prov,
            prov_id: vm.resume.shipping_prov_id,
            email: vm.resume.lain_lain.email,
            hp: vm.resume.lain_lain.hp,
            kode_pos: vm.resume.lain_lain.kode_pos,
          };

          vm.additionalUI.noCrm = false;
        } else if (data.resume.cust_id) {
          vm.selectedCustomer = {
            id: data.resume.cust_id,
            nama: data.resume.pembeli,
            hp: data.resume.lain_lain.hp,
          };
        } else {
          vm.selectedCustomer = {
            id: 0,
            nama: data.resume.pembeli,
          };
        }

        if (!vm.resume.lain_lain.diskon) {
          vm.resume.lain_lain.diskon = [];

          if (vm.resume.discount_transaction_persen !== 0) {
            vm.resume.lain_lain.diskon.push({
              id: 0,
              jenis: "persen",
              nilai: vm.resume.discount_transaction_persen,
            });
          }

          if (vm.resume.discount_transaction_nominal !== 0) {
            vm.resume.lain_lain.diskon.push({
              id: 0,
              jenis: "nominal",
              nilai: vm.resume.discount_transaction_nominal,
            });
          }

          if (_.isEmpty(vm.resume.lain_lain.diskon)) {
            vm.addDiskon();
          }
        }

        /**
         * Untuk vm.resume.lain_lain.biaya, cek:
         * - Jika tidak ada, dan vm.resume.lain_lain.biaya_kirim === 0  atau vm.resume.lain_lain.biaya_lain === 0, atau keduanya tidak ada,  maka init baru
         * - Jika vm.resume.lain_lain.biaya_kirim / vm.resume.lain_lain.biaya_lain ada, maka init dengan nilai mereka
         */

        if (!vm.resume.lain_lain.biaya) {
          /**
           *  Ini adalah code lama, perlu dipertahankan untuk jaga2 jika ada yg ngefek di data.
           */

          vm.resume.lain_lain.biaya = [];

          if (vm.resume.lain_lain.biaya_kirim !== 0) {
            vm.resume.lain_lain.biaya.push({
              id: 0,
              jenis: "ongkir",
              nilai: vm.resume.lain_lain.biaya_kirim,
            });
          }

          if (vm.resume.lain_lain.biaya_lain !== 0) {
            vm.resume.lain_lain.biaya.push({
              id: 0,
              jenis: "lain",
              nilai: vm.resume.lain_lain.biaya_lain,
            });

            vm.showBiayaLain = true;
          }
        } else {
          _.each(vm.resume.lain_lain.biaya, function (biaya, n) {
            if (biaya.jenis === "ongkir") {
              vm.resume.lain_lain.biaya.splice(n, 1);
            }
          });

          /** Jika ada biaya lain lain, maka secara default, tampilkan di UI */
          if (vm.resume.lain_lain.biaya_lain !== 0) {
            vm.showBiayaLain = true;
          }
        }

        if (_.isEmpty(vm.resume.lain_lain.biaya)) {
          vm.addBiaya();
        }

        /** Penting untuk hitung ulang return, agar data diskon dan biaya masuk ke rekapitulasi */
        vm.calculateReturn();
      } else {
        /* Jika transaksi baru, maka init dulu semuanya menjadi 0 */
        vm.resume.lain_lain = {
          biaya_kirim: 0,
          biaya_lain: 0,
          diskon: [],
          biaya: [],
          dropship: {
            isDropship: false,
            sender: null,
          },
        };
        vm.resume.total_lain_lain = 0;
        vm.resume.discount_transaction_persen = 0;
        vm.resume.discount_transaction_nominal = 0;
        vm.resume.discount_transaction_total = 0;

        vm.pembayaran = [];
        vm.addTermin();
        vm.addDiskon();
        vm.addBiaya();
      }
    }

    /*
      Untuk init tgl trx. Saat disubmit, akan diubah formatnya, sehingga perlu dibuat di variable
      tersendiri agar tetap tampil di datePicker
    */
    vm.tglTrans = vm.today;
    vm.resume.total_akhir =
      vm.resume.total * 1 - vm.resume.discount_transaction_total * 1;

    vm.calculateReturn = function () {
      vm.resume.discount_transaction_total =
        (vm.resume.discount_transaction_persen / 100) * vm.resume.total +
        vm.resume.discount_transaction_nominal * 1;

      vm.resume.ongkir = vm.resume.ongkir || 0;

      /** total_lain_lain = ongkir + total_biaya_lain */
      vm.resume.total_lain_lain =
        vm.resume.ongkir * 1 + vm.resume.lain_lain.biaya_lain * 1;

      // vm.resume.total_lain_lain = vm.resume.ongkir;
      vm.resume.total_akhir =
        vm.resume.total * 1 -
        vm.resume.discount_transaction_total * 1 +
        vm.resume.total_lain_lain * 1;

      vm.resume.bayar = 0;
      _.each(vm.pembayaran, function (termin) {
        vm.resume.bayar = vm.resume.bayar + termin.nominal;
      });

      var selisih = vm.resume.bayar * 1 - vm.resume.total_akhir * 1;

      if (selisih < 0) {
        vm.resume.sisa_kembali = 0;
        vm.resume.kurang = selisih;
      } else {
        vm.resume.sisa_kembali = selisih;
        vm.resume.kurang = 0;
      }
    };

    vm.calculateBiaya = function () {
      // vm.resume.lain_lain.biaya_kirim = _.chain(vm.resume.lain_lain.biaya)
      //   .filter(function (n) { return n.jenis === 'ongkir';})
      //   .reduce(function (m, n) { return m + n.nilai;}, 0)
      //   .value();

      vm.resume.lain_lain.biaya_lain = _.chain(vm.resume.lain_lain.biaya)
        .filter(function (n) {
          return n.jenis === "lain";
        })
        .reduce(function (m, n) {
          return m + n.nilai;
        }, 0)
        .value();

      vm.calculateReturn();
    };

    vm.calculateDiskon = function () {
      vm.resume.discount_transaction_persen = _.chain(
        vm.resume.lain_lain.diskon
      )
        .filter(function (n) {
          return n.jenis === "persen";
        })
        .reduce(function (m, n) {
          return m * 1 + n.nilai * 1;
        }, 0)
        .value();

      vm.resume.discount_transaction_nominal = _.chain(
        vm.resume.lain_lain.diskon
      )
        .filter(function (n) {
          return n.jenis === "nominal";
        })
        .reduce(function (m, n) {
          return m * 1 + n.nilai * 1;
        }, 0)
        .value();

      vm.calculateReturn();
    };

    vm.saveTransaction = function (isPending) {
      var posting = null;
      vm.inProcess = true;

      var infoToastr = toastr.info(
        "Sedang memproses data transaksi. Bisa sampai 5 menit. Harap tunggu",
        "Proses Transaksi",
        { timeOut: APIHandling.timeOutLimit, progressBar: true }
      );

      /* Format tanggal */
      vm.resume.tgl = moment(vm.tglTrans).format("YYYY-MM-DD HH:mm:ss");

      vm.resume.shipping_prov_id = vm.selectedCustomer.prov_id;
      vm.resume.shipping_kab_id = vm.selectedCustomer.kab_id;
      vm.resume.shipping_kec_id = vm.selectedCustomer.kec_id;
      vm.resume.shipping_prov = vm.selectedCustomer.prov;
      vm.resume.shipping_kab = vm.selectedCustomer.kab;
      vm.resume.shipping_kec = vm.selectedCustomer.kec;
      vm.resume.shipping_alamat = vm.selectedCustomer.alamat;
      vm.resume.lain_lain.hp = vm.selectedCustomer.hp;
      vm.resume.lain_lain.kode_pos = vm.selectedCustomer.kode_pos;

      if (vm.resume.lain_lain.dropship.isDropship) {
        vm.resume.dropship = 1;
        vm.resume.reseller_id = vm.resume.lain_lain.dropship.sender.id;
      } else {
        vm.resume.dropship = 0;
        vm.resume.reseller_id = 0;
      }

      _.each(vm.tglBayar, function (tgl, n) {
        vm.pembayaran[n].tgl = moment(tgl).format("YYYY-MM-DD HH:mm:ss");
        vm.pembayaran[n].id = vm.pembayaran[n].id || 0;
      });

      if (isPending === 1) {
        vm.resume.status = "pending";
      } else {
        vm.resume.status = "dibayar";
      }

      var payload = {
        order: vm.resume,
        produk_jual: vm.product,
        pembayaran: _.cloneDeep(vm.pembayaran),
      };

      if (isPending === 1) {
        payload.order.status = "pending";

        /**
         * Jika pembayaran yang ada hanya dari template, berarti belum bayar.
         * Kosongkan payload pembayaran agar tidak tersimpan dan muncul di riwayat pembayaran sebagai record pembayaran dengan nilai 0
         */
        if (
          payload.pembayaran.length === 1 &&
          payload.pembayaran[0].nominal * 1 === 0
        ) {
          payload.pembayaran = [];
        }
      } else {
        payload.order.status = "dibayar";
      }

      /* Jika transaksi baru, pakai api save. Jika edit, pakai api edit */
      if (data.id !== null) {
        payload.id = data.id;
        LOGHandling.debug({ comment: "order/edit", data: payload });
        posting = APIHandling.post("order/edit", payload, true);
      } else {
        LOGHandling.debug({ comment: "order/save", data: payload });
        posting = APIHandling.post("order/save", payload, true);
      }

      posting
        .then(
          function (response) {
            toastr.success("Data transaksi tersimpan", "Simpan berhasil");

            LOGHandling.debug({
              comment: "Response save / edit",
              data: response.data,
            });

            if (isPending === 1) {
              vm.finish();
            } else {
              var map = [];
              var produk_jual = [];
              vm.transaksi = response.data;

              /* Data lain_lain dalam bentuk JSON, perlu diparse agar bisa diproses */
              vm.transaksi.lain_lain = angular.fromJson(vm.transaksi.lain_lain);

              /* Siapkan array untuk menyimpan data produk unik */
              vm.transaksi.produk_unik = [];

              _.each(response.data.produk_jual, function (item) {
                var index = _.indexOf(map, item.produk_id);

                if (index < 0) {
                  map.push(item.produk_id);
                  produk_jual.push(item);
                } else {
                  produk_jual[index].jumlah =
                    produk_jual[index].jumlah * 1 + item.jumlah * 1;
                }
              });

              vm.transaksi.produk_unik = produk_jual;

              vm.status.paid = true;
            }
          },
          function (error) {
            LOGHandling.info("Response save /edit");
            if (error.status === 408) {
              /*
            Jika timeout, maka:
            - Beri pesan
            - Simpan transaksi yang error cache verify untuk nanti diverifikasi
            - Hapus transaksi dari cache order
          */

              toastr.warning(
                "Sistem tidak mengetahui apakah proses transaksi terakhir sukses atau gagal. Harap lakukan verifikasi manual dan lakukan tindakan yang diperlukan",
                "Butuh verifikasi",
                { timeOut: 0 }
              );
              toastr.error(error.data.message, "Terjadi Kesalahan");
              vm.batal();
            } else if (error.status === 423) {
              var item = _.find(vm.product, function (o) {
                return o.produk_id * 1 === error.data.data * 1;
              });

              toastr.error(
                error.data.msg + "<br />" + item.sku + " - " + item.nama,
                "Gagal"
              );
            } else if (error.status === 503) {
              toastr.error(
                "Server sedang sibuk. Tunggu beberapa saat, kemudian coba lagi!",
                "Server Sibuk",
                { timeOut: 15000 }
              );
            } else if (error.status === 409) {
              var msg = "Stok produk";

              _.each(error.data, function (n) {
                var prodSize = n.size ? n.size.toString().toUpperCase() : "";
                msg = msg + " " + n.nama + " " + prodSize + ",";
              });

              msg = msg.substring(0, msg.length - 1) + " tidak cukup";

              toastr.error(msg, "Stok tidak cukup", { timeOut: 0 });
            } else {
              toastr.error("Gagal menyimpan transaksi", "Gagal");
              LOGHandling.error(error);
            }
          }
        )
        .finally(function () {
          toastr.clear(infoToastr);
          vm.inProcess = false;
        });
    };

    vm.printValidation = function (type) {
      LOGHandling.debug({ comment: "Print validasi", data: vm.transaksi });
      STRUKHandling.print(type, vm.transaksi);
      vm.status.print = true;
    };

    vm.finish = function () {
      $uibModalInstance.close("Ok");
    };

    vm.batal = function () {
      $uibModalInstance.dismiss("batal");
    };

    vm.addNewCustomer = function () {
      vm.additionalUI.newCust = true;
      vm.additionalUI.noCrm = true;

      vm.newCustomer.nama = vm.selectedCustomer.nama;
    };

    vm.cancelNewCustomer = function () {
      vm.additionalUI.newCust = false;
      vm.selectedCustomer = undefined;

      vm.newCustomer = {};
    };

    vm.removeDropship = function () {
      vm.resume.lain_lain.dropship.sender = null;
      vm.resume.lain_lain.dropship.sender = null;
      vm.resume.lain_lain.dropship.alamat_sender = null;
      vm.resume.dropship = 0;
      vm.resume.ekspedisi = null;
      vm.resume.ekspedisi_service = null;
      vm.resume.lain_lain.jobNumber = null;
      vm.resume.lain_lain.ekspedisiMP = null;
      vm.resume.lain_lain.ekspedisiMPOther = null;
    };

    vm.changeCustomer = function () {
      vm.resume.pembeli = vm.selectedCustomer.nama;
      vm.resume.cust_id = vm.selectedCustomer.id;

      if (vm.selectedCustomer.id > 0) {
        vm.additionalUI.noCrm = false;
        vm.additionalUI.newCust = false;

        if (vm.selectedCustomer.kab_id && vm.selectedCustomer.kec_id) {
          vm.calculateShipping();
        }
        /** Jika ganti customer, pastikan hilangkan dropship */
        vm.resume.lain_lain.dropship.isDropship = false;
        vm.removeDropship();
      } else if (vm.selectedCustomer.id === -1) {
        vm.addNewCustomer();

        /** Jika ganti customer, pastikan hilangkan dropship */
        vm.resume.lain_lain.dropship.isDropship = false;
        vm.removeDropship();
      } else if (vm.selectedCustomer.id === -2) {
        vm.resume.lain_lain.dropship.isDropship = true;
        vm.resume.cust_id = 0;
        vm.additionalUI.noCrm = true;
        vm.additionalUI.newCust = false;
      } else {
        vm.additionalUI.noCrm = true;
        vm.additionalUI.newCust = false;
        /** Jika ganti customer, pastikan hilangkan dropship */
        vm.resume.lain_lain.dropship.isDropship = false;
        vm.removeDropship();
      }
    };

    vm.getCustomerContact = function (search) {
      vm.getContact(search).then(function (response) {
        vm.contactList = response.data;
        vm.contactList.data.push({
          id: 0,
          nama: search,
          info: "Pembeli",
          minfo: "Sebagai pembeli tanpa masuk ke CRM",
          style: "noadd",
        });
        vm.contactList.data.push({
          id: -1,
          nama: search,
          info: "Pelanggan baru",
          minfo: "Tambahkan sbg pelanggan baru ke CRM",
          style: "addnew",
        });
        vm.contactList.data.push({
          id: -2,
          nama: search,
          info: "Pembeli Dropship",
          minfo: "Sebagai pembeli tanpa masuk ke CRM",
          style: "noadd",
        });
      });
    };

    vm.getDropshipContact = function (search) {
      vm.getContact(search).then(function (response) {
        vm.dropshipList = response.data;
        vm.dropshipList.data.push({
          id: 0,
          nama: search,
          info: "Dropshipper",
          minfo: "Sebagai Dropshipper tanpa masuk ke CRM",
          style: "noadd",
        });
      });
    };

    vm.saveNewCustomer = function () {
      vm.inProcess = true;
      var infoSaveNewCust = toastr.info(
        "Menyimpan data konsumen baru",
        "Harap tunggu"
      );

      vm.newCustomer.prov = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.province
        : null;
      vm.newCustomer.prov_id = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.province_id
        : null;

      vm.newCustomer.kab = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.type +
          " " +
          vm.additionalUI.selectedKec.city
        : null;
      vm.newCustomer.kab_id = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.city_id
        : null;

      vm.newCustomer.kec = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.subdistrict_name
        : null;
      vm.newCustomer.kec_id = vm.additionalUI.selectedKec
        ? vm.additionalUI.selectedKec.subdistrict_id
        : null;

      APIHandling.post("kontak/save", vm.newCustomer, true).then(
        function (response) {
          vm.resume.pembeli = vm.newCustomer.nama;
          vm.resume.cust_id = response.data.id;

          vm.selectedCustomer = _.cloneDeep(response.data);

          vm.inProcess = false;
          toastr.clear(infoSaveNewCust);
          if (response.data.warning) {
            toastr.warning(response.data.warning, "Peringatan", {
              timeOut: 25000,
            });
          }
          toastr.info("Berhasil simpan data konsumen.", "Berhasil");

          vm.additionalUI.newCust = false;
          vm.additionalUI.noCrm = false;
        },
        function (error) {
          toastr.clear(infoSaveNewCust);
          $log.error(error);
          vm.inProcess = false;

          switch (error.status) {
            case 423:
              toastr.error(error.data.response.msg, "Gagal");
              break;
            default:
              toastr.error("Gagal menyimpan data konsumen", "Gagal");
              break;
          }
        }
      );
    };

    vm.getKecamatan = function (search) {
      /** Kosongkan dulu biar tidak salah */
      vm.additionalUI.selectedKec = undefined;

      LOCATIONHandling.getKecamatan(search).then(function (response) {
        vm.additionalUI.kecamatan = response.data;
      });
    };

    vm.calculateShipping = function (secondary) {
      /** Reset ongkir ketika ganti customer */
      vm.ongkir.selected = null;
      vm.resume.ongkir = 0;
      vm.resume.ekspedisi = null;
      vm.resume.ekspedisi_service = null;

      vm.ongkir.error = false;

      vm.ongkir.calc.dest_kab = vm.selectedCustomer.kab_id;
      vm.ongkir.calc.dest_kec = vm.selectedCustomer.kec_id;
      vm.ongkir.calc.list_courier = ["jne", "jnt", "pos"];
      if (secondary) {
        vm.ongkir.calc.list_courier = ["tiki", "lion", "sicepat", "ide"];
      }
      vm.ongkir.calc.weight = vm.ongkir.weight * 1000;

      APIHandling.post("raja-ongkir/get-cost", vm.ongkir.calc).then(
        function (response) {
          if (!secondary) {
            vm.ongkir.costlist = response.data.results;

            if (vm.resume.lain_lain.dropship.isDropship) {
              vm.ongkir.costlist.unshift({
                code: "online",
                name: "Resi Online",
                costs: [
                  {
                    service: "Resi Online",
                    description: "Resi via Marketplace / Apps / Mitra",
                    cost: [
                      {
                        etd: "3 -6",
                        note: "",
                        value: 0,
                      },
                    ],
                  },
                ],
              });
            }

          } else {
            vm.ongkir.costlist = vm.ongkir.costlist.concat(
              response.data.results
            );
            vm.ongkir.showMore = false;
          }
        },
        function (error) {
          $log.error(error);
          toastr.error("Gagal mendapatkan data ongkos kirim", "Gagal");
          vm.ongkir.error = true;
        }
      );
    };

    vm.setShippingCost = function (selectedCost) {
      vm.ongkir.selected = selectedCost;
      vm.resume.ongkir = selectedCost.cost.cost[0].value;
      vm.resume.ekspedisi = selectedCost.ekspedisi;
      vm.resume.ekspedisi_service = selectedCost.cost.service;

      if (selectedCost.ekspedisi === "pos") {
        vm.resume.lain_lain.biaya_lain = 500;
        vm.resume.lain_lain.biaya.unshift({
          id: 0,
          jenis: "lain",
          nilai: 500,
          ket: "Asuransi",
        });

        vm.showBiayaLain = true;
      }

      /** TODO: Perlu fix calculateReturn untuk hitung ulang data ongkir */
      vm.calculateReturn();
      vm.ongkir.show = false;
    };

    vm.cetakAlamat = function (type) {
      function processPrint(address) {
        /**
         * Untuk transaksi biasa, untuk reseller yg masuk CRM, data hp ada di data drophip.sender.hp,
         * sementara reseller yg tidak masuk CRM, no hp ada di dropship.alamat_sender
         */
        var sender;

        if (vm.resume.lain_lain.dropship.isDropship) {
          sender = vm.resume.lain_lain.dropship.sender;
          sender.hp = sender.hp
            ? sender.hp
            : vm.resume.lain_lain.dropship.alamat_sender;
        }

        address.sender.sender =
          address.sender.selected === "custom" ? address.sender.sender : sender;

        address.ekspedisi = {
          nama: vm.resume.ekspedisi ? vm.resume.ekspedisi.toUpperCase() : "",
          service: vm.resume.ekspedisi_service
            ? vm.resume.ekspedisi_service.toUpperCase()
            : "",
          jobNumber: vm.resume.lain_lain.jobNumber
            ? vm.resume.lain_lain.jobNumber
            : "",
        };

        ADDRESSHandling.print(type, vm.selectedCustomer, address);
        APIHandling.post("order/mark-print", {
          id: vm.transaksi.id,
        }).then(
          function (response) {
            angular.log(response);
          },
          function (error) {
            angular.error(error);
          }
        );
      }

      if (vm.selectedCustomer.alamat) {
        $uibModal
          .open({
            animation: true,
            templateUrl:
              "app/components/modals/pilihAlamatCetak/pilihAlamatCetakDialog.html",
            controller: "PilihAlamatCetakDialogController as vm",
            backdrop: "static",
            resolve: {
              data: function () {
                return vm.resume;
              },
            },
          })
          .result.then(function (response) {
            processPrint(response);
          });
      }
    };

    vm.cetakResi = function () {
      RESIHandling.print(
        vm.resume.ekspedisi ? vm.resume.ekspedisi.toUpperCase() : "",
        vm.resume.lain_lain.jobNumber
      );
    };

    initView();
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('AddResellerDialogController', AddResellerDialogController);

  /** @ngInject */
  function AddResellerDialogController($uibModalInstance) {
    var vm = this;

    vm.refund = {
      reseller: null,
      value: 0,
      info: null
    };

    vm.process = function () {
      $uibModalInstance.close('batal');
    };

    vm.batal = function () {
      $uibModalInstance.dismiss('batal');
    };


  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller("StrukOptionDialogController", StrukOptionDialogController);

  /** @ngInject */
  function StrukOptionDialogController($uibModalInstance, data) {
    var vm = this;

    vm.transaksi = data;
    vm.withNote = true;

    vm.process = function () {
      $uibModalInstance.close({
        withNote: vm.withNote,
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss("batal");
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("fmuslimPosClient")
    .controller(
      "DetailTransaksiDialogController",
      DetailTransaksiDialogController
    );

  /** @ngInject */
  function DetailTransaksiDialogController(
    $uibModalInstance,
    $uibModal,
    _,
    $log,
    APIHandling,
    STRUKHandling,
    ADDRESSHandling,
    CUSTOMERHandling,
    DETAILHandling,
    RESIHandling,
    data,
    toastr,
    moment,
    OrderNote
  ) {
    var vm = this;
    vm.id = data;
    vm.isOresell = false;
    vm.tracking = null;
    vm.inProgerss = false;

    vm.cashierNote = [];

    vm.userNote = null;

    vm.initView = function () {
      APIHandling.get("order/get", { id: vm.id }).then(
        function (response) {
          var map = [];
          var produk_jual = [];
          vm.transaksi = response.data;

          vm.isOresell = vm.transaksi.dropship * 1 === 2 ? true : false;

          /* Data lain_lain dalam bentuk JSON, perlu diparse agar bisa diproses */
          vm.transaksi.lain_lain = angular.fromJson(vm.transaksi.lain_lain);

          /* Siapkan array untuk menyimpan data produk unik */
          vm.transaksi.produk_unik = [];

          _.each(response.data.produk_jual, function (item) {
            var index = _.indexOf(map, item.produk_id);

            if (index < 0) {
              map.push(item.produk_id);

              var detail = angular.fromJson(item.detail);

              if (detail.attributes) {
                item.ukuran = _.find(detail.attributes, function (o) {
                  return o.name === "SIZE";
                });
              } else {
                item.ukuran = _.find(detail, function (o) {
                  return o.name === "SIZE";
                });
              }

              item.family = _.find(detail.attributes, function (o) {
                return o.name === "FAMILY";
              });

              produk_jual.push(item);
            } else {
              produk_jual[index].jumlah =
                produk_jual[index].jumlah * 1 + item.jumlah * 1;
              produk_jual[index].discount_persen =
                produk_jual[index].discount_persen * 1 +
                item.discount_persen * 1;
              produk_jual[index].discount_nominal =
                produk_jual[index].discount_nominal * 1 +
                item.discount_nominal * 1;
            }
          });

          vm.transaksi.produk_unik = produk_jual;
          vm.transaksi.lain_lain = angular.fromJson(vm.transaksi.lain_lain);

          // $log.debug(vm.transaksi);
        },
        function (error) {
          $log.error(error);
          toastr.error(
            "Terjadi kesalahan saat mengambil data transaksi",
            "Gagal"
          );
        }
      );

      OrderNote.list(vm.id).then(function (response) {
        vm.cashierNote = response.data;
      });
    };

    vm.batal = function () {
      $uibModalInstance.dismiss("batal");
    };

    vm.printStruk = function (type) {
      if (vm.transaksi.lain_lain.hasNote) {
        $uibModal
          .open({
            animation: true,
            templateUrl:
              "app/components/modals/StrukOption/strukOptionDialog.html",
            controller: "StrukOptionDialogController as vm",
            backdrop: "static",
            resolve: {
              data: function () {
                return vm.transaksi;
              },
            },
          })
          .result.then(function (response) {
            if (response.withNote) {
              OrderNote.list(vm.id).then(function (result) {
                if (result.data.length > 0) {
                  STRUKHandling.print(
                    type,
                    _.cloneDeep(vm.transaksi),
                    result.data[result.data.length - 1]
                  );
                } else {
                  STRUKHandling.print(type, _.cloneDeep(vm.transaksi), null);
                }
              });
            } else {
              STRUKHandling.print(type, _.cloneDeep(vm.transaksi), null);
            }
          });
      } else {
        /* Clone dulu data sebelum dikirim ke pdfmake, karena pdfmake biasanya merubah data yang diterima */
        STRUKHandling.print(type, _.cloneDeep(vm.transaksi), null);
      }
    };

    vm.printAlamat = function (type) {
      function processPrint(address) {
        var sender;
        var customer_address;

        /**
         * Format data sender dari transaksi Oresell tidak sama dengan format data dari transaksi
         * biasa, jadi perlu dibedakan.
         *
         * Untuk transaksi biasa, untuk reseller yg masuk CRM, data hp ada di data drophip.sender.hp,
         * sementara reseller yg tidak masuk CRM, no hp ada di dropship.alamat_sender
         */
        if (vm.isOresell) {
          sender = vm.transaksi.lain_lain.dropship.sender;

          if (vm.transaksi.lain_lain.dropship.customSender) {
            if (vm.transaksi.lain_lain.dropship.customSender.use === "1") {
              sender = vm.transaksi.lain_lain.dropship.customSender;
            }
          }
        } else if (vm.transaksi.dropship * 1 === 1) {
          sender = vm.transaksi.lain_lain.dropship.sender;
          sender.hp = sender.hp
            ? sender.hp
            : vm.transaksi.lain_lain.dropship.alamat_sender;
        }

        address.sender.sender =
          address.sender.selected === "custom" ? address.sender.sender : sender;

        if (_.isUndefined(vm.transaksi.lain_lain.dropship)) {
          vm.transaksi.lain_lain.dropship = {
            isDropship: false,
          };
        }

        var ekspedisi = vm.transaksi.ekspedisi
          ? vm.transaksi.ekspedisi.toUpperCase()
          : "";
        var service = vm.transaksi.ekspedisi_service
          ? vm.transaksi.ekspedisi_service.toUpperCase()
          : "";

        if (vm.transaksi.lain_lain.jobNumber) {
          if (vm.transaksi.lain_lain.ekspedisiMP !== 'other') {
            ekspedisi =vm.transaksi.lain_lain.ekspedisiMP;
            service = '';
          } else {
            ekspedisi =vm.transaksi.lain_lain.ekspedisiMPOther;
            service = '';
          }
        }

        address.ekspedisi = {
          nama: ekspedisi,
          service: service,
          jobNumber: vm.transaksi.lain_lain.jobNumber
            ? vm.transaksi.lain_lain.jobNumber
            : "",
        };

        if (vm.isOresell) {
          if (address.receiver.selected === "transaction") {
            customer_address = {
              nama: vm.transaksi.pembeli,
              alamat: vm.transaksi.shipping_alamat,
              kec: vm.transaksi.shipping_kec,
              kec_id: vm.transaksi.shipping_kec_id,
              kab: vm.transaksi.shipping_kab,
              kab_id: vm.transaksi.shipping_kab_id,
              prov: vm.transaksi.shipping_prov,
              prov_id: vm.transaksi.shipping_prov_id,
              email: vm.transaksi.lain_lain.email,
              hp: vm.transaksi.lain_lain.hp,
              kode_pos: vm.transaksi.lain_lain.kode_pos,
            };

            ADDRESSHandling.print(type, customer_address, address);

            APIHandling.post("order/mark-print", { id: vm.transaksi.id }).then(
              function (response) {
                angular.log(response);
              },
              function (error) {
                angular.error(error);
                toastr.error(
                  "Gagal menandai transaksi sudah cetak alamat. Coba klik lagi tombol cetak lalu ketika keluar dialog preview, klik cancel.",
                  "Gagal tandai transaksi"
                );
              }
            );
          } else {
            CUSTOMERHandling.getCustomer(
              vm.transaksi.cust_uuid,
              vm.isOresell
            ).then(function (response) {
              if (response.data.alamat) {
                ADDRESSHandling.print(type, response.data, address);
                APIHandling.post("order/mark-print", {
                  id: vm.transaksi.id,
                }).then(
                  function (response) {
                    angular.log(response);
                  },
                  function (error) {
                    angular.error(error);
                    toastr.error(
                      "Gagal menandai transaksi sudah cetak alamat. Coba klik lagi tombol cetak lalu ketika keluar dialog preview, klik cancel.",
                      "Gagal tandai transaksi"
                    );
                  }
                );
              } else {
                toastr.info(
                  "Data alamat konsumen tidak diisi sehingga tidak dicetak",
                  "Tidak cetak"
                );
              }
            });
          }
        } else {
          customer_address = {
            nama: vm.transaksi.pembeli,
            alamat: vm.transaksi.shipping_alamat,
            kec: vm.transaksi.shipping_kec,
            kec_id: vm.transaksi.shipping_kec_id,
            kab: vm.transaksi.shipping_kab,
            kab_id: vm.transaksi.shipping_kab_id,
            prov: vm.transaksi.shipping_prov,
            prov_id: vm.transaksi.shipping_prov_id,
            email: vm.transaksi.lain_lain.email,
            hp: vm.transaksi.lain_lain.hp,
            kode_pos: vm.transaksi.lain_lain.kode_pos,
          };

          ADDRESSHandling.print(type, customer_address, address);

          APIHandling.post("order/mark-print", { id: vm.transaksi.id }).then(
            function (response) {
              angular.log(response);
            },
            function (error) {
              angular.error(error);
            }
          );
        }
      }

      if (vm.transaksi.shipping_alamat) {
        $uibModal
          .open({
            animation: true,
            templateUrl:
              "app/components/modals/pilihAlamatCetak/pilihAlamatCetakDialog.html",
            controller: "PilihAlamatCetakDialogController as vm",
            backdrop: "static",
            resolve: {
              data: function () {
                return vm.transaksi;
              },
            },
          })
          .result.then(function (response) {
            processPrint(response);
          });
      }
    };

    vm.printResi = function () {
      var ekspedisi = vm.transaksi.ekspedisi
        ? vm.transaksi.ekspedisi.toUpperCase()
        : "";

      if (vm.transaksi.lain_lain.jobNumber) {
        if (vm.transaksi.lain_lain.ekspedisiMP !== "other") {
          ekspedisi = vm.transaksi.lain_lain.ekspedisiMP;
        } else {
          ekspedisi = vm.transaksi.lain_lain.ekspedisiMPOther;
        }
      }

      RESIHandling.print(ekspedisi, vm.transaksi.lain_lain.jobNumber);
    };

    vm.trackShipping = function () {
      vm.tracking = null;
      vm.inProgerss = true;
      var courier = vm.transaksi.ekspedisi.toLowerCase();

      /** Kode kurir J&T adalah jnt */
      if (courier === "j&t") {
        courier = "jnt";
      }

      if (courier === "indah") {
        APIHandling.post(
          "raja-ongkir/track",
          {
            waybill: vm.transaksi.no_resi,
            courier: courier,
          },
          true
        ).then(
          function (response) {
            vm.inProgerss = false;
            if (response.data.rajaongkir.status.code === 200) {
              vm.tracking = response.data.rajaongkir;
            } else {
              toastr.error(
                response.data.rajaongkir.status.description,
                "Error"
              );
            }
          },
          function (error) {
            vm.inProgerss = false;
            $log.error(error);
            toastr.error(angular.toJson(error.data), "Error");
          }
        );
      } else {
        APIHandling.post(
          "resi/track",
          {
            waybill: vm.transaksi.no_resi,
            courier: courier,
          },
          true
        ).then(
          function (response) {
            vm.inProgerss = false;
            vm.tracking = response.data;
          },
          function (error) {
            vm.inProgerss = false;
            $log.error(error);
            toastr.error(
              "Tracking sedang gangguan. Silahkan coba lagi",
              "Error"
            );
          }
        );
      }
    };

    vm.printDetail = function () {
      DETAILHandling.print(_.cloneDeep(vm.transaksi));
    };

    vm.addNote = function () {
      OrderNote.create({
        transaction_id: vm.id,
        note: vm.userNote,
      }).then(
        function (response) {
          toastr.success("Catatan ditambahkan", "Sukses");
          vm.cashierNote.push(response.data);

          vm.userNote = null;
        },
        function (error) {
          $log.error(error);
          toastr.error("Gagal menambahkan catatan", "Gagal");
        }
      );
    };

    vm.initView();
  }
})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DetailCustomerDialogController', DetailCustomerDialogController);

  /** @ngInject */
  function DetailCustomerDialogController($uibModalInstance, CUSTOMERHandling, data, toastr, $log) {
      var vm = this;
      vm.cust_id = data.id;
      vm.isOresell = data.isOresell;
      vm.noConsumen = false;

      vm.initView = function () {

        CUSTOMERHandling.getCustomer(vm.cust_id, data.isOresell).then( function (response) {
          vm.pelanggan = response.data;

          if (response.data.extra) {
            vm.pelanggan.extra = angular.fromJson(response.data.extra);
          } else {
            vm.pelanggan.extra = {
              keterangan: null
            };
          }

        }, function (error) {
          $log.error(error);

          if (error.status === 404) {
            // toastr.error('Data pelanggan tidak ada atau sudah dihapus', 'Gagal');
            vm.noConsumen = true;
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data pelanggan', 'Gagal');
          }
        });
      };

      vm.batal = function () {
        $uibModalInstance.dismiss('batal');
      };

      vm.initView();

  }

})();

 (function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('DetailResellerDialogController', DetailResellerDialogController);

  /** @ngInject */
  function DetailResellerDialogController($uibModalInstance, Oresell, data, toastr, $log) {
      var vm = this;
      vm.reseller = data;

      vm.initView = function () {

        Oresell.contact.get(data.contact_id).then( function (response) {
          vm.reseller.address = response.data;
        }, function (error) {
          $log.error(error);

          if (error.status === 404) {
            // toastr.error('Data pelanggan tidak ada atau sudah dihapus', 'Gagal');
            vm.noConsumen = true;
          } else {
            toastr.error('Terjadi kesalahan saat mengambil data reseller', 'Gagal');
          }
        });
      };

      vm.batal = function () {
        $uibModalInstance.dismiss('batal');
      };

      vm.initView();

  }

})();


/*eslint angular/no-private-call: [2,{"allow":["$$rawModelValue"]}]*/

/*
 * ng-locale-number
 * based on ng-currency
 * http://alaguirre.com/
 * Version: 0.9.6 - 2016-04-04
 * License: MIT
 */

angular.module('ng-locale-number', [])
    .directive('ngLocaleNumber', ngLocaleNumber);

    function ngLocaleNumber ($filter, $locale) {
        return {
            require: 'ngModel',
            scope: {
                min: '=?min',
                max: '=?max',
                ngRequired: '=?ngRequired',
                fraction: '=?fraction'
            },
            link: function (scope, element, attrs, ngModel) {

                if (attrs.ngLocaleNumber === 'false') return;

                scope.fraction = (typeof scope.fraction !== 'undefined')?scope.fraction:2;

                function decimalRex(dChar) {
                    return RegExp("\\d|\\-|\\" + dChar, 'g');
                }

                function clearRex(dChar) {
                    return RegExp("\\-{0,1}((\\" + dChar + ")|([0-9]{1,}\\" + dChar + "?))&?[0-9]{0," + scope.fraction + "}", 'g');
                }

                function clearValue(value) {
                    value = String(value);
                    var dSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
                    var cleared = null;

                    if(value.indexOf($locale.NUMBER_FORMATS.DECIMAL_SEP) == -1 &&
                       value.indexOf('.') != -1 &&
                       scope.fraction)
                    {
                        dSeparator = '.';
                    }

                    // Replace negative pattern to minus sign (-)
                    var neg_dummy = $filter('number')("-1",  scope.fraction);
                    var neg_regexp = RegExp("[0-9."+$locale.NUMBER_FORMATS.DECIMAL_SEP+$locale.NUMBER_FORMATS.GROUP_SEP+"]+");
                    var neg_dummy_txt = neg_dummy.replace(neg_regexp.exec(neg_dummy), "");
                    var value_dummy_txt = value.replace(neg_regexp.exec(value), "");

                    // If is negative, just remove the negative sign :-P
                    if(neg_dummy_txt == value_dummy_txt) {
                        value = '' + neg_regexp.exec(value);
                    }

                    if(RegExp("^-[\\s]*$", 'g').test(value)) {
                        value = "-0";
                    }

                    if(decimalRex(dSeparator).test(value))
                    {
                        cleared = value.match(decimalRex(dSeparator))
                            .join("").match(clearRex(dSeparator));
                        cleared = cleared ? cleared[0].replace(dSeparator, ".") : null;
                    }

                    return cleared;
                }

                function reformatViewValue(){
                    var formatters = ngModel.$formatters,
                        idx = formatters.length;

                    var viewValue = ngModel.$$rawModelValue || 0;
                    while (idx--) {
                      viewValue = formatters[idx](viewValue);
                    }

                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                }

                ngModel.$parsers.push(function (viewValue) {
                    var cVal = clearValue(viewValue);
                    //return parseFloat(cVal);
                    // Check for fast digitation (-. or .)
                    if(cVal == "." || cVal == "-.")
                    {
                        cVal = ".0";
                    }
                    return parseFloat(cVal);
                });

                element.on("blur", function () {
                    ngModel.$commitViewValue();
                    reformatViewValue();
                });

                ngModel.$formatters.unshift(function (value) {
                    return $filter('number')(value,  scope.fraction);
                });

                ngModel.$validators.min = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.min  !== 'undefined') {
                        return cVal >= parseFloat(scope.min);
                    }
                    return true;
                };

                scope.$watch('min', function () {
                    ngModel.$validate();
                });

                ngModel.$validators.max = function(cVal) {
                    if (!scope.ngRequired && isNaN(cVal)) {
                        return true;
                    }
                    if(typeof scope.max  !== 'undefined') {
                        return cVal <= parseFloat(scope.max);
                    }
                    return true;
                };

                scope.$watch('max', function () {
                    ngModel.$validate();
                });


                ngModel.$validators.fraction = function(cVal) {
                    if (!!cVal && isNaN(cVal)) {
                        return false;
                    }

                    return true;
                };

                element.on('focus',function(){
                    var viewValue = ngModel.$$rawModelValue;

                    if(isNaN(viewValue) || viewValue === '' || viewValue == null)
                    {
                        viewValue = '';
                    }
                    else
                    {
                        viewValue = parseFloat(viewValue).toFixed(scope.fraction);
                    }
                    ngModel.$setViewValue(viewValue);
                    ngModel.$render();
                });
            }
        };
    }

//
// angular-file-model
// ==================
//
// Directive that makes the inputs with type `file` to be
// available in the `$scope` and be assigned to a model.
//
(function () {
  'use strict';

  angular.module('file-model', [])

  .directive('fileModel', fileModel);

    function fileModel ($parse) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          var model = $parse(attrs.fileModel);
          var modelSetter = model.assign;

          element.bind('change', function(){
            scope.$apply(function(){
              if (attrs.multiple) {
                modelSetter(scope, element[0].files);
              }
              else {
                modelSetter(scope, element[0].files[0]);
              }
            });
          });
        }
      };
    }


})();


/**
 * Module definition and dependencies
 * Ambil dari: https://gist.github.com/adamreisnz/354364e2a58786e2be71
 */
angular.module('Api.DuplicateRequestsFilter.Decorator', [])

  /**
   * Config
   */
  .config(function ($provide) {

    /**
     * Decorator for the $http service
     */
    $provide.decorator('$http', function ($delegate, $q) {

      /**
       * Pending requests and local $http var for natural reference
       */
      var pendingRequests = {};
      var $http = $delegate;

      /**
       * Hash generator
       */
      function hash(str) {
        var h = 0;
        var strlen = str.length;
        if (strlen === 0) {
          return h;
        }
        for (var i = 0, n; i < strlen; ++i) {
          n = str.charCodeAt(i);
          h = ((h << 5) - h) + n;
          h = h & h;
        }
        return h >>> 0;
      }

      /**
       * Helper to generate a unique identifier for a request
       */
      function getRequestIdentifier(config) {
        var str = config.method + config.url;
        if (config.params && angular.isObject(config.params)) {
          str += angular.toJson(config.params);
        }
        if (config.data && angular.isObject(config.data)) {
          str += angular.toJson(config.data);
        }
        return hash(str);
      }

      /**
       * Modified $http service
       */
      var $duplicateRequestsFilter = function (config) {

        //Ignore for this request?
        if (config.ignoreDuplicateRequest) {
          return $http(config);
        }

        //Get unique request identifier
        var identifier = getRequestIdentifier(config);

        //Check if such a request is pending already
        if (pendingRequests[identifier]) {
          if (config.rejectDuplicateRequest) {
            return $q.reject({
              data: '',
              headers: {},
              status: config.rejectDuplicateStatusCode || 400,
              config: config
            });
          }
          return pendingRequests[identifier];
        }

        //Create promise using $http and make sure it's reset when resolved
        pendingRequests[identifier] = $http(config).finally(function () {
          delete pendingRequests[identifier];
        });

        //Return promise
        return pendingRequests[identifier];
      };

      //Map rest of methods
      Object.keys($http).filter(function (key) {
        return (angular.isFunction($http[key]));
      }).forEach(function (key) {
        $duplicateRequestsFilter[key] = $http[key];
      });

      //Map defaults
      $duplicateRequestsFilter.defaults = $http.defaults;

      //Return it
      return $duplicateRequestsFilter;
    });
  });

(function () {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .filter('fm-detail', fmdetail);

  function fmdetail(_) {
    return filterdetail;

    function filterdetail(detail) {

      var data = _.each(detail, function (n) {
        n.detail = angular.fromJson(n.detail);
        if (n.detail) {
          if (n.detail.hasOwnProperty('attributes')) {
            n.family = _.find(n.detail.attributes, function (o) {
              return o.name === 'FAMILY';
            });
          }
        }
        return n;
      });

      return data;
    }
  }
})();

'use strict';
angular.module('fmuslimPosClient')
.filter('udate', function ($filter) {
  return function (input, format) {
    if (input) {
      var a = input.split(/[^0-9]/);
      var date = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

      return $filter('date')(date, format);
    } else {
      return null;
    }
  };
});

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainStockController', MainStockController);

  /** @ngInject */
  function MainStockController($scope, $state, $uibModal) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });

    vm.inProcess = false;

    vm.importCSV = function () {

        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/modals/importCSVDialog/ImportCSVDialog.html',
          controller: 'ImportCSVDialogController as vm',
          resolve: {
            data: function () {
              return vm.resume;
            }
          }
        });

    };

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainReportController', MainReportController);

  /** @ngInject */
  function MainReportController($scope, $state) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainPosController', MainPosController);

  /** @ngInject */
  function MainPosController($scope, $state) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainDashboardController', MainDashboardController);

  /** @ngInject */
  function MainDashboardController($log) {
    $log.log('Dashboard');
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainAdministrasiController', MainAdministrasiController);

  /** @ngInject */
  function MainAdministrasiController($scope, $state) {

    var vm = this;

    /*
      Controller ini hanya dieksekusi sekali. Jika terjadi perubahan state di substate,
      maka isi Controller tidak akan dieksekusi lagi. Oleh karena itu, untuk merubah title
      perlu melakukan watch terhadap $state
    */
    $scope.$watch(function () {
      vm.state = $state.current.name;
      return $state.current.title;
    }, function (newVal) {
      vm.title = newVal;
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('WebReportController', WebReportController);

  /** @ngInject */
  function WebReportController($log, APIHandling, $filter, _) {
    var vm = this;

    vm.productList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.year = new Date().getFullYear();

    vm.filter = {
      by_sku : null,
      search : null,
      only_with_sku: 1,
      per_page : 10,
      by_attr_val: null
    };

    vm.initView = function (page) {

      vm.filter.page = page;

      /* Pastikan search ada isinya atay null, kalau tidak, akan memperoleh hasil query yang salah */
      vm.filter.search = vm.filter.search || null;

      if (vm.filter.by_attr_val !== null)  {
        vm.filter.by_attr_name = 'SIZE';
      }

      APIHandling.getLiveStock(vm.filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        /* Filter data detail produk, ubah yang sebelumnya cuma data teks, menjadi object */
        vm.productList = $filter ('fm-detail') (response.data.data);

        /** Tampilkan keterangan family jika ada */
        _.each(vm.productList, function(item) {
          var a = _.find(item.detail.attributes, function(o) { return o.name === 'FAMILY'; });

          if (a) {
            item.family = a.option;
          }

        });

      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, APIHandling, $state, toastr, VERSION, BUILD) {
    var vm = this;

    vm.info = {
      server: null,
      client: {
        version: VERSION,
        build: BUILD
      }
    };

    vm.doLogin = function () {
      APIHandling.login(vm.user.uname, vm.user.password).then(function (response) {
        if (response.status === 200) {
          APIHandling.saveLoginState(response.data);
          $state.go('main.pos.cashier');
        }
      }, function (error) {
        $log.error(error);
        var msg = '';

        if (error.status === 503) {
          msg = 'Server sedang sibuk. Coba beberapa saat lagi';
        } else if (error.status === 401){
          msg = 'Username atau password salah';
        } else {
          msg = 'Terjadi masalah di server';
        }

        toastr.error(msg, 'Gagal login');
      });
    };

    // APIHandling.cleanLoginState();
    APIHandling.getInfoServer().then(function (response) {
      vm.info.server = response.data;
      $log.info(vm.info);
    });


    APIHandling.get('check-token', null).then(function () {
      /** Jika valid, maka langsung masuk ke cashier */
      $state.go('main.pos.cashier');
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($state, $timeout, store, APIHandling) {
    var vm = this;

    vm.navCollapsed = false;
    vm.message = '';

    vm.menuItem = [
        // {
        //     text        : 'Dashboard',
        //     sref        : 'main.dashboard',
        //     icon        : 'fa-dashboard'
        // },
        {
            text        : 'Kasir',
            sref        : 'main.pos.cashier',
            icon        : 'fa-shopping-cart'
        },
        {
            text        : 'Produk dan Stok',
            sref        : 'main.stock.stock-change',
            icon        : 'fa-cubes'
        },
        {
            text        : 'Laporan',
            sref        : 'main.report.location',
            icon        : 'fa-bar-chart-o'
        },
        {
            text        : 'Administrasi',
            sref        : 'main.administrasi.sinkronisasi',
            icon        : 'fa-gear'
        }

    ];


    vm.logout = function () {
      // store.remove('token');
      // store.remove('info');

      APIHandling.cleanLoginState();

      $timeout(function () {
        $state.go('login');
      }, 300);

    };

    vm.isActive = function (state) {
        var origin = state.split('.');
        var current = $state.current.name.split('.');

        if ((origin[0] === current[0]) && (origin[1] === current[1])) {
          return true;
        } else {
          return false;
        }

    };

    APIHandling.get('check-token', null).then(function () {
      /** Jika valid, maka langsung masuk ke cashier */
      vm.loginInfo = {
        text        :  '( ' + store.get('info').uname + ' ) ' +  'Logout',
        sref        : 'login',
        icon        : 'fa-sign-out'
      };
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .controller('GaleriStokController', WebReportController);

  /** @ngInject */
  function WebReportController($log, APIHandling, $filter, _, $stateParams) {
    var vm = this;

    vm.productList;
    vm.isLastPage = false;
    vm.maxPage = null;
    vm.year = new Date().getFullYear();

    vm.filter = {
      by_sku : null,
      search : $stateParams.name,
      only_with_sku: 1,
      per_page : 12,
      by_attr_name: null,
      by_attr_val: $stateParams.size,
      only_with_stok: 1
    };

    vm.initView = function (page) {

      vm.filter.page = page;

      /* Pastikan search ada isinya atay null, kalau tidak, akan memperoleh hasil query yang salah */
      vm.filter.search = vm.filter.search || null;

      if (vm.filter.by_attr_val)  {
        vm.filter.by_attr_name = 'SIZE';
      }

      APIHandling.getLiveStock(vm.filter).then(function (response) {

        if (page === 1) {
          vm.maxPage = (response.data.max_page * 1) || 1;
        }

        /* Cek apakah page === last page. Jika true, maka set vm.isLastPage = true */
        if (page === vm.maxPage) {
          vm.isLastPage = true;
        } else {
          vm.isLastPage = false;
        }

        /* Filter data detail produk, ubah yang sebelumnya cuma data teks, menjadi object */
        vm.productList = $filter ('fm-detail') (response.data.data);

        /** Tampilkan keterangan family jika ada */
        _.each(vm.productList, function(item) {
          var a = _.find(item.detail.attributes, function(o) { return o.name === 'FAMILY'; });

          if (a) {
            item.family = a.option;
          }

        });

      });
    };

    vm.initView(1);

  }
})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('main', {
        url: '/main',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        abstrac: true,
        onEnter: function(){
            angular.element('.loader-container').hide();
        }
      })
      // .state('main.dashboard', {
      //   url: '/dashboard',
      //   templateUrl: 'app/main/main.dashboard/main.dashboard.html',
      //   controller: 'MainDashboardController',
      //   controllerAs: 'vm'
      // })
      .state('main.stock', {
        url: '/stock',
        templateUrl: 'app/main/main.stock/main.stock.html',
        controller: 'MainStockController',
        controllerAs: 'vm',
        abstrac: true
      })
      .state('main.stock.stock-change', {
        url: '/stock-change',
        templateUrl: 'app/main/main.stock/main.stock.stock-change/main.stock.stock-change.html',
        controller: 'MainStockChangeController',
        controllerAs: 'vm',
        title: 'Ubah Data Stok Produk',
        onEnter: function($rootScope){
            $rootScope.title = 'Ubah Data Stok Produk | Zafrada POS';
        }
      })
      .state('main.stock.stock-history', {
        url: '/stock-history',
        templateUrl: 'app/main/main.stock/main.stock.stock-history/main.stock.stock-history.html',
        controller: 'MainStockHistoryController',
        controllerAs: 'vm',
        title: 'Riwayat Perubahan Stok',
        onEnter: function($rootScope){
            $rootScope.title = 'Riwayat Perubahan Stok | Zafrada POS';
        }
      })
      .state('main.stock.stock-opname', {
        url: '/stock-opname',
        templateUrl: 'app/main/main.stock/main.stock.stock-opname/main.stock.stock-opname.html',
        controller: 'MainStockOpnameController',
        controllerAs: 'vm',
        title: 'Stok Opname',
        onEnter: function($rootScope){
            $rootScope.title = 'Stok Opname | Zafrada POS';
        }
      })
      .state('main.stock.product-list', {
        url: '/product-list',
        templateUrl: 'app/main/main.stock/main.stock.product-list/main.stock.product-list.html',
        controller: 'MainProductListController',
        controllerAs: 'vm',
        title: 'Daftar Produk',
        onEnter: function($rootScope){
            $rootScope.title = 'Daftar Produk | Zafrada POS';
        }
      })
      .state('main.stock.bulk-update', {
        url: '/bulk-update',
        templateUrl: 'app/main/main.stock/main.stock.bulk-update/main.stock.bulk-update.html',
        controller: 'MainBulkUpdateController',
        controllerAs: 'vm',
        title: 'Update Stok Massal',
        onEnter: function($rootScope){
            $rootScope.title = 'Update Stok Massal | Simple POS Management';
        }
      })
      .state('main.pos', {
        url: '/pos',
        templateUrl: 'app/main/main.pos/main.pos.html',
        controller: 'MainPosController',
        controllerAs: 'vm',
        abstrac: true
      })
      .state('main.pos.cashier', {
        url: '/cashier',
        templateUrl: 'app/main/main.pos/main.pos.cashier/main.pos.cashier.html',
        controller: 'MainPosCashierController',
        controllerAs: 'vm',
        title: 'Penjualan',
        onEnter: function($rootScope){
            $rootScope.title = 'Penjualan | Zafrada POS';
        }
      })
      .state('main.pos.pending', {
        url: '/pending',
        templateUrl: 'app/main/main.pos/main.pos.transaction-pending/main.pos.transaction-pending.html',
        controller: 'MainPosTransactionPendingController',
        controllerAs: 'vm',
        title: 'Transaksi Pending',
        onEnter: function($rootScope){
            $rootScope.title = 'Transaksi Pending | Zafrada POS';
        }
      })
      .state('main.pos.process-pending', {
        url: '/pending/process/:id',
        templateUrl: 'app/main/main.pos/main.pos.process-pending/main.pos.process-pending.html',
        controller: 'MainPosProcessPendingController',
        controllerAs: 'vm',
        title: 'Proses Transaksi Pending',
        onEnter: function($rootScope){
            $rootScope.title = 'Proses Transaksi Pending | Zafrada POS';
        }
      })
      .state('main.pos.transaction-list', {
        url: '/transaction-list',
        templateUrl: 'app/main/main.pos/main.pos.transaction-list/main.pos.transaction-list.html',
        controller: 'MainPosTransactionListController',
        controllerAs: 'vm',
        title: 'Riwayat Penjualan',
        onEnter: function($rootScope){
            $rootScope.title = 'Riwayat Penjualan | Zafrada POS';
        }
      })
      .state('main.pos.product-transaction-list', {
        url: '/product-transaction-list',
        templateUrl: 'app/main/main.pos/main.pos.product-transaction-list/main.pos.product-transaction-list.html',
        controller: 'MainPosProductTransactionListController',
        controllerAs: 'vm',
        title: 'Riwayat Penjualan Produk',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Riwayat Penjualan Produk | Simple POS Management';
        }
      })
      .state('main.pos.payment-history', {
        url: '/payment-history',
        templateUrl: 'app/main/main.pos/main.pos.payment-history/main.pos.payment-history.html',
        controller: 'MainPosPaymentHistoryController',
        controllerAs: 'vm',
        title: 'Riwayat Pembayaran',
        onEnter: function($rootScope){
            $rootScope.title = 'Riwayat Pembayaran | Zafrada POS';
        }
      })
      .state('main.report', {
        url: '/report',
        templateUrl: 'app/main/main.report/main.report.html',
        controller: 'MainReportController',
        controllerAs: 'vm',
        abstrac: true,
        onEnter: function(store, $state) {
            var user = store.get('info');

            if (user.group !== 'admin') {
              $state.go('main.pos.cashier');
            }
        }
      })
      .state('main.report.location', {
        url: '/location',
        templateUrl: 'app/main/main.report/main.report.location/main.report.location.html',
        controller: 'MainReportLocationController',
        controllerAs: 'vm',
        title: 'Laporan Berdasar Lokasi',
        onEnter: function($rootScope){
            $rootScope.title = 'Laporan Berdasar Lokasi | Zafrada POS';
        }
      })
      .state('main.report.customer', {
        url: '/customer',
        templateUrl: 'app/main/main.report/main.report.customer/main.report.customer.html',
        controller: 'MainReportCustomerController',
        controllerAs: 'vm',
        title: 'Laporan Berdasar Konsumen',
        onEnter: function($rootScope){
            $rootScope.title = 'Laporan Berdasar Konsumen | Zafrada POS';
        }
      })
      .state('main.report.product', {
        url: '/product',
        templateUrl: 'app/main/main.report/main.report.product/main.report.product.html',
        controller: 'MainReportProductController',
        controllerAs: 'vm',
        title: 'Laporan Berdasar Produk',
        onEnter: function($rootScope){
            $rootScope.title = 'Laporan Berdasar Produk | Zafrada POS';
        }
      })
      .state('main.report.compare', {
        url: '/compare',
        templateUrl: 'app/main/main.report/main.report.compare/main.report.compare.html',
        controller: 'MainReportCompareController',
        controllerAs: 'vm',
        title: 'Laporan Perbandingan',
        onEnter: function($rootScope){
            $rootScope.title = 'Laporan Perbandingan | Zafrada POS';
        }
      })
      .state('main.report.transaction', {
        url: '/transaction',
        templateUrl: 'app/main/main.report/main.report.transaction/main.report.transaction.html',
        controller: 'MainReportTransactionController',
        controllerAs: 'vm',
        title: 'Laporan Transaksi',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Laporan Transaksi | Simple POS Management';
        }
      })
      .state('main.report.transaction-oresell', {
        url: '/transaction-otoresell',
        templateUrl: 'app/main/main.report/main.report.transaction-oresell/main.report.transaction-oresell.html',
        controller: 'MainReportTransactionOresellController',
        controllerAs: 'vm',
        title: 'Laporan Transaksi Otoresell',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Laporan Transaksi Oresell | Simple POS Management';
        }
      })
      .state('main.report.transaction-dropship', {
        url: '/transaction-dropship',
        templateUrl: 'app/main/main.report/main.report.transaction-dropship/main.report.transaction-dropship.html',
        controller: 'MainReportTransactionDropshipController',
        controllerAs: 'vm',
        title: 'Laporan Transaksi Dropship',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Laporan Transaksi Dropship | Simple POS Management';
        }
      })
      .state('main.administrasi', {
        url: '/administrasi',
        templateUrl: 'app/main/main.administrasi/main.administrasi.html',
        controller: 'MainAdministrasiController',
        controllerAs: 'vm',
        abstrac: true,
        onEnter: function(store, $state) {
            var user = store.get('info');

            if (user.group !== 'admin') {
              $state.go('main.pos.cashier');
            }
        }
      })
      .state('main.administrasi.sinkronisasi', {
        url: '/sinkronisasi',
        templateUrl: 'app/main/main.administrasi/main.administrasi.sinkronisasi/main.administrasi.sinkronisasi.html',
        controller: 'MainAdministrasiSinkronisasiController',
        controllerAs: 'vm',
        title: 'Sinkronisasi',
        onEnter: function($rootScope){
            $rootScope.title = 'Sinkronisasi | Zafrada POS';
        }
      })
      .state('main.administrasi.product', {
        url: '/product',
        templateUrl: 'app/main/main.administrasi/main.administrasi.product/main.administrasi.product.html',
        controller: 'MainAdministrasiProductController',
        controllerAs: 'vm',
        title: 'Administrasi Produk',
        onEnter: function($rootScope){
            $rootScope.title = 'Administrasi Produk | Zafrada POS';
        }
      })

      .state('main.administrasi.category', {
        url: '/category',
        templateUrl: 'app/main/main.administrasi/main.administrasi.category/main.administrasi.category.html',
        controller: 'MainAdministrasiCategoryController',
        controllerAs: 'vm',
        title: 'Kategori Produk',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Kategori Produk | Simple POS Management';
        }
      })

      .state('main.administrasi.product-double', {
        url: '/product-double',
        templateUrl: 'app/main/main.administrasi/main.administrasi.product-double/main.administrasi.product-double.html',
        controller: 'MainAdministrasiProductDoubleController',
        controllerAs: 'vm',
        title: 'Produk Dobel',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Produk Dobel | Simple POS Management';
        }
      })

      .state('main.administrasi.oresell', {
        url: '/oresell',
        templateUrl: 'app/main/main.administrasi/main.administrasi.oresell/main.administrasi.oresell.html',
        controller: 'MainAdministrasiOresellController',
        controllerAs: 'vm',
        title: 'Reseller Otoreseller',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Reseller Otoreseller | Simple POS Management';
        }
      })
      .state('main.administrasi.mutasi-oresell', {
        url: '/mutasi-oresell',
        templateUrl: 'app/main/main.administrasi/main.administrasi.mutasi-oresell/main.administrasi.mutasi-oresell.html',
        controller: 'MainAdministrasiMutasiOresellController',
        controllerAs: 'vm',
        title: 'Mutasi Otoreseller',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Mutasi Otoreseller | Simple POS Management';
        }
      })
      .state('main.administrasi.kontak-oresell', {
        url: '/kontak-oresell',
        templateUrl: 'app/main/main.administrasi/main.administrasi.kontak-oresell/main.administrasi.kontak-oresell.html',
        controller: 'MainAdministrasiContactOresellController',
        controllerAs: 'vm',
        title: 'Kontak Otoreseller',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Kontak Otoreseller | Simple POS Management';
        }
      })
      .state('main.administrasi.log-deposit-oresell', {
        url: '/log-deposit-oresell',
        templateUrl: 'app/main/main.administrasi/main.administrasi.log-deposit-oresell/main.administrasi.log-deposit-oresell.html',
        controller: 'MainAdministrasiLogDepositOresellController',
        controllerAs: 'vm',
        title: 'Log Deposit Otoreseller',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Log Deposit Otoreseller | Simple POS Management';
        }
      })
      .state('main.administrasi.log-level-oresell', {
        url: '/log-level-oresell',
        templateUrl: 'app/main/main.administrasi/main.administrasi.log-level-oresell/main.administrasi.log-level-oresell.html',
        controller: 'MainAdministrasiLogLevelOresellController',
        controllerAs: 'vm',
        title: 'Log Level Otoreseller',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Log Level Otoreseller | Simple POS Management';
        }
      })
      .state('main.administrasi.oresell-broadcast', {
        url: '/oresell-broadcast',
        templateUrl: 'app/main/main.administrasi/main.administrasi.oresell-broadcast/main.administrasi.oresell-broadcast.html',
        controller: 'MainAdministrasiOresellBroadcastController',
        controllerAs: 'vm',
        title: 'Broadcast Otoreseller Mobile',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Broadcast Otoreseller Mobile | Simple POS Management';
        }
      })

      .state('main.administrasi.shopee', {
        url: '/shopee',
        templateUrl: 'app/main/main.administrasi/main.administrasi.shopee/main.administrasi.shopee.html',
        controller: 'MainAdministrasiShopeeController',
        controllerAs: 'vm',
        title: 'Shopee',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Shopee | Simple POS Management';
        }
      })
      .state('main.administrasi.bukalapak', {
        url: '/bukalapak',
        templateUrl: 'app/main/main.administrasi/main.administrasi.bukalapak/main.administrasi.bukalapak.html',
        controller: 'MainAdministrasiBukalapakController',
        controllerAs: 'vm',
        title: 'Bukalapak',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Bukalapak | Simple POS Management';
        }
      })
      .state('main.administrasi.tiktok', {
        url: '/tiktok',
        templateUrl: 'app/main/main.administrasi/main.administrasi.tiktok/main.administrasi.tiktok.html',
        controller: 'MainAdministrasiTiktokController',
        controllerAs: 'vm',
        title: 'Tiktok',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Tiktok | Simple POS Management';
        }
      })
      .state('main.administrasi.lazada', {
        url: '/lazada',
        templateUrl: 'app/main/main.administrasi/main.administrasi.lazada/main.administrasi.lazada.html',
        controller: 'MainAdministrasiLazadaController',
        controllerAs: 'vm',
        title: 'Lazada',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Lazada | Simple POS Management';
        }
      })
      .state('main.administrasi.jubelio', {
        url: '/jubelio',
        templateUrl: 'app/main/main.administrasi/main.administrasi.jubelio/main.administrasi.jubelio.html',
        controller: 'MainAdministrasiJubelioController',
        controllerAs: 'vm',
        title: 'Jubelio',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Jubelio | Simple POS Management';
        }
      })
      .state('main.administrasi.facebook', {
        url: '/facebook',
        templateUrl: 'app/main/main.administrasi/main.administrasi.facebook/main.administrasi.facebook.html',
        controller: 'MainAdministrasiFacebookController',
        controllerAs: 'vm',
        title: 'Facebook Offline Event',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Facebook Offline Event | Simple POS Management';
        }
      })
      .state('main.administrasi.whatsapp', {
        url: '/whatsapp',
        templateUrl: 'app/main/main.administrasi/main.administrasi.whatsapp/main.administrasi.whatsapp.html',
        controller: 'MainAdministrasiWhatsappController',
        controllerAs: 'vm',
        title: 'Pesan WhatsApp',
        onEnter: function ($rootScope) {
          $rootScope.title = 'Pesan WhatsApp | Simple POS Management';
        }
      })
      .state('main.administrasi.users', {
        url: '/users',
        templateUrl: 'app/main/main.administrasi/main.administrasi.users/main.administrasi.users.html',
        controller: 'MainAdministrasiUsersController',
        controllerAs: 'vm',
        title: 'Atur Pengguna',
        onEnter: function($rootScope){
            $rootScope.title = 'Atur Pengguna | Zafrada POS';
        }
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        onEnter: function($rootScope){
            angular.element('.loader-container').hide();
            $rootScope.title = 'Login | Zafrada POS';
        }
      }).state('webreport', {
        url: '/stok-online',
        templateUrl: 'app/webreport/webreport.html',
        controller: 'WebReportController',
        controllerAs: 'vm',
        onEnter: function($rootScope){
            angular.element('.loader-container').hide();
            $rootScope.title = 'Daftar Stok Produk';
        }
      }).state('galeri-stok', {
        url: '/galeri-stok/:name/:size',
        templateUrl: 'app/galeri-stok/galeri-stok.html',
        controller: 'GaleriStokController',
        controllerAs: 'vm',
        onEnter: function($rootScope){
            angular.element('.loader-container').hide();
            $rootScope.title = 'Galeri Stok';
        }
      });

    $urlRouterProvider.otherwise('/login');
  }

})();

/* global _:false, moment:false, saveAs:false, Papa:false, pdfMake: false, d3: false, XLSX: false */
(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .constant('_', _)
    .constant('moment', moment)
    .constant('saveAs', saveAs)
    .constant('Papa', Papa)
    .constant('pdfMake', pdfMake)
    .constant('d3', d3)
    .constant('XLSX', XLSX)
    .constant('BASEURL', 'https://poszafrada-oa6gl3qzu1k.zafrada.com/api/public/')
    .constant('TIMEOUT', 1800000)
    .constant('VERSION', '1.49.2')
    .constant('BUILD', '20250601')
    .constant('APIDOMAIN', 'localhost');

})();

(function() {
  'use strict';

  angular
    .module('fmuslimPosClient')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, $httpProvider, toastrConfig, ngDexieProvider, jwtOptionsProvider, $qProvider, APIDOMAIN) {
    // Enable log
    $logProvider.debugEnabled(true);

    /* Hilangkan # di akhir url */
    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.extendedTimeOut = 2500;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;

    ngDexieProvider.setOptions({name: 'fmuslim-pos-client', debug: false});
    ngDexieProvider.setConfiguration(function (db, $log) {
        db.version(2).stores({
          logs: "++id, timestamp, type, log"
        });
        db.on('error', function (err) {
            // Catch all uncatched DB-related errors and exceptions
            $log.error("db error err=" + err);
        });
    });

    jwtOptionsProvider.config({
      tokenGetter: ['store', function (store) {
        return store.get('token');
      }],
      whiteListedDomains: [APIDOMAIN]
    });

    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('AuthInterceptor');

    /** Temporary measure to remove annoying error warning */
    $qProvider.errorOnUnhandledRejections(false);
  }

})();

angular.module("fmuslimPosClient").run(["$templateCache", function($templateCache) {$templateCache.put("app/galeri-stok/galeri-stok.html","<div class=container-fluid><div class=row><!-- <div class=\"col-sm-12\"> --><!-- <img src=\"https://www.ethica-collection.com/wp-content/uploads/2015/11/header-ethica.jpg\" alt=\"header\" class=\"img img-responsive\"> --><!-- </div> --><div class=col-sm-4><h1>Ethica Collection</h1><h5>Agen Busana Muslim Ethica</h5></div><div class=col-sm-8><h2>Galeri Produk Ready Stock</h2></div></div><hr><div class=row><div class=col-sm-3 ng-repeat=\"item in vm.productList track by item.id\"><div class=thumbnail><img src=http://via.placeholder.com/480x640 alt=...><div class=caption><h3><a href={{item.permalink}} target=_blank>{{item.nama}}</a></h3><p>Stok: <span class=\"label label-warning\">{{item.jumlah}}</span> | Ukuran: <span class=\"label label-info\">{{item.size}}</span></p></div></div></div></div><hr ng-if=\"vm.maxPage > 1\"><div class=row ng-if=\"vm.maxPage > 1\"><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=col-sm-6><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div><hr><div class=row><div class=\"col-sm-12 text-center\">Copyright &copy; Ethica Collection {{::vm.year}}</div></div><p>&nbsp;</p></div>");
$templateCache.put("app/login/login.html","<div class=\"container-fluid login-container\"><div class=row style=margin-top:20vh><div class=\"col-sm-4 col-sm-offset-4 login-box text-center\"><img src=assets/images/zafrada.png alt=\"Zafrada POS\" width=20%><h1><span style=\"color: #99d420\">Zafrada</span> POS</h1><hr><form class=form name=loginForm style=\"margin-top: 2em\"><div class=form-group><input type=text class=\"form-control input-lg text-center\" placeholder=\"User Name\" autofocus required ng-model=vm.user.uname></div><div class=form-group><input type=password class=\"form-control input-lg text-center\" placeholder=Password required ng-model=vm.user.password></div><div class=form-group><input type=submit class=\"btn btn-primary btn-lg btn-block\" value=\"L O G I N\" ng-disabled=loginForm.$invalid ng-click=vm.doLogin()></div><p><small>Versi {{vm.info.client.version}}<br>Client build: {{vm.info.client.build}}<br>Server build: {{vm.info.server.versi}}</small></p></form></div></div></div>");
$templateCache.put("app/main/main.html","<nav class=\"navbar navbar-static-top navbar-custom\"><div class=container-fluid><!-- Brand and toggle get grouped for better mobile display --><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#bs-example-navbar-collapse-1 aria-expanded=false ng-init=\"main.navCollapsed = true\" ng-click=\"main.navCollapsed = !main.navCollapsed\"><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#><img src=assets/images/zafrada.png alt=\"Zafrada POS\" width=10% style=\"float:left; margin-top:-15px\"> <span style=\"color: #99d420\">afrada</span> POS</a></div><!-- Collect the nav links, forms, and other content for toggling --><div uib-collapse=main.navCollapsed class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-1><ul class=\"nav navbar-nav navbar-right\"><li ng-repeat=\"item in main.menuItem\"><a ui-sref={{::item.sref}} ng-class=\"{active: main.isActive(item.sref)}\"><i class=\"fa {{::item.icon}}\"></i> {{::item.text}}</a></li><li><a href ng-click=main.logout()><i class=\"fa {{::main.loginInfo.icon}}\"></i> {{main.loginInfo.text}}</a></li></ul></div><!-- /.navbar-collapse --></div><!-- /.container-fluid --></nav><div class=container-fluid style=\"padding-bottom: 2em\"><div ui-view></div></div><div class=loading-animation><div class=cssload-thecube><div class=\"cssload-cube cssload-c1\"></div><div class=\"cssload-cube cssload-c2\"></div><div class=\"cssload-cube cssload-c4\"></div><div class=\"cssload-cube cssload-c3\"></div></div><h2 class=\"text-center loading-information\">{{main.message}}</h2></div>");
$templateCache.put("app/webreport/webreport.html","<div class=container-fluid><div class=row><!-- <div class=\"col-sm-12\"> --><!-- <img src=\"https://www.ethica-collection.com/wp-content/uploads/2015/11/header-ethica.jpg\" alt=\"header\" class=\"img img-responsive\"> --><!-- </div> --><div class=col-sm-4><h1>Ethica Collection</h1><h5>Agen Busana Muslim Ethica</h5></div><div class=col-sm-8><h2>Daftar Stok Produk</h2></div></div><hr><form><div class=row><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>SKU</label><input type=text class=form-control placeholder=\"SKU Produk\" ng-model=vm.filter.by_sku></div><div class=\"form-group col-sm-6\"><label for=\"\" class=reqfield>Nama</label><input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.search></div><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Ukuran</label><input type=text class=form-control placeholder=\"Ukuran Produk\" ng-model=vm.filter.by_attr_val></div></div><div class=row><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Kondisi Stok</label><select name=\"\" class=form-control ng-model=vm.filter.only_with_stok ng-init=\"vm.filter.only_with_stok = \'0\'\"><option value=0>Semua Stok</option><option value=1>Stok Tersedia</option><option value=2>Stok Kosong</option></select></div><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Urutan</label><select name=\"\" class=form-control ng-model=vm.filter.order_by ng-init=\"vm.filter.order_by = \'by_sku\'\"><option value=by_sku>SKU</option><option value=by_harga>Harga</option><option value=by_jumlah>Jumlah Stok</option><!-- <option value=\"by_created_at\">Terbaru</option> --></select></div><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Jenis Urutan</label><select name=\"\" class=form-control ng-model=vm.filter.sorting ng-init=\"vm.filter.sorting = \'asc\'\"><option value=asc>Kecil ke Besar / A - Z</option><option value=desc>Besar ke Kecil / Z - A</option></select></div><div class=\"form-group col-sm-3\"><label for=\"\">&nbsp;</label><button class=\"btn btn-info btn-block\" ng-click=vm.initView(1)><i class=\"fa fa-search\"></i> Filter Data</button></div></div></form><hr><!-- <div class=\"row\"> --><div class=table-responsive><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><!-- <th scope=\"col\" >Waktu</th> --><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col>Keterangan</th><th scope=col>Harga</th><th scope=col>Stok</th></tr></thead><tbody><tr ng-repeat=\"item in vm.productList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td><a ng-if=item.permalink ng-href={{item.permalink}} target=_blank>{{item.sku | uppercase}}</a> <a ng-if=!item.permalink ng-href={{item.detail.permalink}} target=_blank>{{item.sku | uppercase}}</a></td><td>{{item.nama}}</td><td><!-- <span ng-repeat=\"varian in item.detail.attributes\" ><strong>{{varian.name + \': \'}}</strong> {{varian.option}}<br></span> --> <span ng-if=item.size><strong>Size: </strong>{{item.size}}<br></span><span ng-if=item.warna><strong>Warna: </strong>{{item.color}}<br></span><span ng-if=item.family><strong>Family: </strong>{{item.family}}<br></span></td><td class=text-right>{{item.harga | number:2}}</td><td class=text-right>{{item.jumlah || 0}}</td></tr></tbody></table></div><!-- </div> --><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=col-sm-6><button class=\"btn btn-default btn-block\" disabled>Menampilkan halaman : {{vm.filter.page}}</button></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div><hr><div class=row><div class=\"col-sm-12 text-center\">Copyright &copy; Ethica Collection {{::vm.year}}</div></div><p>&nbsp;</p></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" ui-sref=main.administrasi.sinkronisasi ng-class=\"{\'btn-info\': (vm.state === \'main.administrasi.sinkronisasi\' ||vm.state === \'main.administrasi.product\' || vm.state === \'main.administrasi.category\' || vm.state === \'main.administrasi.product-double\' ), \'btn-default\': !(vm.state === \'main.administrasi.sinkronisasi\' ||vm.state === \'main.administrasi.product\' || vm.state === \'main.administrasi.category\' || vm.state === \'main.administrasi.product-double\' )}\"><i class=\"fa fa-fw fa-th-large\"></i> Produk</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" ui-sref=main.administrasi.oresell ng-class=\"{\'btn-info\': (vm.state === \'main.administrasi.oresell\' ||vm.state === \'main.administrasi.mutasi-oresell\' || vm.state === \'main.administrasi.kontak-oresell\' || vm.state === \'main.administrasi.log-deposit-oresell\' || vm.state === \'main.administrasi.log-level-oresell\' ), \'btn-default\': !(vm.state === \'main.administrasi.oresell\' ||vm.state === \'main.administrasi.mutasi-oresell\' || vm.state === \'main.administrasi.kontak-oresell\' || vm.state === \'main.administrasi.log-deposit-oresell\' || vm.state === \'main.administrasi.log-level-oresell\' )}\"><i class=\"fa fa-fw fa-credit-card\"></i> Otoresell</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" ui-sref=main.administrasi.shopee ng-class=\"{\'btn-info\': (vm.state === \'main.administrasi.shopee\' ||vm.state === \'main.administrasi.bukalapak\' || vm.state === \'main.administrasi.tiktok\' || vm.state === \'main.administrasi.lazada\' || vm.state === \'main.administrasi.jubelio\' ), \'btn-default\': !(vm.state === \'main.administrasi.shopee\' ||vm.state === \'main.administrasi.bukalapak\' || vm.state === \'main.administrasi.tiktok\' || vm.state === \'main.administrasi.lazada\' || vm.state === \'main.administrasi.jubelio\' )}\"><i class=\"fa fa-fw fa-shopping-bag\"></i> Marketplace</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" ui-sref=main.administrasi.facebook ng-class=\"{\'btn-info\': (vm.state === \'main.administrasi.facebook\' ), \'btn-default\': !(vm.state === \'main.administrasi.facebook\')}\"><i class=\"fa fa-fw fa-facebook-official\"></i> Facebook</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" ui-sref=main.administrasi.whatsapp ng-class=\"{\'btn-info\': (vm.state === \'main.administrasi.whatsapp\' ), \'btn-default\': !(vm.state === \'main.administrasi.whatsapp\')}\"><i class=\"fa fa-fw fa-whatsapp\"></i> Pesan WA</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Atur pengguna aplikasi\" ui-sref=main.administrasi.users ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.users\', \'btn-default\': vm.state !==\'main.administrasi.users\'}\"><i class=\"fa fa-fw fa-users\"></i> Atur Pengguna</a></div></div></div><div class=col-sm-9><div class=row ng-if=\"(vm.state === \'main.administrasi.sinkronisasi\' ||vm.state === \'main.administrasi.product\' || vm.state === \'main.administrasi.category\' || vm.state === \'main.administrasi.product-double\' )\"><div class=col-sm-12><div class=btn-group role=group aria-label=...><button type=button class=btn uib-tooltip=\"Sinkronisasi data dar website, server aplikasi, dan lokal\" ui-sref=main.administrasi.sinkronisasi ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.sinkronisasi\', \'btn-default\': vm.state\n          !==\'main.administrasi.sinkronisasi\'}\"><i class=\"fa fa-fw fa-refresh\"></i> Sinkronisasi Produk</button> <button type=button class=btn uib-tooltip=\"Administrasi produk\" ui-sref=main.administrasi.product ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.product\', \'btn-default\': vm.state !==\'main.administrasi.product\'}\"><i class=\"fa fa-fw fa-th-large\"></i> Administrasi Produk</button> <button type=button class=btn uib-tooltip=\"Kategori produk\" ui-sref=main.administrasi.category ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.category\', \'btn-default\': vm.state !==\'main.administrasi.category\'}\"><i class=\"fa fa-fw fa-th-large\"></i> Kategori Produk</button> <button type=button class=btn uib-tooltip=\"Produk dobel\" ui-sref=main.administrasi.product-double ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.product-double\', \'btn-default\': vm.state !==\'main.administrasi.product-double\'}\"><i class=\"fa fa-fw fa-star-half-empty\"></i> Produk Dobel</button></div></div></div><div class=row ng-if=\"(vm.state === \'main.administrasi.oresell\' ||vm.state === \'main.administrasi.mutasi-oresell\' || vm.state === \'main.administrasi.kontak-oresell\' || vm.state === \'main.administrasi.log-deposit-oresell\' || vm.state === \'main.administrasi.log-level-oresell\' || vm.state === \'main.administrasi.oresell-broadcast\' )\"><div class=col-sm-12><div class=btn-group role=group aria-label=...><button type=button class=btn uib-tooltip=\"Reseller Otoresell\" ui-sref=main.administrasi.oresell ng-class=\"{\'btn-info\': vm.state\n            ===\'main.administrasi.oresell\', \'btn-default\': vm.state !==\'main.administrasi.oresell\'}\"><i class=\"fa fa-fw fa-credit-card\"></i> Reseller</button> <button type=button class=btn uib-tooltip=\"Mutasi Deposit Otoresell\" ui-sref=main.administrasi.mutasi-oresell ng-class=\"{\'btn-info\': vm.state\n            ===\'main.administrasi.mutasi-oresell\', \'btn-default\': vm.state !==\'main.administrasi.mutasi-oresell\'}\"><i class=\"fa fa-fw fa-list\"></i> Mutasi</button> <button type=button class=btn uib-tooltip=\"Kontak Otoresell\" ui-sref=main.administrasi.kontak-oresell ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.kontak-oresell\', \'btn-default\': vm.state\n            !==\'main.administrasi.kontak-oresell\'}\"><i class=\"fa fa-fw fa-address-card-o\"></i> Kontak</button> <button type=button class=btn uib-tooltip=\"Log Deposit Otoresell\" ui-sref=main.administrasi.log-deposit-oresell ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.log-deposit-oresell\', \'btn-default\': vm.state\n            !==\'main.administrasi.log-deposit-oresell\'}\"><i class=\"fa fa-fw fa-history\"></i> Log Deposit</button> <button type=button class=btn uib-tooltip=\"Log Level Otoresell\" ui-sref=main.administrasi.log-level-oresell ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.log-level-oresell\', \'btn-default\': vm.state\n            !==\'main.administrasi.log-level-oresell\'}\"><i class=\"fa fa-fw fa-history\"></i> Log Level</button> <button type=button class=btn uib-tooltip=Broadcast ui-sref=main.administrasi.oresell-broadcast ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.oresell-broadcast\', \'btn-default\': vm.state\n            !==\'main.administrasi.oresell-broadcast\'}\"><i class=\"fa fa-fw fa-bullhorn\"></i> Broadcast</button></div></div></div><div class=row ng-if=\"(vm.state === \'main.administrasi.shopee\' ||vm.state === \'main.administrasi.bukalapak\' ||vm.state === \'main.administrasi.tiktok\' || vm.state === \'main.administrasi.lazada\' || vm.state === \'main.administrasi.jubelio\' )\"><div class=col-sm-12><div class=btn-group role=group aria-label=...><button type=button class=btn uib-tooltip=\"Aktivitas Shopee\" ui-sref=main.administrasi.shopee ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.shopee\', \'btn-default\': vm.state !==\'main.administrasi.shopee\'}\"><i class=\"fa fa-fw fa-shopping-bag\"></i> Shopee</button> <button type=button class=btn uib-tooltip=\"Aktivitas Bukalapak\" ui-sref=main.administrasi.bukalapak ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.bukalapak\', \'btn-default\': vm.state\n          !==\'main.administrasi.bukalapak\'}\"><i class=\"fa fa-fw fa-shopping-bag\"></i> Bukalapak</button> <button type=button class=btn uib-tooltip=\"Aktivitas Tiktok\" ui-sref=main.administrasi.tiktok ng-class=\"{\'btn-info\': vm.state ===\'main.administrasi.tiktok\', \'btn-default\': vm.state\n          !==\'main.administrasi.tiktok\'}\"><i class=\"fa fa-fw fa-youtube-play\"></i> Tiktok</button> <button type=button class=btn uib-tooltip=\"Aktivitas Lazada\" ui-sref=main.administrasi.lazada ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.lazada\', \'btn-default\': vm.state !==\'main.administrasi.lazada\'}\"><i class=\"fa fa-fw fa-shopping-cart\"></i> Lazada</button> <button type=button class=btn uib-tooltip=\"Aktivitas Jubelio\" ui-sref=main.administrasi.jubelio ng-class=\"{\'btn-info\': vm.state\n          ===\'main.administrasi.jubelio\', \'btn-default\': vm.state !==\'main.administrasi.jubelio\'}\"><i class=\"fa fa-fw fa-cloud\"></i> Jubelio</button></div></div></div><hr><div class=row><div class=col-sm-12><div ui-view></div></div></div></div></div>");
$templateCache.put("app/main/main.dashboard/main.dashboard.html","<div class=row><div class=col-sm-4><a ui-sref=main.pos class=\"btn btn-success btn-block btn-lg btn-elg\"><i class=\"fa fa-shopping-cart fa-4x fa-fw\"></i><br>Kasir</a></div><div class=col-sm-4><a ui-sref=main.stock class=\"btn btn-danger btn-block btn-lg btn-elg\"><i class=\"fa fa-cubes fa-4x fa-fw\"></i><br>Data Stok</a></div><div class=col-sm-4><a ui-sref=main.stock class=\"btn btn-warning btn-block btn-lg btn-elg\"><i class=\"fa fa-gear fa-4x fa-fw\"></i><br>Setting</a></div></div>");
$templateCache.put("app/main/main.pos/main.pos.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Melakukan penjualan\" ui-sref=main.pos.cashier ng-class=\"{\'btn-info\': vm.state ===\'main.pos.cashier\', \'btn-default\': vm.state !==\'main.pos.cashier\'}\"><i class=\"fa fa-fw fa-shopping-bag\"></i> Penjualan</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Transaksi Pending\" ui-sref=main.pos.pending ng-class=\"{\'btn-info\': (vm.state ===\'main.pos.pending\' || vm.state ===\'main.pos.process-pending\'), \'btn-default\': vm.state !==\'main.pos.pending\'}\"><i class=\"fa fa-fw fa-save\"></i> Transaksi Pending</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Lihat riwayat transaksi penjualan\" ui-sref=main.pos.transaction-list ng-class=\"{\'btn-info\': vm.state ===\'main.pos.transaction-list\', \'btn-default\': vm.state !==\'main.pos.transaction-list\'}\"><i class=\"fa fa-fw fa-shopping-cart\"></i> Riwayat Transaksi</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Lihat riwayat transaksi produk\" ui-sref=main.pos.product-transaction-list ng-class=\"{\'btn-info\': vm.state ===\'main.pos.product-transaction-list\', \'btn-default\': vm.state !==\'main.pos.product-transaction-list\'}\"><i class=\"fa fa-fw fa-shopping-basket\"></i> Riwayat Transaksi Produk</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Lihat riwayat pembayaran\" ui-sref=main.pos.payment-history ng-class=\"{\'btn-info\': vm.state ===\'main.pos.payment-history\', \'btn-default\': vm.state !==\'main.pos.payment-history\'}\"><i class=\"fa fa-fw fa-credit-card\"></i> Riwayat Pembayaran</a></div></div></div><div class=col-sm-9><div ui-view></div></div></div>");
$templateCache.put("app/main/main.report/main.report.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan berdasar Wilayah\" ui-sref=main.report.location ng-class=\"{\'btn-info\': vm.state ===\'main.report.location\', \'btn-default\': vm.state !==\'main.report.location\'}\"><i class=\"fa fa-fw fa-map-marker\"></i> Lokasi</a></div></div><!--<div class=\"row\" style=\"margin-top:1em;\">\n            <div class=\"col-sm-12\">\n                <a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan berdasar Konsumen\" ui-sref=\"main.report.customer\" ng-class=\"{\'btn-info\': vm.state ===\'main.report.customer\', \'btn-default\': vm.state !==\'main.report.customer\'}\" >\n                  <i class=\"fa fa-fw fa-user-circle-o\"></i>  Konsumen</a>\n            </div>\n        </div>--><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan berdasar Produk\" ui-sref=main.report.product ng-class=\"{\'btn-info\': vm.state ===\'main.report.product\', \'btn-default\': vm.state !==\'main.report.product\'}\"><i class=\"fa fa-fw fa-shopping-bag\"></i> Produk</a></div></div><div class=row style=\"margin-top:1em;margin-bottom: 2em\"><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan Perbandingan\" ui-sref=main.report.compare ng-class=\"{\'btn-info\': vm.state ===\'main.report.compare\', \'btn-default\': vm.state !==\'main.report.compare\'}\"><i class=\"fa fa-fw fa-th-large\"></i> Perbandingan</a></div></div><hr><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan Transaksi\" ui-sref=main.report.transaction ng-class=\"{\'btn-info\': vm.state ===\'main.report.transaction\', \'btn-default\': vm.state !==\'main.report.transaction\'}\"><i class=\"fa fa-fw fa-file-text\"></i> Transaksi</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan Transaksi Otoresell\" ui-sref=main.report.transaction-oresell ng-class=\"{\'btn-info\': vm.state ===\'main.report.transaction-oresell\', \'btn-default\': vm.state !==\'main.report.transaction-oresell\'}\"><i class=\"fa fa-fw fa-file-text-o\"></i> Transaksi Otoresell</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Laporan Transaksi Dropship\" ui-sref=main.report.transaction-dropship ng-class=\"{\'btn-info\': vm.state ===\'main.report.transaction-dropship\', \'btn-default\': vm.state !==\'main.report.transaction-dropship\'}\"><i class=\"fa fa-fw fa-file-code-o\"></i> Transaksi Dropship</a></div></div></div><div class=col-sm-9><div ui-view></div></div></div>");
$templateCache.put("app/main/main.stock/main.stock.html","<div class=row><div class=\"col-sm-12 text-center\"><h3 class=page-title>{{vm.title}}</h3></div></div><hr><div class=row><div class=col-sm-3><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Simpan data stok yang sudah dimasukkan ke database server\" ui-sref=main.stock.stock-change ng-class=\"{\'btn-info\': vm.state ===\'main.stock.stock-change\', \'btn-default\': vm.state !==\'main.stock.stock-change\'}\"><i class=\"fa fa-fw fa-database\"></i> Ubah Stok</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Riwayat perubahan stok\" ui-sref=main.stock.stock-history ng-class=\"{\'btn-info\': vm.state ===\'main.stock.stock-history\', \'btn-default\': vm.state !==\'main.stock.stock-history\'}\"><i class=\"fa fa-fw fa-history\"></i> Riwayat Stok</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Stok Opname\" ui-sref=main.stock.stock-opname ng-class=\"{\'btn-info\': vm.state ===\'main.stock.stock-opname\', \'btn-default\': vm.state !==\'main.stock.stock-opname\'}\"><i class=\"fa fa-fw fa-cubes\"></i> Stok Opname</a></div></div><hr><div class=row><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Daftar produk yang tersimpan di aplikasi\" ui-sref=main.stock.product-list ng-class=\"{\'btn-info\': vm.state ===\'main.stock.product-list\', \'btn-default\': vm.state !==\'main.stock.product-list\'}\"><i class=\"fa fa-fw fa-table\"></i> Daftar Produk</a></div></div><div class=row style=margin-top:1em><div class=col-sm-12><button class=\"btn btn-block btn-default btn-left\" uib-tooltip=\"Upload Data Produk ke File CSV\" ng-click=vm.importCSV()><i class=\"fa fa-fw fa-cloud-upload\"></i> Upload CSV Produk</button></div></div><div class=row style=margin-top:1em><div class=col-sm-12><a class=\"btn btn-block btn-left\" uib-tooltip=\"Daftar produk yang tersimpan di aplikasi\" ui-sref=main.stock.bulk-update ng-class=\"{\'btn-info\': vm.state ===\'main.stock.bulk-update\', \'btn-default\': vm.state !==\'main.stock.bulk-update\'}\"><i class=\"fa fa-fw fa-cloud-upload\"></i> Ubah Stok Massal</a></div></div></div><div class=col-sm-9><div ui-view></div></div></div>");
$templateCache.put("app/components/modals/DetailCustomer/DetailCustomerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Detail Pelanggan <span ng-if=!vm.isOresell>#{{::vm.cust_id}}</span> {{::vm.pelanggan.nama}}</h4></div><div class=modal-body><table class=\"table table-condensed\" ng-if=!vm.noConsumen><tr><th scope=row class=col-sm-3>Nama</th><td class=autofit>:</td><td>{{vm.pelanggan.nama}}</td></tr><tr><th scope=row class=col-sm-3>Email</th><td class=autofit>:</td><td><a ng-href=mailto:{{vm.pelanggan.email}}>{{vm.pelanggan.email}}</a></td></tr><tr><th scope=row class=col-sm-3>No HP</th><td class=autofit>:</td><td>{{vm.pelanggan.hp}}</td></tr><tr><th scope=row class=col-sm-3>No Telepon</th><td class=autofit>:</td><td>{{vm.pelanggan.telp}}</td></tr><tr><th scope=row class=col-sm-3>Alamat</th><td class=autofit>:</td><td>{{vm.pelanggan.alamat}} {{vm.pelanggan.kec}} {{vm.pelanggan.kab}} {{vm.pelanggan.prov}} {{vm.pelanggan.kode_pos}}</td></tr><tr><th scope=row class=col-sm-3>Keterangan</th><td class=autofit>:</td><td>{{vm.pelanggan.extra.keterangan}}</td></tr></table><div class=\"alert alert-danger\" ng-if=vm.noConsumen>Data pelanggan tidak ada atau sudah dihapus</div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/DetailReseller/DetailResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Kontak Reseller <strong>{{::vm.reseller.name}}</strong></h4></div><div class=modal-body><table class=\"table table-condensed\" ng-if=!vm.noConsumen><tr><th scope=row class=col-sm-3>Nama</th><td class=autofit>:</td><td>{{::vm.reseller.name}}</td></tr><tr><th scope=row class=col-sm-3>Email</th><td class=autofit>:</td><td><a ng-href=mailto:{{::vm.reseller.email}}>{{::vm.reseller.email}}</a></td></tr><tr><th scope=row class=col-sm-3>No HP</th><td class=autofit>:</td><td>{{::vm.reseller.phone}}</td></tr><tr><th scope=row class=col-sm-3>Alamat</th><td class=autofit>:</td><td>{{::vm.reseller.address.alamat}} {{::vm.reseller.address.kec}} {{::vm.reseller.address.kab}} {{::vm.reseller.address.prov}} {{::vm.reseller.address.kode_pos}}</td></tr></table><div class=\"alert alert-danger\" ng-if=vm.noConsumen>Data alamat reseller tidak ada atau sudah dihapus</div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/DetailTransaksi/DetailTransaksiDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-shopping-cart\"></i> Detail Transaksi #{{::vm.id}}&nbsp; <span ng-if=\"vm.transaksi.dropship === 1\">(Dropship: <a href=\"\" ng-click=\"vm.showReseller = !vm.showReseller\" style=\"color: #ffeb9b; text-decoration: underline\">#{{::vm.transaksi.reseller_id}}</a>) </span><!-- dropship oresell --> <span ng-if=\"vm.transaksi.dropship === 2\">(Otoresell: <a href=\"\" ng-click=\"vm.showReseller = !vm.showReseller\" style=\"color: #ffeb9b; text-decoration: underline\">{{::vm.transaksi.reseller_id}}</a>) </span><span ng-if=vm.transaksi.shopee_ordersn>| Shopee Trx ID: #{{vm.transaksi.shopee_ordersn}} </span><span ng-if=vm.transaksi.tokopedia_orderid>| Tokopedia Trx ID: #{{vm.transaksi.tokopedia_orderid}} </span><span ng-if=vm.transaksi.tiktok_orderid>| Tiktok Trx ID: #{{vm.transaksi.tiktok_orderid}}</span></h4></div><div class=modal-body><div class=row ng-if=\"(vm.transaksi.dropship * 1) > 0\" uib-collapse=!vm.showReseller><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><p><strong>{{ vm.transaksi.lain_lain.dropship.sender.nama }}</strong></p><p ng-if=vm.transaksi.lain_lain.dropship.alamat_sender>{{ vm.transaksi.lain_lain.dropship.alamat_sender }}</p><p ng-if=vm.transaksi.lain_lain.dropship.sender.alamat>{{ vm.transaksi.lain_lain.dropship.sender.alamat }} {{ vm.transaksi.lain_lain.dropship.sender.kec }} {{ vm.transaksi.lain_lain.dropship.sender.kab }} {{ vm.transaksi.lain_lain.dropship.sender.prov }}</p><p><span ng-if=vm.transaksi.lain_lain.dropship.sender.hp><i class=\"fa fa-phone\"></i> {{ vm.transaksi.lain_lain.dropship.sender.hp }} </span><span ng-if=vm.transaksi.lain_lain.dropship.sender.email>&nbsp;-&nbsp; <i class=\"fa fa-envelope\"></i> <a href=\"\">{{ vm.transaksi.lain_lain.dropship.sender.email }}</a></span></p></div></div></div></div><div class=row><div class=col-sm-6><table class=\"table table-condensed\"><tr><th scope=row class=col-sm-3>Waktu</th><td>: <span ng-if=\"vm.transaksi.status !== \'pending\'\">{{ vm.transaksi.tgl | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</span> <span ng-if=\"vm.transaksi.status === \'pending\'\" uib-tooltip=\"Created at: {{\n                  vm.transaksi.created_at | udate: \'dd MMMM yyyy - HH:mm:ss\'\n                }}\">{{ vm.transaksi.tgl | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</span></td></tr><tr><th scope=row>Konsumen</th><td>: {{ vm.transaksi.pembeli }}</td></tr><!--<tr>\n                  <th scope=\"row\">Kasir</th>\n                  <td>: {{vm.transaksi.kasir}}</td>\n                </tr>--><tr><th scope=row>Editor</th><td>: {{ vm.transaksi.user }}</td></tr><tr><th scope=row>Status</th><td>: <button class=\"btn btn-xs\" disabled ng-class=\"{\'btn-danger\': vm.transaksi.status ===\'pending\', \'btn-info\': vm.transaksi.status === \'dibayar\', \'btn-success\': \'selesai\'}\">{{ vm.transaksi.status | uppercase }}</button></td></tr></table></div><div class=col-sm-6><table class=\"table table-condensed\"><tr><th scope=row class=col-sm-3>Ekspedisi</th><td ng-if=\"vm.transaksi.ekspedisi !== \'online\'\">: {{ vm.transaksi.ekspedisi | uppercase }}</td><td ng-if=\"vm.transaksi.ekspedisi === \'online\'\">: {{ vm.transaksi.lain_lain.ekspedisiMP !== \'other\' ? vm.transaksi.lain_lain.ekspedisiMP : vm.transaksi.lain_lain.ekspedisiMPOther }}</td></tr><tr><th scope=row class=col-sm-3>Jenis Paket</th><td ng-if=\"vm.transaksi.ekspedisi !== \'online\'\">: {{ vm.transaksi.ekspedisi_service }}</td></tr><tr><th scope=row>Nomor Resi</th><td>:&nbsp; <span ngif=\"vm.transaksi.job_number && !vm.transaksi.no_resi\" class=text-danger><strong>{{vm.transaksi.job_number}}</strong></span> <span ngif=vm.transaksi.no_resi>{{vm.transaksi.no_resi}}</span> <button class=\"btn btn-xs btn-info pull-right\" ng-if=vm.transaksi.no_resi ng-click=vm.trackShipping() ng-disabled=vm.inProgress title=\"Klik untuk cek resi\"><i class=\"fa fa-search fa-fw\"></i></button></td><!-- <td>: {{vm.transaksi.lain_lain.no_resi}}</td> --></tr><tr><th scope=row class=col-sm-3>Waktu</th><td>: <span ng-if=vm.transaksi.no_resi>{{ vm.transaksi.updated_at | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</span></td></tr></table></div></div><table class=table><thead><tr><th scope=col>No</th><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col>Qty</th><th scope=col>Harga</th><th scope=col>Diskon (%)</th><th scope=col>Diskon (Nom)</th><th scope=col>Total Harga</th></tr></thead><tbody><tr ng-repeat=\"item in vm.transaksi.produk_unik track by $index\"><td class=text-right>{{::$index + 1}}</td><td>{{::item.sku}}</td><td><strong>{{::item.nama}}</strong><br><small>{{item.ket}}</small></td><td class=text-right>{{::item.jumlah}}</td><td class=text-right>{{::item.harga_jual | number:2}}</td><td class=text-right>{{::item.discount_persen | number:2}}</td><td class=text-right>{{::item.discount_nominal | number:2}}</td><td class=text-right>{{ item.harga_jual * item.jumlah - (item.discount_nominal * 1 + item.jumlah * ((item.discount_persen / 100) * item.harga_jual)) | number: 2 }}</td></tr><tr><th colspan=5></th><th scope=row colspan=2 class=\"info text-right\">Jumlah</th><td class=\"info text-right\"><strong>{{ vm.transaksi.total_akhir * 1 + vm.transaksi.discount_transaction_total * 1 - vm.transaksi.total_lain_lain * 1 | number: 2 }}</strong></td></tr><!-- <tr class=\"warning\">\n              <th scope=\"row\" colspan=\"5\" class=\"text-right\">Biaya Kirim</th>\n              <td class=\"text-right\"><strong>{{(vm.transaksi.lain_lain.biaya_kirim  * 1) | number:2}}</strong></td>\n            </tr> --><tr><th colspan=5></th><th scope=row colspan=2 class=\"warning text-right\">Total Biaya Lain</th><td class=\"warning text-right\"><strong>{{ vm.transaksi.total_lain_lain * 1 | number: 2 }}</strong></td></tr><tr><th scope=row colspan=2 class=text-right>Diskon (%): {{ vm.transaksi.discount_transaction_persen | number: 2 }} %</th><th scope=row colspan=2 class=text-right>Diskon (Nom): {{ vm.transaksi.discount_transaction_nominal | number: 2 }}</th><th></th><th scope=row colspan=2 class=\"success text-right\">Total Diskon</th><td class=\"success text-right\"><strong>{{ vm.transaksi.discount_transaction_total * 1 | number: 2 }}</strong></td></tr><tr><th colspan=5></th><th scope=row colspan=2 class=\"danger text-right\">Total Akhir</th><td class=\"danger text-right\"><strong>{{ vm.transaksi.total_akhir * 1 | number: 2 }}</strong></td></tr></tbody></table><div ng-if=\"vm.transaksi.bayar > 0\"><h4><strong>Riwayat Pembayaran</strong> <a href ng-click=\"vm.showPayment = !vm.showPayment\"><span ng-if=!vm.showPayment>[tampilkan]</span> <span ng-if=vm.showPayment>[sembunyikan]</span></a></h4><hr><div class=row uib-collapse=!vm.showPayment><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th scope=col class=col-sm-1>No</th><th scope=col class=col-sm-2>Tanggal</th><th scope=col class=col-sm-2>Metode</th><th scope=col class=col-sm-4>Kasir</th><th scope=col class=\"col-sm-4 text-right\">Nominal</th></tr></thead><tbody><tr ng-repeat=\"termin in vm.transaksi.pembayaran.data\" ng-if=\"vm.transaksi.pembayaran.data.length > 0\"><td class=\"text-right col-sm-1\">{{ $index + 1 }}</td><td class=col-sm-2>{{ termin.tgl | udate: \'dd-MM-yyyy\' }}</td><td class=col-sm-2><strong>{{ termin.metode_bayar }}</strong></td><td class=col-sm-4>{{ termin.kasir }}</td><td class=\"text-right col-sm-4\">{{ termin.nominal | number: 2 }}</td></tr><tr ng-if=\"(vm.transaksi.pembayaran.data.length === 0) && (vm.transaksi.bayar > 0)\"><td class=\"text-right col-sm-1\">{{ $index + 1 }}</td><td class=col-sm-2>{{ vm.transaksi.tgl | udate: \'dd-MM-yyyy\' }}</td><td class=col-sm-2><strong>Lain - Lain</strong></td><td class=col-sm-4>{{ vm.transaksi.kasir }} / {{ vm.transaksi.user }}</td><td class=\"text-right col-sm-4\">{{ vm.transaksi.bayar | number: 2 }}</td></tr><tr><th colspan=3></th><th scope=row class=\"success text-right\">Total Pembayaran</th><th scope=row class=\"text-right col-sm-4 success\">{{ vm.transaksi.bayar | number: 2 }}</th></tr><tr><th colspan=3></th><th scope=row class=\"info text-right\">Uang Kembali</th><th scope=row class=\"text-right col-sm-4 info\">{{ vm.transaksi.sisa_kembali | number: 2 }}</th></tr></tbody></table></div></div></div><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><h4><strong>Catatan Kasir</strong> <a href ng-click=\"vm.showCashierNote = !vm.showCashierNote\"><span ng-if=!vm.showCashierNote>[tampilkan]</span> <span ng-if=vm.showCashierNote>[sembunyikan]</span></a></h4><hr></div></div><div class=row uib-collapse=!vm.showCashierNote><div class=col-xs-12><div class=row ng-if=\"vm.cashierNote.length > 0\"><div class=col-xs-12><table class=\"table table-bordered\"><thead><th scope=col class=autofit>Waktu</th><th scope=col>Catatan</th><th scope=col class=autofit>User</th></thead><tbody><tr ng-repeat=\"cnote in vm.cashierNote\"><td class=autofit>{{ cnote.created_at | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</td><td>{{ cnote.note }}</td><td class=autofit>{{ cnote.user }}</td></tr></tbody></table></div></div><div class=row><div class=col-xs-12><div class=input-group><input type=text class=form-control placeholder=\"Tambahkan catatan baru ...\" ng-model=vm.userNote> <span class=input-group-btn><button class=\"btn btn-warning\" title=\"Klik untuk menyimpan catatan\" ng-click=vm.addNote() ng-disabled=!vm.userNote><i class=\"fa fa-plus-circle\"></i> Tambah Catatan</button></span></div></div></div></div></div></div></div><div class=row ng-if=vm.transaksi.lain_lain.jobNumber><div class=col-xs-12><div class=row><div class=col-xs-12><h4><strong>Reseller: Resi Online</strong></h4></div></div><div class=row><div class=col-xs-12><div class=\"alert alert-info\"><h5><strong>Nomor Resi Online Booking: <span style=\"color: #f90\">{{ vm.transaksi.lain_lain.jobNumber }}</span> ekspedisi <span ng-if=\"vm.transaksi.lain_lain.ekspedisiMP !== \'lain\'\" style=\"color: #f90\">{{vm.transaksi.lain_lain.ekspedisiMP}}</span> <span ng-if=\"vm.transaksi.lain_lain.ekspedisiMP === \'lain\'\" style=\"color: #f90\">{{vm.transaksi.lain_lain.ekspedisiMPOther}}</span></strong></h5></div></div></div></div></div><div class=row ng-if=vm.transaksi.lain_lain.customerNote><div class=col-xs-12><div class=row><div class=col-xs-12><h4><strong>Reseller: Catatan Konsumen</strong></h4><hr></div></div><div class=row><div class=col-xs-12><div class=\"alert alert-danger\"><p><strong>{{ vm.transaksi.lain_lain.customerNote }}</strong></p></div></div></div></div></div><div class=row ng-if=vm.tracking><div class=col-xs-12><h4>Tracking Resi: {{ vm.transaksi.no_resi }} |&nbsp; <span class=float-right>Status: {{vm.tracking.status}}</span></h4><hr><table class=\"table table-bordered table-striped\"><tbody><tr ng-repeat=\"manifest in vm.tracking.history\"><td>{{ manifest.date }}</td><td>{{ manifest.location }}</td><td>{{ manifest.desc }}</td></tr></tbody></table></div></div></div><div class=modal-footer><div class=row><div class=col-sm-3><div class=\"btn-group btn-group-justified\"><div class=btn-group uib-dropdown><button class=\"btn btn-warning btn-block\" type=button ng-if=\"vm.transaksi.status===\'dibayar\' || vm.transaksi.status===\'selesai\'\" uib-dropdown-toggle><i class=\"fa fa-print\"></i> Cetak Struk <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.printStruk(0)><a href>Cetak Tinta</a></li><li role=menuitem ng-click=vm.printStruk(1)><a href>Cetak Thermal</a></li></ul></div></div></div><div class=col-sm-3><button class=\"btn btn-warning btn-block\" type=button ng-if=\"((vm.transaksi.shipping_alamat) && (vm.transaksi.shipping_kec_id)) && (vm.transaksi.status===\'dibayar\' || vm.transaksi.status===\'selesai\') && (!vm.transaksi.lain_lain.jobNumber)\" ng-click=vm.printAlamat(1)>Cetak Alamat</button> <button class=\"btn btn-warning btn-block\" type=button ng-if=\"(!vm.transaksi.shipping_alamat) && (vm.transaksi.status===\'dibayar\' || vm.transaksi.status===\'selesai\') && (vm.transaksi.lain_lain.jobNumber)\" ng-click=vm.printResi()>Cetak Resi</button><div class=btn-group uib-dropdown ng-if=\"((vm.transaksi.shipping_alamat) && (vm.transaksi.shipping_kec_id)) && (vm.transaksi.status===\'dibayar\' || vm.transaksi.status===\'selesai\') && (vm.transaksi.lain_lain.jobNumber)\"><button class=\"btn btn-warning btn-block\" type=button uib-dropdown-toggle><i class=\"fa fa-print\"></i> Cetak Alamat / Resi <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.printAlamat(1)><a href>Cetak Alamat</a></li><li role=menuitem ng-click=vm.printResi()><a href>Cetak Resi Reseller</a></li></ul></div></div><div class=col-sm-3><button class=\"btn btn-info btn-block\" type=button ng-click=vm.printDetail()><i class=\"fa fa-file-pdf-o\"></i> PDF Detail Transaksi</button></div><div class=\"col-sm-3 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/StrukOption/strukOptionDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-edit fa-fw\"></i> Option Cetak Struk</h4></div><div class=modal-body><form action=\"\" name=optionForm id=optionForm><div class=row><div class=col-sm-12><div class=checkbox><label><input type=checkbox ng-model=vm.withNote> Cetak catatan terakhir dari Kasir</label></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-warning btn-block\" ng-click=vm.process() ng-disabled=addressForm.$invalid><i class=\"fa fa-print fa-fw\"></i> Proses Cetak</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/addResellerDialog/addResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user-plus\"></i> Reseller Baru</h4></div><div class=modal-body><form action=\"\" class=form name=userForm><div class=row><div class=col-sm-2><select name=\"\" class=form-control ng-model=vm.reseller.contact.kelamin required><option value=P>Ibu</option><option value=L>Bpk</option></select></div><div class=col-sm-10><input type=text class=form-control placeholder=\"Nama Lengkap\" ng-model=vm.reseller.auth.name required maxlength=100 id=name name=name></div></div><hr><div class=row><div class=col-sm-4><input type=email class=form-control placeholder=Email ng-model=vm.reseller.auth.email required></div><div class=col-sm-4><input type=text class=form-control placeholder=\"Nomor HP\" ng-model=vm.reseller.contact.hp required ng-pattern=vm.alamat.validasi.nomor></div><div class=col-sm-4><input type=text class=form-control placeholder=\"Nomor Telepon lain\" ng-model=vm.reseller.contact.telp ng-pattern=vm.alamat.validasi.nomor></div></div><hr class=hr-no-margin-top><div class=\"row form-group\"><div class=col-sm-12><input type=text class=form-control placeholder=Alamat ng-model=vm.reseller.contact.alamat required></div></div><div class=row><div class=col-sm-5><ui-select ng-model=vm.alamat.kabupaten ng-change=vm.changeKabupaten(vm.alamat.kabupaten.city_id) required><ui-select-match placeholder=\"Kabupaten / Kota\"><span>{{$select.selected.type}} {{$select.selected.city_name}} - {{$select.selected.province}}</span></ui-select-match><ui-select-choices repeat=\"kab in (vm.alamat.source.kabupaten | filter: $select.search)\" refresh=vm.getKabupaten($select.search)><span><strong>{{kab.type}} {{kab.city_name}}</strong></span><br><small>{{kab.province}}</small></ui-select-choices></ui-select></div><div class=col-sm-5><ui-select ng-model=vm.alamat.kecamatan required ng-disabled=\"vm.alamat.source.kecamatan.length < 1\"><ui-select-match placeholder=Kecamatan><span>{{$select.selected.subdistrict_name}}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.alamat.source.kecamatan | filter: $select.search)\"><span><strong>{{kec.subdistrict_name}}</strong></span></ui-select-choices></ui-select></div><div class=col-sm-2><input type=text class=form-control placeholder=\"Kode Pos\" ng-model=vm.reseller.contact.kode_pos maxlength=5 ng-pattern=vm.alamat.validasi.nomor></div></div><hr class=hr-no-margin-top><div class=row><div class=col-sm-12><textarea class=form-control placeholder=Keterangan... rows=3 ng-model=vm.reseller.extra.contact.keterangan></textarea></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=\"userForm.$invalid || vm.invalidPassword()\"><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/bayarDialog/BayarDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-shopping-cart\"></i> Transaksi</h4></div><div class=modal-body><form action=\"\" name=paymentForm><div class=row><div class=col-sm-9><div uib-collapse=vm.additionalUI.hideProduct><div class=row><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-heading><h4 class=panel-title>Daftar Produk</h4></div><table class=table><thead><tr><th scope=column>Produk</th><th scope=column class=text-right>Harga</th><th scope=column class=text-right>Jml</th><th scope=column class=text-right>Harga Total</th><th scope=column class=text-right>Diskon</th><th scope=column class=text-right>Total</th></tr></thead><tbody><tr ng-repeat=\"product in vm.product\"><td>{{product.nama}} {{product.size | uppercase}}<br><small>{{product.ket}}</small></td><td class=text-right>{{product.harga_jual | number: 2}}</td><td class=text-right>{{product.jumlah}}</td><td class=text-right>{{(product.harga_jual * product.jumlah) | number: 2}}</td><td class=text-right>{{product.discount_total | number: 2}}</td><td class=text-right>{{product.total | number: 2}}</td></tr><tr><th colspan=3 class=text-right>Jumlah</th><td class=text-right>{{vm.resume.product_price_total | number: 2}}</td><td class=text-right>{{vm.resume.discount_product_total | number: 2}}</td><td class=text-right>{{vm.resume.total | number: 2}}</td></tr></tbody></table></div></div></div><hr class=hr-no-margin></div><div class=\"form row\"><div class=\"col-sm-8 pull-right\"><div class=form-group><ui-select ng-model=vm.selectedCustomer autofocus ng-required=!vm.additionalUI.newCust ng-change=vm.changeCustomer() ng-disabled=vm.status.paid><ui-select-match placeholder=\"Nama / no hp / email Konsumen...\"><span>{{$select.selected.nama}}</span></ui-select-match><ui-select-choices repeat=\"contact in (vm.contactList.data ) track by contact.id\" refresh=vm.getCustomerContact($select.search) refresh-delay=300 minimum-input-length=3><div ng-if=!contact.info><span><strong>{{contact.nama}}</strong></span><br><small ng-if=contact.email>Email : {{contact.email}}<br></small><small ng-if=contact.hp>HP : {{contact.hp}}</small></div><div ng-if=contact.info><strong ng-bind=contact.nama></strong><br><span ng-bind=contact.info></span></div></ui-select-choices></ui-select></div></div><div class=col-sm-4><div class=form-group><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy datepicker-options=\"{maxDate: vm.today}\" ng-model=vm.tglTrans is-open=\"vm.datePicker[\'tglTransaksi\']\" close-text=Close ng-required=true placeholder=\"Tgl Transaksi\" readonly ng-disabled=vm.status.paid uib-tooltip=\"Tanggal Transaksi\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglTransaksi\')\" ng-disabled=vm.status.paid><i class=\"fa fa-calendar\"></i></button></span></div></div></div></div><div class=row uib-collapse=!vm.additionalUI.newCust><div class=col-sm-12><div class=\"alert alert-info alert-minimalis\"><h5>Data Konsumen Baru</h5><hr class=hr-no-margin><div class=row><div class=col-sm-12><div class=form-group><div class=input-group><div class=input-group-btn><select name=\"\" class=\"btn btn-default select-in-group\" ng-model=vm.newCustomer.kelamin ng-init=\"vm.newCustomer.kelamin = \'P\'\"><option value=P>Ibu</option><option value=L>Bapak</option></select></div><input type=text class=form-control placeholder=Nama ng-model=vm.newCustomer.nama ng-required=vm.additionalUI.newCust maxlength=255 ng-disabled=vm.status.paid autofocus></div></div></div></div><div class=row><div class=col-sm-4><div class=form-group><input type=email class=form-control placeholder=Email ng-model=vm.newCustomer.email maxlength=255 ng-disabled=vm.status.paid ng-required=\"vm.additionalUI.newCust && !vm.newCustomer.hp\"></div></div><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Nomor HP\" ng-model=vm.newCustomer.hp maxlength=13 ng-disabled=vm.status.paid ng-pattern=vm.additionalUI.onlyNumbers ng-required=\"vm.additionalUI.newCust && !vm.newCustomer.email\"></div></div><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Nomor Telepon\" ng-model=vm.newCustomer.telp maxlength=15 ng-disabled=vm.status.paid ng-pattern=vm.additionalUI.onlyNumbers></div></div></div><div class=row uib-collapse=!vm.additionalUI.additionalAddress><div class=col-sm-8><div class=form-group><input type=text class=form-control placeholder=Alamat ng-model=vm.newCustomer.alamat maxlength=255 ng-disabled=vm.status.paid ng-required=vm.additionalUI.selectedKab></div></div><div class=col-sm-4><div class=form-group><input type=text class=form-control placeholder=\"Kode Pos\" ng-model=vm.newCustomer.kode_pos maxlength=5 ng-disabled=vm.status.paid ng-pattern=vm.additionalUI.onlyNumbers></div></div></div><div class=row uib-collapse=!vm.additionalUI.additionalAddress><div class=col-sm-12><div class=form-group><ui-select ng-model=vm.additionalUI.selectedKec ng-disabled=vm.status.paid ng-required=vm.newCustomer.alamat><ui-select-match placeholder=Kecamatan><span>{{$select.selected.subdistrict_name}} {{$select.selected.type}} {{$select.selected.city}} - {{$select.selected.province}}</span></ui-select-match><ui-select-choices repeat=\"kec in (vm.additionalUI.kecamatan | filter: $select.search)\" refresh=vm.getKecamatan($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{kec.subdistrict_name}} {{kec.type}} {{kec.city}}</strong><br><small>{{kec.province}}</small></span></ui-select-choices></ui-select></div></div></div><hr><div class=row><div class=col-sm-4><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelNewCustomer()><i class=\"fa fa-times-circle\"></i> Batal</button></div><div class=col-sm-4><button type=button class=\"btn btn-primary btn-block\" ng-click=\"vm.additionalUI.additionalAddress=true\" ng-if=!vm.additionalUI.additionalAddress><i class=\"fa fa-expand\"></i> Alamat</button> <button type=button class=\"btn btn-primary btn-block\" ng-click=\"vm.additionalUI.additionalAddress=false\" ng-if=vm.additionalUI.additionalAddress><i class=\"fa fa-compress\"></i> Sembunyikan</button></div><div class=col-sm-4><button type=button class=\"btn btn-warning btn-block\" ng-disabled=paymentForm.$invalid ng-click=vm.saveNewCustomer()><i class=\"fa fa-save\"></i> Simpan</button></div></div></div></div></div><div class=row uib-collapse=vm.additionalUI.noCrm><div class=col-sm-12><div class=\"alert alert-warning\"><div class=row><div class=col-sm-4><strong>Nama:</strong><br>{{vm.selectedCustomer.nama}}</div><div class=col-sm-4><strong>Email:</strong><br><a href=mailto:{{vm.selectedCustomer.email}}>{{vm.selectedCustomer.email}}</a></div><div class=col-sm-4 ng-if=vm.selectedCustomer.hp><strong>HP:</strong><br>{{vm.selectedCustomer.hp}}</div></div><hr><div class=row ng-if=\"vm.selectedCustomer.kec_id != 0\"><div class=col-sm-8><strong>Alamat:</strong> {{vm.selectedCustomer.alamat}} {{vm.selectedCustomer.kec}} {{vm.selectedCustomer.kab}} {{vm.selectedCustomer.prov}} {{vm.selectedCustomer.kode_pos}}</div><div class=col-sm-4 ng-if=vm.selectedCustomer.kec_id><div class=\"checkbox checkbox-nomargin\"><label><input type=checkbox ng-model=vm.resume.lain_lain.dropship.isDropship ng-change=vm.removeDropship() ng-disabled=vm.status.paid> Dropship</label></div></div></div><!-- <div uib-collapse=\"!vm.resume.lain_lain.dropship.isDropship\">\n                  <hr>\n                  <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                      <p>\n                        <strong>Pengirim Dropship</strong>\n                      </p>\n                    </div>\n                  </div>\n                  <div class=\"row\">\n                    <div class=\"col-sm-8\">\n                      <div class=\"form-group \">\n                        <ui-select ng-model=\"vm.resume.lain_lain.dropship.sender\" autofocus ng-disabled=\"vm.status.paid\">\n                          <ui-select-match placeholder=\"Nama Pengirim...\">\n                            <span>{{$select.selected.nama}}</span>\n                          </ui-select-match>\n                          <ui-select-choices repeat=\"contact in (vm.dropshipList.data ) track by contact.id\" refresh=\"vm.getDropshipContact($select.search)\"\n                            refresh-delay=\"300\" minimum-input-length=\"3\">\n                            <div ng-if=\"!contact.info\">\n                              <span>\n                                <strong>{{contact.nama}}</strong>\n                              </span>\n                              <br />\n                              <small ng-if=\"contact.email\">Email : {{contact.email}}\n                                <br>\n                              </small>\n                              <small ng-if=\"contact.hp\">HP : {{contact.hp}}</small>\n                            </div>\n                            <div ng-if=\"contact.info\">\n                              <strong ng-bind=\"contact.nama\"></strong>\n                              <br>\n                              <span ng-bind=\"contact.info\"></span>\n                            </div>\n\n                          </ui-select-choices>\n                        </ui-select>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"row\" ng-if=\"vm.resume.lain_lain.dropship.sender.id === 0\">\n                    <div class=\"col-sm-6\">\n                      <div class=\"form-group\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.resume.lain_lain.dropship.alamat_sender\" placeholder=\"Nomor HP pengirim dropship...\"\n                          ng-disabled=\"vm.status.paid\" ng-pattern=\"vm.additionalUI.onlyNumbers\" maxlength=\"15\">\n                      </div>\n                    </div>\n                  </div>\n                  <div uib-collapse=\"!vm.resume.lain_lain.dropship.sender || vm.resume.lain_lain.dropship.sender.id <= 0\">\n                    <div class=\"row\">\n                      <div class=\"col-sm-4\">\n                        <strong>Nama:</strong>\n                        <br>{{vm.resume.lain_lain.dropship.sender.nama}}</div>\n                      <div class=\"col-sm-4\">\n                        <strong>Email:</strong>\n                        <br>\n                        <a href=\"mailto:{{vm.resume.lain_lain.dropship.sender.email}}\">{{vm.resume.lain_lain.dropship.sender.email}}</a>\n                      </div>\n                      <div class=\"col-sm-4\" ng-if=\"vm.resume.lain_lain.dropship.sender.hp\">\n                        <strong>HP:</strong>\n                        <br>{{vm.resume.lain_lain.dropship.sender.hp}}</div>\n                    </div>\n                    <hr>\n                    <div class=\"row\" ng-if=\"vm.resume.lain_lain.dropship.sender.kec_id != 0\">\n                      <div class=\"col-sm-8\">\n                        <strong>Alamat:</strong> {{vm.resume.lain_lain.sender.alamat}} {{vm.resume.lain_lain.dropship.sender.kec}}\n                        {{vm.resume.lain_lain.dropship.sender.kab}} {{vm.resume.lain_lain.dropship.sender.prov}} {{vm.resume.lain_lain.dropship.sender.kode_pos}}\n                      </div>\n                    </div>\n                  </div>\n\n                  <hr>\n                  <div class=\"row\" >\n                    <div class=\"col-sm-12\">\n                      <label for=\"\">No Resi Dropship (Pastikan sudah entry ekspedisi)</label>\n                      <input type=\"text\" class=\"form-control\" uib-tooltip=\"Masukkan no resi dropship jika ada\" placeholder=\"No Resi Dropship\" ng-model=\"vm.resume.lain_lain.jobNumber\"\n                        ng-disabled=\"vm.status.paid  || !vm.resume.ekspedisi\"\n                      >\n                    </div>\n                  </div>\n\n                </div> --></div></div></div><div uib-collapse=!vm.resume.lain_lain.dropship.isDropship><!-- <hr> --><div class=\"alert alert-warning\"><div class=row><div class=col-sm-12><p><strong>Pengirim Dropship</strong></p></div></div><div class=row><div class=col-sm-12><div class=form-group><ui-select ng-model=vm.resume.lain_lain.dropship.sender autofocus ng-disabled=vm.status.paid><ui-select-match placeholder=\"Nama Pengirim...\"><span>{{$select.selected.nama}}</span></ui-select-match><ui-select-choices repeat=\"contact in (vm.dropshipList.data ) track by contact.id\" refresh=vm.getDropshipContact($select.search) refresh-delay=300 minimum-input-length=3><div ng-if=!contact.info><span><strong>{{contact.nama}}</strong></span><br><small ng-if=contact.email>Email : {{contact.email}}<br></small><small ng-if=contact.hp>HP : {{contact.hp}}</small></div><div ng-if=contact.info><strong ng-bind=contact.nama></strong><br><span ng-bind=contact.info></span></div></ui-select-choices></ui-select></div></div></div><div class=row ng-if=\"vm.resume.lain_lain.dropship.sender.id === 0\"><div class=col-sm-6><div class=form-group><input type=text class=form-control ng-model=vm.resume.lain_lain.dropship.alamat_sender placeholder=\"Nomor HP pengirim dropship...\" ng-disabled=vm.status.paid ng-pattern=vm.additionalUI.onlyNumbers maxlength=15></div></div></div><div uib-collapse=\"!vm.resume.lain_lain.dropship.sender || vm.resume.lain_lain.dropship.sender.id <= 0\"><div class=row><div class=col-sm-4><strong>Nama:</strong><br>{{vm.resume.lain_lain.dropship.sender.nama}}</div><div class=col-sm-4><strong>Email:</strong><br><a href=mailto:{{vm.resume.lain_lain.dropship.sender.email}}>{{vm.resume.lain_lain.dropship.sender.email}}</a></div><div class=col-sm-4 ng-if=vm.resume.lain_lain.dropship.sender.hp><strong>HP:</strong><br>{{vm.resume.lain_lain.dropship.sender.hp}}</div></div><hr><div class=row ng-if=\"vm.resume.lain_lain.dropship.sender.kec_id != 0\"><div class=col-sm-8><strong>Alamat:</strong> {{vm.resume.lain_lain.sender.alamat}} {{vm.resume.lain_lain.dropship.sender.kec}} {{vm.resume.lain_lain.dropship.sender.kab}} {{vm.resume.lain_lain.dropship.sender.prov}} {{vm.resume.lain_lain.dropship.sender.kode_pos}}</div></div></div><hr><div class=row ng-if=vm.resume.lain_lain.dropship.isDropship><div class=col-sm-6 ng-if=\"vm.selectedCustomer && !vm.selectedCustomer.alamat\"><label for=\"\">Ekspedisi</label><input type=text class=form-control uib-tooltip=\"Masukkan ekspedisi\" placeholder=Ekspedisi ng-model=vm.resume.ekspedisi ng-disabled=vm.status.paid required></div><!-- <div class=\"col-sm-4\">\n                  <label for=\"\">No Resi Dropship</label>\n                  <input type=\"text\" class=\"form-control\" uib-tooltip=\"Masukkan no resi dropship jika ada\" placeholder=\"No Resi Dropship\" ng-model=\"vm.resume.lain_lain.jobNumber\"\n                    ng-disabled=\"vm.status.paid\"\n                  >\n                </div>\n                <div class=\"col-sm-4\">\n                  <label for=\"ekspedisiMP\">Ekspedisi MP/Apps/Mitra</label>\n                  <select name=\"ekspedisiMP\" id=\"ekspedisiMP\" class=\"form-control\" ng-model=\"vm.resume.lain_lain.ekspedisiMP\" ng-disabled=\"vm.status.paid\" required >\n                    <option value=\"SPX\">Shopee Express</option>\n                    <option value=\"IDX\">ID Express</option>\n                    <option value=\"jne\">JNE</option>\n                    <option value=\"j&t\">J&T</option>\n                    <option value=\"other\">Ekspedisi Lain</option>\n                  </select>\n                </div>\n                <div class=\"col-sm-4\" ng-if=\"vm.resume.lain_lain.ekspedisiMP === \'other\'\" >\n                  <label for=\"ekspedisiMPOther\">Nama Ekspedisi</label>\n                  <input type=\"text\" class=\"form-control\" uib-tooltip=\"Masukkan ekspedisi\" placeholder=\"Ekspedisi\"\n                    ng-disabled=\"vm.status.paid\"\n                    required\n                    ng-model=\"vm.resume.lain_lain.ekspedisiMPOther\"\n                  >\n                </div> --></div></div></div><hr class=hr-no-margin><div class=row><div class=col-sm-4><h5 class=h5-no-margin-top><strong>Diskon</strong></h5></div></div><div class=\"form-group row\" ng-repeat=\"diskon in vm.resume.lain_lain.diskon\"><div class=col-sm-2><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=vm.addDiskon() uib-tooltip=\"Tambahkan diskon\" ng-disabled=vm.status.paid><span class=text-success><i class=\"fa fa-plus-circle\"></i></span></button> <button type=button class=\"btn btn-default\" ng-click=vm.removeDiskon($index) uib-tooltip=\"Hapus diskon\" ng-disabled=vm.status.paid><span class=text-danger><i class=\"fa fa-minus-circle\"></i></span></button></div></div><div class=col-sm-5><input type=text class=form-control placeholder=\"Keterangan (optional)\" ng-model=vm.resume.lain_lain.diskon[$index].ket ng-disabled=vm.status.paid></div><div class=\"col-sm-5 pull-right\"><div class=input-group><span class=input-group-btn><select class=\"btn btn-default select-in-group\" uib-tooltip=\"Pilih jenis diskon\" ng-disabled=vm.status.paid ng-model=vm.resume.lain_lain.diskon[$index].jenis ng-change=vm.calculateDiskon()><option value=persen>%</option><option value=nominal>Rp</option></select></span><input type=text class=\"form-control input-number\" autofocus ng-model=vm.resume.lain_lain.diskon[$index].nilai ng-locale-number min=0 max=vm.validasi.diskonMax[vm.resume.lain_lain.diskon[$index].jenis] ng-change=vm.calculateDiskon() required uib-tooltip=\"Masukkan nilai diskon\" ng-disabled=vm.status.paid></div></div></div><div uib-collapse=\"!(vm.selectedCustomer.kab_id && vm.selectedCustomer.kec_id)\"><hr><div class=row><div class=col-sm-12><h5 class=h5-no-margin-top><strong>Biaya Kirim</strong></h5></div></div><div class=\"form-group row\"><div class=col-sm-1><button type=button class=\"btn btn-default\" ng-click=vm.ongkir.toggleShow($index) ng-disabled=vm.status.paid><span class=text-info><i class=\"fa fa-calculator\"></i></span></button></div><div class=col-sm-3><input type=text class=form-control uib-tooltip=\"Masukkan kode ekspedisi\" placeholder=Ekspedisi ng-model=vm.resume.ekspedisi ng-class=\"{\'toUpperCase\': vm.resume.ekspedisi}\" ng-disabled=vm.status.paid ng-required=vm.resume.lain_lain.dropship.isDropship></div><div class=col-sm-5><input type=text class=form-control uib-tooltip=\"Masukkan kode service ekspedisi\" placeholder=Service ng-model=vm.resume.ekspedisi_service ng-disabled=vm.status.paid></div><div class=\"col-sm-3 pull-right\"><input type=text class=\"form-control input-number\" autofocus ng-model=vm.resume.ongkir ng-locale-number min=0 ng-change=vm.calculateBiaya() uib-tooltip=\"Masukkan Biaya kirim\" placeholder=\"Biaya kirim\" ng-disabled=vm.status.paid></div></div><div class=row uib-collapse=!vm.ongkir.show><div class=col-sm-12><div class=\"alert alert-info alert-minimalis\"><div class=row uib-collapse=\"vm.ongkir.costlist || vm.ongkir.error\"><div class=col-sm-12><h5>Biaya kirim</h5><hr class=hr-no-margin><i class=\"fa fa-spinner fa-pulse\" fa-fw></i> Loading biaya kirim ...</div></div><div class=row uib-collapse=!vm.ongkir.error><div class=col-sm-12><h5><span class=text-danger><i class=\"fa fa-exclamation-triangle\" fa-fw></i> </span>Gagal mendapatkan ongkos kirim.</h5><a href ng-click=vm.calculateShipping() class=\"btn btn-primary btn-sm btn-block\"><i class=\"fa fa-refresh\"></i> Coba lagi</a></div></div><div class=row uib-collapse=!vm.ongkir.costlist><div class=col-sm-12><h5>Pilih Pengiriman</h5><div class=row ng-repeat=\"ekspedisi in vm.ongkir.costlist\"><div class=col-sm-12><hr class=hr-no-margin><div class=\"alert alert-danger\" ng-if=\"ekspedisi.code === \'pos\'\">Pengiriman via POS dikenakan asuransi Rp. 500</div><div class=radio ng-repeat=\"item in ekspedisi.costs\"><label><input type=radio name=OptioanOngkir value={{ekspedisi.code}}-{{item.service}} ng-model=vm.ongkir.selectedCost ng-change=\"vm.setShippingCost({ekspedisi:ekspedisi.code, cost: item})\"> {{ekspedisi.code | uppercase}} - {{item.description}} <strong>{{item.cost[0].value | number: 2}}</strong></label></div></div></div></div><div class=row ng-if=vm.ongkir.showMore><div class=col-xs-5><hr></div><div class=col-xs-2 uib-tooltip=\"Tampilkan ekspedisi lain - lain\"><button type=button class=\"btn btn-xs btn-block btn-info\" ng-click=vm.calculateShipping(true)><i class=\"fa fa-fw\" ng-class=\"{\'fa-angle-double-down\': !vm.showBiayaLain, \'fa-angle-double-up\': vm.showBiayaLain}\"></i></button></div><div class=col-xs-5><hr></div></div></div></div></div></div></div><div class=\"alert alert-warning\" ng-if=\"vm.resume.ekspedisi === \'online\' && vm.resume.lain_lain.dropship.isDropship\"><div class=row><div class=col-sm-12><strong>Detail Resi Online</strong></div></div><hr class=hr-no-margin-top><div class=row><div class=col-sm-4><label for=\"\">No Resi Online</label><input type=text class=form-control uib-tooltip=\"Masukkan no resi dropship jika ada\" placeholder=\"No Resi Dropship\" ng-model=vm.resume.lain_lain.jobNumber ng-disabled=vm.status.paid></div><div class=col-sm-4><label for=ekspedisiMP>Ekspedisi MP/Apps/Mitra</label><select name=ekspedisiMP id=ekspedisiMP class=form-control ng-model=vm.resume.lain_lain.ekspedisiMP ng-disabled=vm.status.paid required><option value=SPX>Shopee Express</option><option value=IDX>ID Express</option><option value=jne>JNE</option><option value=j&t>J&T</option><option value=other>Ekspedisi Lain</option></select></div><div class=col-sm-4 ng-if=\"vm.resume.lain_lain.ekspedisiMP === \'other\'\"><label for=ekspedisiMPOther>Nama Ekspedisi</label><input type=text class=form-control uib-tooltip=\"Masukkan ekspedisi\" placeholder=Ekspedisi ng-disabled=vm.status.paid required ng-model=vm.resume.lain_lain.ekspedisiMPOther></div></div></div><div class=row><div class=col-xs-5><hr></div><div class=col-xs-2 uib-tooltip=\"Tampilkan / Sembunyikan Biaya lain - lain\"><button type=button class=\"btn btn-xs btn-block btn-default\" ng-click=\"vm.showBiayaLain = !vm.showBiayaLain\"><i class=\"fa fa-fw\" ng-class=\"{\'fa-angle-double-down\': !vm.showBiayaLain, \'fa-angle-double-up\': vm.showBiayaLain}\"></i></button></div><div class=col-xs-5><hr></div></div><div uib-collapse=!vm.showBiayaLain><div class=row><div class=col-sm-4><h5 class=h5-no-margin-top><strong>Biaya Lain</strong></h5></div></div><div class=\"form-group row\" ng-repeat=\"biaya in vm.resume.lain_lain.biaya\"><div class=col-sm-2><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=vm.addBiaya() uib-tooltip=\"Tambahkan biaya\" ng-disabled=vm.status.paid><span class=text-success><i class=\"fa fa-plus-circle\"></i></span></button> <button type=button class=\"btn btn-default\" ng-click=vm.removeBiaya($index) uib-tooltip=\"Hapus biaya\" ng-disabled=vm.status.paid><span class=text-danger><i class=\"fa fa-minus-circle\"></i></span></button></div></div><div class=col-sm-7 ng-if=\"vm.resume.lain_lain.biaya[$index].jenis === \'lain\'\"><input type=text class=form-control placeholder=Keterangan ng-model=vm.resume.lain_lain.biaya[$index].ket uib-tooltip=\"Masukkan keterangan biaya\" ng-disabled=vm.status.paid></div><div class=\"col-sm-3 pull-right\"><input type=text class=\"form-control input-number\" autofocus ng-model=vm.resume.lain_lain.biaya[$index].nilai ng-locale-number min=0 ng-change=vm.calculateBiaya() required uib-tooltip=\"Masukkan besar biaya\" ng-disabled=vm.status.paid></div></div><hr></div><div class=form-horizontal><!-- <hr class=\"\"> --><div class=row><div class=col-sm-4><h5 class=h5-no-margin-top><strong>Pembayaran</strong></h5></div></div><div class=form-group ng-repeat=\"termin in vm.tmpBayar\"><div class=col-sm-2><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=vm.addTermin() uib-tooltip=\"Tambahkan termin pembayaran\" ng-disabled=vm.status.paid><span class=text-success><i class=\"fa fa-plus-circle\"></i></span></button> <button type=button class=\"btn btn-default\" ng-click=vm.removeTermin($index) ng-disabled=\"((vm.tmpBayar.length === 1) || (vm.status.paid))\" uib-tooltip=\"Hapus pembayaran\"><span class=text-danger><i class=\"fa fa-minus-circle\"></i></span></button></div></div><div class=col-sm-4><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy datepicker-options=\"{maxDate: vm.today}\" ng-model=vm.tglBayar[$index] is-open=\"vm.datePicker[\'tglTermin\' + $index]\" close-text=Close ng-required=true placeholder=\"Tgl Pembayaran\" readonly ng-disabled=vm.status.paid ng-init=\"vm.tglBayar[$index] = termin.tgl\" uib-tooltip=\"Pilih tanggal pembayaran\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglTermin\' + $index)\" ng-disabled=vm.status.paid><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-sm-5 pull-right\"><div class=input-group><span class=input-group-btn><select class=\"btn btn-default select-in-group\" uib-tooltip=\"Pilih metode pembayaran\" ng-model=vm.pembayaran[$index].metode_bayar ng-init=\"vm.pembayaran[$index].metode_bayar = termin.metode_bayar\" ng-disabled=vm.status.paid><option value=Cash>Tunai</option><option value=BCA>BCA</option><option value=BRI>BRI</option><option value=MANDIRI>Mandiri</option><option value=MUAMMALAT>Muammalat</option><option value=DEPOSIT>Deposit</option><option value=\"Lain - Lain\">Lain - Lain</option></select></span><input type=text class=\"form-control input-number\" autofocus ng-model=vm.pembayaran[$index].nominal ng-init=\"vm.pembayaran[$index].nominal = termin.nominal\" ng-locale-number min=0 ng-change=vm.calculateReturn() required uib-tooltip=\"Masukkan nilai pembayaran\" ng-disabled=vm.status.paid></div></div></div></div></div><div class=col-sm-3><div class=\"panel panel-default panel-resume\"><div class=panel-heading>Resume <a href ng-click=\"vm.additionalUI.hideProduct = !vm.additionalUI.hideProduct\">[detail]</a></div><div class=panel-body><div class=row><div class=col-sm-12><label class=control-label style=\"text-align: left\">Harga Produk</label><input type=text class=\"form-control input-number input-flat\" disabled value=\"{{vm.resume.product_price_total | number:2}}\"></div></div><div class=row ng-if=vm.resume.discount_product_total><div class=col-sm-12><label class=control-label style=\"text-align: left\">Diskon Produk</label><input type=text class=\"form-control input-number input-flat\" disabled value=\"{{vm.resume.discount_product_total | number:2}}\"></div></div><div class=row uib-collapse=!vm.resume.discount_transaction_total><div class=col-sm-12><label class=control-label style=\"text-align: left\">Diskon Transaksi</label><input type=text class=\"form-control input-number input-flat\" autofocus ng-model=vm.resume.discount_transaction_total ng-locale-number min=0 ng-change=vm.calculateReturn() required disabled max=vm.resume.total></div></div><div class=row uib-collapse=!vm.resume.total_lain_lain><div class=col-sm-12><label class=control-label>Total Biaya</label><input type=text class=\"form-control input-number input-flat\" autofocus ng-model=vm.resume.total_lain_lain ng-locale-number min=0 ng-change=vm.calculateReturn() required disabled></div></div><div class=row><div class=col-sm-12><label class=control-label>Total Tagihan</label><input type=text class=\"form-control input-number input-flat\" ng-model=vm.resume.total_akhir ng-locale-number required disabled></div></div><div class=row><div class=col-sm-12><label class=control-label>Total Pembayaran</label><input type=text class=\"form-control input-number input-flat\" disabled value=\"{{vm.resume.bayar | number:2}}\"></div></div><div class=row><div class=col-sm-12><label class=control-label>Uang Kembali</label><input type=text class=\"form-control input-number input-flat\" disabled value=\"{{vm.resume.sisa_kembali | number:2}}\"></div></div></div></div></div></div></form></div><div class=modal-footer><div class=row><div class=col-sm-4><button class=\"btn btn-info btn-block\" ng-if=!vm.status.paid type=button ng-click=vm.batal() uib-tooltip=\"Kembali ke halaman penjualan / transaksi pending\"><i class=\"fa fa-chevron-circle-left\"></i> Kembali</button> <button class=\"btn btn-info btn-block\" type=button ng-click=vm.finish() ng-if=vm.status.print autofocus uib-tooltip=\"Selesai proses penjualan\"><i class=\"fa fa-check-circle\"></i> Selesai</button></div><div class=col-sm-4><div class=\"btn-group btn-group-justified\" ng-if=\"vm.status.print && vm.selectedCustomer.alamat && vm.resume.lain_lain.jobNumber\"><div class=btn-group uib-dropdown><button class=\"btn btn-warning btn-block\" type=button uib-dropdown-toggle><i class=\"fa fa-print\"></i> Cetak Alamat / Resi <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.cetakAlamat(1)><a href>Cetak Alamat</a></li><li role=menuitem ng-click=vm.cetakResi()><a href>Cetak Resi</a></li></ul></div></div><button class=\"btn btn-warning btn-block\" type=button ng-click=vm.cetakResi() ng-if=\"vm.status.print && !vm.selectedCustomer.alamat && vm.resume.lain_lain.jobNumber\" uib-tooltip=\"Cetak Resi\"><i class=\"fa fa-print\"></i> Cetak Resi</button> <button class=\"btn btn-warning btn-block\" type=button ng-click=vm.cetakAlamat(1) ng-if=\"vm.status.print && vm.selectedCustomer.alamat && !vm.resume.lain_lain.jobNumber\" uib-tooltip=\"Cetak Alamat Kirim\"><i class=\"fa fa-print\"></i> Cetak Alamat</button> <button class=\"btn btn-success btn-block\" ng-if=!vm.status.paid type=button ng-click=vm.saveTransaction(1) uib-tooltip=\"Simpan data ke transaksi pending\" ng-disabled=paymentForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.saveTransaction(0) ng-if=!vm.status.paid ng-disabled=\"vm.inProcess || paymentForm.$invalid || (vm.resume.bayar < vm.resume.total_akhir)\" uib-tooltip=\"Proses pembayaran\"><i class=\"fa fa-money\"></i> Bayar</button><!-- <button class=\"btn btn-warning btn-block \" type=\"button\" ng-click=\"vm.printValidation()\" ng-if=\"vm.status.paid\" uib-tooltip=\"Cetak struk transaksi\">\n          <i class=\"fa fa-print\"></i> Cetak Struk</button> --><div class=\"btn-group btn-group-justified\" ng-if=vm.status.paid><div class=btn-group uib-dropdown><button class=\"btn btn-warning btn-block\" type=button uib-tooltip=\"Cetak struk transaksi\" uib-dropdown-toggle><i class=\"fa fa-print\"></i> Cetak Struk <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.printValidation(0)><a href>Cetak Tinta</a></li><li role=menuitem ng-click=vm.printValidation(1)><a href>Cetak Thermal</a></li></ul></div></div></div></div></div></div>");
$templateCache.put("app/components/modals/cancelTransaction/cancelTransactionDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Bataklan Transaksi #{{vm.resume.id}}</h4></div><div class=modal-body><h4>Anda yakin hendak membatalkan transaksi berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row class=col-sm-4>ID</th><td>#{{vm.resume.id}}</td></tr><tr><th scope=row class=col-sm-4>Nama Konsumen</th><td>{{vm.resume.pembeli}}</td></tr><tr><th scope=row class=col-sm-4>Nilai</th><td>{{vm.resume.total_akhir | number:2}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Proses Batalkan</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Kembali</button></div></div></div></div>");
$templateCache.put("app/components/modals/cashierNote/cashierNoteDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-file-text-o\"></i> Catatan Kasir Transaksi #{{ vm.transaksi.id }}</h4></div><div class=modal-body><div class=row><div class=col-sm-12><table class=\"table table-condensed\"><tr><th scope=row class=col-sm-3>Waktu</th><td>: <span ng-if=\"vm.transaksi.status !== \'pending\'\">{{ vm.transaksi.tgl | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</span> <span ng-if=\"vm.transaksi.status === \'pending\'\" uib-tooltip=\"Created at: {{\n                  vm.transaksi.created_at | udate: \'dd MMMM yyyy - HH:mm:ss\'\n                }}\">{{ vm.transaksi.tgl | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</span></td></tr><tr><th scope=row>Konsumen</th><td>: {{ vm.transaksi.pembeli }}</td></tr><tr><th scope=row>Status</th><td>: <button class=\"btn btn-xs\" disabled ng-class=\"{\'btn-danger\': vm.transaksi.status ===\'pending\', \'btn-info\': vm.transaksi.status === \'dibayar\', \'btn-success\': \'selesai\'}\">{{ vm.transaksi.status | uppercase }}</button></td></tr></table></div></div><hr class=hr-no-margin><div class=row ng-if=\"vm.cashierNote.length > 0\"><div class=col-xs-12><table class=\"table table-bordered\"><thead><th scope=col class=autofit>Waktu</th><th scope=col>Catatan</th><th scope=col class=autofit>User</th></thead><tbody><tr ng-repeat=\"cnote in vm.cashierNote\"><td class=autofit>{{ cnote.created_at | udate: \'dd MMMM yyyy - HH:mm:ss\' }}</td><td>{{ cnote.note }}</td><td class=autofit>{{ cnote.user }}</td></tr></tbody></table></div></div><div class=row><div class=col-xs-12><div class=input-group><input type=text class=form-control placeholder=\"Tambahkan catatan baru ...\" ng-model=vm.userNote> <span class=input-group-btn><button class=\"btn btn-warning\" title=\"Klik untuk menyimpan catatan\" ng-click=vm.addNote() ng-disabled=!vm.userNote><i class=\"fa fa-plus-circle\"></i> Tambah Catatan</button></span></div></div></div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-info-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/changeStockDialog/changeStockDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-exclamation-triangle\"></i> Data harga beli bernilai nol (0)</h4></div><div class=modal-body><h4>Ada produk dengan harga beli nol (0)</h4><div class=\"alert alert-warning\"><p>Di antara produk yang hendak diubah stoknya, ada yang memilki harga beli senilai nol (0). Kemungkinan besar terjadi kesalahan saat memasukkan data produk.</p><p>Jika Anda yakin ini bukan kesalahan, maka klik Lanjutkan. Jika Anda merasa ini adalah kesalahan, maka klik Perbaiki.</p></div></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-gear\"></i> Lanjutkan</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Perbaiki</button></div></div></div></div>");
$templateCache.put("app/components/modals/deleteInactiveReseller/deleteInactiveResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Reseller Nonaktif</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus<stong class=text-danger>SEMUA</stong>Reseller Nonaktif ?</h4></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/deleteReseller/deleteResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Reseller</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus reseller berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Username</th><td><a href=mailto:{{vm.user.email}}>{{vm.user.email}}</a></td></tr><tr><th scope=row>Nama</th><td>{{vm.user.name}}</td></tr><tr><th scope=row>Status</th><td><strong>{{vm.user.status}}</strong></td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/deleteUser/deleteUserDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Hapus Pengguna</h4></div><div class=modal-body><h4>Anda yakin hendak menghapus pengguna berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Username</th><td>{{vm.user.uname}}</td></tr><tr><th scope=row>Nama</th><td>{{vm.user.detail.name}}</td></tr><tr><th scope=row>Group</th><td>{{vm.user.group | uppercase}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish() ng-disabled=userForm.$invalid><i class=\"fa fa-trash\"></i> Hapus</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/diskonLevelResellerDialog/diskonLevelResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-credit-card fa-fw\"></i> Diskon Level Reseller</h4></div><div class=modal-body><div class=row><div class=col-sm-12><ul><li>Diskon ini hanya otomatis digunakan untuk transaksi via Otoresell.</li><li>Jika nilai diskon lebih besar dari <strong>Diskon SKU</strong> atau <strong>Diskon Kategori</strong>, maka nilai diskon ini tidak digunakan.</li><li>Jika produk memiliki diskon SALE, maka nilai diskon yang dipergunakan adalah yang lebih besar antara diskon ini dan diskon SALE.</li></ul></div></div><hr><form action=\"\" name=diskonReseller id=diskonReseller><div class=form-horizontal><div class=form-group ng-repeat=\"level in vm.listLevel\"><label for=debet class=\"col-sm-8 control-label\" style=text-align:left>Reseller {{level.description}}</label><div class=col-sm-4><div class=input-group><input type=text class=\"form-control text-right\" ng-model=level.discount ng-locale-number min=0 max=100 fraction=0 required autofocus> <span class=input-group-addon>%</span></div></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process() ng-disabled=diskonReseller.$invalid><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editDepositDialog/editDepositDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-usd fa-fw\"></i> Deposit</h4></div><div class=modal-body><form action=\"\" name=depositForm><div class=row><div class=col-sm-12><h4><strong>{{::vm.dataReseller.name}}</strong></h4><p>Email : <a href=\"\">{{::vm.dataReseller.email}}</a> | Level : <strong>{{::vm.dataReseller.level_description}}</strong> | Saldo : {{::vm.dataReseller.balance | number}}</p></div></div><hr><div class=row><div class=col-sm-6><div class=form-group><label for=debet class=control-label>Jenis Perubahan Deposit</label><select name=\"\" class=form-control ng-model=vm.deposit.type ng-change=vm.changeType() required><option value=DEPOSIT>Tambah Deposit</option><option value=DEPOSIT-C>Kurangi Deposit</option><option value=REFUND>Pengembalian Dana</option><option value=FINE>Denda</option><option value=BONUS>Bonus</option></select></div></div><div class=col-sm-6><div class=form-group><label for=debet class=control-label>Nomor Tiket</label><ui-select ng-model=vm.deposit.ticket ng-change=vm.changeTicket() ng-disabled=\"vm.deposit.type !== \'DEPOSIT\'\"><ui-select-match placeholder=\"Pilih tiket jika ada\"><span><strong>#{{$select.selected.id}}</strong> - {{$select.selected.bank}} Total Rp. {{$select.selected.total_transfer | number: 0}}</span></ui-select-match><ui-select-choices repeat=\"ticket in vm.listTicket\"><span><strong>#{{ticket.id}}</strong> - {{ticket.bank}} Total Rp. {{ ticket.total_transfer | number: 0}}</span></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-sm-6><div class=form-group><label for=debet>Debet</label><input type=text class=\"form-control text-right\" placeholder=Debet required maxlength=15 ng-locale-number min=0 ng-model=vm.deposit.debet name=debet id=debet ng-disabled=\"(vm.deposit.type == \'DEPOSIT-C\') || (vm.deposit.type == \'FINE\')\" required></div></div><div class=col-sm-6><div class=form-group><label for=kredit>Kredit</label><input type=text class=\"form-control text-right\" placeholder=Kredit required maxlength=15 ng-locale-number min=0 ng-model=vm.deposit.credit name=kredit id=kredit ng-disabled=\"(vm.deposit.type == \'DEPOSIT\') || (vm.deposit.type ==\'REFUND\' || (vm.deposit.type == \'BONUS\') )\" required></div></div></div><div class=row ng-if=\"(vm.deposit.type === \'DEPOSIT\') || (vm.deposit.type === \'DEPOSIT-C\')\"><div class=col-sm-12><div class=form-group><label for=bank>Bank</label><select name=bank id=bank class=form-control ng-model=vm.deposit.bank ng-required=\"(vm.deposit.type === \'DEPOSIT\') || (vm.deposit.type === \'DEPOSIT-C\')\"><option value=BCA>BCA</option><option value=BRI>BRI</option><option value=MANDIRI>Mandiri</option><option value=MUAMMALAT>Muammalat</option><option value=OTHER>Lain - Lain</option></select></div></div></div><hr><div class=row><div class=col-sm-12><div class=form-group><!-- <label for=\"keterangan\">Keterangan</label> --><textarea placeholder=Keterangan class=form-control maxlength=250 ng-model=vm.deposit.description rows=2 name=keterangan id=keterangan required></textarea></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process() ng-disabled=\"depositForm.$invalid || vm.inProcess\"><i class=\"fa fa-credit-card-alt fa-fw\"></i> Deposit</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editDiskonKategoriOtoreseller/editDiskonKategoriOtoresellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-percent fa-fw\"></i> Diskon Kategori</h4></div><div class=modal-body><div class=row><div class=col-sm-12><h5>{{::vm.item.name}}</h5><h6>ID: <strong>{{::vm.item.id}}</strong></h6></div></div><hr><div class=row><div class=col-sm-12><ul><li>Diskon ini hanya otomatis digunakan untuk transaksi via Otoresell.</li><li>Prioritas diskon ini di bawah <strong>Diskon SKU</strong>.</li><li>Jika 1 produk masuk ke lebih dari 1 kategori, maka akan dipilih diskon kategori yang terbesar.</li><li>Diskon ini adalah batas atas dari <strong>Diskon Level Reseller</strong></li><li>Jika hendak menghilangkan diskon ini, isi dengan nilai 0.</li></ul></div></div><hr><form action=\"\" class=form-horizontal name=discountForm><div class=form-group><label class=\"col-sm-8 control-label\">Diskon Kategori</label><div class=col-sm-4><div class=input-group><input type=text class=\"form-control text-right\" ng-model=vm.item.discount ng-locale-number min=0 max=100 fraction=0 required autofocus> <span class=input-group-addon>%</span></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=discountForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editDiskonOtoreseller/editDiskonOtoresellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-percent fa-fw\"></i> Diskon SKU Otoreseller</h4></div><div class=modal-body><div class=row><div class=col-sm-12><h5>{{::vm.item.nama}}</h5><h6>SKU: <strong>{{::vm.item.sku}}</strong> | Size: <strong>{{::vm.item.size}}</strong></h6></div></div><hr><div class=row><div class=col-sm-12><ul><li>Diskon ini hanya otomatis digunakan untuk transaksi via Otoresell.</li><li>Diskon ini akan diprioritaskan atas <strong>Diskon Kategori</strong>.</li><li>Diskon ini adalah batas atas dari <strong>Diskon Level Reseller</strong></li><li>Jika hendak menghilangkan diskon ini, isi dengan nilai 0.</li></ul></div></div><hr><form action=\"\" class=form-horizontal name=stockForm><div class=form-group><label class=\"col-sm-8 control-label\">Diskon Produk</label><div class=col-sm-4><div class=input-group><input type=text class=\"form-control text-right\" ng-model=vm.item.reseller_discount_persen_sku ng-locale-number min=0 max=100 fraction=0 required autofocus> <span class=input-group-addon>%</span></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=stockForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editStatusResellerDialog/editStatusResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-edit fa-fw\"></i> Status Reseller</h4></div><div class=modal-body><form action=\"\" name=statusForm id=statusForm><div class=row><div class=col-sm-12><h4><strong>{{::vm.dataReseller.name}}</strong></h4><p>Email : <a href=\"\">{{::vm.dataReseller.email}}</a> | Level : <strong>{{::vm.dataReseller.level_description}}</strong> | Saldo : {{::vm.dataReseller.balance | number}}</p></div></div><hr><div class=form-horizontal><div class=form-group><label for=debet class=\"col-sm-4 control-label\" style=text-align:left>Level Reseller</label><div class=col-sm-8><select name=\"\" class=form-control ng-model=vm.dataReseller.level required><option value=1>Silver</option><option value=4>Silver Pro</option><option value=2>Gold</option><option value=3>Platinum</option></select></div></div></div><div class=form-horizontal><div class=form-group><label for=debet class=\"col-sm-4 control-label\" style=text-align:left>Status Reseller</label><div class=col-sm-8><select name=\"\" class=form-control ng-model=vm.dataReseller.status required><option value=REGISTERED>REGISTERED</option><option value=ACTIVE>ACTIVE</option><option value=INACTIVE>INACTIVE</option></select></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process() ng-disabled=statusForm.$invalid><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Ubah</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editStock/editStockDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cubes\"></i> Edit Riwayat Stok</h4></div><div class=modal-body><form action=\"\" class=form-horizontal name=stockForm><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Tanggal</label><div class=col-sm-6><input type=text class=form-control value=\"{{vm.item.tgl | date: \'dd-MM-yyyy\'}}\" required disabled></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">SKU</label><div class=col-sm-6><input type=text class=form-control value={{vm.item.sku}} disabled></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Nama Produk</label><div class=col-sm-6><input type=text class=form-control value={{vm.item.nama}} disabled></div></div><hr><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Harga Beli</label><div class=col-sm-6><input type=text class=\"form-control text-right\" placeholder=\"Masukkan harga beli\" ng-model=vm.item.harga_beli ng-locale-number min=0 required></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Jumlah masuk</label><div class=col-sm-6><input type=number class=\"form-control text-right\" placeholder=\"Masukkan jumlah item masuk\" ng-model=vm.item.jumlah_in min=0 required></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Keterangan</label><div class=col-sm-6><textarea class=form-control placeholder=\"Masukkan keterangan\" ng-model=vm.item.ket></textarea></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=stockForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/editUser/editUserDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-user\"></i> Pengguna</h4></div><div class=modal-body><form action=\"\" class=form-horizontal name=userForm><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Username</label><div class=col-sm-6><input type=text class=form-control placeholder=\"Masukkan username\" ng-model=vm.user.uname required ng-disabled=!vm.user.new></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Nama</label><div class=col-sm-6><input type=text class=form-control placeholder=\"Masukkan nama\" ng-model=vm.user.detail.name required></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Grup</label><div class=col-sm-6><select class=form-control ng-model=vm.user.group required><option value=kasir>Kasir</option><option value=admin>Admin</option></select></div></div><hr><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Password</label><div class=col-sm-6><input type=password class=form-control placeholder=\"Masukkan password\" ng-model=vm.user.password ng-required=vm.user.new></div></div><div class=form-group><label class=\"col-sm-6 control-label\" style=\"text-align: left\">Konfirmasi Password</label><div class=col-sm-6><input type=password class=form-control placeholder=\"Masukkan ulang password\" ng-model=vm.user.confirm_password ng-required=vm.user.new></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=userForm.$invalid><i class=\"fa fa-save\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/entryResi/entryResiDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cubes\"></i> Resi Transaksi #{{vm.transaksi.id}} {{vm.transaksi.pembeli}}</h4></div><div class=modal-body><p>Menyimpan resi transaksi, kemudian mengirimkan notifikasi SMS ke nomor HP yang ditentukan atau ke nomor HP pelanggan yang tersimpan di CRM.</p><hr><form action=\"\" class=form-horizontal name=stockForm><div class=form-group><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Ekspedisi</label><div class=col-sm-4><select name=\"\" class=form-control ng-model=vm.resi.ekspedisi ng-change=vm.changeEkspedisi()><option value=jne>JNE</option><option value=J&T>J&amp;T</option><option value=pos>POS</option><option value=lion>Lion Parcel</option><option value=lain>Lain - Lain</option></select></div></div><div class=form-group uib-collapse=\"vm.resi.ekspedisi !== \'lain\'\"><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Nama Ekspedisi</label><div class=col-sm-8><input type=text class=form-control placeholder=\"Masukkan Nama Ekspedisi...\" ng-model=vm.resi.nama_ekspedisi ng-required=\"vm.resi.ekspedisi === \'lain\'\" ng-disabled=!vm.baru></div></div><div class=form-group><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Nomor Resi</label><div class=col-sm-8><input type=text class=form-control placeholder=\"Masukkan Nomor Resi\" ng-model=vm.resi.no_resi required ng-disabled=!vm.baru></div></div><div class=form-group ng-if=\"vm.transaksi.dropship > 0\"><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Kirim SMS ke</label><div class=col-sm-8><select name=\"\" class=form-control ng-model=vm.resi.target ng-change=vm.changeSMSTarget()><option value=s ng-if=\"vm.transaksi.dropship === 1\">Nomor Pengirim (Dropshipper)</option><option value=s ng-if=\"vm.transaksi.dropship === 2\">Nomor Pengirim (Reseller)</option><option value=o>Nomor Lain</option></select></div></div><div class=form-group ng-if=\"(vm.transaksi.dropship < 1) || (vm.resi.target === \'o\')\"><!--\n                Untuk transaksi dropship dan oresell, nomor HP wajib diisi.\n                Untuk trx dropship, agar CS bisa bebas mau isi apa.\n                Untuk trx oresell, data no HP tidak ada di CRM. Adanya di kontak Oresell.\n\n                Pada awalnya, kedua kasus itu tidak ada nomor default.\n\n                Sekarang: tambahkan nomor default untuk keduanya. Transaksi dropship kasih no dropshipper\n                Trx oresell kasih nomor reseller.\n\n                Intinya, kalau mau ubah, harus oprek engine CRM yang memang dah out of date.\n\n                Jadi, biar aman, untuk resi trx dropship / oresell, pastikan no HP terisi.\n              --><label class=\"col-sm-4 control-label\" style=\"text-align: left\">Nomor HP <span ng-if=!vm.transaksi.lain_lain.dropship.isDropship>(optional)</span></label><div class=col-sm-8><input type=text class=form-control placeholder=\"Nomor HP\" ng-model=vm.resi.nohp uib-tooltip=\"Hanya isi jika hendak mengirim SMS ke nomor yang beda dg data pelanggan di CRM\" ng-required=vm.transaksi.lain_lain.dropship.isDropship ng-pattern=vm.numberPattern></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.finish() ng-disabled=stockForm.$invalid><i class=\"fa fa-gear\"></i> Proses</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/importCSVDialog/ImportCSVDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cloud-download\"></i> Upload CSV Produk</h4></div><div class=modal-body><form action=\"\" class=form><div class=row><div class=\"col-sm-12 form-group\"><label for=\"\">Pilih file csv yang akan diupload</label><input type=file class=\"form-control input-file\" file-model=vm.inputFile></div></div><div class=row style=\"margin-top: 1em\"><div class=\"col-sm-12 form-group\"><label for=\"\">Pilih fields yang akan disimpan</label><ui-select multiple ng-model=vm.fields.result><ui-select-match placeholder=\"Pilih fields yang disimpan\"><span>{{$item.nama}}</span></ui-select-match><ui-select-choices repeat=\"item in (vm.fields.source | filter: $select.search) track by item.id\"><span><strong>{{item.nama}}</strong></span></ui-select-choices></ui-select></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-6 col-sm-offset-2 pull-right\"><button class=\"btn btn-warning btn-block\" type=button ng-click=vm.importTheFile() ng-disabled=vm.inProcess><i class=\"fa fa-cloud-download\"></i> Proses Upload CSV</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/listOtoresellDepositDialog/listOtoresellDepositDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cog fa-fw\"></i> Mutasi Deposit {{vm.reseller.email}}</h4></div><div class=modal-body><table class=\"table table-striped table-bordered\"><tr><th scope=col>No</th><th scope=col>Tgl</th><th scope=col>Tipe</th><th scope=col>Keterangan</th><th scope=col>Debet</th><th scope=col>Kredit</th><th scope=col>Saldo</th></tr><tr ng-repeat=\"data in vm.mutasi.deposit track by data.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td>{{data.trx_date | udate:\'dd/MM/yyyy - HH:mm:ss\'}}</td><td>{{data.type}}</td><td>{{data.description}}</td><td class=text-right>{{data.debet | number}}</td><td class=text-right>{{data.credit | number}}</td><td class=text-right>{{data.balance | number}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-6 pull-right\"><div class=\"btn-group btn-group-justified\" role=group aria-label=...><div class=btn-group><button type=button class=\"btn btn-default\" style=\"border-right: none\" ng-click=\"vm.getData(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page === 1\"><i class=\"fa fa-arrow-circle-left\"></i> Sebelumnya</button></div><div class=btn-group><button type=button class=\"btn btn-default\" disabled style=\"border-right: none\">Halaman: {{vm.filter.page}}</button></div><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"vm.getData(vm.filter.page + 1)\" ng-disabled=\"vm.filter.page === vm.maxPage\">Selanjutnya <i class=\"fa fa-arrow-circle-right\"></i></button></div></div></div><div class=col-sm-3><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Tutup</button></div></div></div></div>");
$templateCache.put("app/components/modals/listTransaksi/listTransaksi.html","<div><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i></button><h4 ng-if=!vm.data.filter.dropship><i class=\"fa fa-trash\"></i> Transaksi {{vm.data.customer.pembeli}}</h4><h4 ng-if=\"(vm.data.filter.dropship === 2)\"><i class=\"fa fa-trash\"></i> Transaksi Reseller {{vm.data.customer.reseller_id}}</h4><h4 ng-if=\"(vm.data.filter.dropship === 1)\"><i class=\"fa fa-trash\"></i> Transaksi Dropshipper #{{vm.data.customer.reseller_id}} - {{vm.data.customer.reseller_id > 0 ? vm.data.customer.lain_lain.dropship.sender.nama : \'DROPSHIPPER NON-CRM\'}}</h4></div><div class=modal-body><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Waktu</th><th scope=col class=\"text-right autofit\">Order Id</th><th scope=col ng-if=\"(vm.data.dropship !== 0) || (vm.data.customer.pembeli ===\'TRANSAKSI NON-CRM\')\">Pembeli</th><th scope=col class=text-right>Nilai Transaksi</th><!--<th scope=\"col\" >Kasir</th>--><!--<th scope=\"col\" ></th>--></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.tgl | udate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><td class=text-right>#{{item.id}}</td><td class=text-left ng-if=\"(vm.data.dropship !== 0) || (vm.data.customer.pembeli ===\'TRANSAKSI NON-CRM\')\">{{item.pembeli}}</td><td class=text-right>{{item.total_akhir | number:2}}</td></tr></tbody></table></div></div><hr><div class=row ng-if=\"vm.maxPage > 1\"><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.getTransaction(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><button class=\"btn btn-block btn-default\" disabled>Hal: {{vm.filter.page}}</button></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.getTransaction(vm.filter.page + 1)\" ng-disabled=\"(vm.maxPage === vm.filter.page)\">Selanjutnya</button></div></div></div><!-- <div class=\"modal-footer\">\n    <div class=\"row\">\n      <div class=\"col-sm-3 pull-right\">\n        <button class=\"btn btn-primary btn-block \" type=\"button\" ng-click=\"vm.batal()\">\n          <i class=\"fa fa-check-circle\"></i> Tutup</button>\n      </div>\n    </div>\n  </div> --></div>");
$templateCache.put("app/components/modals/pilihAlamatCetak/pilihAlamatCetakDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-edit fa-fw\"></i> Pilih Alamat yang akan Dicetak</h4></div><div class=modal-body><form action=\"\" name=addressForm id=addressForm><fieldset ng-if=\"vm.data.dropship >= 1\"><h4>Alamat Pengirim</h4><div class=radio><label><input type=radio name=optionsRadios id=optionsRadios1 value=reseller ng-model=vm.address.selected> Alamat Reseller</label></div><div class=radio><label><input type=radio name=optionsRadios id=optionsRadios2 value=ethica ng-model=vm.address.selected> Alamat Zafrada</label></div><div class=radio><label><input type=radio name=optionsRadios id=optionsRadios3 value=custom ng-model=vm.address.selected> Alamat Custom</label></div><div class=row uib-collapse=\"vm.address.selected !== \'custom\'\"><div class=col-sm-12><hr><div class=form-group><input type=text class=form-control id=name placeholder=\"Nama Pengirim\" autofocus ng-model=vm.address.sender.nama ng-required=\"vm.address.selected === \'custom\'\" minlength=3 maxlength=50></div><div class=form-group><input type=text class=form-control id=phone placeholder=\"Nomor HP\" ng-model=vm.address.sender.hp ng-required=\"vm.address.selected === \'custom\'\" ng-pattern=/^\\d+$/ minlength=10 maxlength=13></div></div></div><hr></fieldset><fieldset><h4>Alamat Penerima</h4><div class=radio><label><input type=radio name=customerAddressOption id=customerAddressOption3 value=transaction ng-model=vm.customeraddress.selected> Alamat di Transaksi</label></div><div class=radio><label><input type=radio name=customerAddressOption id=customerAddressOption1 value=contact ng-model=vm.customeraddress.selected> Alamat Kontak</label></div><div class=radio><label><input type=radio name=customerAddressOption id=customerAddressOption2 value=custom ng-model=vm.customeraddress.selected> Alamat Custom</label></div><div class=row uib-collapse=\"vm.customeraddress.selected !== \'custom\'\"><div class=col-sm-12><hr><div class=form-group><input type=text class=form-control id=customername placeholder=\"Nama Penerima\" autofocus ng-model=vm.customeraddress.receiver.nama ng-required=\"vm.customeraddress.selected === \'custom\'\" minlength=3 maxlength=50></div><div class=form-group><input type=text class=form-control id=customerphone placeholder=\"Alamat Lengkap Penerima\" ng-model=vm.customeraddress.receiver.address ng-required=\"vm.customeraddress.selected === \'custom\'\" minlength=3 maxlength=250></div><div class=form-group><input type=text class=form-control id=customerphone placeholder=\"No HP\" ng-model=vm.customeraddress.receiver.hp ng-required=\"vm.customeraddress.selected === \'custom\'\" ng-pattern=/^\\d+$/ minlength=10 maxlength=13></div></div></div></fieldset></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-warning btn-block\" ng-click=vm.process() ng-disabled=addressForm.$invalid><i class=\"fa fa-print fa-fw\"></i> Proses Cetak</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/processOresellTransaction/ProcessOresellTransactionDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-credit-card\"></i> Prosess Transaksi #{{vm.resume.id}}</h4></div><div class=modal-body><h4>Anda yakin hendak memproses transaksi berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row class=col-sm-4>ID</th><td>#{{vm.resume.id}}</td></tr><tr><th scope=row class=col-sm-4>Nama Konsumen</th><td>{{vm.resume.pembeli}}</td></tr><tr><th scope=row class=col-sm-4>Nilai</th><td>{{vm.resume.total_akhir | number:2}}</td></tr><tr ng-if=vm.resume.lain_lain.customerNote><th scope=row class=col-sm-4>Catatan Konsumen</th><td>{{vm.resume.lain_lain.customerNote}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 col-sm-offset-2 pull-right\"><button class=\"btn btn-danger btn-block\" type=button ng-click=vm.finish()><i class=\"fa fa-credit-card\"></i> Proses Transaksi</button></div><div class=col-sm-4><button class=\"btn btn-success btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-times-circle\"></i> Kembali</button></div></div></div></div>");
$templateCache.put("app/components/modals/resetPasswordResellerDialog/resetPasswordResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-lock fa-fw\"></i> Reset Password Reseller</h4></div><div class=modal-body><h4>Anda yakin hendak reset password reseller berikut ?</h4><table class=\"table table-striped\"><tr><th scope=row>Email</th><td>{{vm.reseller.email}}</td></tr><tr><th scope=row>Nama</th><td>{{vm.reseller.name}}</td></tr><tr><th scope=row>Level</th><td>{{vm.reseller.level_description}}</td></tr></table></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process()><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Reset</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/settingOtoresellDialog/settingOtoresellDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-cog fa-fw\"></i> Setting Otoresell</h4></div><div class=modal-body><hr><form action=\"\" name=settingOtoresell id=settingOtoresell><div class=form-horizontal><div class=form-group><label for=debet class=\"col-sm-8 control-label\" style=text-align:left>Denda Pembatalan Item Transaksi</label><div class=col-sm-4><input type=text class=\"form-control text-right\" ng-model=vm.setting.fine ng-locale-number fraction=0 min=0 required></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process() ng-disabled=settingOtoresell.$invalid><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Simpan</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/components/modals/stockHabis/stockHabis.html","<div><div class=modal-header><h4><i class=\"fa fa-trash\"></i> Stok Habis atau Tidak Cukup</h4></div><div class=modal-body><div class=\"alert alert-danger\"><p>Anda hendak menambah pesanan untuk item:</p><hr><ul><li>SKU: {{vm.item.sku}}</li><li>Nama: {{vm.item.nama}}</li><li>Stok tersedia: {{vm.item.jumlah}}</li></ul><hr><p>Saat ini, stok produk tersebut sedang kosong atau tidak mencukupi jumlah pesanan yang Anda inginkan</p></div></div><div class=modal-footer><div class=row><div class=col-sm-12><button class=\"btn btn-primary btn-block\" type=button ng-click=vm.batal()><i class=\"fa fa-check-circle\"></i> Selesai</button></div></div></div></div>");
$templateCache.put("app/components/modals/uplineResellerDialog/uplineResellerDialog.html","<div><div class=modal-header><h4><i class=\"fa fa-edit fa-fw\"></i> Upline Reseller</h4></div><div class=modal-body><form action=\"\" name=statusForm id=statusForm><div class=row><div class=col-sm-12><h4><strong>{{::vm.dataReseller.name}}</strong></h4><p>Email : <a href=\"\">{{::vm.dataReseller.email}}</a> | Level : <strong>{{::vm.dataReseller.level_description}}</strong> | Saldo : {{::vm.dataReseller.balance | number}}</p></div></div><hr><div class=form-horizontal><div class=form-group><label for=debet class=\"col-sm-4 control-label\" style=\"text-align: left\">Upline</label><div class=col-sm-8><ui-select ng-model=vm.selectedUpline><ui-select-match placeholder=Upline><span><strong>{{ $select.selected.email }}</strong></span></ui-select-match><ui-select-choices repeat=\"item in (vm.resellerList | filter: $select.search) track by item.id\" refresh=vm.getReseller($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{ item.name }}</strong></span><br><small>{{ item.email }}</small></ui-select-choices></ui-select></div></div><div class=form-group ng-if=vm.selectedUpline><div class=\"col-sm-8 pull-right\"><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.clear()><span class=\"fa fa-remove\"></span> Hapus upline</button></div></div></div></form></div><div class=modal-footer><div class=row><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-primary btn-block\" ng-click=vm.process() ng-disabled=statusForm.$invalid><i class=\"fa fa-arrow-circle-o-right fa-fw\"></i> Ubah</button></div><div class=col-sm-4><button class=\"btn btn-danger btn-block\" ng-click=vm.batal()><i class=\"fa fa-times-circle fa-fw\"></i> Batal</button></div></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.bukalapak/main.administrasi.bukalapak.html","<div class=row><div class=col-sm-6><label for=\"\">Upload file stok dari Bukalapak</label><input type=file class=\"form-control input-file\" id=uploadedFile></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.category/main.administrasi.category.html","<div class=row><form><div class=\"col-sm-1 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit uib-tooltip=\"Refresh filter\" tooltip-append-to-body=true><i class=\"fa fa-search fa-fw\"></i></button></div></div></div><div class=\"form-group col-sm-11\"><input type=text class=form-control placeholder=\"Nama Kategori\" ng-model=vm.filter.name></div></form></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>ID</th><th scope=col>Nama</th><th scope=col class=\"text-right autofit\">Diskon (%)</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"category in vm.categoryList track by category.id\"><td class=\"text-right autofit\">{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td class=\"autofit text-right\">{{category.id}}</td><td ng-bind-html=category.name></td><td class=text-right>{{category.discount | number: 0}}</td><td class=autofit><button class=\"btn btn-xs btn-default\" ng-click=vm.setDiscount(category) uib-tooltip=\"Set diskon kategori\" tooltip-placement=left><span class=text-danger><i class=\"fa fa-percent fa-fw\"></i></span></button></td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.facebook/main.administrasi.facebook.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tgl_min\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.tgl_max readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tgl_min\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tgl_max\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.tgl_min max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tgl_max\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-sm-3><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-warning\" ng-click=vm.downloadTransaction() type=submit ng-disabled=\"!(vm.filter.tgl_min && vm.filter.tgl_max)\"><i class=\"fa fa-cloud-download\"></i> Download Offline Event</button></div></div></div></div></form></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.jubelio/main.administrasi.jubelio.html","<div class=row><div class=col-sm-8><label for=\"\">Sinkronisasi Stok Produk di Jubelio</label><p>POS akan otomatis mengedit file stok dari Jubelio menyesuaikan dengan stok terbaru di POS.</p><form action=\"\"><div class=form-group><label for=skuField>Nama Field SKU</label><input required type=text maxlength=50 class=form-control id=skuField name=skuField ng-model=vm.skuField></div><div class=form-group><label for=stockField>Nama Field Stok</label><input required type=text maxlength=50 class=form-control id=stockField name=stockField ng-model=vm.stockField></div><div class=form-group><label for=priceField>Nama Field Harga</label><input required type=text maxlength=50 class=form-control id=priceField name=priceField ng-model=vm.priceField></div><div class=form-group><label for=uploadedFile>File</label><input type=file class=\"form-control input-file\" id=uploadedFile></div></form></div><!-- <div class=\"col-sm-4\">\n    <label for=\"\">&nbsp;</label>\n    <button class=\"btn btn-warning btn-block \" type=\"button\" ng-click=\"vm.importTheFile()\" ng-disabled=\"vm.inProcess\">\n      <i class=\"fa fa-cloud-download\"></i> Proses Upload</button>\n  </div> --></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.kontak-oresell/main.administrasi.kontak-oresell.html","<div class=row><div class=col-xs-12><form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit uib-tooltip=\"Refresh filter\" tooltip-append-to-body=true style=\"border-right: 0\"><i class=\"fa fa-search fa-fw\"></i></button></div><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.downloadContact() type=submit uib-tooltip=\"Download data kontak\" tooltip-append-to-body=true><i class=\"fa fa-cloud-download fa-fw\"></i></button></div></div></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"Nama / Email\" ng-model=vm.filter.search></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"No HP\" ng-model=vm.filter.by_hp></div><div class=\"form-group col-sm-3\"><input type=email class=form-control placeholder=Reseller ng-model=vm.filter.reseller></div></div></form></div></div><hr><div class=row ng-if=\"vm.resellerContactList.length === 0\"><div class=col-sm-12><div class=\"alert alert-info\"><h4 class=text-center>Belum ada data reseller yang cocok dengan filter.</h4></div></div></div><div class=row ng-if=\"vm.resellerContactList.length > 0\"><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>Nama</th><th scope=col>Email</th><th scope=col>No HP</th><th scope=col>Alamat</th><th scope=col>Reseller</th></tr></thead><tbody><tr ng-repeat=\"reseller in vm.resellerContactList track by reseller.id\"><td class=\"text-right autofit\">{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td><a href ng-click=vm.userModal(user)>{{reseller.nama}}</a></td><td>{{reseller.email}}</td><td>{{ reseller.hp }}</td><td>{{ reseller.alamat }} {{reseller.kec}} {{reseller.kab}} {{reseller.prov}}</td><td>{{ reseller.owner }}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.lazada/main.administrasi.lazada.html","<div class=row><div class=col-sm-8><label for=\"\">Sinkronisasi Stok Produk di Lazada</label><p>POS akan otomatis mengedit file stok dari Lazada menyesuaikan dengan stok terbaru di POS.</p><input type=file class=\"form-control input-file\" id=uploadedFile></div><!-- <div class=\"col-sm-4\">\n    <label for=\"\">&nbsp;</label>\n    <button class=\"btn btn-warning btn-block \" type=\"button\" ng-click=\"vm.importTheFile()\" ng-disabled=\"vm.inProcess\">\n      <i class=\"fa fa-cloud-download\"></i> Proses Upload</button>\n  </div> --></div><hr><div class=row><div class=col-sm-8><p><strong>Sinkronisasi data produk dari Lazada</strong></p><p>Jalankan ketika ada penambahan produk baru di Lazada.<ol><li>Pastikan produk baru tesebut sudah dimasukkan di POS.</li><li>Sinkronisasi hanya untuk produk yang dimaasukkan setelah tanggal yang dipilih.</li><li>Stok produk hanya akan disinkronkan ketika terjadi trans<span ng-if=vm.isConnected>Ulang Dengan</span>aksi.</li></ol></p></div></div><div class=row><div class=\"form-group col-sm-3\"><label for=tglAwal class=reqfield>Tgl Awal</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.startDate is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Mulai\" datepicker-options=\"{maxDate: vm.today}\" readonly name=tglAwal id=tglAwal> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><label for=tglAkhir class=reqfield>Tgl Akhir</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.endDate is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{maxDate: vm.today}\" readonly name=tglAkhir id=tglAkhir> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\" ng-if=!vm.doSync><label for=\"\" class=reqfield>&nbsp;</label><div class=input-group><button class=\"btn btn-primary\" ng-click=vm.syncProduct() ng-disabled=vm.inProcess><i class=\"fa fa-refresh\" ng-class=\"vm.doSync ? \'fa-spin\': \'\'\"></i> Proses Sinkronisasi</button></div></div><div class=col-sm-8 ng-if=vm.doSync><div class=\"alert alert-warning\"><i class=\"fa fa-refresh fa-spin\"></i> Proses sinkronisasi seadang berjalan di server. Silahkan lanjutkan aktivitas lain.</div></div></div><hr><div class=row><div class=col-sm-8><p><strong>Koneksi Lazada Store</strong></p><button class=\"btn btn-default\" ng-if=vm.isConnected><span class=text-success><i class=\"fa fa-circle\"></i> <strong>Terhubung</strong></span></button> <button class=\"btn btn-default\" ng-if=!vm.isConnected><span class=text-danger><i class=\"fa fa-circle\"></i> <strong>Terputus</strong></span></button> <button class=\"btn btn-warning\" ng-click=vm.generateURL() ng-disabled=vm.inProcess><i class=\"fa fa-link\"></i> Hubungkan <span ng-if=vm.isConnected>Ulang Dengan</span> Lazada Store</button></div></div><div class=row style=\"margin-top: 1em\" ng-if=vm.connectURL><div class=col-sm-12><div class=\"alert alert-info\" style=\"overflow: hidden\"><p><strong>Buka URL berikut untuk menghubungkan Lazada Store dg POS.</strong></p><p><a href={{vm.connectURL}} target=_blank>{{vm.connectURL}}</a></p></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.log-deposit-oresell/main.administrasi.log-deposit-oresell.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default\" ng-disabled=vm.inProcess ng-click=vm.downloadLog() type=button><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Awal</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.startDate is-open=\"vm.datePicker[\'startDate\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.endDate readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'startDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Akhir</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.endDate is-open=\"vm.datePicker[\'endDate\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.startDate max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'endDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-sm-2><input type=email class=form-control placeholder=\"Email reseller\" ng-model=vm.filter.user></div><div class=\"form-group col-sm-2\"><select name=\"\" ng-model=vm.filter.bank class=form-control><option value=\"\">Semua Bank</option><option value=BCA>BCA</option><option value=BRI>BRI</option><option value=MANDIRI>Mandiri</option><option value=MUAMMALAT>Muammalat</option></select></div></div></form></div></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.depositList.data.length === 0\"><div class=col-sm-12><div class=\"alert alert-custom text-center\"><p><strong>Data mutasi deposit tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.depositList.data.length > 0\"><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Tgl</th><th scope=col>Reseller</th><th scope=col>Bank</th><th scope=col class=text-right>Debet</th><th scope=col class=text-right>Kredit</th><th scope=col>Keterangan</th><th scope=col>User</th></tr></thead><tbody><tr ng-repeat=\"item in vm.depositList.data track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td>{{item.trx_date | udate:\'dd-MM-yyyy - HH:mm:ss\' }}</td><td><a href=#>{{item.owner}}</a></td><td><strong>{{item.bank}}</strong></td><td class=text-right>{{item.debet | number: 2}}</td><td class=text-right>{{item.credit | number: 2}}</td><td>{{item.description}}</td><td>{{item.updated_by}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.log-level-oresell/main.administrasi.log-level-oresell.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"col-sm-1 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Awal</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.startDate is-open=\"vm.datePicker[\'startDate\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.endDate readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'startDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Akhir</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.endDate is-open=\"vm.datePicker[\'endDate\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.startDate max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'endDate\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-sm-5><input type=email class=form-control placeholder=\"ID (email) reseller\" ng-model=vm.filter.user></div></div></form></div></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.logLevelList.data.length === 0\"><div class=col-sm-12><div class=\"alert alert-custom text-center\"><p><strong>Data log level tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.logLevelList.data.length > 0\"><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Tgl</th><th scope=col>Reseller</th><th scope=col>Level Sebelumnya</th><th scope=col>Level Sekarang</th><th scope=col>User</th></tr></thead><tbody><tr ng-repeat=\"item in vm.logLevelList.data track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td>{{item.created_at | udate:\'dd-MM-yyyy - HH:mm:ss\' }}</td><td><a href=#>{{item.user}}</a></td><td><strong>{{item.previous_level_name}}</strong></td><td><strong>{{item.current_level_name}}</strong></td><td>{{item.created_by}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.mutasi-oresell/main.administrasi.mutasi-oresell.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default\" ng-disabled=vm.inProcess ng-click=vm.downloadMutasi() type=button><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Awal</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAwal is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" min-date=vm.minDate max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!-- <label for=\"\" class=\"reqfield\">Tgl Akhir</label> --><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tglAkhir is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal max-date=vm.today readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=col-sm-4><input type=email class=form-control placeholder=\"ID (email) reseller\" ng-model=vm.filter.id></div></div><div class=row><div class=\"form-group col-sm-3\"><select name=\"\" ng-model=vm.filter.type class=form-control><option value=\"\">Semua Jenis</option><option value=DEPOSIT>Deposit</option><option value=PAYMENT>Pembelian</option><option value=BONUS>Bonus</option><option value=REFUND>Refund</option><option value=FINE>Denda</option></select></div><div class=\"form-group col-sm-3\"><select name=\"\" ng-model=vm.filter.flow class=form-control><option value=\"\">Semua Jenis</option><option value=DEBET>Debet</option><option value=CREDIT>Kredit</option></select></div><div class=\"form-group col-sm-3\"><input type=number class=form-control placeholder=Debet ng-model=vm.filter.debet></div><div class=\"form-group col-sm-3\"><input type=number class=form-control placeholder=Kredit ng-model=vm.filter.credit></div></div><div class=row><div class=\"form-group col-sm-8\"><input type=text class=form-control placeholder=Deskripsi ng-model=vm.filter.description></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=User ng-model=vm.filter.user></div></div></form></div></div><hr class=hr-no-margin-top><div class=row ng-if=\"vm.depositList.deposit.length === 0\"><div class=col-sm-12><div class=\"alert alert-custom text-center\"><p><strong>Data mutasi deposit tidak ada / tidak ditemukan</strong></p></div></div></div><div class=row ng-if=\"vm.depositList.deposit.length > 0\"><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Tgl</th><th scope=col>Reseller</th><th scope=col>Jenis</th><th scope=col>Deskripsi</th><th scope=col class=text-right>Debet</th><th scope=col class=text-right>Kredit</th><th scope=col class=text-right>Saldo</th><th scope=col>User</th></tr></thead><tbody><tr ng-repeat=\"item in vm.depositList.deposit track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td><strong>{{item.trx_date | udate:\'dd-MM-yyyy\' }}</strong><br>{{item.trx_date | udate:\'HH:mm:ss\' }}</td><td>{{item.owner}}</td><td><a href uib-tooltip=\"By: {{item.updated_by}}\">{{item.type}}</a></td><td>{{item.description}} <span ng-if=item.trxId><br><a href=\"\" ng-click=vm.detailTrx(item.trxId)>[Cek trx]</a></span></td><td class=text-right>{{item.debet | number: 2}}</td><td class=text-right>{{item.credit | number: 2}}</td><td class=text-right>{{item.balance | number: 2}}</td><td>{{item.updated_by}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.oresell/main.administrasi.oresell.html","<div class=row><div class=col-xs-12><form><div class=row><div class=\"col-sm-2 pull-right\"><div class=btn-group uib-dropdown style=\"width: 100%\"><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit uib-tooltip=\"Refresh filter\" tooltip-append-to-body=true style=\"border-right: 0; width: 40%\"><i class=\"fa fa-search fa-fw\"></i></button> <button class=\"btn btn-default\" ng-click=vm.downloadReseller() type=submit uib-tooltip=\"Download data reseller\" tooltip-append-to-body=true style=\"border-right: 0; width: 40%\"><i class=\"fa fa-cloud-download fa-fw\"></i></button> <button type=button class=\"btn btn-default\" uib-dropdown-toggle style=\"width: 20%\" uib-tooltip=\"Setting Otoresell\" tooltip-placement=left><span class=caret></span> <span class=sr-only>Split button!</span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=split-button style=\"right: 0 !important; left: inherit !important\"><li role=menuitem><a href=# ng-click=vm.settingOresell()><i class=\"fa fa-credit-card fa-fw\"></i> Setting Otoresell</a></li><li role=menuitem><a href=# ng-click=vm.setDiscountLevelReseller()><i class=\"fa fa-cog fa-fw\"></i> Setting Diskon Level</a></li><li role=menuitem><a href=# ng-click=vm.toggleGCLID()><i class=\"fa fa-toggle-on fa-fw\"></i> Toggle GCLID</a></li><li class=divider></li><li role=menuitem><a href=# ng-click=vm.deleteInactiveReseller() uib-tooltip=\"Hapus SEMUA Reseller dg status REGISTERED dan saldo kosong\" tooltip-append-to-body=true tooltip-placement=left><span class=text-danger><i class=\"fa fa-trash fa-fw\"></i> </span>Hapus Reseller Nonaktif</a></li></ul></div></div><div class=\"form-group col-sm-3\"><input type=email class=form-control placeholder=Email ng-model=vm.filter.email></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=Nama ng-model=vm.filter.name></div><div class=\"form-group col-sm-2\"><select name=\"\" class=form-control ng-model=vm.filter.level><option value=\"\">Level</option><option value=1>Silver</option><option value=4>Silver Pro</option><option value=2>Gold</option><option value=3>Platinum</option></select></div><div class=\"form-group col-sm-2\"><select name=\"\" class=form-control ng-model=vm.filter.status><option value=\"\">Status</option><option value=REGISTERED>REGISTERED</option><option value=ACTIVE>ACTIVE</option><option value=INACTIVE>INACTIVE</option></select></div></div></form></div></div><hr><div class=row ng-if=\"vm.resellerList.length === 0\"><div class=col-sm-12><div class=\"alert alert-info\"><h4 class=text-center>Belum ada data reseller yang cocok dengan filter.</h4></div></div></div><div class=row ng-if=\"vm.resellerList.length > 0\"><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>Username</th><th scope=col>Nama</th><th scope=col>Level</th><th scope=col>Deposit</th><th scope=col>Status</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"reseller in vm.resellerList track by reseller.id\" ng-class=\"{\'warning\' : reseller.gclid}\"><td class=\"text-right autofit\">{{($index + 1) + ((vm.filter.page - 1) * 10)}}</td><td class=col-sm-3><span ng-if=!reseller.gclid><a href ng-click=vm.showDetail(reseller)>{{reseller.email}}</a></span> <span ng-if=reseller.gclid><a href ng-click=vm.userModal(user) title=\"GCLID: {{reseller.gclid}}\">{{reseller.email}}</a></span></td><td class=col-sm-4>{{reseller.name}}</td><td>{{ reseller.level_description }}</td><td class=text-right>{{ reseller.balance | number }}</td><td>{{ reseller.status }}</td><td class=autofit><button class=\"btn btn-xs btn-default\" ng-click=vm.resetPasswordReseller(reseller) uib-tooltip=\"Reset Password\" tooltip-placement=left><span class=text-danger><i class=\"fa fa-lock fa-fw\"></i></span></button> <button class=\"btn btn-xs btn-default\" ng-click=vm.statusReseller(reseller) uib-tooltip=\"Ubah Status\" tooltip-placement=left><span class=text-warning><i class=\"fa fa-edit fa-fw\"></i></span></button> <button class=\"btn btn-xs btn-default\" ng-click=vm.deposit(reseller) uib-tooltip=\"Ubah Deposit\"><span class=text-info><i class=\"fa fa-usd fa-fw\"></i></span></button> <button class=\"btn btn-xs btn-default\" ng-click=vm.listDeposit(reseller) uib-tooltip=\"Mutasi Deposit\"><span class=text-info><i class=\"fa fa-list fa-fw\"></i></span></button> <button class=\"btn btn-xs btn-default\" ng-click=vm.upline(reseller) uib-tooltip=\"Ubah Upline\" tooltip-placement=left ng-if=\"reseller.level !== 3\"><span class=text-warning><i class=\"fa fa-chain fa-fw\"></i></span></button> <button class=\"btn btn-xs btn-danger\" ng-click=vm.deleteReseller(reseller) uib-tooltip=Hapus ng-if=\"(reseller.status === \'REGISTERED\') && (reseller.balance === 0 || reseller.balance === null)\"><span><i class=\"fa fa-trash fa-fw\"></i></span></button></td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.oresell-broadcast/main.administrasi.oresell-broadcast.html","<div class=row><div class=col-sm-12><form name=broadcastForm><div class=form-group><label for=title>Title</label><input type=text class=form-control placeholder=\"Ketik judul broadcast ...\" required minlength=3 maxlength=100 autofocus ng-model=vm.broadcast.title></div><div class=form-group><label for=content>Message</label><textarea name=content id=content cols=80 rows=5 class=form-control placeholder=\"Ketik isi pesan anda ...\" required minlength=3 maxlength=500 ng-model=vm.broadcast.message></textarea></div><button type=submit class=\"btn btn-primary\" ng-disabled=broadcastForm.$invalid ng-click=vm.submitBroadcast()>Kirim</button></form></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.product/main.administrasi.product.html","<div class=row><form><div class=\"col-sm-3 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\" uib-tooltip=\"Refresh filter\" tooltip-append-to-body=true><i class=\"fa fa-search fa-fw\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.verify() ng-disabled=vm.inProcess uib-tooltip=\"Verifikasi ulang semua produk\" style=\"border-right: none\" tooltip-append-to-body=true><i class=\"fa fa-retweet fa-fw\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.deleteSelected() ng-disabled=vm.inProcess uib-tooltip=\"Hapus semua produk yang dipilih\" style=\"border-right: none\" tooltip-append-to-body=true><i class=\"fa fa-trash fa-fw\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.deleteNonWoo() ng-disabled=vm.inProcess uib-tooltip=\"Hapus semua produk yang tidak ada di website\" tooltip-append-to-body=true tooltip-placement=left><i class=\"fa fa-trash-o fa-fw\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=\"SKU Produk\" ng-model=vm.filter.by_sku></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.search></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Posisi</label>--><select name=\"\" class=form-control ng-model=vm.filter.woo_only ng-init=\"vm.filter.woo_only = \'0\'\"><option value=0>Semua Produk</option><option value=1>Produk di POS dan Woo</option><option value=2>Produk di POS Saja</option></select></div></form></div><!--<hr>\n<div class=\"row\">\n  <div class=\"col-sm-6\">\n    <button class=\"btn btn-danger btn-block\" ng-click=\"vm.deleteSelected();\" ><i class=\"fa fa-trash\"></i> Hapus semua produk yang dipilih</button>\n  </div>\n  <div class=\"col-sm-6\">\n    <button class=\"btn btn-success btn-block\" uib-tooltip=\"Membandingkan produk yang ada di sistem POS dan di website, kemudian menandai produk yang hanya ada di POS tapi tidak ada di website\" ng-click=\"vm.verify();\" ><i class=\"fa fa-retweet\"></i> Verifikasi Ulang Semua Produk</button>\n  </div>\n</div>--><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col><input type=checkbox ng-model=vm.checkAll ng-change=vm.changeCheckAll() uib-tooltip=\"Pilih semua / Hilangkan semua pilihan\"></th><th scope=col>No</th><!-- <th scope=\"col\" >Waktu</th> --><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col class=text-right>Ukuran</th><th scope=col class=text-right>Berat (kg)</th><th scope=col class=text-right>Harga</th><th scope=col class=text-right>Stok</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.productList track by item.id\" ng-class=\"{danger: item.status == \'nw\'}\"><td class=autofit><input type=checkbox ng-model=vm.itemCheckbox[$index] ng-if=\"item.status == \'nw\'\"></td><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td><a class=clickable ng-click=vm.editProduct(item)>{{item.sku | uppercase}}</a></td><td>{{item.nama}}<br><!-- <small ng-if=\"item.family\">Family: {{item.family.option}}</small> --> <small>{{item.ket}}</small></td><td class=text-right>{{item.size | uppercase}}<!-- <span ng-repeat=\"varian in item.detail.attributes\" ><strong>{{varian.name + \': \'}}</strong> {{varian.option}}<br></span>\n              <span ng-if=\"item.size\" ><strong>Size: </strong> {{item.size}}<br></span>\n              <span ng-if=\"item.warna\" ><strong>Warna: </strong> {{item.warna}}<br></span> --></td><td class=text-right>{{ item.weight | number:2 }}</td><td class=text-right>{{item.harga | number:2}}</td><td class=text-right>{{item.jumlah || 0}}</td><td><button class=\"btn btn-xs btn-default\" uib-tooltip=\"Set Diskon Otoresell\" tooltip-placement=left ng-click=vm.editDiskonOtoreseller(item)><span class=text-danger><i class=\"fa fa-fw fa-percent\"></i></span></button> <button class=\"btn btn-xs btn-default\" uib-tooltip=\"Sync produk\" tooltip-placement=top ng-click=vm.syncProduk(item)><span class=text-info><i class=\"fa fa-fw fa-refresh\"></i></span></button></td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.product-double/main.administrasi.product-double.html","<div class=row><div class=\"col-sm-3 pull-right\"><button class=\"btn btn-danger btn-block\" ng-click=vm.deleteDobel() ng-disabled=\"vm.productList.length === 0\"><i class=\"fa fa-trash\"></i> Hapus Dobel</button></div></div><hr><div class=row ng-if=\"vm.productList.length === 0\"><div class=col-sm-12><div class=\"alert alert-info\"><i class=\"fa fa-info-circle\"></i> <strong>Tidak ada produk dobel</strong></div></div></div><div class=row ng-if=\"vm.productList.length > 0\"><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col class=text-right>Ukuran</th><th scope=col class=text-right>Jumlah Dobel</th><th scope=col class=autofit></th></tr></thead><tbody><tr ng-repeat=\"item in vm.productList track by item.id\" ng-class=\"{danger: item.status == \'nw\'}\"><td class=text-right>{{($index + 1) }}</td><td><a class=clickable ng-click=vm.editProduct(item)>{{item.sku | uppercase}}</a></td><td>{{item.nama}}</td><td class=text-right>{{item.size | uppercase}}</td><td class=text-right>{{ item.dobel }}</td></tr></tbody></table></div></div><hr>");
$templateCache.put("app/main/main.administrasi/main.administrasi.shopee/main.administrasi.shopee.html","<div class=row><div class=col-sm-8><label for=\"\">Sinkronisasi Stok Produk di Shopee</label><p>POS akan otomatis mengedit file stok dari Shopee menyesuaikan dengan stok terbaru di POS.</p><form action=\"\"><div class=form-group><label for=minRow>Nomor baris data dimulai dari 0 (misal baris 7 maka diisi 6)</label><input required type=number min=0 max=20 class=form-control id=minRow name=minRow ng-model=vm.minRow></div><div class=form-group><label for=skuColumn>Kolom SKU</label><input required type=text maxlength=1 class=form-control id=skuColumn name=skuColumn ng-model=vm.skuColumn></div><div class=form-group><label for=stockColumn>Kolom Stok</label><input required type=text maxlength=1 class=form-control id=stockColumn name=stockColumn ng-model=vm.stockColumn></div><div class=form-group><label for=uploadedFile>File</label><input type=file class=\"form-control input-file\" id=uploadedFile></div></form></div><!-- <div class=\"col-sm-4\">\n    <label for=\"\">&nbsp;</label>\n    <button class=\"btn btn-warning btn-block \" type=\"button\" ng-click=\"vm.importTheFile()\" ng-disabled=\"vm.inProcess\">\n      <i class=\"fa fa-cloud-download\"></i> Proses Upload</button>\n  </div> --></div><hr><div class=row><div class=col-sm-8><p><strong>Sinkronisasi data produk dari Shopee</strong></p><p>Jalankan ketika ada penambahan produk baru di Shopee. Pastikan produk baru tesebut sudah dimasukkan di POS. Stok produk hanya akan disinkronkan ketika terjadi transaksi.</p></div></div><div class=row><div class=col-sm-3 ng-if=!vm.doSync><button class=\"btn btn-primary\" ng-click=vm.syncProduct() ng-disabled=vm.inProcess><i class=\"fa fa-refresh\" ng-class=\"vm.doSync ? \'fa-spin\': \'\'\"></i> Proses Sinkronisasi</button></div><div class=col-sm-8 ng-if=vm.doSync><div class=\"alert alert-warning\"><i class=\"fa fa-refresh fa-spin\"></i> Proses sinkronisasi seadang berjalan di server. Silahkan lanjutkan aktivitas lain.</div></div></div><hr><div class=row><div class=col-sm-8><p><strong>Koneksi Shopee Store</strong></p><button class=\"btn btn-default\" ng-if=vm.isConnected><span class=text-success><i class=\"fa fa-circle\"></i> <strong>Terhubung</strong></span></button> <button class=\"btn btn-default\" ng-if=!vm.isConnected><span class=text-danger><i class=\"fa fa-circle\"></i> <strong>Terputus</strong></span></button> <button class=\"btn btn-warning\" ng-click=vm.generateURL() ng-disabled=vm.inProcess><i class=\"fa fa-link\"></i> Hubungkan <span ng-if=vm.isConnected>Ulang Dengan</span> Shopee Store</button></div></div><div class=row style=\"margin-top: 1em\" ng-if=vm.connectURL><div class=col-sm-12><div class=\"alert alert-info\" style=\"overflow: hidden\"><p><strong>Buka URL berikut untuk menghubungkan Shopee Store dg POS. URL hanya valid selama 5 menit.</strong></p><p><a href={{vm.connectURL}} target=_blank>{{vm.connectURL}}</a></p></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.sinkronisasi/main.administrasi.sinkronisasi.html","<div class=row><div class=col-sm-12><div class=\"panel panel-simplepos\"><div class=panel-heading><h3 class=panel-title><i class=\"fa fa-fw fa-cloud-download\"></i> Import Data Produk</h3></div><div class=panel-body><div class=row><div class=col-sm-8><img src=assets/images/import.png alt=Import class=img-info></div><div class=col-sm-4><div class=info-box><p>Import data produk dari website ke server alikasi Simple POS</p></div></div></div><hr><div class=row><!--<div class=\"col-sm-12\">\n                    <button class=\"btn btn-block btn-warning btn-lg\"  uib-tooltip=\"Klik di sini untuk import data ke aplikasi Simple POS\"  ng-click=\"vm.importProductWoo()\" ng-disabled=\"vm.inProcess || !vm.importValid\" ><i class=\"fa fa-fw fa-cloud-download\"></i> Import Data Produk</button>\n                  </div>--><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-click=vm.importProductWoo(0) ng-disabled=\"vm.inProcess || vm.customImport\" uib-tooltip=\"Tanggal hari ini adalah tanggal produk DIBUAT, bukan tanggal produk DIEDIT.\"><span class=text-success><i class=\"fa fa-fw fa-cloud-download\"></i> </span>Import Perubahan Hari Ini</button></div><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-click=vm.importProductWoo(1) ng-disabled=\"vm.inProcess || vm.customImport\"><span class=text-danger><i class=\"fa fa-fw fa-cloud-download\"></i> </span>Import Semua</button></div><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-model=vm.customImport uib-btn-checkbox uib-tooltip=\"Waktu custom yg digunakan di sini adalah waktu produk DIBUAT, bukan waktu produk DIEDIT\"><span class=text-info><i class=\"fa fa-fw fa-cloud-download\"></i> </span>Import Custom</button></div></div><hr><div class=row uib-collapse=!vm.customImport><form><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Tgl Awal</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.option1.updated_min is-open=\"vm.datePicker[\'tglAwal1\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: (vm.option1.updated_max || vm.today)}\" readonly ng-change=vm.checkValid() uib-tooltip=\"Tanggal produk DIBUAT, bukan tanggal produk DIEDIT\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal1\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><label for=\"\">Jam awal</label><div uib-timepicker ng-model=vm.option1.jamAwal show-spinners=false hour-step=1 minute-step=1 show-meridian=false ng-change=vm.checkValid()></div></div><div class=\"form-group col-sm-3\"><label for=\"\" class=reqfield>Tgl Akhir</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.option1.updated_max is-open=\"vm.datePicker[\'tglAkhir1\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate:vm.option1.updated_min, maxDate: vm.today}\" readonly ng-change=vm.checkValid() uib-tooltip=\"Tanggal produk DIBUAT, bukan tanggal produk DIEDIT\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir1\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><label for=\"\">Jam akhir</label><div uib-timepicker ng-model=vm.option1.jamAkhir show-spinners=false hour-step=1 minute-step=1 show-meridian=false ng-change=vm.checkValid()></div></div><div class=\"form-group col-sm-2\"><label for=\"\">&nbsp;</label><button class=\"btn btn-block btn-default\" uib-tooltip=\"Klik di sini untuk import data ke aplikasi Simple POS\" ng-click=vm.importProductWoo(2) ng-disabled=\"vm.inProcess || !vm.importValid\"><span class=text-warning><i class=\"fa fa-fw fa-gear\"></i> </span>Proses</button></div></form></div></div></div></div></div><hr><div class=row><div class=col-sm-12><div class=\"panel panel-simplepos\"><div class=panel-heading><h4 class=panel-title><i class=\"fa fa-fw fa-cloud-upload\"></i> Upload Data Produk</h4></div><div class=panel-body><div class=row><div class=col-sm-8><img src=assets/images/upload.png alt=Upload class=img-info></div><div class=col-sm-4><div class=info-box><p>Upload data produk dari aplikasi Simple POS ke website</p></div></div></div><hr><div class=row><form><!--<div class=\"form-group col-sm-3\">\n                        <label for=\"\" class=\"reqfield\">Tgl Awal</label>\n                        <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\"  uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"vm.option.updated_min\" is-open=\"vm.datePicker[\'tglAwal\']\"  close-text=\"Close\" ng-required=\"true\" placeholder=\"Tgl Awal\"  max-date=\"vm.option.tglAkhir\" readonly=\"readonly\" />\n                            <span class=\"input-group-btn\">\n                                <button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ><i class=\"fa fa-calendar\"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-sm-3\">\n                        <label for=\"\" class=\"reqfield\">Tgl Akhir</label>\n                        <div class=\"input-group\">\n                            <input type=\"text\" class=\"form-control\"  uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=\"vm.option.updated_max\" is-open=\"vm.datePicker[\'tglAkhir\']\"  close-text=\"Close\" ng-required=\"true\" placeholder=\"Tgl Akhir\" min-date=\"vm.option.tglAwal\" max-date=\"vm.today\" readonly=\"readonly\" />\n                            <span class=\"input-group-btn\">\n                                <button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ><i class=\"fa fa-calendar\"></i></button>\n                            </span>\n                        </div>\n                    </div>--><div class=\"form-group col-sm-4\"><label for=\"\">Jenis data yang diupdate</label><select class=form-control ng-model=vm.option.all><option value=1>Semua</option><option value=0>Hanya data stok</option></select></div></form></div><hr><div class=row><!--<div class=\"col-sm-12\">\n                    <button class=\"btn btn-block btn-danger btn-lg\" uib-tooltip=\"Klik di sini untuk upload data produk dari aplikasi Simple POS ke website\" ng-click=\"vm.updateProductWoo()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-fw fa-cloud-upload\"></i> Upload Data Produk</button>\n                  </div>--><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-click=vm.updateProductWoo(0) ng-disabled=\"vm.inProcess || vm.customUpload\"><span class=text-success><i class=\"fa fa-fw fa-cloud-upload\"></i> </span>Upload Perubahan Hari Ini</button></div><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-click=vm.updateProductWoo(1) ng-disabled=\"vm.inProcess || vm.customUpload\"><span class=text-danger><i class=\"fa fa-fw fa-cloud-upload\"></i> </span>Upload Semua</button></div><div class=col-sm-4><button class=\"btn btn-block btn-default\" ng-model=vm.customUpload uib-btn-checkbox><span class=text-info><i class=\"fa fa-fw fa-cloud-upload\"></i> </span>Upload Custom</button></div></div><hr><div class=row uib-collapse=!vm.customUpload><form><div class=\"form-group col-sm-4\"><label for=\"\" class=reqfield>Tgl Awal</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.option.updated_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close ng-required=true placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: (vm.option.updated_max || vm.today)}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-4\"><label for=\"\" class=reqfield>Tgl Akhir</label><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.option.updated_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close ng-required=true placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate:vm.option.updated_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-4\"><label for=\"\">&nbsp;</label><button class=\"btn btn-block btn-default\" ng-click=vm.updateProductWoo(2) ng-disabled=vm.inProcess><span class=text-warning><i class=\"fa fa-fw fa-gear\"></i> </span>Proses</button></div></form></div></div></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.tiktok/main.administrasi.tiktok.html","<div class=row><div class=col-sm-8><label for=\"\">Sinkronisasi Stok Produk di Tiktok</label><p>POS akan otomatis mengedit file stok dari Tiktok menyesuaikan dengan stok terbaru di POS.</p><input type=file class=\"form-control input-file\" id=uploadedFile></div></div><hr><div class=row><div class=col-sm-8><p><strong>Sinkronisasi data produk dari Tiktok</strong></p><p>Jalankan ketika ada penambahan produk baru di Tiktok. Pastikan produk baru tesebut sudah dimasukkan di POS. Stok produk hanya akan disinkronkan ketika terjadi transaksi.</p></div></div><div class=row><div class=col-sm-3 ng-if=!vm.doSync><button class=\"btn btn-primary\" ng-click=vm.syncProduct() ng-disabled=vm.inProcess><i class=\"fa fa-refresh\" ng-class=\"vm.doSync ? \'fa-spin\': \'\'\"></i> Proses Sinkronisasi</button></div><div class=col-sm-8 ng-if=vm.doSync><div class=\"alert alert-warning\"><i class=\"fa fa-refresh fa-spin\"></i> Proses sinkronisasi seadang berjalan di server. Silahkan lanjutkan aktivitas lain.</div></div></div><hr><div class=row><div class=col-sm-8><p><strong>Koneksi Tiktok Store</strong></p><button class=\"btn btn-default\" ng-if=vm.isConnected><span class=text-success><i class=\"fa fa-circle\"></i> <strong>Terhubung</strong></span></button> <button class=\"btn btn-default\" ng-if=!vm.isConnected><span class=text-danger><i class=\"fa fa-circle\"></i> <strong>Terputus</strong></span></button> <button class=\"btn btn-warning\" ng-click=vm.generateURL() ng-disabled=vm.inProcess><i class=\"fa fa-link\"></i> Hubungkan <span ng-if=vm.isConnected>Ulang Dengan</span> Tiktok Store</button></div></div><div class=row style=\"margin-top: 1em\" ng-if=vm.connectURL><div class=col-sm-12><div class=\"alert alert-info\" style=\"overflow: hidden\"><p><strong>Buka URL berikut untuk menghubungkan Tiktok Store dg POS</strong></p><p><a href={{vm.connectURL}} target=_blank>{{vm.connectURL}}</a></p></div></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.users/main.administrasi.users.html","<div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-block btn-default\" ng-click=vm.userModal()><i class=\"fa fa-user-plus\"></i></button></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col>No</th><th scope=col>Username</th><th scope=col>Nama</th><th scope=col>Grup</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"user in vm.userList track by user.id\"><td class=\"text-right col-sm-1\">{{$index + 1}}</td><td class=col-sm-3><a href ng-click=vm.userModal(user)>{{user.uname}}</a></td><td class=col-sm-4>{{user.detail.name}}</td><td>{{user.group | uppercase}}</td><td class=autofit><button class=\"btn btn-xs btn-default\" ng-click=vm.deleteUser(user) ng-if=\"user.uname !== vm.currentUser.uname\"><span class=text-danger><i class=\"fa fa-trash\"></i></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.administrasi/main.administrasi.whatsapp/main.administrasi.whatsapp.html","<div class=row><div class=col-sm-12><form class=form name=messageForm><div class=form-group><label for=nomor>Nomor Tujuan</label><input type=tel class=form-control name=nomor placeholder=\"Contoh: 628123456789\" required ng-model=vm.nomor minlength=10 maxlength=16 autocomplete=off></div><div class=form-group><label for=pesan>Isi Pesan</label><textarea name=pesan id=pesan cols=30 rows=5 class=form-control placeholder=\"Isi pesan ...\" required ng-model=vm.pesan maxlength=1000 autocomplete=off></textarea></div><div class=form-group><button type=submit class=\"btn btn-primary\" ng-click=vm.sendMessage() ng-disabled=messageForm.$invalid>Kirim Pesan</button></div></form></div></div>");
$templateCache.put("app/main/main.pos/main.pos.cashier/main.pos.cashier.html","<div class=row><div class=col-sm-3><input type=text class=form-control ng-model=vm.sku ng-keypress=vm.addViaSKU($event) placeholder=\"SKU Produk\" autofocus></div><div class=col-sm-9><ui-select ng-model=vm.selectedProduct ng-change=vm.addViaSelect()><ui-select-match placeholder=\"Nama Produk\"><span>{{$select.selected.sku}} {{$select.selected.nama}}</span></ui-select-match><ui-select-choices repeat=\"item in (vm.productList | filter: $select.search) track by item.id\" refresh=vm.getProducts($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{item.nama}}</strong> {{item.ket}}</span><br><small>SKU : {{item.sku}}</small></ui-select-choices></ui-select></div></div><hr><h4>Data Order</h4><div class=row><div class=col-sm-12><form name=productForm><table class=\"table table-striped\"><thead><tr><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col>Harga</th><th scope=col>Jumlah</th><th scope=col><a href=\"\" ng-click=\"vm.bulk.persen.show = !vm.bulk.persen.show\" uib-tooltip=\"Klik untuk ubah diskon persen semua produk\" style=\"text-decoration: underline; color: inherit\">Diskon ( % )</a> <input type=text class=\"form-control input-in-table input-number\" ng-locale-number min=0 max=100 ng-model=vm.bulk.persen.value ng-if=vm.bulk.persen.show ng-change=vm.bulk.persen.change() ng-blur=\"vm.bulk.persen.show = false\"></th><th scope=col><a href=\"\" ng-click=\"vm.bulk.nominal.show = !vm.bulk.nominal.show\" uib-tooltip=\"Klik untuk ubah diskon nominal semua produk\" style=\"text-decoration: underline; color: inherit\">Diskon (Nominal)</a> <input type=text class=\"form-control input-in-table input-number\" ng-locale-number min=0 ng-model=vm.bulk.nominal.value ng-if=vm.bulk.nominal.show ng-change=vm.bulk.nominal.change() ng-blur=\"vm.bulk.nominal.show = false\"></th><th scope=col>Total Diskon</th><th scope=col>Total</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.product track by item.sku\" ng-class=\"{\'danger\': ((item.jumlah == null) || (item.jumlah > item.jumlah_max))}\"><td>{{item.sku}}</td><td><strong>{{item.nama}}</strong><br><!-- <small ng-if=\"item.family\">Family: {{item.family.option}}</small> --> <small>{{item.ket}}</small></td><td class=text-right>{{item.harga_jual | number:2}}</td><td><input type=number ng-model=item.jumlah min=1 max={{item.jumlah_max}} class=\"form-control input-in-table\" ng-change=vm.changeStock(item) required uib-tooltip=\"Jumlah maksimal {{item.jumlah_max}}\"></td><td class=text-right><input type=text ng-model=item.discount_persen ng-locale-number min=0 max=100 class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) required></td><td class=text-right><input type=text ng-model=item.discount_nominal ng-locale-number min=0 class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) required></td><td class=text-right><input type=text ng-model=item.discount_total ng-locale-number min=0 max=\"(item.harga_jual * item.jumlah)\" class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) disabled></td><td class=text-right>{{item.total | number:2}}</td><td class=autofit><a class=\"btn btn-xs btn-default\" title=Hapus ng-click=\"vm.removeStock($index, item)\"><span class=text-danger><i class=\"fa fa-fw fa-times-circle\"></i></span></a></td></tr></tbody></table></form></div></div><hr style=margin-top:0><div class=row><div class=col-sm-3></div><div class=\"col-sm-6 text-right\"><h4>Jumlah Tagihan</h4></div><div class=col-sm-3><input type=text class=\"form-control input-number input-lg\" disabled value=\"{{vm.resume.total | number:2}}\"></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-danger btn-block\" ng-click=vm.clearTransaction() ng-disabled=\"vm.product.length < 1\" uib-tooltip=\"Batalkan transaksi, hapus semua produk yang sudah dimasukkan\"><i class=\"fa fa-times-circle\"></i> Batal</button></div><div class=\"col-sm-3 col-sm-offset-6\"><button class=\"btn btn-primary btn-block\" ng-click=vm.dialogBayar() ng-disabled=\"(vm.product.length < 1) || productForm.$invalid\" uib-tooltip=\"Proses pembayaran atau simpan data transaksi\"><i class=\"fa fa-shopping-cart\"></i> Proses</button></div></div>");
$templateCache.put("app/main/main.pos/main.pos.payment-history/main.pos.payment-history.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"form-group col-sm-1 pull-right\"><!--<label for=\"\" class=\"reqfield\">&nbsp;</label>--> <button class=\"btn btn-default btn-block\" ng-click=vm.initView(1)><i class=\"fa fa-search\"></i></button></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Awal</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Akhir</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><input type=text class=form-control placeholder=\"Order ID\" ng-model=vm.filter.by_order_id></div><div class=\"form-group col-sm-3\"><select name=\"\" class=form-control ng-model=vm.filter.by_metode_bayar ng-init=\"vm.filter.by_metode_bayar = \'\'\"><option value=\"\">Semua Metode Bayar</option><option value=Cash>Cash</option><option value=BCA>BCA</option><option value=BRI>BRI</option><option value=MANDIRI>Mandiri</option><option value=MUAMMALAT>Muammalat</option><option value=DEPOSIT>Deposit</option><option value=\"Lain - Lain\">Lain - Lain</option></select></div><div class=\"form-group col-sm-3\"><input type=text class=\"form-control text-right\" placeholder=Nominal ng-model=vm.filter.by_nominal ng-locale-number></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=Kasir ng-model=vm.filter.by_kasir></div></div></form></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><th scope=col>Waktu</th><th scope=col class=text-center>Order Id</th><th scope=col>Metode Bayar</th><th scope=col class=text-right>Nilai</th><th scope=col>Kasir</th></tr></thead><tbody ng-if=\"vm.paymentList.length > 0\"><tr ng-repeat=\"item in vm.paymentList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.tgl | udate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><td class=text-right><button class=\"btn btn-link btn-block btn-xs\" ng-click=vm.showDetail(item.order_id)>#{{item.order_id}}</button></td><td><strong>{{item.metode_bayar}}</strong></td><td class=text-right>{{ item.nominal | number:2 }}</td><td>{{item.kasir}}</td></tr></tbody></table><div class=\"alert alert-info text-center\" ng-if=\"vm.paymentList.length === 0\"><span>Belum ada pembayaran yang sesuai dengan filter yang Anda tentukan</span></div></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.pos/main.pos.process-pending/main.pos.process-pending.html","<div class=row ng-if=\"vm.resume.dropship !== 2\"><div class=col-sm-3><input type=text class=form-control ng-model=vm.sku ng-keypress=vm.addViaSKU($event) placeholder=\"SKU Produk\" autofocus></div><div class=col-sm-9><ui-select ng-model=vm.selectedProduct ng-change=vm.addViaSelect()><ui-select-match placeholder=\"Nama Produk\"><span>{{$select.selected.sku}} {{$select.selected.nama}}</span></ui-select-match><ui-select-choices repeat=\"item in (vm.productList | filter: $select.search) track by item.id\" refresh=vm.getProducts($select.search)><span><strong>{{item.nama}}</strong> {{item.ket}}</span><br><small>SKU : {{item.sku}}</small></ui-select-choices></ui-select></div></div><hr><h4>Data Transaksi Pending #{{vm.id}}</h4><div class=row><div class=col-sm-12><form name=productForm><table class=\"table table-striped\"><thead><tr class=danger><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col>Harga</th><th scope=col>Jumlah</th><th scope=col><a href=\"\" ng-click=\"vm.bulk.persen.show = !vm.bulk.persen.show\" uib-tooltip=\"Klik untuk ubah diskon persen semua produk\">Diskon ( % )</a> <input type=text class=\"form-control input-in-table input-number\" ng-locale-number min=0 max=100 ng-model=vm.bulk.persen.value ng-if=vm.bulk.persen.show ng-change=vm.bulk.persen.change() ng-blur=\"vm.bulk.persen.show = false\"></th><th scope=col><a href=\"\" ng-click=\"vm.bulk.nominal.show = !vm.bulk.nominal.show\" uib-tooltip=\"Klik untuk ubah diskon nominal semua produk\">Diskon (Nominal)</a> <input type=text class=\"form-control input-in-table input-number\" ng-locale-number min=0 ng-model=vm.bulk.nominal.value ng-if=vm.bulk.nominal.show ng-change=vm.bulk.nominal.change() ng-blur=\"vm.bulk.nominal.show = false\"></th><th scope=col>Total Diskon</th><th scope=col>Total</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.product track by item.sku\" ng-class=\"{\'danger\': ((item.jumlah == null) || (item.jumlah > item.jumlah_max))}\"><td>{{item.sku}}</td><td><strong>{{item.nama}}</strong><br><!-- <small ng-if=\"item.family\">Family: {{item.family.option}}</small> --> <small>{{item.ket}}</small></td><td class=text-right>{{item.harga_jual | number:2}}</td><td><input type=number ng-model=item.jumlah min=1 max={{item.jumlah_max}} class=\"form-control input-in-table\" ng-change=vm.changeStock(item) required uib-tooltip=\"Jumlah maksimal {{item.jumlah_max}}\" ng-disabled=vm.resume.lain_lain.fromWeb></td><td class=text-right><input type=text ng-model=item.discount_persen ng-locale-number min=0 max=100 class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) required ng-disabled=vm.resume.lain_lain.fromWeb></td><td class=text-right><input type=text ng-model=item.discount_nominal ng-locale-number min=0 max=item.harga_jual class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) required ng-disabled=vm.resume.lain_lain.fromWeb></td><td class=text-right><input type=text ng-model=item.discount_total ng-locale-number min=0 max=\"(item.harga_jual * item.jumlah)\" class=\"form-control input-in-table input-number\" ng-change=vm.changeStock(item) disabled></td><td class=text-right>{{item.total | number:2}}</td><td class=autofit><a class=\"btn btn-xs btn-default\" title=Hapus ng-click=vm.removeStock($index) ng-disabled=vm.resume.lain_lain.fromWeb><span class=text-danger><i class=\"fa fa-fw fa-times-circle\"></i></span></a></td></tr></tbody></table></form></div></div><hr style=margin-top:0><div class=row><div class=col-sm-3></div><div class=\"col-sm-6 text-right\"><h4>Jumlah Tagihan</h4></div><div class=col-sm-3><input type=text class=\"form-control input-number input-lg\" disabled value=\"{{vm.resume.total | number:2}}\"></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-info btn-block\" ui-sref=main.pos.pending uib-tooltip=\"Kembali ke daftar transaksi pending\"><i class=\"fa fa-chevron-circle-left\"></i> Kembali</button></div><div class=col-sm-3><button class=\"btn btn-danger btn-block\" ng-click=vm.cancelTransaction() uib-tooltip=\"Batalkan transaksi. Hapus semua data transaksi\"><i class=\"fa fa-ban\"></i> Batal</button></div><div class=\"col-sm-3 col-sm-offset-3\"><button class=\"btn btn-primary btn-block\" ng-click=vm.dialogBayar() ng-disabled=\"vm.product.length < 1 || productForm.$invalid\" uib-tooltip=\"Proses pembayaran atau simpan ulang data transaksi\"><i class=\"fa fa-shopping-cart\"></i> Proses</button></div></div>");
$templateCache.put("app/main/main.pos/main.pos.product-transaction-list/main.pos.product-transaction-list.html","<form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default\" ng-disabled=vm.inProcess ng-click=vm.downloadTransaction() type=button><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"#Id Trx\" ng-model=vm.filter.transaction_id></div></div><div class=row><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=SKU ng-model=vm.filter.sku></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.product_name></div><div class=\"form-group col-sm-3\"><select name=order_status id=order_status class=form-control ng-model=vm.filter.order_status><option value=process>Diproses</option><option value=pending>Pending</option></select></div></div></form><hr><div class=row><div class=col-sm-12><div class=\"alert alert-info\"><strong>RESUME</strong><div class=row><div class=\"col-sm-2 text-primary\"><strong>Total Qty:</strong></div><div class=\"col-sm-2 text-primary\"><strong>Total Harga:</strong></div><div class=\"col-sm-2 text-primary\"><strong>Total Diskon:</strong></div><div class=\"col-sm-2 text-primary\"><strong>Total Bayar:</strong></div><div class=\"col-sm-2 text-primary\"><strong>Total HPP:</strong></div><div class=\"col-sm-2 text-primary\"><strong>Total Margin:</strong></div></div><div class=row><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.qty | number: 0}}</strong></div><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.harga | number: 0}}</strong></div><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.diskon | number: 0}}</strong></div><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.bayar | number: 0}}</strong></div><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.hpp | number: 0}}</strong></div><div class=\"col-sm-2 text-right\"><strong>{{vm.resume.margin | number: 0}}</strong></div></div></div></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Waktu</th><th scope=col class=\"text-right autofit\">Order</th><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col class=text-right>Qty</th><th scope=col class=text-right>Harga</th><th scope=col class=text-right>Diskon</th><th scope=col class=text-right>Bayar</th><th scope=col class=text-right>HPP</th><th scope=col class=text-right>Margin</th></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td><strong>{{item.tgl | udate:\'dd-MM-yyyy\'}}</strong><br><small>{{item.tgl | udate:\'HH:mm:ss\'}}</small></td><td><a href ng-click=vm.showDetail(item.order_id)>#{{item.order_id}}</a></td><td>{{item.sku}}</td><td><strong>{{item.nama}}</strong><br><!-- <small>Size: {{item.size}} <span ng-if=\"item.family\">| Family: {{item.family.option}}</span></small> --> <small>{{item.ket}}</small></td><td class=text-right>{{ (item.jumlah * 1) }}</td><td class=text-right>{{ (item.harga_jual * item.jumlah) | number:2 }}</td><td class=text-right>{{ (item.discount_total * 1) | number:2 }}</td><td class=text-right>{{ (item.harga_akhir * 1) | number:2 }}</td><td class=text-right>{{ (item.harga_beli * item.jumlah) | number:2}}</td><td class=text-right>{{ (item.margin * 1) | number:2 }}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.pos/main.pos.transaction-list/main.pos.transaction-list.html","<form><div class=row><!--<div class=\"form-group col-sm-1 pull-right\">\n        <button class=\"btn btn-info btn-block\" ng-click=\"vm.initView(1)\" type=\"submit\" ><i class=\"fa fa-search\"></i></button>\n    </div>--><div class=\"col-sm-3 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group uib-dropdown><button class=\"btn btn-default\" ng-disabled=vm.inProcess type=button uib-dropdown-toggle style=\"border-right: none\"><i class=\"fa fa-print\"></i> <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.printTransaction()><a href>Cetak Trx (by Filter)</a></li><li role=menuitem ng-click=vm.procesPrint(1)><a href>Cetak Struk</a></li><li role=menuitem ng-click=vm.procesPrint(2)><a href>Cetak Alamat</a></li></ul></div><div class=btn-group uib-dropdown><button class=\"btn btn-default\" ng-disabled=vm.inProcess type=button uib-dropdown-toggle><i class=\"fa fa-cloud-download\"></i> <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.downloadReport()><a href>Laporan Keuangan</a></li><li role=menuitem ng-click=vm.downloadTransaction()><a href>Riwayat Penjualan</a></li><li role=menuitem ng-click=vm.downloadFull()><a href>Detail Penjualan</a></li></ul></div></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Awal</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" max-date=vm.filter.tglAkhir readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Akhir</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" min-date=vm.filter.tglAwal datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"Nama Pembeli\" ng-model=vm.filter.by_pembeli></div></div><div class=row><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"#Id Trx\" ng-model=vm.filter.by_id></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"ID Reseller\" ng-model=vm.filter.by_reseller_id></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"ID Trx Shopee / Tokped, dll\" ng-model=vm.filter.by_marketplace_id></div></div></form><div class=row><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=\"No Resi\" ng-model=vm.filter.by_no_resi></div><div class=\"form-group col-sm-3\"><select name=byDropship id=byDropship class=form-control ng-model=vm.filter.by_dropship><option value=\"\">Semua Trx</option><option value=0>Trx Biasa</option><option value=1>Dropship</option><option value=2>Otoresell</option><option value=99>Trx Web</option><option value=4>Trx Shopee</option><option value=5>Trx Tokopedia</option><option value=6>Trx Tiktok</option></select></div><div class=\"form-group col-sm-3\"><select name=byEkspedisi id=byEkspedisi class=form-control ng-model=vm.filter.by_ekspedisi><option value=\"\">Semua Ekspedisi</option><option value=jne>JNE</option><option value=J&T>J&amp;T</option><option value=pos>Pos</option><option value=lion>Lion Parcel</option><option value=lain>Lain - lain</option></select></div><!-- <div class=\"col-sm-4\"><button class=\"btn btn-success btn-block\" ng-click=\"vm.downloadReport()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-cloud-download\"></i> Download Laporan Keuangan</button></div>\n  <div class=\"col-sm-4\"><button class=\"btn btn-warning btn-block\" ng-click=\"vm.downloadTransaction()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-cloud-download\"></i> Download Riwayat Penjualan</button></div> --></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col class=autofit><input type=checkbox ng-model=vm.checkAll ng-change=vm.changeCheckAll() uib-tooltip=\"Pilih semua / Hilangkan semua pilihan\"></th><!-- <th scope=\"col\" class=\"autofit\">No</th> --><th scope=col>Waktu</th><th scope=col class=\"text-right autofit\">Order Id</th><th scope=col></th><th scope=col>Pembeli</th><th scope=col class=text-right>Harga Produk</th><th scope=col class=text-right>Total Diskon</th><th scope=col class=text-right>Total Biaya</th><th scope=col class=text-right>Total</th><!--<th scope=\"col\" >Kasir</th>--><!--<th scope=\"col\" ></th>--></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\" ng-class=\"{\'success\': item.lain_lain.hasPrint}\"><td class=autofit><input type=checkbox ng-model=vm.itemCheckbox[$index]></td><!-- <td class=\"text-right\">{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td> --><td>{{item.tgl | udate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><td class=text-right><span uib-dropdown on-toggle=toggled(open)><a href id=simple-dropdown uib-dropdown-toggle>#{{item.id}}</a><ul class=dropdown-menu uib-dropdown-menu aria-labelledby=simple-dropdown><li><a href ng-click=vm.showDetail(item.id)>Lihat Detail</a><hr><a href ng-click=vm.changeProcess(item) ng-if=\"(item.dropship === 2) && (item.status !== \'selesai\')\">Tandai: <span ng-if=(!item.lain_lain.processed)>Diproses</span><span ng-if=(item.lain_lain.processed)>Baru</span></a> <a href ng-click=vm.changeStatus(item)>Set Status: <span ng-if=\"(item.status === \'dibayar\')\">Selesai</span><span ng-if=\"(item.status === \'selesai\')\">Dibayar</span></a><hr><a href ng-click=\"vm.entryResi(item, true)\">Input Resi</a> <a href ng-click=\"vm.entryResi(item, false)\" ng-if=item.no_resi>SMS Ulang Resi</a></li></ul></span></td><td><span ng-if=\"item.status === \'selesai\'\" ng-class=vm.setStatusResi(item)><i class=\"fa fa-fw fa-check-circle fa-fw\"></i> </span><!-- deprecated, format lama. hapus saat tidak dipakai --><!-- <span ng-if=\"item.lain_lain.dropship.isDropship === true\" class=\"text-danger\" >\n              <i class=\"fa fa-fw fa-shopping-bag fa-fw\" ></i>\n            </span> --><!-- dropship normal --> <a href=\"\" ng-if=\"item.dropship === 1\" class=text-danger uib-tooltip=#{{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><!-- dropship oresell --> <a href=\"\" ng-if=\"item.dropship === 2\" class=text-success uib-tooltip={{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><span ng-if=\"(item.dropship === 2) && (!item.lain_lain.processed) && (item.status !== \'selesai\')\" class=\"label label-warning\" uib-tooltip={{item.reseller_id}}>New </span><!-- From web via webhook --> <span ng-if=item.lain_lain.fromWeb class=\"label label-info\" uib-tooltip=\"Transaksi dari web\">Web </span><!-- From shopee via webhook --> <span ng-if=item.lain_lain.fromShopee class=\"label label-danger\" uib-tooltip=\"Transaksi Shopee #{{item.shopee_ordersn}}\">Shopee </span><!-- Transaksi Shopee yg dropship --> <a href=\"\" ng-if=\"item.lain_lain.fromShopee && item.lain_lain.dropship.isDropship\" class=text-danger uib-tooltip=#{{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><!-- From Tokopedia via webhook --> <span ng-if=item.lain_lain.fromTokopedia class=\"label label-success\" uib-tooltip=\"Transaksi Tokpedia #{{item.tokopedia_orderid}}\">Tokped </span><!-- From Tiktok via webhook --> <span ng-if=item.lain_lain.fromTiktok class=\"label label-info\" uib-tooltip=\"Transaksi Tiktok #{{item.tiktok_orderid}}\">Tiktok </span><!-- Beri tanda jika ada catatan reseller di transaksi oresell --> <span class=text-info uib-tooltip=\"Ada catatan reseller\" ng-if=item.lain_lain.customerNote><i class=\"fa fa-fw fa-file-text-o fa-fw\"></i> </span><!-- Ada catatan kasir --> <a href=\"\" ng-click=vm.showCashierNote(item) ng-if=item.lain_lain.hasNote class=text-danger uib-tooltip=\"Ada catatan kasir\"><i class=\"fa fa-fw fa-file-text-o fa-fw\"></i></a></td><td class=text-left><a ng-click=\"vm.showCustomerDetail(item.cust_id, false)\" ng-if=\"item.cust_id !== 0\" style=\"cursor: pointer\">{{item.pembeli}} </a><a ng-click=\"vm.showCustomerDetail(item.cust_uuid, true)\" ng-if=\"item.cust_uuid !== null\" style=\"cursor: pointer\">{{item.pembeli}} </a><span ng-if=\"(item.cust_id === 0) && (item.cust_uuid === null)\">{{item.pembeli}}</span></td><td class=text-right>{{ (item.product_price_total * 1) | number:2 }}</td><td class=text-right>{{((item.discount_transaction_total * 1) + (item.discount_product_total * 1)) | number:2}}</td><td class=text-right>{{ (item.total_lain_lain * 1) | number:2 }}</td><td class=text-right>{{item.total_akhir | number:2}}</td><!--<td class=\"text-right\" >{{item.kasir}}</td>--></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label for=page>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required name=page id=page></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.pos/main.pos.transaction-pending/main.pos.transaction-pending.html","<form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group uib-dropdown><button class=\"btn btn-default\" ng-disabled=vm.inProcess type=button uib-dropdown-toggle><i class=\"fa fa-cloud-download\"></i> <span class=caret></span></button><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=menu><li role=menuitem ng-click=vm.downloadReport()><a href>Keuangan Pending</a></li><li role=menuitem ng-click=vm.downloadTransaction()><a href>Riwayat Pending</a></li></ul></div></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><input type=text class=form-control placeholder=\"#Id trx\" ng-model=vm.filter.by_id></div><div class=\"form-group col-sm-2\"><select name=\"\" class=form-control ng-model=vm.filter.by_dropship><option value=\"\">Semua Trx</option><option value=0>Trx Biasa</option><option value=1>Dropship</option><option value=2>Otoresell</option><option value=99>Trx Web</option><option value=4>Trx Shopee</option><option value=5>Trx Tokopedia</option><option value=6>Trx Tiktok</option></select></div></div><div class=row><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"Nama Pembeli\" ng-model=vm.filter.by_pembeli></div><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"ID Reseller\" ng-model=vm.filter.by_reseller_id></div><div class=\"form-group col-sm-4\"><input type=text class=form-control placeholder=\"ID Trx Shopee / Tokped, dll\" ng-model=vm.filter.by_marketplace_id></div></div></form><!-- <div class=\"row\">\n  <div class=\"col-sm-4 col-sm-offset-8\"><button class=\"btn btn-warning btn-block\" ng-click=\"vm.downloadTransaction()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-cloud-download\"></i> Download Riwayat Penjualan</button></div>\n</div> --><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><th scope=col>Waktu</th><th scope=col>Order Id</th><th scope=col></th><th scope=col>Konsumen</th><th scope=col class=text-right>Nilai</th><!-- <th scope=\"col\" >Diskon (Nominal)</th> --><!-- <th scope=\"col\" >Diskon Total</th> --><!-- <th scope=\"col\" >Total</th> --><th scope=col>Editor</th><th scope=col></th></tr></thead><tbody><tr ng-repeat=\"item in vm.transactionList track by item.id\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td><span uib-tooltip=\"Updated at: {{item.tgl | udate:\'dd-MM-yyyy - HH:mm:ss\'}}\">{{item.created_at | udate:\'dd-MM-yyyy - HH:mm:ss\'}}</span></td><td class=text-right><button class=\"btn btn-link btn-block btn-xs\" ng-click=vm.showDetail(item.id) uib-tooltip=\"Klik untuk lihat detail transaksi\">#{{item.id}}</button></td><td><!-- dropship normal --> <a href=\"\" ng-if=\"item.dropship === 1\" class=text-danger uib-tooltip={{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><!-- dropship oresell --> <a href=\"\" ng-if=\"item.dropship === 2\" class=text-success uib-tooltip={{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><!-- From web via webhook --> <span ng-if=item.lain_lain.fromWeb class=\"label label-info\" uib-tooltip=\"Transaksi dari web\">Web </span><!-- From shopee via webhook --> <span ng-if=item.lain_lain.fromShopee class=\"label label-danger\" uib-tooltip=\"Transaksi Shopee #{{item.shopee_ordersn}}\">Shopee </span><!-- Transaksi Shopee yg dropship --> <a href=\"\" ng-if=\"item.lain_lain.fromShopee && item.lain_lain.dropship.isDropship\" class=text-danger uib-tooltip=#{{item.reseller_id}}><i class=\"fa fa-fw fa-shopping-bag fa-fw\"></i> </a><!-- From Tokopedia via webhook --> <span ng-if=item.lain_lain.fromTokopedia class=\"label label-success\" uib-tooltip=\"Transaksi Tokpedia #{{item.tokopedia_orderid}}\">Tokped </span><!-- From Tiktok via webhook --> <span ng-if=item.lain_lain.fromTiktok class=\"label label-info\" uib-tooltip=\"Transaksi Tiktok #{{item.tiktok_orderid}}\">Tiktok </span><!-- Beri tanda jika ada catatan reseller di transaksi oresell --> <span class=text-info uib-tooltip=\"Ada catatan reseller\" ng-if=item.lain_lain.customerNote><i class=\"fa fa-fw fa-file-text-o fa-fw\"></i> </span><!-- Ada catatan kasir --> <a href=\"\" ng-click=vm.showCashierNote(item) ng-if=item.lain_lain.hasNote class=text-danger uib-tooltip=\"Ada catatan kasir\"><i class=\"fa fa-fw fa-file-text-o fa-fw\"></i></a></td><td><a ng-click=\"vm.showCustomerDetail(item.cust_id, false)\" ng-if=\"item.cust_id !== 0\" style=\"cursor: pointer\">{{item.pembeli}} </a><a ng-click=\"vm.showCustomerDetail(item.cust_uuid, true)\" ng-if=\"item.cust_uuid !== null\" style=\"cursor: pointer\">{{item.pembeli}} </a><span ng-if=\"(item.cust_id === 0) && (item.cust_uuid === null)\">{{item.pembeli}}</span></td><td class=text-right>{{ (item.total_akhir * 1)| number:2 }}</td><!-- <td class=\"text-right\" >{{item.discount_transaction_nominal | number:2}}</td> --><!-- <td class=\"text-right\" >{{item.discount_transaction_total | number:2}}</td> --><!-- <td class=\"text-right\" >{{item.total_akhir | number:2}}</td> --><td class=text-right>{{item.user}}</td><td><button ng-if=\"item.dropship !== 2 && item.dropship !== 4 && item.dropship !== 5\" class=\"btn btn-default btn-xs btn-block\" uib-tooltip=\"Proses Transaksi\" tooltip-placement=left tooltip-append-to-body=true ui-sref=\"main.pos.process-pending({id: item.id})\"><span class=text-success><i class=\"fa fa-gear fa-fw\"></i></span></button> <button ng-if=\"item.dropship === 2\" class=\"btn btn-default btn-xs btn-block\" uib-tooltip=\"Proses Transaksi Otoresell\" tooltip-placement=left tooltip-append-to-body=true ng-click=vm.processOresellTransaction(item)><span class=text-success><i class=\"fa fa-credit-card fa-fw\"></i></span></button> <button ng-if=\"item.dropship === 2\" class=\"btn btn-danger btn-xs btn-block\" uib-tooltip=\"Batalkan Transaksi Otoreseller\" tooltip-placement=left tooltip-append-to-body=true ng-click=vm.cancelOresellTransaction(item)><span><i class=\"fa fa-ban fa-fw\"></i></span></button> <button ng-if=\"item.dropship === 4\" class=\"btn btn-danger btn-xs btn-block\" uib-tooltip=\"Batalkan Transaksi Shopee\" tooltip-placement=left tooltip-append-to-body=true ng-click=vm.cancelShopeeTransaction(item)><span><i class=\"fa fa-ban fa-fw\"></i></span></button></td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.report/main.report.compare/main.report.compare.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.initView(1) ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.timeOne ng-change=\"vm.timeTemplate.change(vm.timeTemplate.timeOne, 0)\"><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source[0].tgl_min is-open=\"vm.datePicker[\'tglAwalOne\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source[0].tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwalOne\')\" ng-if=\"vm.timeTemplate.timeOne === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source[0].tgl_max is-open=\"vm.datePicker[\'tglAkhirOne\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source[0].tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhirOne\')\" ng-if=\"vm.timeTemplate.timeOne === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=row><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.timeTwo ng-change=\"vm.timeTemplate.change(vm.timeTemplate.timeTwo, 1)\"><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source[1].tgl_min is-open=\"vm.datePicker[\'tglAwalTwo\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source[1].tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwalTwo\')\" ng-if=\"vm.timeTemplate.timeTwo === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source[1].tgl_max is-open=\"vm.datePicker[\'tglAkhirTwo\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source[1].tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhirTwo\')\" ng-if=\"vm.timeTemplate.timeTwo === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div></form><hr><div class=row><div class=col-sm-8><h4>Laporan Perbandingan Nilai Transaksi</h4></div><div class=\"col-sm-4 pull-right\"><div class=\"btn-group pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\"><i class=\"fa fa-pie-chart fa-fw\"></i></button></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.options data=vm.report></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Seri Data</th><th scope=col>Nilai Transaksi</th></tr></thead><tbody><tr ng-repeat=\"item in vm.report[0].values\"><td class=text-right>{{$index + 1}}</td><td>{{item.label}}</td><td class=text-right>{{item.value | number: 2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.report/main.report.location/main.report.location.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.refreshData() ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.value ng-change=vm.timeTemplate.change(vm.timeTemplate.value)><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source.tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source.tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div></form><hr><div class=row><div class=col-sm-8><h4>Laporan Transaksi&nbsp; <span ng-if=\"vm.filter.scope === 0\">Semua Wilayah</span> <span ng-if=\"vm.filter.scope !== 0\">{{vm.source.info[vm.filter.scope - 1].wilayah}}</span></h4></div><div class=\"col-sm-4 pull-right\"><div class=\"btn-group pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\"><i class=\"fa fa-pie-chart fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-click=vm.switchField() uib-tooltip=\"Jumlah / Nilai\"><i class=\"fa fa-exchange fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-click=vm.backUpArea() ng-disabled=\"vm.filter.scope === 0\"><i class=\"fa fa-arrow-circle-left fa-fw\"></i></button></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.options data=vm.report.data></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Wilayah</th><th scope=col><a href ng-click=\"vm.changeOrder(\'jumlah_trans\')\">Jumlah Transaksi</a></th><th scope=col><a href ng-click=\"vm.changeOrder(\'nilai_trans\')\" uib-tooltip=\"Harga + Ongkir - Diskon\">Nilai Transaksi</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.report.data\"><td class=text-right>{{$index + 1}}</td><td><a href ng-click=vm.changeLocation(item) ng-if=\"(vm.filter.scope < 2) && (item.wilayah_id != 0)\">{{item.wilayah}}</a> <span ng-if=\"(vm.filter.scope === 2) || (item.wilayah_id == 0)\">{{item.wilayah || \'LOKASI TIDAK TERDAFTAR\'}}</span></td><td class=text-right>{{item.jumlah_trans}}</td><td class=text-right>{{item.nilai_trans | number: 2}}</td></tr><tr><th scope=row class=text-right colspan=2>Total</th><td class=text-right>{{vm.report.total.trans}}</td><td class=text-right>{{vm.report.total.nilai | number: 2}}</td></tr></tbody></table></div></div><hr class=hr-no-margin><div ng-if=\"vm.filter.scope !== 0\"><div class=row><div class=col-sm-7><h4>Distribusi Produk di {{vm.source.info[vm.filter.scope - 1].wilayah}}</h4></div><div class=col-sm-3><input type=text class=form-control placeholder=\"Filter Produk\" ng-model=vm.filterProduk.filter ng-change=vm.filterProduk.change() ng-disabled=\"(vm.collapseReport.product.graph && vm.collapseReport.product.table)\" ng-model-options=\"{ debounce: 400 }\"></div><div class=\"col-sm-2 pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.product.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=vm.changeCollapseProductReport(0)><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.product.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\" ng-change=vm.changeCollapseProductReport(1)><i class=\"fa fa-pie-chart fa-fw\"></i></button></div></div><hr><div class=row uib-collapse=vm.collapseReport.product.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.distribusi.produk.option data=vm.distribusi.produk.graph></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.product.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Nama</th><th scope=col>Jumlah Item</th><!--<th scope=\"col\"><a href ng-click=\"vm.changeOrder(\'nilai_produk\')\" >Nilai Item</a></th>--></tr></thead><tbody><tr ng-repeat=\"item in vm.distribusi.produk.data.data\"><td class=text-right>{{$index + 1}}</td><td>{{item.nama}}</td><td class=text-right>{{item.jumlah_produk}}</td><!--<td class=\"text-right\">{{item.nilai_produk | number: 2}}</td>--></tr><tr><th scope=row class=text-right colspan=2>Total</th><td class=text-right>{{vm.distribusi.produk.data.total_produk}}</td></tr></tbody></table></div></div></div><div class=row><div class=col-sm-8><h4>Distribusi Waktu di <span ng-if=\"vm.filter.scope === 0\">Semua Wilayah</span> <span ng-if=\"vm.filter.scope !== 0\">{{vm.source.info[vm.filter.scope - 1].wilayah}}</span></h4></div><div class=col-sm-2><select name=\"\" class=\"form-control pull-right\" ng-model=vm.distribusi.waktu.periode ng-change=vm.changeTimeChartPeriode(vm.distribusi.waktu.periode)><option value=d>Hari</option><option value=w>Minggu</option><option value=m>Bulan</option></select></div><div class=\"col-sm-2 pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.time.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=vm.changeCollapseTimeReport(0)><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.time.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\" ng-change=vm.changeCollapseTimeReport(1)><i class=\"fa fa-area-chart fa-fw\"></i></button></div></div><hr><div class=row uib-collapse=vm.collapseReport.time.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.distribusi.waktu.option data=vm.distribusi.waktu.graph></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.time.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Waktu</th><th scope=col>Jumlah Transaksi</th><th scope=col>Nilai Transaksi</th></tr></thead><tbody><tr ng-repeat=\"item in vm.distribusi.waktu.data.data\"><td class=text-right>{{$index + 1}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'d\'\">{{item.tgl | udate}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'w\'\">{{item.tgl | udate: \'ww yyyy\'}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'m\'\">{{item.tgl | udate: \'MMMM yyyy\'}}</td><td class=text-right>{{item.jumlah_trans}}</td><td class=text-right>{{item.nilai_trans | number: 2}}</td></tr></tbody></table></div></div><div class=row><div class=col-sm-8><h4>Konsumen Terbesar yang Berasal dari <span ng-if=\"vm.filter.scope === 0\">Semua Wilayah</span> <span ng-if=\"vm.filter.scope !== 0\">{{vm.source.info[vm.filter.scope - 1].wilayah}}</span></h4></div><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.customer.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=\"vm.getTopCustomer(\'by_nilai\')\"><i class=\"fa fa-table fa-fw\"></i></button></div></div><hr><div class=row uib-collapse=vm.collapseReport.customer.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Nama</th><th scope=col><a href ng-click=\"vm.getTopCustomer(\'by_jumlah\')\">Jumlah Transaksi</a></th><th scope=col><a href ng-click=\"vm.getTopCustomer(\'by_nilai\')\">Nilai Transaksi</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.distribusi.konsumen.data.data\"><td class=text-right>{{$index + 1}}</td><td><a href ng-click=\"vm.showCustomerDetail(item.cust_id, item.cust_uuid)\">{{item.pembeli}}</a></td><td class=text-right>{{item.jumlah_trans}}</td><td class=text-right>{{item.nilai_trans | number: 2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.report/main.report.product/main.report.product.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.refreshData() ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.value ng-change=vm.timeTemplate.change(vm.timeTemplate.value)><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source.tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source.tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div></form><hr><div class=row><div class=col-sm-6><h4>Laporan Transaksi&nbsp; <span ng-if=\"vm.filter.mode === 0\"><span ng-if=!vm.filterProduk.filter>Semua Produk</span><span ng-if=vm.filterProduk.filter>{{vm.filterProduk.filter | uppercase}}</span></span> <span ng-if=\"vm.filter.mode !== 0\">{{vm.source.info[vm.filter.mode - 1].nama}}</span></h4></div><div class=col-sm-3><input type=text class=form-control placeholder=\"Filter Produk\" ng-model=vm.filterProduk.filter ng-change=vm.filterProduk.change() ng-if=\"vm.filter.mode === 0\" ng-model-options=\"{ debounce: 400 }\"></div><div class=\"col-sm-3 pull-right\"><div class=\"btn-group pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=vm.changeCollapsePrimaryReport(0)><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.primary.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\" ng-change=vm.changeCollapsePrimaryReport(1)><i class=\"fa fa-pie-chart fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-click=vm.switchField() uib-tooltip=\"Jumlah / Nilai\"><i class=\"fa fa-exchange fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-click=vm.productUp() ng-disabled=\"vm.filter.mode === 0\"><i class=\"fa fa-arrow-circle-left fa-fw\"></i></button></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.options data=vm.report.graph></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.primary.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col ng-if=\"vm.filter.mode !== 0\">SKU</th><th scope=col>Nama</th><th scope=col><a href ng-click=\"vm.changeOrder(\'jumlah_produk\')\">Jumlah Item</a></th><th scope=col>HPP</th><th scope=col><a href ng-click=\"vm.changeOrder(\'nilai_produk\')\">Harga Jual</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.report.data\"><td class=text-right>{{$index + 1}}</td><td ng-if=\"vm.filter.mode !== 0\">{{item.sku}}</td><td><a ng-if=\"vm.filter.mode === 0\" href ng-click=vm.changeProduct(item)>{{item.nama}}</a> <span ng-if=\"vm.filter.mode !== 0\">{{item.nama}} {{item.size}}</span></td><td class=text-right>{{item.jumlah_produk}}</td><td class=text-right>{{item.nilai_hpp | number: 2}}</td><td class=text-right>{{item.nilai_produk | number: 2}}</td></tr><tr><th scope=row class=text-right colspan=2 ng-if=\"vm.filter.mode === 0\">Total</th><th scope=row class=text-right colspan=3 ng-if=\"vm.filter.mode !== 0\">Total</th><td class=text-right>{{vm.report.total.jumlah}}</td><td class=text-right>{{vm.report.total.hpp | number: 2}}</td><td class=text-right>{{vm.report.total.nilai | number: 2}}</td></tr></tbody></table></div></div><hr><div ng-if=\"vm.filter.mode === 1\"><div class=row><div class=col-sm-8><h4>Distribusi Wilayah Produk {{vm.source.info[vm.filter.mode - 1].nama}}</h4></div><div class=\"col-sm-4 pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.location.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=vm.changeCollapseLocationReport(0)><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.location.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\" ng-change=vm.changeCollapseLocationReport(1)><i class=\"fa fa-pie-chart fa-fw\"></i></button></div></div><hr><div class=row uib-collapse=vm.collapseReport.location.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.distribusi.lokasi.option data=vm.distribusi.lokasi.graph></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.location.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col ng-if=\"vm.filter.mode !== 0\">Wilayah</th><th scope=col>Jumlah</th><th scope=col>Nilai</th></tr></thead><tbody><tr ng-repeat=\"item in vm.distribusi.lokasi.data.data\"><td class=text-right>{{$index + 1}}</td><td>{{item.wilayah || \'LOKASI TIDAK TERDAFTAR\'}}</td><td class=text-right>{{item.jumlah_produk}}</td><td class=text-right>{{item.nilai_produk | number: 2}}</td></tr></tbody></table></div></div></div><div class=row><div class=col-sm-8><h4>Distribusi Waktu <span ng-if=\"vm.filter.mode === 0\">Semua Produk</span> <span ng-if=\"vm.filter.mode !== 0\">Produk {{vm.source.info[vm.filter.mode - 1].nama}}</span></h4></div><div class=col-sm-2><select name=\"\" class=\"form-control pull-right\" ng-model=vm.distribusi.waktu.periode ng-change=vm.changeTimeChartPeriode(vm.distribusi.waktu.periode)><option value=d>Hari</option><option value=w>Minggu</option><option value=m>Bulan</option></select></div><div class=\"col-sm-2 pull-right\"><button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.time.table uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true ng-change=vm.changeCollapseTimeReport(0)><i class=\"fa fa-table fa-fw\"></i></button> <button class=\"btn btn-default pull-right\" ng-model=vm.collapseReport.time.graph uib-btn-checkbox btn-checkbox-true=false btn-checkbox-false=true style=\"border-right: none\" ng-change=vm.changeCollapseTimeReport(1)><i class=\"fa fa-area-chart fa-fw\"></i></button></div></div><hr><div class=row uib-collapse=vm.collapseReport.time.graph><div class=col-sm-12><div class=\"panel panel-default\"><div class=panel-body><nvd3 options=vm.distribusi.waktu.option data=vm.distribusi.waktu.graph></nvd3></div></div></div></div><div class=row uib-collapse=vm.collapseReport.time.table><div class=col-sm-12><table class=\"table table-striped table-bordered\"><thead><tr><th scope=col class=autofit>No</th><th scope=col>Waktu</th><th scope=col>Jumlah Produk</th><th scope=col>Nilai Produk</th></tr></thead><tbody><tr ng-repeat=\"item in vm.distribusi.waktu.data.data\"><td class=text-right>{{$index + 1}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'d\'\">{{item.tgl | udate}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'w\'\">{{item.tgl | udate: \'ww yyyy\'}}</td><td ng-if=\"vm.distribusi.waktu.periode === \'m\'\">{{item.tgl | udate: \'MMMM yyyy\'}}</td><td class=text-right>{{item.jumlah_produk}}</td><td class=text-right>{{item.nilai_produk | number: 2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.report/main.report.transaction/main.report.transaction.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.refreshData() ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.value ng-change=vm.timeTemplate.change(vm.timeTemplate.value)><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source.tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source.tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-2\"><select name=onlycrm id=onlycrm class=form-control ng-model=vm.filter.only_crm><option value=1>CRM</option><option value=0>ALL</option></select></div></div></form><hr><!-- <div class=\"row\">\n  <div class=\"col-sm-8\">\n    <h4>\n      Laporan Transaksi\n    </h4>\n  </div>\n  <div class=\"col-sm-4 pull-right\">\n    <div class=\"btn-group pull-right\" >\n      <button class=\"btn btn-default pull-right\" ng-model=\"vm.collapseReport.primary.table\" uib-btn-checkbox btn-checkbox-true=\"false\" btn-checkbox-false=\"true\"  ><i class=\"fa fa-table fa-fw\"></i></button>\n      <button class=\"btn btn-default pull-right\"  ng-model=\"vm.collapseReport.primary.graph\" uib-btn-checkbox btn-checkbox-true=\"false\" btn-checkbox-false=\"true\" style=\"border-right: none\"  ><i class=\"fa fa-pie-chart fa-fw\"></i></button>\n    </div>\n  </div>\n</div> --><div class=row ng-if=vm.report.data><div class=col-sm-12><table class=\"table table-bordered\"><thead><tr><th>No</th><th>Nama Pembeli</th><th><a href ng-click=\"vm.changeOrder(\'transaction_count\')\">Jumlah Transaksi</a></th><th><a href ng-click=\"vm.changeOrder(\'transaction_value\')\">Nilai Transaksi</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.report.data track by item.cust_id\"><td class=text-right>{{$index + 1}}</td><td><a href=\"\" ng-click=vm.detailTransaction(item)>{{item.pembeli}}</a></td><td class=text-right>{{item.transaction_count | number}}</td><td class=text-right>{{item.transaction_value | number: 2 }}</td></tr><tr><th scope=row colspan=2 class=text-right><strong>Total</strong></th><td class=text-right><strong>{{vm.report.transaction_count | number}}</strong></td><td class=text-right><strong>{{vm.report.transaction_value | number: 2}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.report/main.report.transaction-dropship/main.report.transaction-dropship.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.refreshData() ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.value ng-change=vm.timeTemplate.change(vm.timeTemplate.value)><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source.tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source.tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div></form><hr><div class=row ng-if=vm.report.data><div class=col-sm-12><table class=\"table table-bordered\"><thead><tr><th>No</th><th>Dropshipper ID</th><th>Nama Dropshipper</th><th><a href ng-click=\"vm.changeOrder(\'transaction_count\')\">Jumlah Transaksi</a></th><th><a href ng-click=\"vm.changeOrder(\'transaction_value\')\">Nilai Transaksi</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.report.data track by item.reseller_id\"><td class=text-right>{{$index + 1}}</td><td class=text-right><a href=\"\" ng-click=vm.detailTransaction(item)>#{{item.reseller_id}}<a></a></td><td>{{item.reseller_id > 0 ? item.lain_lain.dropship.sender.nama : \'DROPSHIPPER NON-CRM\' }}</td><td class=text-right>{{item.transaction_count | number}}</td><td class=text-right>{{item.transaction_value | number: 2 }}</td></tr><tr><th scope=row colspan=3 class=text-right><strong>Total</strong></th><td class=text-right><strong>{{vm.report.transaction_count | number}}</strong></td><td class=text-right><strong>{{vm.report.transaction_value | number: 2}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.report/main.report.transaction-oresell/main.report.transaction-oresell.html","<form name=filterForm><div class=row><div class=\"col-sm-1 pull-right\"><button class=\"btn btn-default btn-block\" ng-click=vm.refreshData() ng-disabled=filterForm.$invalid type=submit><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-sm-3 form-group\"><select class=form-control ng-model=vm.timeTemplate.value ng-change=vm.timeTemplate.change(vm.timeTemplate.value)><option value=1>7 hari terakhir</option><option value=2>Bulan ini</option><option value=3>Bulan Kemarin</option><option value=4>6 Bulan Terakhir</option><option value=5>Tahun Ini</option><option value=7>Tahun Kemarin</option><option value=6>Custom</option></select></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.source.tgl_max}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><div class=input-group><input type=text class=form-control uib-datepicker-popup=dd-MM-yyyy ng-model=vm.source.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{minDate: vm.source.tgl_min, maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\" ng-if=\"vm.timeTemplate.value === \'6\'\"><i class=\"fa fa-calendar\"></i></button></span></div></div></div></form><hr><div class=row ng-if=vm.report.data><div class=col-sm-12><table class=\"table table-bordered\"><thead><tr><th>No</th><th>Reseller ID</th><th>Nama Reseller</th><th><a href ng-click=\"vm.changeOrder(\'transaction_count\')\">Jumlah Transaksi</a></th><th><a href ng-click=\"vm.changeOrder(\'transaction_value\')\">Nilai Transaksi</a></th></tr></thead><tbody><tr ng-repeat=\"item in vm.report.data track by item.reseller_id\"><td class=text-right>{{$index + 1}}</td><td><a href=\"\" ng-click=vm.detailTransaction(item)>{{item.reseller_id}}<a></a></td><td>{{item.lain_lain.dropship.sender.nama}}</td><td class=text-right>{{item.transaction_count | number}}</td><td class=text-right>{{item.transaction_value | number: 2 }}</td></tr><tr><th scope=row colspan=3 class=text-right><strong>Total</strong></th><td class=text-right><strong>{{vm.report.transaction_count | number}}</strong></td><td class=text-right><strong>{{vm.report.transaction_value | number: 2}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/main.stock/main.stock.bulk-update/main.stock.bulk-update.html","<div class=row><div class=col-sm-8><label for=\"\">Updata Stok Massal</label><p>Pilih file Excel berisi info stok produk yang ditentukan</p><input type=file class=\"form-control input-file\" id=uploadedFile ng-disable=vm.inProcess></div></div><hr><div class=row ng-if=\"vm.products.length > 0\"><div class=col-sm-12><div class=row><div class=col-sm-12><p>Berikut adalah data produk yang akan diubah stoknya.</p></div></div><div class=row><div class=col-sm-12><table class=\"table table-bordered table-hover\"><thead><tr><th scope=col>No</th><th scope=col>SKU</th><th scope=col>Nama</th><th scope=col>Harga Beli</th><th scope=col>Stok Awal</th><th scope=col>Stok Masuk</th><th scope=col>Stok Akhir</th></tr></thead><tbody><tr ng-repeat=\"product in vm.products\"><td class=text-right>{{ $index + 1}}</td><td>{{ product.sku }}</td><td>{{ product.nama }}<br><small>{{product.info}}</small></td><td class=text-right>{{ product.harga_beli | number:2 }}</td><td class=text-right>{{ product.stok_awal }}</td><td class=text-right>{{ product.jumlah_in }}</td><td class=text-right>{{ product.jumlah_in + product.stok_awal }}</td></tr></tbody></table></div></div><hr class=hr-no-margin-top><div class=row><div class=col-sm-4><button class=\"btn btn-lg btn-danger btn-block\" ng-click=vm.reset() ng-disable=vm.inProcess>Batal</button></div><div class=col-sm-4></div><div class=col-sm-4><button class=\"btn btn-lg btn-primary btn-block\" ng-disable=vm.inProcess ng-click=vm.update()>Proses Update Stok</button></div></div></div></div>");
$templateCache.put("app/main/main.stock/main.stock.product-list/main.stock.product-list.html","<div class=row><div class=col-sm-12><form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.exportCSV() ng-disabled=vm.inProcess><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-2\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=SKU ng-model=vm.filter.by_sku></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Nama</label>--> <input type=text class=form-control placeholder=Nama ng-model=vm.filter.search></div><div class=\"form-group col-sm-2\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=Ukuran ng-model=vm.filter.by_size></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Kondisi Stok</label>--><select name=\"\" class=form-control ng-model=vm.filter.only_with_stok><option value=0>Semua Stok</option><option value=1>Hanya Stok yg Tersedia</option><option value=2>Hanya Stok yg Kosong</option></select></div></div></form></div></div><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><!-- <th scope=\"col\" >Waktu</th> --><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col class=text-right>Ukuran</th><th scope=col class=text-right>Berat (kg)</th><th scope=col class=text-right>Harga</th><th scope=col class=text-right>Stok</th></tr></thead><tbody><tr ng-repeat=\"item in vm.productList track by item.id\" ng-class=\"{danger: item.status == \'nw\'}\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.sku | uppercase}}</td><td><strong>{{item.nama}}</strong><br><!-- <small ng-if=\"item.family\">Family: {{item.family.option}}</small> --> <small>{{item.ket}}</small></td><td class=text-right>{{item.size | uppercase}}<!-- <span ng-repeat=\"varian in item.detail.attributes\" ><strong>{{varian.name + \': \'}}</strong> {{varian.option}}<br></span>\n              <span ng-if=\"item.size\" ><strong>Size: </strong> {{item.size}}<br></span>\n              <span ng-if=\"item.warna\"><strong>Warna: </strong> {{item.warna}}<br></span> --></td><td class=text-right>{{item.weight | number: 2}}</td><td class=text-right>{{item.harga | number:2}}</td><td class=text-right>{{item.jumlah || 0}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.stock/main.stock.stock-change/main.stock.stock-change.html","<div class=row><div class=col-sm-3><input type=text class=form-control ng-model=vm.sku ng-keypress=vm.addViaSKU($event) placeholder=\"SKU Produk\" autofocus></div><div class=col-sm-9><ui-select ng-model=vm.selectedProduct ng-change=vm.addViaSelect()><ui-select-match placeholder=\"Nama Produk\"><span>{{ $select.selected.sku }} {{ $select.selected.nama }}</span></ui-select-match><ui-select-choices repeat=\"item in (vm.productList | filter: $select.search) track by item.id\" refresh=vm.getProducts($select.search) refresh-delay=300 minimum-input-length=3><span><strong>{{ item.nama }}</strong> {{ item.ket }}</span><br><small>SKU : {{ item.sku }}</small></ui-select-choices></ui-select></div></div><hr><div class=row ng-if=\"vm.stockDraft.length > 0\"><div class=col-sm-1><strong>Draft:</strong></div><div class=col-sm-11><div class=btn-group ng-repeat=\"draft in vm.stockDraft\"><button style=\"margin-left: 1em\" class=\"btn btn-xs btn-warning\" ng-click=vm.useDraft(draft) title=\"Load Draft\" ng-disabled=\"draft.id == vm.loadDraft.id\">Draft: {{ draft.name }}</button> <button class=\"btn btn-xs btn-danger\" ng-click=vm.removeDraft($index) title=\"Delete Draft\" ng-disabled=\"(draft.id == vm.loadDraft.id) || (draft.created_by !== vm.user.uname)\"><i class=\"fa fa-times\"></i></button></div></div></div><hr><h4>Perubahan data stok</h4><form action=\"\" name=productForm id=productForm><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>Produk</th><!--<th scope=\"col\" >Nama</th>--><th scope=col>Harga Beli</th><th scope=col>Awal</th><th scope=col class=autofit>+ / -</th><th scope=col>Jml</th><!--<th scope=\"col\" >Out</th>--><th scope=col>Akhir</th><th scope=col>Ket</th><th scope=col class=autofit></th></tr></thead><tbody><tr ng-repeat=\"item in vm.product track by item.sku\"><td><strong>{{ item.sku }}</strong><br>{{ item.nama }}</td><!--<td>{{item.nama}}</td>--><td class=\"text-right col-sm-2\"><input type=text class=\"form-control input-number no-animate input-in-table\" ng-model=item.harga_beli ng-locale-number min=0 required ng-if=item.is_input ng-disabled=!vm.draftUser><select class=\"form-control input-number no-animate input-in-table text-right\" ng-model=item.harga_beli ng-if=!item.is_input ng-change=vm.changeAwal(item) ng-init=\"item.harga_beli = \'\'\" ng-disabled=!vm.draftUser><option value=\"\">Semua Harga</option><option value=\"{{ item.harga_beli * 1 }}\" ng-repeat=\"item in item.info.opname\" class=text-right>{{ item.harga_beli | number: 2 }}</option></select></td><td class=text-right>{{ item.awal }}</td><td><button type=button class=\"btn btn-xs btn-primary\" uib-tooltip=\"Ubah jenis penambahan atau pengurangan stok\" ng-if=item.is_input ng-click=vm.changeInOut(item) ng-disabled=!vm.draftUser><i class=\"fa fa-plus-circle\"></i></button> <button type=button class=\"btn btn-xs btn-danger\" uib-tooltip=\"Ubah jenis penambahan atau pengurangan stok\" ng-if=!item.is_input ng-click=vm.changeInOut(item) ng-disabled=!vm.draftUser><i class=\"fa fa-minus-circle\"></i></button></td><td ng-if=item.is_input class=col-sm-1><input type=number ng-model=item.jumlah_in min=0 class=\"form-control input-in-table text-right\" ng-change=vm.changeStock(item) required ng-disabled=!vm.draftUser></td><td ng-if=!item.is_input class=col-sm-1><input type=number ng-model=item.jumlah_out min=0 class=\"form-control input-in-table text-right input-danger\" ng-change=vm.changeStock(item) required ng-disabled=!vm.draftUser></td><td class=text-right>{{ item.akhir }}</td><td><textarea class=form-control ng-model=item.ket maxlength=250 placeholder=Keterangan ng-change=vm.changeStock(item) ng-disabled=!vm.draftUser></textarea></td><td class=autofit><button class=\"btn btn-xs btn-danger\" title=Hapus ng-click=vm.removeStock($index) ng-disabled=!vm.draftUser><i class=\"fa fa-fw fa-times-circle\"></i></button></td></tr></tbody></table></div></div></form><hr><div class=row><div class=col-sm-3><button class=\"btn btn-danger btn-block\" ng-click=vm.cancelStock() ng-disabled=\"vm.product.length < 1\">Batal</button></div><div class=\"col-sm-3 col-sm-offset-3\"><button type=button class=\"btn btn-info btn-block\" uib-tooltip=\"Simpan draft stok\" ng-click=vm.saveDraft() ng-disabled=\"(vm.product.length < 1) || productForm.$invalid || !vm.draftUser\"><i class=\"fa fa-save fa-fw\"></i> Simpan Draft</button></div><div class=col-sm-3><button type=button class=\"btn btn-primary btn-block\" uib-tooltip=\"Simpan data stok ke server\" ng-click=vm.saveStock() ng-disabled=\"(vm.product.length < 1) || productForm.$invalid\"><i class=\"fa fa-save fa-fw\"></i> Simpan Perubahan Stok</button></div></div>");
$templateCache.put("app/main/main.stock/main.stock.stock-history/main.stock.stock-history.html","<form><div class=row><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.exportCSVStockChanges() ng-disabled=vm.inProcess><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Awal</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_min is-open=\"vm.datePicker[\'tglAwal\']\" close-text=Close placeholder=\"Tgl Awal\" datepicker-options=\"{maxDate: vm.today}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAwal\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-3\"><!--<label for=\"\" class=\"reqfield\">Tgl Akhir</label>--><div class=input-group><input type=text class=form-control uib-datepicker-popup=\"dd MMMM yyyy\" ng-model=vm.filter.tgl_max is-open=\"vm.datePicker[\'tglAkhir\']\" close-text=Close placeholder=\"Tgl Akhir\" datepicker-options=\"{maxDate: vm.today}\" min-date=vm.filter.tglAwal readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=\"vm.openDatePicker($event, \'tglAkhir\')\"><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"form-group col-sm-4\"><select name=\"\" class=form-control ng-model=vm.filter.mode><option value=0>Semua</option><option value=1>Inventori</option><option value=2>Penjualan</option></select></div></div><div class=row><div class=\"form-group col-sm-3\"><input type=text class=form-control placeholder=\"SKU Produk\" ng-model=vm.filter.by_sku></div><div class=\"form-group col-sm-7\"><input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.by_nama></div></div></form><hr><div class=row><div class=col-sm-12><table class=\"table table-striped table-hover\"><thead><tr><th scope=col>No</th><th scope=col>Waktu</th><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col>Harga Beli</th><th scope=col>Masuk</th><th scope=col>Keluar</th><th scope=col>Akhir</th><th scope=col>Keterangan</th><th scope=col>Kasir</th></tr></thead><tbody><tr ng-repeat=\"item in vm.stockList track by $index\" ng-click=vm.editHistory(item) ng-class=\"{\'editable info\': ((item.sisa_stok * 1) === ((item.jumlah_in * 1) - (item.jumlah_out * 1))) }\" title=\"Klik untuk edit\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.tgl | udate:\'dd-MM-yyyy - HH:mm:ss\'}}</td><td><a ng-click=vm.showTranscation(item.trx_id) ng-if=item.trx_id class=clickable>{{item.sku}}</a> <span ng-if=!item.trx_id>{{item.sku}}</span></td><td>{{item.nama}} {{item.size}} {{item.warna}}</td><td class=text-right>{{item.harga_beli | number:2}}</td><td class=text-right>{{item.jumlah_in || 0}}</td><td class=text-right>{{item.jumlah_out || 0}}</td><td class=text-right>{{item.jumlah_akhir || 0}}</td><td class=text-right>{{item.ket}}</td><td>{{item.user}}</td><!-- <td class=\"autofit\"><button class=\"btn btn-block btn-warning btn-xs\" ng-if=\"((item.sisa_stok * 1) === ((item.jumlah_in * 1) - (item.jumlah_out * 1)))\" uib-tooltip=\"Edit\" ><i class=\"fa fa-edit\" ></i></button></td> --></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");
$templateCache.put("app/main/main.stock/main.stock.stock-opname/main.stock.stock-opname.html","<div class=row><form><div class=\"col-sm-2 pull-right\"><div class=\"btn-group btn-group-justified\"><div class=btn-group role=group><button class=\"btn btn-default\" ng-click=vm.initView(1) type=submit style=\"border-right: none\"><i class=\"fa fa-search\"></i></button></div><div class=btn-group><button class=\"btn btn-default btn-block\" ng-click=vm.exportCSVStockChanges() ng-disabled=vm.inProcess><i class=\"fa fa-cloud-download\"></i></button></div></div></div><div class=\"form-group col-sm-5\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=\"SKU Produk\" ng-model=vm.filter.by_sku></div><div class=\"form-group col-sm-5\"><!--<label for=\"\" class=\"reqfield\">SKU</label>--> <input type=text class=form-control placeholder=\"Nama Produk\" ng-model=vm.filter.by_nama></div></form></div><!--<div class=\"row\">\n\n  <div class=\"col-sm-3 pull-right\">\n    <button class=\"btn btn-warning btn-block\" ng-click=\"vm.exportCSVStockChanges()\" ng-disabled=\"vm.inProcess\" ><i class=\"fa fa-cloud-download\"></i> Download Stok Opname</button>\n  </div>\n</div>--><hr><div class=row><div class=col-sm-12><table class=\"table table-striped\"><thead><tr><th scope=col>No</th><th scope=col>SKU</th><th scope=col>Nama Produk</th><th scope=col class=text-right>Ukuran</th><th scope=col class=text-right>Berat (kg)</th><th scope=col class=text-right>Harga Beli</th><th scope=col class=text-right>Sisa Stok</th></tr></thead><tbody><tr ng-repeat=\"item in vm.stockList track by $index\" ng-class=\"{danger: item.status == \'nw\'}\"><td class=text-right>{{($index + 1) + ((vm.filter.page - 1) * vm.filter.per_page)}}</td><td>{{item.sku}}</td><td><strong>{{item.nama}}</strong><br><!-- <small ng-if=\"item.family\">Family: {{item.family.option}}</small> --> <small>{{item.ket}}</small></td><td class=text-right>{{item.size | uppercase}}<!-- <span ng-if=\"item.size\"><strong>Size: </strong> {{item.size}}<br></span>\n            <span ng-if=\"item.warna\"><strong>Warna: </strong> {{item.warna}}<br></span>\n            {{item.ket}} --></td><td class=text-right>{{item.weight | number:2}}</td><td class=text-right>{{item.harga_beli | number:2}}</td><td class=text-right>{{item.sisa}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page - 1)\" ng-disabled=\"vm.filter.page <= 1\">Sebelumnya</button></div><div class=\"col-sm-6 form-inline text-center\"><div class=form-group><label>Halaman&nbsp;&nbsp;</label><input type=number min=1 max={{vm.maxPage}} class=\"form-control text-right\" ng-model=vm.shownPage ng-change=vm.changePage(vm.shownPage) ng-model-options=\"{ debounce: 1000 }\" ng-blur=vm.onPageBlur(vm.shownPage) required></div></div><div class=col-sm-3><button class=\"btn btn-primary btn-block\" ng-click=\"vm.initView(vm.filter.page + 1)\" ng-disabled=vm.isLastPage>Selanjutnya</button></div></div>");}]);